/* eslint-disable */
/* tslint:disable */

/**
 * 이 파일은 toolkit/generate-api 에 의해 자동으로 생성됩니다.
 *
 * - ACLOSET_ENV : qa
 * - 생성일 : 2025. 1. 23. 오후 4:42:52
 */

/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface DomainAIMSBrandResponse {
  brandID?: string;
  englishName?: string;
  koreanName?: string;
}

export interface DomainAIProperty {
  aims_type?: DomainMultiClassProperty;
  bgr: DomainBackgroundModel;
  bgr_backlight: DomainBackgroundModel;
  category: DomainSingleClassProperty;
  color: DomainMultiClassProperty;
  detail_bottom: DomainMultiClassProperty;
  fabric?: DomainSingleClassProperty;
  filename?: string;
  formal: DomainSingleClassProperty;
  keypoint?: DomainKeyPointProperty;
  line: DomainSingleClassProperty;
  neck: DomainSingleClassProperty;
  open?: DomainSingleClassProperty;
  open_button?: DomainSingleClassProperty;
  pattern: DomainSingleClassProperty;
  pattern_shoes: DomainSingleClassProperty;
  sleeve_length?: DomainSingleClassProperty;
}

export interface DomainAclosetAdditionalImage {
  imageName?: string;
  imageURL?: string;
}

export interface DomainAclosetCategoryMappingRuleResponse {
  aiCategory?: string;
  aimsAttribute?: string;
  aimsCategory?: string;
  platformCategoryIDs?: string[];
}

export interface DomainAclosetClaimDetailResponse {
  /** 구매자 누적 주문 건수 	// 할인 거절 사유 */
  buyerAccumulatedOrderCount?: number;
  /** 구매자 누적 결제 금액 */
  buyerAccumulatedPaymentAmount?: number;
  /** 취소 사유 */
  cancelReason?: string;
  /** 취소 사유 유형 (/shops/acloset-reject-price-offer-reasons 반환값 참조) */
  cancelReasonType?: string;
  /** 취소 유형 (order, acloset-cancel-type 메타데이터 참조) */
  cancelType?: string;
  /** 할인 요청 여부 */
  isOffer?: boolean;
  /** 할인 요청 전 상품 가격 */
  itemPriceBeforeOffer?: number;
  /** 셀러 쿠폰 할인 금액 */
  sellerCouponDiscountAmount?: number;
  /** 할인 요청 전 총 결제 금액 */
  totalPaymentAmountBeforeOffer?: number;
}

export interface DomainAclosetCouponResponse {
  /** 재발급 가능 여부 */
  allowReissue: boolean;
  /** 발급 타입 */
  conditionType: string;
  /** 발급 조건 (구매 횟수, 구매 금액) */
  conditionValue?: number;
  /** 정률, 정액 */
  couponCalcType: string;
  couponID: number;
  /** 쿠폰 이름 */
  couponName: string;
  /** 진행 상태 */
  couponStatus: string;
  /** 발급 한도 */
  couponUsageMax: number;
  /** 할인 금액(혹은 할인율) */
  discountAmount: number;
  /** 정률인 경우 - 최대 할인 금액 */
  discountAmountMax: number;
  /** 발급 가능 기간 종료일 */
  eventEndDate: string;
  /** 발급 가능 기간 시작일 */
  eventStartDate: string;
  /** 발급 후 사용 기간 */
  expirationDuration: number;
  /** 쿠폰 발급 한도 제한 여부 */
  hasIssueLimit: boolean;
  /** 발급 수량 */
  issuedCouponCount: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
  /** 사용 수 */
  usedCouponCount: number;
}

export interface DomainAclosetCrawlingWebhookRequest {
  marketItemIDs?: number[];
  sellerID?: number;
}

export interface DomainAclosetCrawlingWebhookResponse {
  /** 가격이 변경된 상품이 있는지 여부 */
  hasModifiedPrice?: boolean;
  /** 품절된 상품이 있는지 여부 */
  hasSoldout?: boolean;
}

export interface DomainAclosetMappingPropertyResponse {
  aimsFabrics?: string[];
  colors?: string[];
}

export interface DomainAclosetOrder {
  /** 상품 금액 */
  amount?: number;
  /** 구매자 누적 주문 금액 */
  buyerAccumulatedOrderAmount?: number;
  /** 구매자 누적 주문 횟수 */
  buyerAccumulatedOrderCount?: number;
  /** 구매자 이메일 */
  buyerEmail?: string;
  /** 구매자 ID */
  buyerID?: number;
  /** 구매자 전화번호 */
  buyerMobile?: string;
  /** 구매자 닉네임 */
  buyerNickname?: string;
  /**
   * ---- 여기서부터는 LookoAI 전용 필드 ----
   * 취소상품 주문 금액
   */
  cancelAmount?: number;
  /** 취소 내역 */
  cancels?: DomainAclosetOrderCancel[];
  /** 주문 생성일 */
  createDate?: string;
  /** 조건부 무료 조건 금액 */
  freeConditionalAmount?: number;
  /** 주문 ID */
  id?: number;
  /** 첫 주문 여부 */
  isFirstOrder?: boolean;
  /** 가격제안 여부 */
  isPriceOffered?: boolean;
  /** 주문 상품 */
  items?: DomainAclosetOrderItem[];
  /** 배송 상세 주소 */
  logixAdditionalAddress?: string;
  /** 배송 주소 */
  logixAddress?: string;
  /** 배송 메모 */
  logixMemo?: string;
  /** 수령인 이름 */
  logixName?: string;
  /** 수령인 전화번호 */
  logixPhone?: string;
  /** 실제 지불 배송비 */
  logixPrice?: number;
  /** 배송비 (세컨솔드 보상비) */
  logixPriceAclosetSupported?: number;
  /** 배송비 (차감) */
  logixPriceDeducted?: number;
  /** 배송비 차감 여부 */
  logixPriceDeduction?: boolean;
  /** 배송비(합산) */
  logixPricePaid?: number;
  /** 배송비 합산여부 */
  logixPricePaidSummation?: boolean;
  /** 배송비 타입 (제주, 도서산간) Enum: [MARKET-ITEM_LOGIX-PRICE-TYPE_NORMAL, MARKET-ITEM_LOGIX-PRICE-TYPE_OUTLYING-AREA, MARKET-ITEM_LOGIX-PRICE-TYPE_JEJU] */
  logixPriceType?: string;
  /** 반품 배송비 */
  logixReturnPrice?: number;
  /** 반품 배송비 (세컨솔드 보상비) */
  logixReturnPriceAclosetSupported?: number;
  /** 배송비 타입 (무료, 유료, 조건부 무료) Enum: [MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE, MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY, MARKET-ITEM_LOGIX-TYPE_FREE, MARKET-ITEM_LOGIX-TYPE_PAY, MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT] */
  logixType?: string;
  /** 배송지 우편번호 */
  logixZipCode?: string;
  /** 가격 제안 금액 */
  offerAmount?: number;
  /** 총 결제 금액(쿠폰 차감 금액) */
  paidAmount?: number;
  /** 지불 방법 (카드, 네이버페이, 카카오페이) Enum: [card, kakaopay, naverpay] */
  payMethod?: string;
  /** 환불 예정 금액 */
  refundAmount?: number;
  /** 최종 환불 */
  refundDeduction?: number;
  /** 취소 상품금액 */
  refundItemsPrice?: number;
  /** 환불 가능 여부 */
  refundable?: boolean;
  /** 반품 내역 */
  returns?: DomainAclosetOrderReturn[];
  /** 판매 금액 (할인 판매가) */
  saleAmount?: number;
  /** 세컨솔드 셀러 쿠폰 차감금액 */
  sellerCouponDeducted?: number;
  /** 프로셀러 쿠폰 할인 금액 */
  sellerCouponDiscountAmount?: number;
  /** 환불후 최종 정산 예정액 */
  sellerExpectedAmount?: number;
  /** 판매자 ID */
  sellerID?: number;
  /** 판매자 닉네임 */
  sellerNickname?: string;
  /** 총 결제 금액 (쿠폰 금액 제외) */
  totalAmount?: number;
  /** 설정 배송비 */
  txLogixPrice?: number;
}

export interface DomainAclosetOrderCancel {
  /** 취소 금액 */
  amount?: number;
  /** 취소 ID */
  id?: number;
  /** 취소 상품 */
  orderCancelItems?: DomainAclosetOrderCancelItem[];
}

export interface DomainAclosetOrderCancelItem {
  /** 주문 상품 ID */
  id?: number;
  /** 마켓 아이템 ID */
  marketItemID?: number;
  /** 가격 스냅샷 */
  marketItemPrice?: number;
  /** 썸네일 스냅샷 */
  marketItemThumbnail?: string;
  /** 타이틀 스냅샷 */
  marketItemTitle?: string;
  /** 주문 취소 ID */
  orderCancelID?: number;
  /** 주문 ID */
  orderID?: number;
  /** 취소할 상품 주문 ID */
  orderItemID?: number;
  /** 취소 사유 구분 */
  orderReason?: string;
  /** 취소 상세 사유 */
  reason?: string;
  /** 취소 귀책 사유 Enum: [BUYER, SELLER] */
  reasonType?: string;
}

export interface DomainAclosetOrderDetailResponse {
  /** 구매자 누적 주문 건수 	// 할인 거절 사유 */
  buyerAccumulatedOrderCount?: number;
  /** 구매자 누적 결제 금액 */
  buyerAccumulatedPaymentAmount?: number;
  /** 취소 사유 */
  cancelReason?: string;
  /** 취소 사유 유형 (/shops/acloset-reject-price-offer-reasons 반환값 참조) */
  cancelReasonType?: string;
  /** 취소 유형 (order, acloset-cancel-type 메타데이터 참조) */
  cancelType?: string;
  /** 할인 요청 여부 */
  isOffer?: boolean;
  /** 할인 요청 전 상품 가격 */
  itemPriceBeforeOffer?: number;
  /** 셀러 쿠폰 할인 금액 */
  sellerCouponDiscountAmount?: number;
  /** 할인 요청 전 총 결제 금액 */
  totalPaymentAmountBeforeOffer?: number;
}

export interface DomainAclosetOrderItem {
  createDate?: string;
  id?: number;
  logixCourierName?: string;
  logixTrackingNumber?: string;
  marketItemID?: number;
  marketItemPrice?: number;
  marketItemSalePrice?: number;
  marketItemThumbnail?: string;
  marketItemTitle?: string;
  offerPrice?: number;
  shippingEndDate?: string;
  status?: string;
}

export interface DomainAclosetOrderReturn {
  address?: string;
  addressDetails?: string;
  createdAt?: string;
  id?: number;
  images?: string[];
  isFirstReturn?: boolean;
  logixReturnPrice?: number;
  logixReturnPriceDeduction?: boolean;
  method?: string;
  name?: string;
  orderID?: number;
  orderReturnItems?: DomainAclosetOrderReturnItem[];
  phone?: string;
  reason?: string;
  reasonDetails?: string;
  reasonType?: string;
  /** 반품 주소가 배송 주소와 다른지 여부 */
  returnAddressIsDifferentFromShipping?: boolean;
  zipCode?: string;
}

export interface DomainAclosetOrderReturnItem {
  id?: number;
  isReturnReRequested?: boolean;
  marketItemID?: number;
  marketItemPrice?: number;
  marketItemThumbnail?: string;
  marketItemTitle?: string;
  orderID?: number;
  orderItemID?: number;
  orderReturnID?: number;
  reason?: string;
  reasonDetails?: string;
  reasonType?: string;
  status?: string;
}

export interface DomainAclosetProperty {
  /** 카테고리 */
  category?: string;
  /** 색상 */
  colors?: string[];
  /** 소재 */
  fabric?: string;
  length?: string;
  lengthOnepiece?: string;
  lengthOuter?: string;
  lengthTop?: string;
  lengths?: DomainLengthWithClothesType[];
  line?: string;
  neck?: string;
  openButton?: string;
  /** 패턴 */
  pattern?: string;
  sleeveLength?: string;
}

export interface DomainAclosetRejectPriceOfferReasonResponse {
  rejectPriceOfferReasonCode?: string;
  rejectPriceOfferReasonMessage?: string;
}

export interface DomainAclosetReturnAddressRequest {
  /** 반품 주소 상세주소 */
  additionalAddress: string;
  /** 반품 주소 도로명 주소 */
  address: string;
  /** 반품 받을 사람 */
  name: string;
  /** 반품 주소 우편번호 */
  zoneCode: string;
}

export interface DomainAclosetReviewRating {
  /** 등급 */
  grade?: string;
  /** 리뷰 평균 점수 (5점 만점에 소수점 있음) */
  rating?: number;
  /** 상위 5%의 점수 */
  top5Rating?: number;
}

export interface DomainAclosetSettlementResponse {
  /** 판매자 예금주명 */
  accountHolder: string;
  /** 판매자 계좌번호 */
  accountNumber: string;
  /** TODO Deprecated: 5.2.0 LegacyAmount */
  amount: number;
  /** 요율이 제거된 판매 금액 (!!!json tag = amountWithoutPgFee) */
  amountWithoutPgFee: number;
  /** 판매자 은행 */
  bankName: string;
  /** 구매자가 결제한 금액 */
  buyerAmount: number;
  /** 쿠폰 할인 금액 */
  couponDiscountAmount: number;
  /** 구매확정일 */
  createDate: string;
  /** 정산일 */
  endDate?: string;
  /** 첫 구매 환불 포함 여부 */
  includeFirstOrderReturn: boolean;
  isFirstOrder: boolean;
  isPriceOffered: boolean;
  marketItemThumbnail: string;
  marketItemTitle: string;
  modifyDate: string;
  /** 결제 타입. enum = [ONLINE, STORE] */
  paymentType: string;
  /** PG 수수료 */
  pgFee: number;
  /** 포인트 할인 금액 */
  pointDiscountAmount: number;
  /** 정산이 취소된다면 취소 사유 */
  reason?: string;
  /** 판매자가 정산받을 금액 */
  sellerAmount: number;
  /** 프로셀러 쿠폰 할인 금액 */
  sellerCouponDiscountAmount: number;
  /** 정산 아이디 */
  settlementID: number;
  /** 판매 상태 */
  status:
    | 'SETTLEMENT_STATUS_UNAUDITED'
    | 'SETTLEMENT_STATUS_SCHEDULED'
    | 'SETTLEMENT_STATUS_COMPLETED'
    | 'SETTLEMENT_STATUS_HOLD';
  /** 거래 아이디 */
  txID: number;
  /** 판매자 아이디 */
  userID: number;
}

export interface DomainAclosetShopDescription {
  /** 상점 키워드 (예: 클래식, 펑키) (메타데이터 proseller-info, keywords-type 참조) */
  keywords?: string[];
  /** 상점 원산지 국가 (메타데이터 proseller-info, country-type 참조) */
  originCountries?: string[];
  /** 상점이 주로 판매하는 상품 카테고리 (예: 가성비, 명품) (메타데이터 proseller-info, product-focus-type 참조) */
  productFocuses?: string[];
  /** 상점이 제공하는 서비스 (예: 세탁, 스팀살균, 빠른배송, 반품가능) (메타데이터 proseller-info, service-options 참조) */
  serviceOptions?: string[];
  /** 상점 위치 */
  storeLocations?: DomainAclosetStoreLocations;
  /** 상점 타겟 연령 (메타데이터 proseller-info, age-type 참조) */
  targetAges?: string[];
  /** 상점 타겟 성별 (메타데이터 proseller-info, gender-type 참조) */
  targetGenders?: string[];
}

export interface DomainAclosetStoreLocations {
  /** 상위 지역 (/shops/metadata/shop-regions 참조) */
  region?: string;
  /** 하위 지역 (/shops/metadata/shop-regions 참조) */
  subRegion?: string;
}

export interface DomainAclosetWebhookRequest {
  eventType?: string;
}

export interface DomainAddBlackConsumerRequest {
  /** 방해고객 등록 사유 */
  reason: string;
  /** 고객의 User ID */
  userID: string;
  /** 고객명 */
  userName: string;
}

export interface DomainAddDefaultMappingGroupMappingRequest {
  platformType?: string;
}

export interface DomainAddDefaultMappingGroupMappingsRequest {
  platformType?: string;
}

export interface DomainAdditionalField {
  fieldCheckBoxValue?: DomainCheckBox;
  /** default or custom 키 */
  fieldName?: string;
  fieldScoreValue?: DomainScore;
  fieldSelectValue?: DomainSelect;
  id?: string;
  /** "select", "checkbox", "score" */
  inputType?: string;
  /** TODO 사장님들 순서 변경을 원할 때 추가 필요 */
  order?: number;
  shopID?: string;
}

export interface DomainAfterServiceInfo {
  /** A/S 안내 */
  afterServiceGuideContent?: string;
  /** A/S 전화번호 */
  afterServiceTelephoneNumber?: string;
}

export interface DomainAliasDetailRequest {
  /**
   * 언어별 별칭 사용 여부
   * @example true
   */
  enable: boolean;
  /**
   * 언어별 별칭
   * @example "화이트"
   */
  value: string;
}

export interface DomainAliasDetailResponse {
  /**
   * 언어별 별칭 사용 여부
   * @example true
   */
  enable: boolean;
  /**
   * 언어별 별칭
   * @example "화이트"
   */
  value: string;
}

export interface DomainAliasRequest {
  /** 영문명 별칭 */
  en?: DomainAliasDetailRequest;
  /** 한국명 별칭 */
  ko?: DomainAliasDetailRequest;
}

export interface DomainAliasResponse {
  /** 영문명 별칭 */
  en?: DomainAliasDetailResponse;
  /** 한국명 별칭 */
  ko?: DomainAliasDetailResponse;
}

export interface DomainAnalyzeShopTaskItemRequest {
  retry?: boolean;
}

export interface DomainAppVersionResponse {
  android?: string;
  ios?: string;
  web?: string;
}

export interface DomainApproveCancelOrdersRequest {
  /**
   * 주문 취소 후 상품의 플랫폼 상태
   * @default "SALE_PLATFORM-STATUS_ON-SALE"
   */
  afterPlatformStatus: 'SALE_PLATFORM-STATUS_ON-SALE' | 'SALE_PLATFORM-STATUS_STOP-SALE';
  /** 환불 은행 계좌 (⚠️ 주문 플랫폼: 카페24, order.paymentMethods.code == "cash"(무통장입금)에만 해당 필드를 요구) */
  bankAccountNumber?: string;
  /** 환불 은행 예금주 (⚠️ 주문 플랫폼: 카페24, order.paymentMethods.code == "cash"(무통장입금)에만해당 필드를 요구) */
  bankAccountOwner?: string;
  /** 환불 은행 코드 (⚠️ 주문 플랫폼: 카페24, order.paymentMethods.code == "cash"(무통장입금)에만 해당 필드를 요구, platform 도메인의 카페 24 은행 코드 참조) */
  bankCode?: string;
  /** 취소 사유 코드 (⚠️주문 플랫폼: 카페24, 취소 사유 코드는 platform의 취소 사유 조회를 추가) */
  cancelReasonCode?: string;
  /** 주문의 결제 수단이 카카오페이인 경우 취소 사유 코드 (⚠️ 주문 플랫폼: 카페24, platform 도메인의 카카오페이 취소 사유 코드 참조) */
  kakaopayCancelReasonCode?: string;
  /** 주문의 결제 수단이 네이버페이인 경우 취소 사유 코드 (⚠️ 주문 플랫폼: 카페24, platform 도메인의 네이버페이 취소 사유 코드 참조) */
  naverpayCancelReasonCode?: string;
  /** 주문 취소 승인 할  OrderIDs 리스트 (⚠️ 카페24의 경우 단건만 가능) */
  orderIDs: string[];
}

export interface DomainAutoCreateAccountRequest {
  /**
   * 번장 플랫폼에서 생성할 경우 번장 Shop ID를 전달받습니다.
   * @example "1234567890"
   */
  bunjangShopID?: string;
  /** @example "SHOP_PLATFORM-TYPE_BUNJANG" */
  platformType: string;
}

export interface DomainAutoLiquifyImageRequest {
  /** 의류 종류 */
  clothType: string;
  /** 이미지 URL */
  imageURL: string;
  /** 키포인트 */
  keypoints: DomainKeyPoint[];
  /** 마스크 URL */
  maskURL?: string;
}

export interface DomainAutoLiquifyImageResponse {
  /** base64 encoded image */
  image?: string;
  /** base64 encoded image (mask) */
  mask?: string;
}

export interface DomainAvailableFeatureResponse {
  /**
   * 코드 (메타데이터 plan, action 참고)
   * @example "PLAN_ACTION_REMOVE-BACKGROUND"
   */
  code?: string;
  /**
   * 상세설명 (셀 안에 설명이 존재 할 경우, 체크의 경우 빈 문자열)
   * @example "세컨솔드 + 1곳"
   */
  detail?: string;
  /**
   * 개수제한 (0이면 무제한)
   * @example 50
   */
  limit?: number;
  /**
   * 설명
   * @example "배경제거 기능"
   */
  name?: string;
}

export interface DomainBackgroundModel {
  base64_mask?: string;
  crop_info?: DomainCropBoxProperty;
  version?: string;
}

export interface DomainBlackConsumerResponse {
  /** 기본키 */
  blackConsumerID?: string;
  /** 등록 일자 */
  createdAt?: string;
  /** 등록 사유 */
  reason?: string;
  /** 설정한 샵 ID */
  shopID?: string;
  /** 고객의 User ID */
  userID?: string;
  /** 고객명 */
  userName?: string;
}

export interface DomainBulletPointSetting {
  /** 글머리를 사용할까요? */
  enabled: boolean;
  /** 글머리 타입이 'AI-DESCRIPTION_BULLET-POINT-TYPE_CUSTOM'일 때 글머리 텍스트 */
  text?: string;
  /** 글머리로 어떤 특수문자를 사용할까요? (ai-description, bullet-point 메타데이터 참조) */
  type: string;
}

export interface DomainBunjangAccountSettingRequest {
  /** 메타데이터 bunjang, account-setting-type 참조 */
  accountSettingType?: string;
  /** 활성화 여부 */
  enable?: boolean;
}

export interface DomainBunjangAccountSettingResponse {
  /** 메타데이터 bunjang, account-setting-type 참조 */
  accountSettingType?: string;
  /** 활성화 여부 */
  enable?: boolean;
}

export interface DomainBunjangCustomerHistoryResponse {
  date?: string;
  description?: string;
  summary?: string;
}

export interface DomainBunjangItemLoadSetting {
  /** 디폴트 성별 설정 */
  defaultGender?: string;
  /** 활성화여부 */
  enable?: boolean;
  /** 최초 동기화 기간 */
  loadDuration?: string;
  /** 대체 문구 리스트 */
  replaceTexts?: DomainReplaceText[];
}

export interface DomainBunjangProductResponse {
  /** 이미지 경로 */
  imageURL?: string;
  /** 가격 */
  price?: number;
  /** 상품명 */
  productName?: string;
}

export interface DomainBunjangShopLoadTaskResponse {
  /** 생성일 */
  createDate: string;
  /** 현재 진행중인 번호 */
  currentIndex: number;
  /** 현재 진행중인 페이지 */
  currentPage: number;
  /** 완료 날짜 */
  doneDate?: string;
  /** 완료된 샵 개수 */
  doneShopCount: number;
  /** 제외 샵 개수 */
  excludeShopCount: number;
  /** 실패한 샵 개수 */
  failedShopCount: number;
  /** 최초 시도 날짜 */
  firstTryDate?: string;
  /** 작업 ID */
  id: string;
  /** 마지막 시도 날짜 */
  lastTryDate?: string;
  /** 불러올 샵 개수 */
  loadShopCount: number;
  /** 검색 키워드 */
  searchKeyword: string;
  /** 검색 타입 */
  searchType: string;
  /** 불러오기 상태 */
  status: string;
  /** 전체 샵 개수 */
  totalShopCount: number;
}

export interface DomainBunjangShopOrderResponse {
  cancelOrderCount?: number;
  firstOrderCancelDate?: string;
  firstOrderCreateDate?: string;
  orderCount?: number;
  orderCreated?: boolean;
}

export interface DomainBunjangShopResponse {
  /** 계정 생성 여부 */
  accountCreated?: boolean;
  /** 계정 설정 */
  accountSettings?: DomainBunjangAccountSettingResponse[];
  /** 불러오기 여부 */
  bunjangItemLoaded?: boolean;
  /** 사업자 전화번호 */
  businessMobile?: string;
  /** 회사 법인명 */
  businessName?: string;
  /** 영업상태 (bunjang, business-status 메타데이터 참조) */
  businessStatus?: string;
  /** 생성 날짜 */
  createDate?: string;
  customerHistories?: DomainBunjangCustomerHistoryResponse[];
  /** 상점소개 */
  description?: string;
  /** 팔로워수 */
  followerCount?: number;
  /** 기본키 */
  id?: string;
  /** 카카오톡 상태 (bunjang, kakaotalk-status 메타데이터 참조) */
  kakaotalkStatus?: string;
  /** 메모 */
  memo?: string;
  /** 수정 날짜 */
  modifyDate?: string;
  /** 상품 오픈일 */
  openDate?: string;
  /** 주문 관리 */
  order?: DomainBunjangShopOrderResponse;
  /** 대표명 */
  ownerName?: string;
  /** 번장 플랫폼 ID */
  platformShopID?: string;
  /** 최근 상품 5개 */
  products?: DomainBunjangProductResponse[];
  /** 프로필 이미지 */
  profileImageUrl?: string;
  /** 별점 */
  rating?: number;
  /** 최근 상품 등록일 */
  recentUploadDate?: string;
  /** 판매 상품수 */
  saleProductCount?: number;
  /** 샵 ID */
  shopID?: string;
  /** 상점명 */
  shopName?: string;
  /** 샵 상태 (bunjang, status 메타데이터 참조) */
  status?: string;
  /** 상품수 */
  totalProductCount?: number;
  /** 상점 방문수 */
  visitCount?: number;
}

export interface DomainCafe24AdditionalOption {
  /** 추가입력옵션명 */
  additionalOptionName?: string;
  /** 추가입력옵션 길이제한 */
  additionalOptionTextLength?: number;
  /** 추가입력옵션 필수 여부 (Default: T) */
  requiredAdditionalOption?: string;
}

export interface DomainCafe24AttachedFileOption {
  /** 파일첨부옵션명 */
  optionName?: string;
  /** 파일첨부옵션 필수 여부 (T, F) */
  required?: string;
  /** 파일첨부옵션 파일 길이 제한(개수 제한) */
  sizeLimit?: number;
}

export interface DomainCafe24ItemLoadSetting {
  /** 블랙리스트 URL 리스트 */
  blackListURLs?: string[];
  /** 통합 이미지 잘라서 버릴 하단 길이 */
  bottomCropLength?: number;
  /** 디폴트 성별 설정 */
  defaultGender?: string;
  /** 상품설명 소스 설정 */
  descriptionSources?: string[];
  /** 활성화여부 */
  enable?: boolean;
  /** 이미지 자르기 활성화 여부 */
  enableImageCutting?: boolean;
  /** 성별 추출어 설정 */
  genderKeywords?: DomainGenderKeywords;
  /** 이미지 자르기 기준값 (기본값 20) */
  imageCuttingThreshold?: number;
  /** 추가할 이미지 소스 설정 */
  imageSources?: string[];
  /** 최초 동기화 기간 */
  loadDuration?: string;
  /** 대체 문구 리스트 */
  replaceTexts?: DomainReplaceText[];
  /** 통합 이미지 잘라서 버릴 상단 길이 */
  topCropLength?: number;
}

export interface DomainCafe24Option {
  /** 옵션 표시방식 (S: 셀렉트박스, P: 미리보기, B: 텍스트버튼, R: 라디오버튼) */
  optionDisplayType?: string;
  /** 옵션명 */
  optionName?: string;
  /** 옵션값 */
  optionValue?: DomainCafe24OptionValue[];
}

export interface DomainCafe24OptionValue {
  /** 컬러칩 색상 (#FFFFFF) */
  optionColor?: string;
  /** 옵션 버튼 이미지 */
  optionImageFile?: string;
  /** 옵션값 */
  optionText?: string;
}

export interface DomainCafe24ProductConditionResponse {
  code?: string;
  name?: string;
}

export interface DomainCafe24WebhookRequest {
  event_no?: number;
}

export interface DomainCancelBunjangProductsRequest {
  /** lookoai 샵 ID */
  shopID: string;
}

export interface DomainCancelOrderRate {
  /** 등급 (A, B, C, D, E) */
  grade?: string;
  /** 주문취소 비율 (0-100 범위) */
  rating?: number;
  /** 상위 5%의 점수 */
  top5Rating?: number;
}

export interface DomainCancelOrderRequest {
  /**
   * 주문 취소 후 상품의 플랫폼 상태
   * @default "SALE_PLATFORM-STATUS_ON-SALE"
   */
  afterPlatformStatus: 'SALE_PLATFORM-STATUS_ON-SALE' | 'SALE_PLATFORM-STATUS_STOP-SALE';
  /** 환불 은행 계좌 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만 해당 필드를 요구) */
  bankAccountNumber?: string;
  /** 환불 은행 예금주 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만해당 필드를 요구) */
  bankAccountOwner?: string;
  /** 환불 은행 코드 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만 해당 필드를 요구, platform 도메인의 카페 24 은행 코드 참조) */
  bankCode?: string;
  /** 취소 사유 (⚠️ 주문 플랫폼: 세컨솔드) */
  cancelReason?: string;
  /** 취소 사유 코드 (⚠️ 세컨솔드 제외. 취소 사유 코드는 platform의 취소 사유 조회를 추가) */
  cancelReasonCode?: string;
  /** 주문의 결제 수단이 카카오페이인 경우 취소 사유 코드 (platform 도메인의 카카오페이 취소 사유 코드 참조) */
  kakaopayCancelReasonCode?: string;
  /** 주문의 결제 수단이 네이버페이인 경우 취소 사유 코드 (platform 도메인의 네이버페이 취소 사유 코드 참조) */
  naverpayCancelReasonCode?: string;
}

export interface DomainCancelOrdersRequest {
  /**
   * 주문 취소 후 상품의 플랫폼 상태
   * @default "SALE_PLATFORM-STATUS_ON-SALE"
   */
  afterPlatformStatus: 'SALE_PLATFORM-STATUS_ON-SALE' | 'SALE_PLATFORM-STATUS_STOP-SALE';
  /** 취소 사유 (⚠️ 주문 플랫폼: 세컨솔드) */
  cancelReason?: string;
  /** 주문 취소 할 OrderID */
  orderIDs?: string[];
}

export interface DomainCategoryAliasRequest {
  /** 별칭 */
  alias: DomainAliasRequest;
  /** 코드 */
  code: string;
}

export interface DomainCategoryAliasResponse {
  /** 별칭 */
  alias: DomainAliasResponse;
  /** 코드, 예: COAT */
  code: string;
  /** 영문명 */
  en: string;
  /** 카테고리의 그룹 코드, 예: OUTERWEAR */
  groupCategoryCode: string;
  /** 카테고리의 그룹의 한국명, 예: 아우터 */
  groupCategoryName: string;
  /** 한국명 */
  ko: string;
}

export interface DomainCategorySizeType {
  /** AIMS 카테고리 */
  aimsCategory: string;
  /** 치수 타입(상의/아우터, 치마 등) */
  clothesSizeType: string;
}

export interface DomainCheckAllShopQueueConsumedResponse {
  consumed?: boolean;
}

export interface DomainCheckBox {
  fieldValues?: DomainFieldValue[];
}

export interface DomainClaimCountResponse {
  claimStatus?: string;
  count?: number;
}

export interface DomainClaimDeliveryInfo {
  /** 교환 배송비 */
  exchangeDeliveryFee?: number;
  /** 반품 배송비 */
  returnDeliveryFee?: number;
}

export interface DomainClaimPlatformErrorResponse {
  /** 에러코드 */
  code?: string;
  /** 에러상세메세지 */
  detailMessage?: string;
  /** 에러메세지 */
  message?: string;
  /** 수정일시 */
  modifyDate?: string;
}

export interface DomainClaimResponse {
  /** 세컨솔드 클레임 상세 */
  acloset?: DomainAclosetClaimDetailResponse;
  /**
   * 환불 은행 계좌 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만 해당 필드를 요구)
   * @example "110-336-822083"
   */
  bankAccountNumber?: string;
  /**
   * 환불 은행 예금주 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만해당 필드를 요구)
   * @example "김아무개"
   */
  bankAccountOwner?: string;
  /**
   * 환불 은행 코드 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만 해당 필드를 요구, platform 도메인의 카페 24 은행 코드 참조)
   * @example "bank_02"
   */
  bankCode?: string;
  /**
   * 환불 은행 이름 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만 해당 필드를 요구, platform 도메인의 카페 24 은행 코드 참조)
   * @example "국민은행"
   */
  bankName?: string;
  /**
   * 구매자 ID
   * @example "lookocopr"
   */
  buyerID?: string;
  /** 방해고객 여부 */
  buyerIsBlackConsumer: boolean;
  /**
   * 구매자 이름
   * @example "김아무개"
   */
  buyerName?: string;
  /**
   * 구매자 전화번호 (하이픈 없이)
   * @example "01000001234"
   */
  buyerPhone?: string;
  /**
   * 구매자 회원 ID
   * @example "1234"
   */
  buyerUserID?: string;
  /**
   * 클레임 ID (자체)
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  claimID?: string;
  /**
   * 클레임 처리 상태 (metadata claim, operation 참조)
   * @example "CLAIM_OPERATION_IDLE"
   */
  claimOperation?: string;
  /**
   * 구매자 클레임 사유
   * @example "물건 바꿔주세요"
   */
  claimReason?: string;
  /**
   * 구매자 클레임 타입 (GET /shops/platform-request-return-reasons 참조)
   * @example "A"
   */
  claimReasonType?: string;
  /**
   * 클레임 상태 (metadata claim, return-status 참조)
   * @example "CLAIM_RETURN-STATUS_REQUEST"
   */
  claimStatus?: string;
  /**
   * 클레임 타입 (metadata claim, type 참조)
   * @example "CLAIM_TYPE_RETURN"
   */
  claimType?: string;
  /**
   * 간편결제 타입 (메타데이터 sale, easy-payment 참조)
   * @example "SALE_EASY-PAYMENT_NAVERPAY"
   */
  easyPayment?: string;
  /**
   * 교환완료일
   * @example "2023-08-08T05:25:32.992Z"
   */
  exchangeDoneDate?: string;
  /**
   * 교환요청일
   * @example "2023-08-08T05:25:32.992Z"
   */
  exchangeRequestDate?: string;
  /**
   * 송장번호
   * @example "123456789012"
   */
  invoiceNumber?: string;
  /**
   * 반품 재신청 여부
   * @example true
   */
  isReturnReRequested?: boolean;
  /**
   * 상품코드
   * @example "A000123"
   */
  itemCode?: string;
  /**
   * 상품가격
   * @example 50000
   */
  itemPrice?: number;
  /**
   * 상품 썸네일 URL
   * @example "https://acloset-kr-s3.s3.amazonaws.com/shops/6426a9c.jpg"
   */
  itemThumbnailURL?: string;
  /**
   * 상품명
   * @example "밝은 색상 청바지"
   */
  itemTitle?: string;
  /**
   * 주문 ID (자체)
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  orderID?: string;
  /**
   * 주문일
   * @example "2023-08-08T05:25:32.992Z"
   */
  orderRequestDate?: string;
  /** 주문 상태(메타데이터 order, status 참조) */
  orderStatus?: string;
  /** 결제수단 목록 */
  paymentMethods?: DomainPaymentMethodResponse[];
  /**
   * 결제금액
   * @example 50000
   */
  paymentPrice?: number;
  /**
   * 플랫폼 클레임 ID
   * @example "12738273"
   */
  platformClaimID?: string;
  /**
   * 플랫폼 클레임 상태코드 (플랫폼별 실제 데이터)
   * @example "R00"
   */
  platformClaimStatusCode?: string;
  /**
   * 플랫폼 클레임 상태이름 (플랫폼별 실제 데이터)
   * @example "반품대기"
   */
  platformClaimStatusName?: string;
  /** 플랫폼 에러 */
  platformError?: DomainClaimPlatformErrorResponse;
  /**
   * 플랫폼 주문 ID
   * @example "12738273"
   */
  platformOrderID?: string;
  /**
   * 플랫폼 상품주문 ID
   * @example "12738273"
   */
  platformProductOrderID?: string;
  /**
   * 플랫폼 타입 (shop, platform-type 참조)
   * @example "SHOP_PLATFORM-TYPE_CAFE24"
   */
  platformType?: string;
  /** 수취인 주소 */
  receiverAddress?: DomainReceiverAddressResponse;
  /**
   * 수취인 이름
   * @example "이아무개"
   */
  receiverName?: string;
  /**
   * 수취인 전화번호
   * @example "123456789012"
   */
  receiverPhone?: string;
  /**
   * 반품 주소가 배송 주소와 다른지 여부
   * @example true
   */
  returnAddressIsDifferentFromShipping: boolean;
  /**
   * 반품완료일
   * @example "2023-08-08T05:25:32.992Z"
   */
  returnDoneDate?: string;
  /**
   * 반품 송장번호
   * @example "127389127931"
   */
  returnInvoiceNumber?: string;
  /**
   * 반품요청일
   * @example "2023-08-08T05:25:32.992Z"
   */
  returnRequestDate?: string;
  /**
   * 반품 택배사 코드
   * @example "CJGLS"
   */
  returnShippingCompanyCode?: string;
  /**
   * 반품 택배사 이름
   * @example "대한통운"
   */
  returnShippingCompanyName?: string;
  /**
   * 배송사 코드
   * @example "CJGLS"
   */
  shippingCompanyCode?: string;
  /**
   * 배송사 이름
   * @example "대한통운"
   */
  shippingCompanyName?: string;
  /**
   * 배송비
   * @example 3000
   */
  shippingFee?: number;
  /**
   * 배송메세지
   * @example "배송메세지"
   */
  shippingMessage?: string;
  /** 공급사 */
  supplier?: DomainShopSupplierResponse;
}

export interface DomainClassifyImageTypesRequest {
  imageURLs: string[];
}

export interface DomainClassifyImageTypesResponse {
  imageTypes?: DomainImageTypeResponse[];
}

export interface DomainColorAliasRequest {
  /** 별칭 */
  alias: DomainAliasRequest;
  /** 코드 */
  code: string;
}

export interface DomainColorAliasResponse {
  /** 별칭 */
  alias: DomainAliasResponse;
  /** 코드 */
  code: string;
  /** 영문명 */
  en: string;
  /** 한국명 */
  ko: string;
}

export interface DomainConfirmLabelingItemRequest {
  /** 수정할 세컨솔드 성별 */
  aclosetGenderWear?: string;
  /** 수정할 AIMS 브랜드 ID */
  aimsBrandID?: string;
  /** 브랜드 */
  brand?: string;
  /** 수정할 카테고리 */
  category?: string;
  /** 수정할 색상 */
  colors?: string[];
  /** 라벨링 아이템 ID */
  id: string;
  /** 아이템이 속한 샵 ID */
  shopID: string;
}

export interface DomainConfirmLabelingRequest {
  /** 라벨링 아이템 리스트 */
  items: DomainConfirmLabelingItemRequest[];
  /** 확인완료 처리할 라벨링 타입 리스트 (labeling, type 메타데이터 참조) */
  types: string[];
}

export interface DomainConfirmOrderShippingsRequest {
  /** 배송 확인 할  OrderIDs 리스트 */
  orderIDs?: string[];
}

export interface DomainConfirmOrderShippingsResponse {
  /** 작업 ID (실 사용 예 없음) */
  saleTaskID?: string;
}

export interface DomainConfirmOrdersRequest {
  /** 주문 확인 할  OrderIDs 리스트 */
  orderIDs?: string[];
}

export interface DomainConfirmOrdersResponse {
  /** 작업 ID (실 사용 예 없음) */
  saleTaskID?: string;
}

export interface DomainConnectPlatformRequest {
  /**
   * 플랫폼 타입 (메타데이터 platform, type 참조)
   * @example "SHOP_PLATFORM-TYPE_CAFE24"
   */
  platformType: string;
}

export interface DomainCountAclosetNotificationsResponse {
  count?: number;
}

export interface DomainCountPendingModifyingResponse {
  /** 수정 대기중인 아이템 수 */
  count?: number;
}

export interface DomainCountShopNotificationsResponse {
  count?: number;
}

export interface DomainCreateAclosetCouponRequest {
  /** 재발급 가능 여부 */
  allowReIssue: boolean;
  /** 쿠폰 발급 고객(컨디션) 설정 */
  conditionType: string;
  /** 쿠폰 발급 고객 조건값 */
  conditionValue?: number;
  /** 쿠폰 타입 */
  couponCalcType: string;
  /** 쿠폰 이름 */
  couponName: string;
  /** 쿠폰 발급 한도 */
  couponUsageMax: number;
  /** 할인 금액(할인율) */
  discountAmount: number;
  /** 최대 할인 가능 금액 */
  discountAmountMax: number;
  /** 쿠폰 발급 가능 기간 (To) */
  eventEndDate: string;
  /** 쿠폰 발급 가능 기간 (From) */
  eventStartDate: string;
  /** 쿠폰 발급 후 사용 기간 */
  expirationDuration: number;
  /** 쿠폰 발급 한도 제한 여부 */
  hasIssueLimit: boolean;
  /** 최소 결제 금액 */
  txAmountMin: number;
}

export interface DomainCreateAclosetStoreCouponRequest {
  /** 쿠폰 이름 */
  couponName: string;
  /** 할인 금액 */
  discountAmount: number;
  /** 파트너 샵 ID */
  partnerShopInfoID: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
}

export interface DomainCreateAclosetSupplierRequest {
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeShippingThreshold: number;
  /** CS 담당 연락처 */
  inquiryContact: string;
  /** 공급사명(지점명) 노출 여부 */
  isVisible: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea: boolean;
  /** 공급사명(지점명) */
  logixName: string;
  /** 배송 정책 */
  logixPolicy?: string;
  /** 배송 타입 */
  logixPriceType: string;
  /** 배송비 */
  orderLogixPrice: DomainMarketItemLogixPrice;
  /** 최대 구매 수량 */
  purchaseQuantityLimit: number;
  /** 반품 주소 */
  returnAddress: DomainShopAclosetAddress;
  /** 택배사 */
  returnLogixName: string;
  /** 반품 배송비 */
  returnLogixPrice: DomainMarketItemLogixPrice;
  /** 반품 정책 */
  returnPolicyDescription: string;
  /** 수거 방법 */
  returnPolicyType: string;
}

export interface DomainCreateAclosetSupplierResponse {
  /** 배송정보 ID */
  logixID?: number;
}

export interface DomainCreateBunjangShopRequest {
  /** 번개장터 플랫폼 샵 ID */
  platformShopID: string;
  /** 번개장터 샵 ID */
  shopID: string;
}

export interface DomainCreateExcelTemplateRequest {
  /** 직접 입력 항목 */
  customFields?: DomainExcelTemplateCustomFieldRequest[];
  /** 엑셀 포멧 확장자 (메타데이터 template, extension 참조) */
  extension: string;
  /** 선택 항목 */
  fields: DomainExcelTemplateFieldRequest[];
  /** 기본 템플릿 여부 */
  isDefault: boolean;
  /** 택배사 코드 (운송장 엑셀일 경우 필수) */
  shippingCompanyCode?: string;
  /** 정렬 순서 */
  sorts?: DomainExcelTemplateSortRequest[];
  /** 템플릿 이름 */
  templateName: string;
  /** 템플릿 타입 (메타데이터 template, type 참조) */
  templateType: string;
  /** 상품명에 HTML 태그 제거 여부 */
  withoutHTMLTag?: boolean;
}

export interface DomainCreateMappingGroupMappingRequest {
  /** 브랜드 그룹 ID (null인 경우 브랜드 그룹이 없는 매핑) */
  brandGroupIDs?: string[];
  /** 소재 매핑 */
  fabrics?: string[];
  /** 메타데이터 (mapping-group, mapping-type 참고) */
  mappingType: string;
  /** 생성할 매핑의 이름 (ex. Premium, Polo ...) */
  name: string;
  /** 메타데이터 (shop, platform-type 참고) */
  platformType: string;
  /** 생성할 매핑의 규칙들 */
  rules: DomainMappingGroupMappingRuleRequest[];
}

export interface DomainCreateMappingGroupRequest {
  /** 메타데이터 (성인 남성, 성인 여성 ...) (mapping-group, type 참고) */
  type?: string;
}

export interface DomainCreateMappingGroupResponse {
  mappingGroupID?: string;
}

export interface DomainCreatePaymentCardRequest {
  /**
   * 카드명
   * @example "신한카드"
   */
  cardName: string;
  /**
   * 카드번호
   * @example "5594-1000-2893-1290"
   */
  cardNumber: string;
  /**
   * 고객 ID
   * @example "84f57e64-6e7b-11ee-b962-0242ac120003"
   */
  customerUID: string;
  /**
   * 이메일
   * @example "penguin@acloset.app"
   */
  email: string;
  /**
   * 상품구매ID
   * @example "84f57e64-6e7b-11ee-b962-0242ac120002"
   */
  merchantUID: string;
}

export interface DomainCreatePopupRequest {
  /** 액션 버튼 이름 */
  actionButtonName: string;
  /** 앱 버젼 */
  appVersion: string;
  /** 설명 */
  description: string;
  /** 액션 버튼 활성화 유무 */
  hasActionButton: boolean;
  /** 팝업 이미지 이름 */
  imageName: string;
  /** 팝업 이미지 URL */
  imageURL: string;
  /** 팝업 대상 */
  popupTargets: string[];
  /** 팝업 URL */
  popupURL: string;
  /** 제목 */
  title: string;
}

export interface DomainCreateShopAdditionalField {
  fieldCheckBoxValue?: DomainCheckBox;
  /** default or custom 키 */
  fieldName?: string;
  fieldScoreValue?: DomainScore;
  fieldSelectValue?: DomainSelect;
  /** "select", "checkBox", "radio" */
  inputType?: string;
  /** 정렬 순서 */
  order?: number;
}

export interface DomainCreateShopAdditionalFieldsRequest {
  CreateShopAdditionalFields?: DomainCreateShopAdditionalField[];
}

export interface DomainCreateShopAuthRequest {
  /** @example "SHOP_PLATFORM-TYPE_CAFE24" */
  platformType: string;
}

export interface DomainCreateShopBrandGroupRequest {
  /** 그룹이름 */
  groupName?: string;
}

export interface DomainCreateShopBrandGroupResponse {
  /** 브랜드 그룹 ID */
  groupID?: string;
}

export interface DomainCreateShopBrandRequest {
  /**
   * 브랜드 이미지 name
   * @example "세컨솔드"
   */
  brandImageName?: string;
  /**
   * 브랜드 이미지 URL
   * @example "https://image.com"
   */
  brandImageURL?: string;
  /**
   * 브랜드 소개 문구
   * @example "브랜드의 소개문구"
   */
  content?: string;
  /**
   * 영문 브랜드이름
   * @example "NIKE"
   */
  englishName: string;
  /**
   * 그룹ID 리스트
   * @example ["63eb6df3f45b6fc2c1045aff"]
   */
  groupIDs?: string[];
  /** 검색 키워드 */
  keywords?: string[];
  /**
   * 한글 브랜드이름
   * @example "나이키"
   */
  koreanName?: string;
  /**
   * 가격 브랜드 그룹 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  priceBrandGroupID?: string;
}

export interface DomainCreateShopBusinessRequest {
  /** 사업장 주소 */
  address: string;
  /** 사업자 이메일 */
  businessEmail: string;
  /** 사업자 전화번호 */
  businessMobile: string;
  /** 회사명 */
  businessName?: string;
  /** 사업자 등록증 파일명 */
  businessRegistrationFileName?: string;
  /** 사업자 등록증 파일 URL */
  businessRegistrationFileURL?: string;
  /** 사업자 등록번호 */
  businessRegistrationNumber?: string;
  /** 업태/업종 (별도의 메타데이터 존재하지 않음) */
  businessType?: string;
  /** 오너 전화번호 */
  ownerMobile: string;
  /** 대표명 */
  ownerName: string;
  /** 사업자 유형 (별도의 메타데이터 존재하지 않음) */
  ownerType?: string;
}

export interface DomainCreateShopCafe24AuthRequest {
  accessToken: string;
  apiKey?: string;
  /** QA 테스트 시 사용하는 필드 */
  clientID?: string;
  clientSecret?: string;
  expiresAt: string;
  mallID: string;
  refreshToken: string;
  refreshTokenExpiresAt: string;
}

export interface DomainCreateShopCouponsRequest {
  /**
   * 쿠폰의 적용 기간 (발급 일수)
   * @example 14
   */
  applyPeriod: number;
  /**
   * 쿠폰의 자동 만료 날짜
   * @example "2023.11.09"
   */
  expireDate: string;
  /** 쿠폰 이름 */
  name?: string;
  /**
   * 쿠폰이 부여될 샵 ID들
   * @example ["63eb6df3f45b6fc2c1045aff"]
   */
  shopIDs: string[];
}

export interface DomainCreateShopCouponsResponse {
  /** 생성된 쿠폰의 아이디 */
  couponIDs: string[];
}

export interface DomainCreateShopCreditRequest {
  /**
   * 금액
   * @example 10000
   */
  amount: number;
  /**
   * 내용
   * @example "content"
   */
  content: string;
  /**
   * 사유
   * @example "reason"
   */
  reason?: string;
  /**
   * 샵 ID
   * @example "65378b60f9505804b23cdaf6"
   */
  shopID: string;
  type: 'CREDIT_TYPE_ISSUED' | 'CREDIT_TYPE_DEDUCTED';
}

export interface DomainCreateShopCreditsRequest {
  shopCredits: DomainCreateShopCreditRequest[];
}

export interface DomainCreateShopHTMLTemplateRequest {
  domTreeJSON: string;
  htmlTemplate: string;
  mappingGroupType: string;
  plainTemplate: string;
  templateType: string;
}

export interface DomainCreateShopPreSignedURLsRequest {
  /** URL 만료 레벨 (1d=1일) */
  expireLevel?: string;
  /** 서명을 위한 URL 정보 */
  preSignedURLs?: DomainShopPreSignedURLsRequest[];
  /** 임시 버킷 사용 여부 */
  useTempBucket?: boolean;
}

export interface DomainCreateShopPreSignedURLsResponse {
  /** 서명을 위한 URL 정보 */
  preSignedURLs?: string[];
}

export interface DomainCreateShopPriceBrandGroupRequest {
  /**
   * 브랜드 ID 리스트
   * @example ["5f9f1b5b9b9b9b9b9b9b9b9b"]
   */
  brandIDs?: string[];
  name?: string;
}

export interface DomainCreateShopPriceBrandGroupResponse {
  priceBrandGroupID?: string;
}

export interface DomainCreateShopRequest {
  /** 세컨솔드 샵 정보 */
  acloset: DomainShopAclosetStaticRequest;
  /** 번개장터 샵 정보 */
  bunjang: DomainShopBunjangStaticRequest;
  /**
   * 입점 쇼핑몰 리스트 (메타 데이터 platform-type 참조)
   * @example ["SHOP_PLATFORM-TYPE_CAFE24","SHOP_PLATFORM-TYPE_NAVER-SMART-STORE"]
   */
  connectedPlatformTypes: string[];
  /**
   * 디테일 이미지 타입
   * @example ["SHOP_IMAGE-TYPE_FRONT"]
   */
  detailImageTypes: string[];
  /**
   * 샵을 생성할 유저 ID
   * @example 1033422
   */
  ownerID: number;
  /** 플레이오토 샵 정보 */
  playAuto: DomainShopPlayAutoStaticRequest;
  /**
   * 자주 사용하는 가격
   * @example [1000,4000]
   */
  pricePresets: number[];
  /**
   * 샵 이름
   * @example "스토어 쟈넬"
   */
  shopName: string;
  /** 자동 생성 제목 포멧 */
  titleTemplate: string;
}

export interface DomainCreateShopResponse {
  /**
   * 샵 ID
   * @example "63ec5ccff19921e0414902b7"
   */
  shopID: string;
}

export interface DomainCreateShopTaskItemRequest {
  /** 이미지 파일 */
  images: DomainShopTaskItemImageRequest[];
}

export interface DomainCreateShopTaskItemResponse {
  /** @example "63eb6df3" */
  shopTaskItemID: string;
}

export interface DomainCreateShopTaskRequest {
  /**
   * AI 분석 목록 (메타 데이터 참조)
   * @example ["SHOP_AI-ANALYSIS_SIZE"]
   */
  aiAnalyses: string[];
  /**
   * AI 정밀도
   * @example "SHOP_AI-PRECISION_SIMPLE-ANALYSIS"
   */
  aiPrecision: string;
  /** 의류 구분 상품별 선택시, 아이템에 디폴트로 들어가는 값 */
  defaultMappingGroupID?: string;
  /** 후면 이미지 배경제거 적용 */
  enableRemoveBackgroundBack: boolean;
  /** 정면 이미지 배경제거 적용 */
  enableRemoveBackgroundFront: boolean;
  /** FIXME 앱 하위호환을 위해 optional로 변경 */
  imageCropOption?: DomainShopImageCropOptionRequest;
  /** FIXME 앱 하위호환을 위해 optional로 변경 */
  imageRatioOption?: DomainShopImageRatioOptionRequest;
  /** 상품코드 규칙 설정 */
  itemCodeRule: DomainShopTaskItemCodeRuleRequest;
  /**
   * 상품코드 영문 코드 (Deprecated)
   * @example "PM"
   */
  itemLetterCode?: string;
  /**
   * 의류 구분(맵핑 그룹 아이디)
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  mappingGroupID?: string;
  /** @example "샵구찌" */
  shopName: string;
  /** 공급사 설정 */
  supplier?: DomainShopSupplierRequest;
  /**
   * 작업명
   * @example "20220103"
   */
  taskName: string;
}

export interface DomainCreateShopTaskResponse {
  /** @example "63eb6df3" */
  shopTaskID: string;
}

export interface DomainCropBoxProperty {
  /** @example 960 */
  bottom: number;
  /** @example 0 */
  left: number;
  /** @example 1080 */
  right: number;
  /** @example 0 */
  top: number;
}

export interface DomainCropBoxRequest {
  bottom?: number;
  left?: number;
  right?: number;
  top?: number;
}

export interface DomainCropBoxResponse {
  bottom?: number;
  left?: number;
  right?: number;
  top?: number;
}

export interface DomainCustomAttributeRequest {
  /** 영어 */
  en?: string;
  /** 한글 */
  ko?: string;
}

export interface DomainCustomAttributeResponse {
  en?: string;
  ko?: string;
}

export interface DomainCustomInputFieldRequest {
  /** 필드명 */
  name?: string;
  /** 값 */
  values?: string[];
}

export interface DomainCustomInputFieldResponse {
  /** 필드명 */
  name?: string;
  /** 값 */
  values?: string[];
}

export interface DomainCustomInputFieldSchemaRequest {
  /** 사용 여부 */
  enable?: boolean;
  /** 필드명 */
  name?: string;
  /** 선택지 */
  options?: string[];
  /** 타입 (shop, custom-input-field-schema-type 참고) */
  type?: string;
}

export interface DomainCustomInputFieldSchemaResponse {
  /** 사용 여부 */
  enable?: boolean;
  /** 필드명 */
  name?: string;
  /** 선택지 */
  options?: string[];
  /** 타입 (shop, custom-input-field-schema-type 참고) */
  type?: string;
}

export interface DomainCustomerReviewRate {
  /** 리뷰 태그별 개수 */
  count?: number;
  /** 리뷰 태그 */
  reviewTag?: string;
}

export interface DomainDashboardItemResponse {
  saleItemID?: string;
  title?: string;
}

export interface DomainDeleteSaleItemsRequest {
  /**
   * 판매 전 상태에서 삭제 시: `true`, 판매 중지인 상태에서 삭제 시: `false`
   * @example false
   */
  isIdleDelete?: boolean;
  platformTypes: string[];
  saleItemIDs: string[];
}

export interface DomainDeleteSaleItemsResponse {
  saleTaskID?: string;
}

export interface DomainDeleteShopTaskItemsRequest {
  shopTaskItemIDs: string[];
}

export interface DomainDeliveryFee {
  /** 기본 배송비 */
  baseFee?: number;
  /** 지역별 추가 배송비 */
  deliveryFeeByArea?: DomainDeliveryFeeByArea;
  /** 배송비 결제 방식 코드. COLLECT(착불), PREPAID(선결제), COLLECT_OR_PREPAID(착불 또는 선결제) */
  deliveryFeePayType?: string;
  /** 배송비 타입 (유료, 조건부 무료) */
  deliveryFeeType?: string;
  /** 지역별 차등 배송비 정보 */
  differentialFeeByArea?: string;
  /** 무료 조건 금액. 배송비 타입이 조건부 무료일 경우 입력 */
  freeConditionalAmount?: number;
  /** 반복 수량. 배송비 유형이 '수량별 부과 - 반복 구간'일 경우 입력합니다. */
  repeatQuantity?: number;
  /** 2구간 최소 수량. 배송비 유형이 '수량별 부과 - 구간 직접 설정'일 경우 입력합니다. */
  secondBaseQuantity?: number;
  /** 2구간 추가 배송비. 배송비 유형이 '수량별 부과 - 구간 직접 설정'일 경우 입력합니다. */
  secondExtraFee?: number;
  /** 3구간 최소 수량. 배송비 유형이 '수량별 부과 - 구간 직접 설정'일 경우 입력합니다. */
  thirdBaseQuantity?: number;
  /** 3구간 추가 배송비. 배송비 유형이 '수량별 부과 - 구간 직접 설정'일 경우 입력합니다. */
  thirdExtraFee?: number;
}

export interface DomainDeliveryFeeByArea {
  /**
   * 2권역인 경우 "제주 및 도서산간" 지역 추가 배송비.
   * 		3권역인 경우 "제주" 지역 추가 배송비.
   * 		묶음배송 가능 여부가 true인 경우 묶음배송 그룹에 설정된 값이 적용됩니다(배송 속성이 ARRIVAL_GUARANTEE인 경우 제외).
   */
  area2extraFee?: number;
  /**
   * "제주 외 도서산간" 지역 추가 배송비.
   * 		deliveryAreaType이 3권역인 경우 필수.
   * 		묶음배송 가능 여부가 true인 경우 묶음배송 그룹에 설정된 값이 적용됩니다 (배송 속성이 ARRIVAL_GUARANTEE인 경우 제외).
   */
  area3extraFee?: number;
  /**
   * 묶음배송 그룹 등록 시 지역별 추가 배송비 권역을 입력하기 위한 코드입니다.
   * 		묶음배송 가능 여부가 true인 경우 묶음배송 그룹에 설정된 값이 적용됩니다(배송 속성이 ARRIVAL_GUARANTEE인 경우 제외).
   * 		AREA_2(내륙/제주 및 도서산간 지역으로 구분(2권역)), AREA_3(내륙/제주/제주 외 도서산간 지역으로 구분(3권역))
   */
  deliveryAreaType?: string;
}

export interface DomainDeliveryInfo {
  /** 클레임(반품/교환) 정보 */
  claimDeliveryInfo?: DomainClaimDeliveryInfo;
  /** 배송 속성 타입 */
  deliveryAttributeType?: string;
  /** 묶음배송 그룹 코드 */
  deliveryBundleGroupId?: number;
  /** 묶음배송 가능 여부 */
  deliveryBundleGroupUsable?: boolean;
  /** 택배사 */
  deliveryCompany?: string;
  /** 배송비 정보 */
  deliveryFee?: DomainDeliveryFee;
  /** 배송 방법 유형 코드 */
  deliveryType?: string;
}

export interface DomainDescriptionJsonDOMRequest {
  /** @example "exchangeInfo" */
  exchangeInfo?: string;
  /** @example "normalDescription" */
  normal: string;
  /** @example "paymentInfo" */
  paymentInfo?: string;
  /** @example "serviceInfo" */
  serviceInfo?: string;
  /** @example "shippingInfo" */
  shippingInfo?: string;
  /** @example "simpleDescription" */
  simple?: string;
}

export interface DomainDescriptionJsonDOMResponse {
  /** @example "exchangeInfo" */
  exchangeInfo: string;
  /** @example "normalDescription" */
  normal: string;
  /** @example "paymentInfo" */
  paymentInfo: string;
  /** @example "serviceInfo" */
  serviceInfo: string;
  /** @example "shippingInfo" */
  shippingInfo: string;
  /** @example "simpleDescription" */
  simple: string;
}

export interface DomainDestroyShopsRequest {
  shopIDs?: string[];
}

export interface DomainDevelopedCountryResponse {
  /** 영문 국가명 */
  englishName: string;
  /** ISO 코드 */
  isoCode: string;
  /** 한글 국가명 */
  koreanName: string;
}

export interface DomainEmbedPlatformShippingCompanyResponse {
  code?: string;
  name?: string;
  platformType?: string;
}

export interface DomainExcelTemplateCustomFieldRequest {
  /**
   * 직접입력 할 컬럼
   * @example "B"
   */
  column: string;
  /**
   * 필드 국문명
   * @example "원산지"
   */
  fieldName: string;
  /**
   * 필드 값
   * @example "한국"
   */
  fieldValue: string;
}

export interface DomainExcelTemplateCustomFieldResponse {
  /**
   * 직접입력 할 컬럼
   * @example "B"
   */
  column?: string;
  /**
   * 필드 국문명
   * @example "원산지"
   */
  fieldName?: string;
  /**
   * 필드 값
   * @example "한국"
   */
  fieldValue?: string;
}

export interface DomainExcelTemplateFieldRequest {
  /**
   * 컬럼
   * @example "A"
   */
  column: string;
  /**
   * 필드 코드
   * @example "platformProductOrderID"
   */
  fieldCode: string;
}

export interface DomainExcelTemplateFieldResponse {
  /**
   * 컬럼
   * @example "A"
   */
  column?: string;
  /**
   * 필드 코드
   * @example "platformProductOrderID"
   */
  fieldCode?: string;
  /**
   * 필드 국문명
   * @example "상품 주문 번호"
   */
  fieldName?: string;
}

export interface DomainExcelTemplateResponse {
  /** 직접 입력 항목 */
  customFields?: DomainExcelTemplateCustomFieldResponse[];
  /** 템플릿 ID */
  excelTemplateID?: string;
  /** 엑셀 포멧 확장자 (메타데이터 template, extension 참조) */
  extension?: string;
  /** 선택 항목 */
  fields?: DomainExcelTemplateFieldResponse[];
  /** 기본 템플릿 여부 */
  isDefault?: boolean;
  /** 택배사 코드 */
  shippingCompanyCode?: string;
  /** 택배사 이름 */
  shippingCompanyName?: string;
  sorts?: DomainExcelTemplateSortResponse[];
  /** 템플릿 이름 */
  templateName?: string;
  /** 템플릿 타입 (메타데이터 template, type 참조) */
  templateType?: string;
  /** 상품명에 HTML 태그 제거 여부 */
  withoutHTMLTag?: boolean;
}

export interface DomainExcelTemplateSortRequest {
  /**
   * 필드 코드
   * @example "platformProductOrderID"
   */
  fieldCode?: string;
  /**
   * 정렬 순서(1: 오름차순, -1: 내림차순)
   * @example 1
   */
  order?: number;
}

export interface DomainExcelTemplateSortResponse {
  /**
   * 필드 코드
   * @example "platformProductOrderID"
   */
  fieldCode?: string;
  /**
   * 필드 국문명
   * @example "상품 주문 번호"
   */
  fieldName?: string;
  /**
   * 정렬 순서(1: 오름차순, -1: 내림차순)
   * @example 1
   */
  order?: number;
}

export interface DomainExistsShopAuthResponse {
  exists: boolean;
  isExpired: boolean;
  platformType: 'CAFE24' | 'NAVER_SMART_STORE';
}

export interface DomainExistsUploadingShopTaskResponse {
  exists?: boolean;
}

export interface DomainExistsUserRequest {
  /** 중복 확인 이메일 */
  email?: string;
  /** 중복 확인 닉네임 */
  shopName?: string;
}

export interface DomainExistsUserResponse {
  /** 해당 이메일이 존재하는지를 나타내는 값 */
  emailExists: boolean;
  /** 해당 계정이 존재하는지를 나타내는 값 (이메일+닉네임 중복 확인. 하나만 중복되어도 true로 반환됩니다.) */
  exists: boolean;
  /** 해당 계정이 존재할 경우, 해당 계정이 프로셀러인지 아닌지를 나타내는 값 */
  isProSeller: boolean;
  /** 해당 닉네임이 존재하는지를 나타내는 값 */
  nicknameExists: boolean;
}

export interface DomainExportExcelAclosetSettlementsRequest {
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /**
   * 세컨솔드 정산 상태값
   * @example ["SETTLEMENT_STATUS_UNAUDITED"]
   */
  status?: string[];
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
}

export interface DomainExportExcelAclosetSettlementsResponse {
  /**
   * 엑셀 압축 파일 base64
   * @format base64
   * @example "dGVzdC1iYXNlNjQ="
   */
  excelBase64?: string;
  /**
   * 엑셀 포멧 확장자 (메타데이터 template, extension 참조)
   * @example "TEMPLATE_EXTENSION_XLSX"
   */
  extension?: string;
}

export interface DomainExportExcelSaleItemsRequest {
  /** 상품 ID 목록 (리스트를 허용합니다.) */
  saleItemIDs?: string[];
}

export interface DomainExportExcelSaleItemsResponse {
  /**
   * 엑셀 압축 파일 base64
   * @format base64
   * @example "dGVzdC1iYXNlNjQ="
   */
  excelBase64?: string;
  /**
   * 엑셀 포멧 확장자 (메타데이터 template, extension 참조) - XLSX 고정임
   * @example "TEMPLATE_EXTENSION_XLSX"
   */
  extension?: string;
}

export interface DomainExportExcelSettlementsRequest {
  /** 정산 월 (예: 202303) */
  month?: string;
}

export interface DomainExportExcelSettlementsResponse {
  /**
   * 엑셀 압축 파일 base64
   * @format base64
   * @example "dGVzdC1iYXNlNjQ="
   */
  excelBase64?: string;
  /**
   * 엑셀 포멧 확장자 (메타데이터 template, extension 참조)
   * @example "TEMPLATE_EXTENSION_XLSX"
   */
  extension?: string;
}

export interface DomainExportExcelShopOrdersRequest {
  /**
   * 구매자명 (LIKE 검색)
   * @example "구매자명"
   */
  buyerName?: string;
  /**
   * 구매자 전화번호 (하이픈 없이) (LIKE 검색)
   * @example "01012345678"
   */
  buyerPhone?: string;
  /**
   * 상품코드 (LIKE 검색)
   * @example "12738273"
   */
  containsItemAlias?: string;
  /** 엑셀 다운로드 모드 (메타데이터 shop, excel-download-mode 참조) */
  excelDownloadMode: string;
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /** 운송장 번호 필터링 여부 (true: 운송장 번호가 있는 주문만, false: 운송장 번호가 없는 주문만, null: 운송장 번호 필터링 안함) */
  hasInvoiceNumber?: boolean;
  /**
   * 송장번호 (IN 검색)
   * @example ["123712378123"]
   */
  invoiceNumbers?: string[];
  /** 중복 주문 필터링 여부 (true: 중복 주문만, false: 중복 주문 포함, null: 중복 주문 필터링 안함) ⚠️ 해당 필드로 필터링 시 정렬 기준이 변경됩니다. */
  isDuplicated?: boolean;
  /**
   * 세컨솔드 할인 요청 여부 (true: 할인 요청만, false: 할인 요청 포함, null: 할인 요청 필터링 안함)
   * @example true
   */
  isOffer?: boolean;
  /**
   * 상품코드 (IN 검색)
   * @example ["12738273"]
   */
  itemAliases?: string[];
  /**
   * 상품명 (LIKE 검색)
   * @example "상품명"
   */
  itemTitle?: string;
  /**
   * 주문 상태 (metadata order, status 참조)
   * @example ["ORDER_STATUS_PAYMENT-DONE"]
   */
  orderStatuses?: string[];
  /**
   * 플랫폼 주문 ID (IN 검색)
   * @example ["12738273"]
   */
  platformOrderIDs?: string[];
  /**
   * 플랫폼 상품주문 ID (IN 검색)
   * @example ["12738274"]
   */
  platformProductOrderIDs?: string[];
  /**
   * 플랫폼 타입 (metadata platform, type 참조)
   * @example ["PLATFORM_TYPE_CAFE24"]
   */
  platformTypes?: string[];
  /** 엑셀 다운로드 사유 */
  reason: string;
  /**
   * 수취인명 (LIKE 검색)
   * @example "받는사람"
   */
  receiverName?: string;
  /**
   * 수취인 전화번호 (하이픈 없이) (LIKE 검색)
   * @example "01012345678"
   */
  receiverPhone?: string;
  /** 기간 필터 타입 (orderDate: 주문일, paymentDone: 결제일, shippingInProgressDate: 발송확인일, purchaseDoneDate: 구매확정일) */
  searchPeriodType?: 'orderDate' | 'paymentDoneDate' | 'shippingInProgressDate' | 'purchaseDoneDate';
  /**
   * 공급사명
   * @example "공급사"
   */
  supplierName?: string;
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
}

export interface DomainExportExcelShopOrdersResponse {
  /**
   * 엑셀 압축 파일 base64
   * @format base64
   * @example "dGVzdC1iYXNlNjQ="
   */
  excelBase64?: string;
  /**
   * 엑셀 포멧 확장자 (메타데이터 template, extension 참조)
   * @example "TEMPLATE_EXTENSION_XLSX"
   */
  extension?: string;
}

export interface DomainExportExcelShopSaleItemsRequest {
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /** ListShopSaleItemsRequest 필드의 필터와 동일 (POST 이기 때문에 query -> body 변경) */
  itemAlias?: string;
  /** 판매 상태 (메타데이터 sale, platform-status 참조) */
  platformStatuses?: string[];
  /**
   * 플랫폼 타입 (메타 데이터 shop, platform-type 참조)
   * @example "SHOP_PLATFORM-TYPE_BUNJANG"
   */
  platformType: 'SHOP_PLATFORM-TYPE_BUNJANG' | 'SHOP_PLATFORM-TYPE_PLAYAUTO' | 'SHOP_PLATFORM-TYPE_OKPOS';
  /**
   * 상품 ID 목록 (리스트를 허용합니다.)
   * @example ["63eb6df3f45b6fc2c1045aff","63eb6df3f45b6fc2c1045aff"]
   */
  saleItemIDs?: string[];
  /** 진행 상태를 조회하고자 할 때 사용 (진행 중, 실패, 대기) (메타데이터 sale, operation 참고) */
  saleOperation?: string;
  /** 판매 상태 (메타데이터 sale, status 참조) */
  saleStatuses?: string[];
  /** 기간 필터 타입 (createDate: 아이템 생성일, modifyDate: 아이템 수정일, postDate: 상품 등록일) (saleItemIDs 를 안쓴다면 필수) */
  searchPeriodType?: 'createDate' | 'modifyDate' | 'postDate';
  /** 상품명 */
  title?: string;
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
}

export interface DomainExportExcelShopSaleItemsResponse {
  /**
   * @format base64
   * @example "dGVzdC1iYXNlNjQ="
   */
  excelBase64?: string;
  excelImages?: DomainItemImageResponse[];
}

export interface DomainExportExcelShopsRequest {
  /**
   * 공식입점 샵 조회 여부 (입점 동의 여부)
   * @example true
   */
  isOfficiallyEntered?: boolean;
  /**
   * 테스트 샵 포함 여부
   * @example true
   */
  isTest?: boolean;
}

export interface DomainExportExcelShopsResponse {
  /**
   * 엑셀 압축 파일 base64
   * @format base64
   * @example "dGVzdC1iYXNlNjQ="
   */
  excelBase64?: string;
}

export interface DomainExportShopSaleItemsImagesRequest {
  saleItemIDs?: string[];
}

export interface DomainExportShopSaleItemsImagesResponse {
  images?: DomainItemImageResponse[];
}

export interface DomainFabricAliasRequest {
  /** 별칭 */
  alias: DomainAliasRequest;
  /** 코드 */
  code: string;
}

export interface DomainFabricAliasResponse {
  /** 별칭 */
  alias: DomainAliasResponse;
  /** 코드 */
  code: string;
  /** 영문명 */
  en: string;
  /** 한국명 */
  ko: string;
}

export interface DomainFabricPriceCalculatorResponse {
  /** 소재 추가 규칙 ID */
  calculatorID?: string;
  /** 반영할 소재목록 */
  fabrics?: string[];
  /** 곱셈치 */
  multiply?: number;
  /** 증가치 */
  plus?: number;
}

export interface DomainFieldValue {
  fieldValue?: string;
  icon?: string;
  isChecked?: boolean;
}

export interface DomainForceChangeSaleItemsStatusRequest {
  /** 카페24 판매상태 (shop, sale-platform-status 메타데이터 참조) */
  cafe24SalePlatformStatus?: string;
  /** 네이버 판매상태 (shop, sale-platform-status 메타데이터 참조) */
  naverSalePlatformStatus?: string;
  /** 판매 상품 ID */
  saleItemID: string;
  /** 세컨솔드 실시간 상태 (shop, sale-platform-status 메타데이터 참조) */
  secondSoldRealtimeStatus?: string;
  /** 세컨솔드 판매상태 (shop, sale-platform-status 메타데이터 참조) */
  secondSoldSalePlatformStatus?: string;
}

export interface DomainForceStopSaleAclosetItemsRequest {
  shopTaskItemIDs: string[];
}

export interface DomainGenderKeywords {
  /** 키즈 남성 */
  kidsMen?: string[];
  /** 유니섹스 */
  kidsUnisex?: string[];
  /** 키즈 여성 */
  kidsWomen?: string[];
  /** 남성 */
  men?: string[];
  /** 유니섹스 */
  unisex?: string[];
  /** 여성 */
  women?: string[];
}

export interface DomainGenerateAIDescriptionPreviewRequest {
  /** AI 상품 설명 설정 */
  aiDescriptionSetting: DomainShopAIDescriptionSetting;
}

export interface DomainGenerateAIDescriptionPreviewResponse {
  /** 설명 텍스트 */
  descriptionText?: string;
}

export interface DomainGenerateInvitationTokenRequest {
  /** 영업용 토큰 생성 할 샵 */
  shopID: string;
}

export interface DomainGenerateInvitationTokenResponse {
  accessToken?: string;
}

export type DomainGenerateRefreshTokenRequest = object;

export interface DomainGenerateRefreshTokenResponse {
  refreshToken?: string;
}

export interface DomainGenerateShopTaskItemAIDescriptionsRequest {
  shopTaskItemIDs: string[];
}

export type DomainGenerateShopTaskItemTitleRequest = object;

export interface DomainGetAclosetSettlementAmountResponse {
  /** 정산예정 대상금액 (구매확정금액) */
  amount: number;
  /** 정산완료 금액 */
  completedAmount: number;
  /** 정산보류 금액 */
  holdAmount: number;
  /** PG 수수료 */
  pgFee: number;
  /** 정산예정 금액 */
  scheduledAmount: number;
  /** 최종 정산 금액 (수수료 제외) */
  sellerAmount: number;
  /** 미정산 금액 */
  unauditedAmount: number;
}

export interface DomainGetAclosetSupplierResponse {
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeShippingThreshold: number;
  /** CS 담당 연락처 */
  inquiryContact: string;
  /** 공급사명(지점명) 노출 여부 */
  isVisible: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea: boolean;
  /** 배송정보 ID */
  logixID?: number;
  /** 공급사명(지점명) */
  logixName: string;
  /** 배송 정책 */
  logixPolicy?: string;
  /** 배송 타입 */
  logixPriceType: string;
  /** 배송비 */
  orderLogixPrice: DomainMarketItemLogixPrice;
  /** 최대 구매 수량 */
  purchaseQuantityLimit: number;
  /** 반품 주소 */
  returnAddress: DomainShopAclosetAddress;
  /** 택배사 */
  returnLogixName: string;
  /** 반품 배송비 */
  returnLogixPrice: DomainMarketItemLogixPrice;
  /** 반품 정책 */
  returnPolicyDescription: string;
  /** 수거 방법 */
  returnPolicyType: string;
}

export interface DomainGetAppVersionResponse {
  appVersion?: DomainAppVersionResponse;
}

export interface DomainGetCafe24AuthTokenRequest {
  /**
   * QA 테스트용 필드 (QA 테스트 시 카페24 상점마다 clientID, clientSecret 가 달라짐)
   * @example "clientID"
   */
  clientID?: string;
  /**
   * QA 테스트용 필드
   * @example "clientSecret"
   */
  clientSecret?: string;
  /** @example "code" */
  code: string;
  /** @example "lookocorp" */
  mallID: string;
}

export interface DomainGetCafe24AuthTokenResponse {
  accessToken: string;
  /** Looko-AI 회원가입 시 사용 */
  email: string;
  expiresAt: string;
  refreshToken: string;
  refreshTokenExpiresAt: string;
}

export interface DomainGetClaimDetailResponse {
  acloset?: DomainAclosetOrder;
}

export interface DomainGetClaimResponse {
  /** 세컨솔드 클레임 상세 */
  acloset?: DomainAclosetClaimDetailResponse;
  /**
   * 환불 은행 계좌 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만 해당 필드를 요구)
   * @example "110-336-822083"
   */
  bankAccountNumber?: string;
  /**
   * 환불 은행 예금주 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만해당 필드를 요구)
   * @example "김아무개"
   */
  bankAccountOwner?: string;
  /**
   * 환불 은행 코드 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만 해당 필드를 요구, platform 도메인의 카페 24 은행 코드 참조)
   * @example "bank_02"
   */
  bankCode?: string;
  /**
   * 환불 은행 이름 (⚠️ 주문 플랫폼: 카페24, 결제 방식: "무통장입금"에만 해당 필드를 요구, platform 도메인의 카페 24 은행 코드 참조)
   * @example "국민은행"
   */
  bankName?: string;
  /**
   * 구매자 ID
   * @example "lookocopr"
   */
  buyerID?: string;
  /** 방해고객 여부 */
  buyerIsBlackConsumer: boolean;
  /**
   * 구매자 이름
   * @example "김아무개"
   */
  buyerName?: string;
  /**
   * 구매자 전화번호 (하이픈 없이)
   * @example "01000001234"
   */
  buyerPhone?: string;
  /**
   * 구매자 회원 ID
   * @example "1234"
   */
  buyerUserID?: string;
  /**
   * 클레임 ID (자체)
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  claimID?: string;
  /**
   * 클레임 처리 상태 (metadata claim, operation 참조)
   * @example "CLAIM_OPERATION_IDLE"
   */
  claimOperation?: string;
  /**
   * 구매자 클레임 사유
   * @example "물건 바꿔주세요"
   */
  claimReason?: string;
  /**
   * 구매자 클레임 타입 (GET /shops/platform-request-return-reasons 참조)
   * @example "A"
   */
  claimReasonType?: string;
  /**
   * 클레임 상태 (metadata claim, return-status 참조)
   * @example "CLAIM_RETURN-STATUS_REQUEST"
   */
  claimStatus?: string;
  /**
   * 클레임 타입 (metadata claim, type 참조)
   * @example "CLAIM_TYPE_RETURN"
   */
  claimType?: string;
  /**
   * 간편결제 타입 (메타데이터 sale, easy-payment 참조)
   * @example "SALE_EASY-PAYMENT_NAVERPAY"
   */
  easyPayment?: string;
  /**
   * 교환완료일
   * @example "2023-08-08T05:25:32.992Z"
   */
  exchangeDoneDate?: string;
  /**
   * 교환요청일
   * @example "2023-08-08T05:25:32.992Z"
   */
  exchangeRequestDate?: string;
  /**
   * 송장번호
   * @example "123456789012"
   */
  invoiceNumber?: string;
  /**
   * 반품 재신청 여부
   * @example true
   */
  isReturnReRequested?: boolean;
  /**
   * 상품코드
   * @example "A000123"
   */
  itemCode?: string;
  /**
   * 상품가격
   * @example 50000
   */
  itemPrice?: number;
  /**
   * 상품 썸네일 URL
   * @example "https://acloset-kr-s3.s3.amazonaws.com/shops/6426a9c.jpg"
   */
  itemThumbnailURL?: string;
  /**
   * 상품명
   * @example "밝은 색상 청바지"
   */
  itemTitle?: string;
  /**
   * 주문 ID (자체)
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  orderID?: string;
  /**
   * 주문일
   * @example "2023-08-08T05:25:32.992Z"
   */
  orderRequestDate?: string;
  /** 주문 상태(메타데이터 order, status 참조) */
  orderStatus?: string;
  /** 결제수단 목록 */
  paymentMethods?: DomainPaymentMethodResponse[];
  /**
   * 결제금액
   * @example 50000
   */
  paymentPrice?: number;
  /**
   * 플랫폼 클레임 ID
   * @example "12738273"
   */
  platformClaimID?: string;
  /**
   * 플랫폼 클레임 상태코드 (플랫폼별 실제 데이터)
   * @example "R00"
   */
  platformClaimStatusCode?: string;
  /**
   * 플랫폼 클레임 상태이름 (플랫폼별 실제 데이터)
   * @example "반품대기"
   */
  platformClaimStatusName?: string;
  /** 플랫폼 에러 */
  platformError?: DomainClaimPlatformErrorResponse;
  /**
   * 플랫폼 주문 ID
   * @example "12738273"
   */
  platformOrderID?: string;
  /**
   * 플랫폼 상품주문 ID
   * @example "12738273"
   */
  platformProductOrderID?: string;
  /**
   * 플랫폼 타입 (shop, platform-type 참조)
   * @example "SHOP_PLATFORM-TYPE_CAFE24"
   */
  platformType?: string;
  /** 수취인 주소 */
  receiverAddress?: DomainReceiverAddressResponse;
  /**
   * 수취인 이름
   * @example "이아무개"
   */
  receiverName?: string;
  /**
   * 수취인 전화번호
   * @example "123456789012"
   */
  receiverPhone?: string;
  /**
   * 반품 주소가 배송 주소와 다른지 여부
   * @example true
   */
  returnAddressIsDifferentFromShipping: boolean;
  /**
   * 반품완료일
   * @example "2023-08-08T05:25:32.992Z"
   */
  returnDoneDate?: string;
  /**
   * 반품 송장번호
   * @example "127389127931"
   */
  returnInvoiceNumber?: string;
  /**
   * 반품요청일
   * @example "2023-08-08T05:25:32.992Z"
   */
  returnRequestDate?: string;
  /**
   * 반품 택배사 코드
   * @example "CJGLS"
   */
  returnShippingCompanyCode?: string;
  /**
   * 반품 택배사 이름
   * @example "대한통운"
   */
  returnShippingCompanyName?: string;
  /**
   * 배송사 코드
   * @example "CJGLS"
   */
  shippingCompanyCode?: string;
  /**
   * 배송사 이름
   * @example "대한통운"
   */
  shippingCompanyName?: string;
  /**
   * 배송비
   * @example 3000
   */
  shippingFee?: number;
  /**
   * 배송메세지
   * @example "배송메세지"
   */
  shippingMessage?: string;
  /** 공급사 */
  supplier?: DomainShopSupplierResponse;
}

export interface DomainGetInstagramPublishLimitResponse {
  /**
   * 총량
   * @example 100
   */
  quotaTotal: number;
  /**
   * 사용량
   * @example 10
   */
  quotaUsage: number;
}

export interface DomainGetMaintenanceResponse {
  /** 점검 종료 시간 */
  endTime?: string;
  /** 점검중 여부 */
  isMaintenance?: boolean;
  /** 업데이트 내용 */
  updateDetails?: string;
}

export interface DomainGetMappingGroupResponse {
  mappingGroupID?: string;
  /** 메타데이터 (mapping-group, type 참고) */
  type?: string;
}

export interface DomainGetMetadataMapResponse {
  descriptions?: Record<string, string>;
}

export interface DomainGetMyServicePricingsResponse {
  /** 마지막 서비스 변경 일자 */
  lastServiceChangeDate?: string;
  /** 서비스 가격 목록 */
  servicePricings: DomainServicePricingResponse[];
}

export interface DomainGetNoticeResponse {
  /** 공지사항 수정일 */
  modifyDate?: string;
  /** 공지사항 상태 (메타데이터 app, notice-status 참조) */
  status?: string;
  /** 공지사항 제목 */
  title?: string;
  /** 공지사항 URL */
  url?: string;
}

export interface DomainGetPaymentCardResponse {
  /** 카드정보 */
  card?: DomainPaymentCardResponse;
}

export interface DomainGetSaleItemInstagramURLResponse {
  /** 인스타그램 URL */
  instagramURL?: string;
}

export interface DomainGetShopBrandGroupResponse {
  /** 그룹ID 리스트 */
  groupID?: string;
  /** 그룹이름 */
  groupName?: string;
}

export interface DomainGetShopBusinessResponse {
  /** 계좌주명 */
  accountHolder: string;
  /** 계좌번호 */
  accountNumber: string;
  /** 사업장 주소 */
  address: string;
  /** 계좌 은행 */
  bankName: string;
  /** 사업자 이메일 */
  businessEmail: string;
  /** 사업자 전화번호 */
  businessMobile: string;
  /** 회사 법인명 */
  businessName: string;
  /** 사업자 등록증 파일명 */
  businessRegistrationFileName?: string;
  /** 사업자 등록증 파일 URL */
  businessRegistrationFileURL?: string;
  /** 사업자 등록번호 */
  businessRegistrationNumber?: string;
  /** 업태/업종 (별도의 메타데이터 존재하지 않음) */
  businessType?: string;
  /** 통신판매신고증 사본 이름 */
  mailOrderSalesRegistrationFileName?: string;
  /** 통신판매신고증 사본 URL */
  mailOrderSalesRegistrationFileURL?: string;
  /** 통신판매신고번호 */
  mailOrderSalesRegistrationNumber?: string;
  /** 오너 전화번호 */
  ownerMobile: string;
  /** 대표명 */
  ownerName: string;
  /** 사업자 유형 (별도의 메타데이터 존재하지 않음) */
  ownerType?: string;
}

export interface DomainGetShopCafe24AuthResponse {
  /**
   * Cafe24 클라이언트 ID
   * @example "example_client_id"
   */
  clientID?: string;
  /**
   * Cafe24 몰 ID
   * @example "vintage-yangtae"
   */
  mallID?: string;
  /**
   * 샵 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  shopID?: string;
}

export interface DomainGetShopPaymentStatusResponse {
  /**
   * 실패한 결제가 있는지 여부
   * @example true
   */
  hasPaymentFailed?: boolean;
  /**
   * (실채한 결제가 있을 경우) 결제 만료일. 해당 만료일이 지날 경우 모든 기능을 잠금합니다.
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  paymentDeadlineDate?: string;
}

export interface DomainGetShopPlanResponse {
  lastPlanChangeDate?: string;
  plan?: DomainPlanResponse;
}

export interface DomainGetShopPlanStatusResponse {
  /** 최근 결제가 실패한 경우 */
  failurePaymentExists?: boolean;
  /** 미 결제된 아이템이 존재하는지 여부 */
  unpaidItemExists?: boolean;
}

export interface DomainGetShopServiceScoreResponse {
  /** 리뷰 점수 */
  aclosetReviewRating?: DomainAclosetReviewRating;
  /** 주문취소 점수 */
  cancelOrderRate?: DomainCancelOrderRate;
  /** 고객 리뷰 목록 */
  customerReviewRates?: DomainCustomerReviewRate[];
  /** 문의대응 속도 점수 */
  inquiryResponseTime?: DomainInquiryResponseTime;
  /** 반품처리 점수 */
  returnProcessingDay?: DomainReturnProcessingDay;
  /** 반품사유 목록 */
  returnReasonRates?: DomainReturnReasonRate[];
  /** 배송시작 점수 */
  shipStartOrderRate?: DomainShipStartOrderRate;
}

export interface DomainGetShopTaskResponse {
  /**
   * AI 분석 목록  (메타 데이터 참조)
   * @example ["AI_ANALYSIS_LIST_SIZE"]
   */
  aiAnalyses?: string[];
  /**
   * AI 정밀도 분석
   * @example "SHOP_AI-PRECISION_SIMPLE-ANALYSIS"
   */
  aiPrecision?: string;
  /** 배경색 설정 색상 헥스 코드 */
  backgroundColorHexCode: string;
  /** @example 1000 */
  count?: number;
  /**
   * 작업 생성일
   * @example 1634243434234
   */
  createDate?: number;
  /** 자유 입력 필드 스키마 */
  customInputFieldSchemas?: DomainCustomInputFieldSchemaResponse[];
  /** 의류 구분 상품별 선택시, 아이템에 디폴트로 들어가는 값 */
  defaultMappingGroupID?: string;
  /**
   * 작업 종료일
   * @example 1676338846176
   */
  endDate?: number;
  /** 배경제거 여백 제거 설정 */
  imageCropOption: DomainShopImageCropOptionResponse;
  /** 이미지 비율 설정 */
  imageRatioOption: DomainShopImageRatioOptionResponse;
  /** 상품 코드 규칙 */
  itemCodeRule: DomainShopTaskItemCodeRuleResponse;
  /** 상품 정보 항목 설정 */
  itemInputFieldSetting?: DomainItemInputField[];
  /** 의류 구분 */
  mappingGroupType?: DomainMappingGroupTypeResponse;
  removeBackgroundOption?: DomainShopRemoveBackgroundOptionResponse;
  /**
   * 샵명
   * @example "스토어 쟈넬"
   */
  shopName?: string;
  /**
   * 작업 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  shopTaskID?: string;
  /**
   * 작업 상태
   * @example "SHOP_TASK-STATUS_DONE"
   */
  status?: string;
  /** 공급사 설정 */
  supplier?: DomainShopSupplierResponse;
  /**
   * 작업명
   * @example "스토어 쟈넬"
   */
  taskName?: string;
}

export interface DomainGlobalStateResponse {
  /** 메타데이터 global-state, key 참조 */
  key?: string;
  /** 해당 값 */
  value?: string;
}

export interface DomainImageEditorPresetRequest {
  /** @example 12 */
  brightness?: number;
  /** @example 18 */
  contrast?: number;
  /** @example 36 */
  hue?: number;
  /** @example "프리셋 이름" */
  name?: string;
  /** @example 44 */
  saturation?: number;
}

export interface DomainImageEditorPresetResponse {
  /** @example 23 */
  brightness?: number;
  /** @example 18 */
  contrast?: number;
  /** @example 45 */
  hue?: number;
  /** @example "프리셋 이름" */
  name?: string;
  /** @example 99 */
  saturation?: number;
}

export interface DomainImageInfo {
  height?: number;
  image_url?: string;
  width?: number;
}

export interface DomainImageRetouchingOptionRequest {
  /** 밝기 */
  brightness?: number;
  /** 대비 */
  contrast?: number;
  /** 이미지 고급 보정 활성화 여부 */
  enableImageRetouchingOption?: boolean;
  /** 채도 */
  saturation?: number;
}

export interface DomainImageRetouchingOptionResponse {
  /** 밝기 */
  brightness?: number;
  /** 대비 */
  contrast?: number;
  /** 이미지 고급 보정 활성화 여부 */
  enableImageRetouchingOption?: boolean;
  /** 채도 */
  saturation?: number;
}

export interface DomainImageTypeProbabilityResponse {
  /** @example 0.92 */
  probability: number;
  /** @example "SHOP_IMAGE-TYPE_FRONT" */
  type: string;
}

export interface DomainImageTypeResponse {
  imageTypes?: DomainImageTypeProbabilityResponse[];
  /** @example "image.jpg" */
  imageURL: string;
}

export interface DomainInquiryResponseTime {
  /** 등급 (A, B, C, D, E) */
  grade?: string;
  /** 평균 문의대응 속도 (시간 단위) */
  hours?: number;
  /** 상위 5%의 점수 */
  top5hours?: number;
}

export interface DomainIntegratedSizeMappingRequest {
  /** 예: JEANS */
  aimsCategories?: string[];
  name?: string;
  rules?: DomainIntegratedSizeMappingRuleRequest[];
}

export interface DomainIntegratedSizeMappingResponse {
  /** 예: JEANS */
  aimsCategories?: string[];
  name?: string;
  rules?: DomainIntegratedSizeMappingRuleResponse[];
}

export interface DomainIntegratedSizeMappingRuleRequest {
  /** 사이즈 규칙을 일관성 있게 통합한 사이즈, 예: s, m, l */
  integratedSizeName?: string;
  /** 사장님 별로 다르게 사용하고 있는 사이즈, 예: 66, small, 36 등등 */
  size?: string;
}

export interface DomainIntegratedSizeMappingRuleResponse {
  /** 사이즈 규칙을 일관성 있게 통합한 사이즈, 예: s, m, l */
  integratedSizeName?: string;
  /** 사장님 별로 다르게 사용하고 있는 사이즈, 예: 66, small, 36 등등 */
  size?: string;
}

export interface DomainIssueShopCafe24AuthRequest {
  code?: string;
}

export interface DomainIssueShopInstagramAuthRequest {
  /** @example "abcdefghijklmnopqrstuvwxyz#_" */
  code: string;
}

export interface DomainIssueShopNaverSmartStoreAuthRequest {
  /** @example "clientID" */
  clientID: string;
  /** @example "clientSecret" */
  clientSecret: string;
}

export interface DomainItemConditionField {
  /** 디폴트 여부 (하나만 가능) */
  isDefault?: boolean;
  /** 상품 상태 레벨 (1이 가장 좋음) */
  level?: number;
  /** 컨디션 표기 */
  name?: string;
}

export interface DomainItemConsistencyReportResponse {
  /** 확인일시 */
  checkedDate?: string;
  /** 오류코드 */
  errorCode?: string;
  /** 오류설명 */
  errorDescription?: string;
  /** Report 고유번호 */
  id?: string;
  /** 상품코드 */
  itemAlias?: string;
  /** 상품명 */
  itemTitle?: string;
  /** 상품 등록일 */
  postDate?: string;
  /** 오류감지시간 */
  reportCreateDate?: string;
  /** 상품 플랫폼 상태 */
  saleItemPlatforms?: DomainSaleItemPlatformResponse[];
  /** 판매상태 (sale, status 메타데이터 참조) */
  saleStatus?: string;
  /** 샵 아이디 */
  shopID?: string;
  /** 샵 이름 */
  shopName?: string;
  /** ShopTaskItem 고유번호 */
  shopTaskItemID?: string;
  /** item-consistency-report, status 메타데이터 확인 */
  status?: string;
}

export interface DomainItemImageResponse {
  /** @example "imageName.jpg" */
  imageName?: string;
  /** @example "https://test.com/test.jpg" */
  imageURL?: string;
}

export interface DomainItemInputField {
  /** 필드 코드값 */
  code?: string;
  /** 활성화여부 */
  enable?: boolean;
}

export interface DomainItemUsageDetailResponse {
  /** 아이템 사용 금액 목록 */
  itemUsagePricings?: DomainItemUsagePricingResponse[];
  /** 아이템 부과 타입 */
  itemUsageType?: string;
}

export interface DomainItemUsagePricingResponse {
  /** 아이템 단가 */
  pricePerItem?: number;
  /** 총 금액 */
  totalPrice?: number;
  /** 아이템 개수 */
  usageItemCount?: number;
}

export interface DomainKakaoNotificationSetting {
  /** 카카오 알림 설정 활성화 여부 */
  enable?: boolean;
  /** 카카오 알림 전송할 모바일 번호 리스트 */
  mobileNumbers?: string[];
}

export interface DomainKakaopayCancelReasonResponse {
  kakaopayCancelReasonCode?: string;
  kakaopayCancelReasonMessage?: string;
}

export interface DomainKakaotalkNotificationArgs {
  /** 매직링크 */
  url?: string;
}

export interface DomainKakaotalkTemplateResponse {
  /** 템플릿 정렬 순서 */
  order?: number;
  /** 템플릿 내용 */
  template?: string;
  /** 템플릿 코드 */
  templateCode?: string;
  /** 템플릿 이동경로 */
  templateDestination?: string;
  /** 템플릿 명 */
  templateName?: string;
  /** 템플릿 타입 (영업용, 주문용 등) */
  templateType?: string;
}

export interface DomainKeyPoint {
  index?: number;
  prob?: number;
  x?: number;
  y?: number;
}

export interface DomainKeyPointLengthRequest {
  /** 길이 정보 (키포인트, 길이 등) JSON형식 */
  content: string;
  /** 길이 정보 유효 여부 */
  valid: boolean;
}

export interface DomainKeyPointLengthResponse {
  /** 길이 정보 (키포인트, 길이 등) JSON형식 */
  content: string;
  /** 길이 정보 유효 여부 */
  valid: boolean;
}

export interface DomainKeyPointProperty {
  keypoints?: DomainKeyPointsWithType;
  length?: DomainLengthWithType;
  version?: string;
}

export interface DomainKeyPointResponse {
  index?: number;
  x?: number;
  y?: number;
}

export interface DomainKeyPointWithClothesTypeResponse {
  clothesType?: string;
  keyPoints?: DomainKeyPointResponse[];
}

export interface DomainKeyPointsWithType {
  /** 키포인트 */
  dress_normal?: DomainKeyPoint[];
  /** 키포인트 */
  dress_sleeveless?: DomainKeyPoint[];
  /** 키포인트 */
  dress_strapless?: DomainKeyPoint[];
  /** 키포인트 */
  pants?: DomainKeyPoint[];
  /** 키포인트 */
  skirts?: DomainKeyPoint[];
  /** 키포인트 */
  tops_outwear_normal?: DomainKeyPoint[];
  /** 키포인트 */
  tops_outwear_sleeveless?: DomainKeyPoint[];
  /** 키포인트 */
  tops_outwear_strapless?: DomainKeyPoint[];
}

export interface DomainLabelingItemResponse {
  /**
   * 세컨솔드 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  aclosetGenderWear?: string;
  /** AIMS 브랜드 */
  aimsBrand?: DomainAIMSBrandResponse;
  /**
   * 브랜드
   * @example "쟈넬"
   */
  brand?: string;
  /**
   * 카테고리
   * @example "SHIRTS"
   */
  category?: string;
  /**
   * 색상
   * @example ["BLACK","RED"]
   */
  colors?: string[];
  /**
   * 성별
   * @example "SHOP_ITEM-GENDER_WOMEN"
   */
  gender?: string;
  /** 라벨링 아이템 ID */
  id: string;
  /** 이미지 */
  images: DomainShopTaskItemImageResponse[];
  /** 라벨링 정보 */
  labelings: DomainLabelingResponse[];
  /** 상품 등록일 */
  postDate?: string;
  /** 샵 ID */
  shopID: string;
  /**
   * 샵명
   * @example "샵이름"
   */
  shopName?: string;
  /**
   * 제목
   * @example "어제 산 샤넬 백 팝니다."
   */
  title?: string;
}

export interface DomainLabelingResponse {
  status?: string;
  type?: string;
}

export interface DomainLengthClassProperty {
  class_id?: number;
  class_name?: string;
  measure?: DomainMeasureProperty;
}

export interface DomainLengthWithClothesType {
  clothesType?: string;
  length?: string;
}

export interface DomainLengthWithType {
  dress_normal?: DomainLengthClassProperty;
  dress_sleeveless?: DomainLengthClassProperty;
  dress_strapless?: DomainLengthClassProperty;
  pants?: DomainLengthClassProperty;
  skirts?: DomainLengthClassProperty;
  tops_outwear_normal?: DomainLengthClassProperty;
  tops_outwear_sleeveless?: DomainLengthClassProperty;
  tops_outwear_strapless?: DomainLengthClassProperty;
}

export interface DomainListAclosetCouponsResponse {
  coupons?: DomainAclosetCouponResponse[];
  pagination?: DomainPaginationResponse;
}

export interface DomainListAclosetMarketItemReviewsResponse {
  pagination: DomainPaginationResponse;
  reviews: DomainMarketItemReviewResponse[];
}

export interface DomainListAclosetNotificationsResponse {
  notifications?: DomainShopAclosetNotificationResponse[];
  pagination?: DomainPaginationResponse;
}

export interface DomainListAclosetPartnerShopsResponse {
  hasNext?: boolean;
  proSellerPartnerShopInfos?: DomainProSellerPartnerShopResponse[];
}

export interface DomainListAclosetRejectPriceOfferReasonsResponse {
  rejectPriceOfferReasons?: DomainAclosetRejectPriceOfferReasonResponse[];
}

export interface DomainListAclosetSettlementsResponse {
  /** 정산 목록 */
  settlements?: DomainAclosetSettlementResponse[];
}

export interface DomainListAclosetStoreCouponsResponse {
  coupons: DomainStoreCouponResponse[];
}

export interface DomainListAclosetSuppliersResponse {
  logixInfos?: DomainGetAclosetSupplierResponse[];
}

export interface DomainListBlackConsumersResponse {
  blackConsumers?: DomainBlackConsumerResponse[];
  pagination?: DomainPaginationResponse;
}

export interface DomainListBunjangShopLoadTasksResponse {
  pagination: DomainPaginationResponse;
  shopLoadTasks: DomainBunjangShopLoadTaskResponse[];
}

export interface DomainListBunjangShopsResponse {
  pagination: DomainPaginationResponse;
  shops: DomainBunjangShopResponse[];
}

export interface DomainListCafe24ProductConditionsResponse {
  cafe24ProductConditions?: DomainCafe24ProductConditionResponse[];
}

export interface DomainListCafe24ScopesResponse {
  scopes?: string[];
}

export interface DomainListCategoryAliasResponse {
  categoryAliases: DomainCategoryAliasResponse[];
  /** 전체 별칭의 사용 여부 */
  enable: boolean;
}

export interface DomainListCategorySizeTypesResponse {
  properties?: DomainCategorySizeType[];
}

export interface DomainListClaimCountsResponse {
  claimCounts?: DomainClaimCountResponse[];
}

export interface DomainListClaimsResponse {
  claims?: DomainClaimResponse[];
  pagination?: DomainPaginationResponse;
}

export interface DomainListColorAliasesResponse {
  colorAliases: DomainColorAliasResponse[];
  /** 전체 별칭의 사용 여부 */
  enable: boolean;
}

export interface DomainListDevelopedCountriesResponse {
  /** 선택된 국가 목록 */
  countries: DomainDevelopedCountryResponse[];
}

export interface DomainListExcelTemplatesResponse {
  templates?: DomainExcelTemplateResponse[];
}

export interface DomainListFabricAliasesResponse {
  /** 전체 별칭의 사용 여부 */
  enable: boolean;
  fabricAliases: DomainFabricAliasResponse[];
}

export interface DomainListFabricPriceCalculatorsResponse {
  calculators?: DomainFabricPriceCalculatorResponse[];
}

export interface DomainListGlobalStatesResponse {
  states?: DomainGlobalStateResponse[];
}

export interface DomainListInstagramScopesResponse {
  scopes?: string[];
}

export interface DomainListItemConsistencyReportsResponse {
  items?: DomainItemConsistencyReportResponse[];
  pagination?: DomainPaginationResponse;
}

export interface DomainListKakaopayCancelReasonsResponse {
  kakaopayCancelReasons?: DomainKakaopayCancelReasonResponse[];
}

export interface DomainListKakaotalkTemplatesResponse {
  templates?: DomainKakaotalkTemplateResponse[];
}

export interface DomainListLabelingItemsResponse {
  items?: DomainLabelingItemResponse[];
  pagination: DomainPaginationResponse;
}

export interface DomainListMappingGroupMappingsResponse {
  mappings?: DomainMappingGroupMappingResponse[];
}

export interface DomainListMappingGroupPropertiesResponse {
  properties?: DomainMappingGroupPropertyResponse[];
}

export interface DomainListMappingGroupsResponse {
  mappingGroups?: DomainMappingGroupResponse[];
}

export interface DomainListMappingPropertiesResponse {
  properties?: DomainMappingPropertyResponse[];
}

export interface DomainListMetadataResponse {
  count: number;
  domains: string[];
  items: DomainMetadataResponse[];
  subDomains: string[];
}

export interface DomainListNaverpayCancelReasonsResponse {
  naverpayCancelReasons?: DomainNaverpayCancelReasonResponse[];
}

export interface DomainListPaymentCardsResponse {
  /** 카드 리스트 */
  cards?: DomainPaymentCardResponse[];
}

export interface DomainListPaymentDetailTasksResponse {
  /** 결제내역의 상세 태스크 목록 */
  tasks?: DomainPaymentDetailTaskResponse[];
}

export interface DomainListPaymentDetailsResponse {
  /** 결제내역 목록 */
  details: DomainPaymentDetailResponse[];
  /** 페이징 정보 */
  pagination: DomainPaginationResponse;
}

export interface DomainListPlansResponse {
  plans?: DomainPlanResponse[];
}

export interface DomainListPlatformBanksResponse {
  banks?: DomainPlatformBankResponse[];
}

export interface DomainListPlatformCancelReasonsResponse {
  /** 취소사유 목록 */
  cancelReasons?: DomainPlatformCancelReasonResponse[];
}

export interface DomainListPlatformCategoryRulesResponse {
  rules?: DomainPlatformCategoryRuleResponse[];
}

export interface DomainListPlatformOriginAreasResponse {
  originAreas?: DomainPlatformOriginAreaResponse[];
}

export interface DomainListPlatformRefundMethodCodesResponse {
  refundMethodCodes?: DomainPlatformRefundMethodCodeResponse[];
}

export interface DomainListPlatformRejectCancelReasonsResponse {
  rejectCancelOrderReasons?: DomainPlatformRejectCancelReasonResponse[];
}

export interface DomainListPlatformRejectReturnReasonsResponse {
  rejectReturnReasons?: DomainPlatformRejectReturnReasonResponse[];
}

export interface DomainListPlatformRequestReturnReasonsResponse {
  requestReturnReasons?: DomainPlatformRequestReturnReasonResponse[];
}

export interface DomainListPlatformShippingCompaniesResponse {
  shippingCompanies?: DomainPlatformShippingCompanyResponse[];
}

export interface DomainListPopupsResponse {
  popups?: DomainPopupResponse[];
}

export interface DomainListRealtimeSettlementsV2Response {
  /** 정산 데이터 */
  settlements?: DomainRealtimeSettlementV2Response[];
  /** 총 정산 데이터 (단일 데이터로 합산해서 반환) */
  totalSettlement?: DomainTotalSettlementResponse;
}

export interface DomainListRealtimeShopSaleItemsResponse {
  shopSaleItems?: DomainRealtimeShopSaleItemResponse[];
}

export interface DomainListSaleItemPlatformPendingModifyingReasonsResponse {
  platformPendingModifyingReasons?: DomainPlatformPendingModifyingReasonResponse[];
}

export interface DomainListSaleTaskDetailsResponse {
  saleTaskDetails?: DomainSaleTaskDetailResponse[];
}

export interface DomainListSaleTasksResponse {
  saleTasks?: DomainSaleTaskResponse[];
}

export interface DomainListSecondSoldCategoryMappingRulesResponse {
  rules?: DomainAclosetCategoryMappingRuleResponse[];
}

export interface DomainListServicePricingsResponse {
  /** 월 구독료 */
  monthlyPrice: number;
  /** 서비스 가격 목록 */
  servicePricings: DomainServicePricingResponse[];
}

export interface DomainListSettlementsResponse {
  /** 페이징 정보 */
  pagination: DomainPaginationResponse;
  /** 정산 데이터 (단일 데이터로 합산해서 반환. paymentDetailID로 필터해서 조회할 때만 의미가 있습니다.) */
  settlement: DomainSettlementResponse;
  /** 정산 목록 */
  settlements: DomainSettlementResponse[];
}

export interface DomainListShippingCompaniesResponse {
  shippingCompanies?: DomainShippingCompanyResponse[];
}

export interface DomainListShopAdditionalFieldMappingsRequest {
  shopID?: string;
}

export interface DomainListShopAdditionalFieldMappingsResponse {
  additionalFieldMappings: DomainShopAdditionalFieldMappingResponse[];
}

export interface DomainListShopAdditionalFieldsRequest {
  shopID?: string;
}

export interface DomainListShopBrandGroupsResponse {
  groups?: DomainShopBrandGroupResponse[];
}

export interface DomainListShopBrandsResponse {
  brands?: DomainShopBrandResponse[];
  pagination?: DomainPaginationResponse;
}

export interface DomainListShopCouponsResponse {
  /** 쿠폰 목록 */
  coupons?: DomainShopCouponResponse[];
  /** 페이징 정보 */
  pagination?: DomainPaginationResponse;
}

export interface DomainListShopCreditsForManagerResponse {
  /** 페이징 정보 */
  pagination?: DomainPaginationResponse;
  /** 샵 크레딧 목록 */
  shopCredits?: DomainShopCreditResponse[];
}

export interface DomainListShopCreditsResponse {
  /** 페이징 정보 */
  pagination?: DomainPaginationResponse;
  /** 샵 크레딧 목록 */
  shopCredits?: DomainShopCreditResponse[];
}

export interface DomainListShopHTMLTemplatesResponse {
  templates?: DomainShopHTMLTemplateResponse[];
}

export interface DomainListShopNotificationsResponse {
  notifications?: DomainShopNotificationResponse[];
  pagination?: DomainPaginationResponse;
}

export interface DomainListShopOrderCountsResponse {
  orderCounts?: DomainShopOrderCountResponse[];
}

export interface DomainListShopOrderDashboardsResponse {
  dashboards?: DomainOrderDashboardResponse[];
}

export interface DomainListShopOrderIDsResponse {
  orderIDs?: string[];
}

export interface DomainListShopOrdersResponse {
  orders?: DomainShopOrderResponse[];
  pagination?: DomainPaginationResponse;
}

export interface DomainListShopPlatformCategoriesResponse {
  categories?: DomainShopPlatformCategoryResponse[];
  /** 외부 플랫폼 타입 */
  platformType: 'SHOP_PLATFORM-TYPE_CAFE24' | 'SHOP_PLATFORM-TYPE_NAVER-SMART-STORE' | 'SHOP_PLATFORM-TYPE_BUNJANG';
}

export interface DomainListShopPriceBrandGroupsResponse {
  priceBrandGroups?: DomainPriceBrandGroupResponse[];
}

export interface DomainListShopPriceRulesResponse {
  priceRules?: DomainShopPriceRuleResponse[];
}

export interface DomainListShopPropertiesResponse {
  /** 속성 목록 */
  properties: DomainProperty[];
}

export interface DomainListShopRegionsResponse {
  /** 지역 정보 목록 */
  regions: DomainShopRegionResponse[];
}

export interface DomainListShopSaleDashboardsResponse {
  dashboards?: DomainSaleDashboardResponse[];
}

export interface DomainListShopSaleFieldsResponse {
  fields?: DomainShopSaleFieldResponse[];
}

export interface DomainListShopSaleItemCountsResponse {
  itemCounts?: DomainShopSaleItemCountResponse[];
}

export interface DomainListShopSaleItemIDsResponse {
  saleItemIDs?: string[];
}

export interface DomainListShopSaleItemsResponse {
  pagination?: DomainPaginationResponse;
  shopSaleItems?: DomainShopSaleItemResponse[];
}

export interface DomainListShopSaleTaskSummariesResponse {
  saleTaskSummaries?: DomainShopSaleTaskSummaryResponse[];
}

export interface DomainListShopTaskItemsResponse {
  shopTaskItems?: DomainShopTaskItemResponse[];
}

export interface DomainListShopTasksResponse {
  pagination?: DomainPaginationResponse;
  /** 작업 목록 */
  shopTasks?: DomainShopTaskResponse[];
}

export interface DomainListShopsResponse {
  /** 페이징 정보 */
  pagination?: DomainPaginationResponse;
  /** 샵 목록 */
  shops?: DomainShopResponse[];
}

export interface DomainListSizeMappingGroupsResponse {
  sizeMappingGroups?: DomainSizeMappingGroupResponse[];
}

export interface DomainListSizeTargetKeywordsResponse {
  /** 사이즈 타겟 키워드 목록 */
  sizeTargetKeywords?: DomainSizeTargetKeywordResponse[];
}

export interface DomainListTasksResponse {
  /** 작업 목록 */
  tasks?: DomainTaskResponse[];
}

export interface DomainListTemplateFieldsResponse {
  /** 필드 리스트 */
  fields?: DomainTemplateFieldResponse[];
}

export interface DomainListUnMappedMappingGroupMappingRulesResponse {
  rules: DomainUnMappedMappingGroupMappingRule[];
}

export interface DomainLoadBunjangProductsRequest {
  /** lookoai 샵 ID */
  shopID: string;
}

export interface DomainLoadBunjangShopLoadTaskRequest {
  /** 검색 키워드, 복수의 검색 키워드를 콤마(,)로 구분하여 입력하면 상점명들을 한 번에 불러온다 */
  searchKeyword: string;
  /** 검색 타입 (bunjang, shop-load-search-type 메타데이터 참조) */
  searchType: string;
}

export interface DomainMappingGroupMappingRequest {
  /** 생성할 매핑의 브랜드 그룹 ID 리스트 (mapping-type 이 MAPPING-GROUP_MAPPING-TYPE_CUSTOM 일 경우에만 해당) */
  brandGroupIDs?: string[];
  /** 생성할 매핑의 소재 */
  fabrics?: string[];
  /** 생성할 매핑의 타입, 메타데이터 (mapping-group, mapping-type 참고) */
  mappingType: string;
  /** 생성할 매핑의 이름 (ex. Premium, Polo ...) */
  name?: string;
  /** 생성할 규칙들이 매핑 될 플랫폼 구분, 메타데이터 (shop, platform-type 참고) */
  platformType: string;
  /** 생성할 매핑의 규칙들 */
  rules: DomainMappingGroupMappingRuleRequest[];
}

export interface DomainMappingGroupMappingResponse {
  /** 브랜드 그룹 아이디 */
  brandGroupIDs?: string[];
  /** 소재 그룹 */
  fabrics?: string[];
  /** 매핑 ID */
  mappingID?: string;
  /** 매핑의 타입, 메타데이터 (mapping-group, mapping-type  참고) */
  mappingType?: string;
  /** 매핑의 이름 (ex. Premium, Polo ...) */
  name?: string;
  /** 매핑이 속한 플랫폼 구분, 메타데이터 (shop, platform-type 참고) */
  platformType?: string;
  /** 매핑의 규칙들 */
  rules?: DomainMappingRuleResponse[];
}

export interface DomainMappingGroupMappingRuleRequest {
  /** 매핑과 연결될 매핑 그룹 속성의 부가 속성 코드 */
  aimsAttribute?: string;
  /** 매핑과 연결될 매핑 그룹 속성 코드 */
  aimsCategory: string;
  /** 사용자가 설정한 매핑과 연결될 매핑 그룹 속성의 부가 속성 코드 */
  customAttribute?: DomainCustomAttributeRequest;
  /** 매핑될 플랫폼의 카테고리 ID 리스트 */
  platformCategoryIDs: string[];
}

export interface DomainMappingGroupPropertyRequest {
  /** 매핑 그룹 속성 부가 속성 코드 */
  aimsAttribute?: string;
  /** 매핑 그룹 카테고리 코드 */
  aimsCategory: string;
  /** 사용자 지정 매핑 그룹 속성 부가 속성 코드 */
  customAttribute?: DomainCustomAttributeRequest;
}

export interface DomainMappingGroupPropertyResponse {
  /** 매핑 그룹 속성 부가속성명 */
  aimsAttribute?: string;
  /** 매핑 그룹 속성 부가속성명 */
  aimsAttributeName?: string;
  /** 매핑 그룹 카테고리 코드 */
  aimsCategory?: string;
  /** 매핑 그룹 카테고리 명 */
  aimsCategoryName?: string;
  /** 사용자 지정 매핑 그룹 속성 부가속성명 */
  customAttribute?: DomainCustomAttributeResponse;
  /** 상위 카테고리 코드 */
  groupCategory?: string;
  /** 상위 카테고리 명 */
  groupCategoryName?: string;
  /** 매핑 그룹 속성 ID */
  propertyID?: string;
}

export interface DomainMappingGroupResponse {
  mappingGroupID?: string;
  /** 메타데이터 (mapping-group, type 참고) */
  type?: string;
}

export interface DomainMappingGroupTypeResponse {
  /** @example "63ec5ccff19921e0414902b7" */
  mappingGroupID: string;
  /** @example "MAPPING-GROUP_TYPE_WOMEN" */
  type: string;
  /** @example "여성" */
  typeName: string;
}

export interface DomainMappingPropertyResponse {
  /** 카테고리 상세분류 (매핑 그룹 속성 부가속성명) */
  aimsAttribute?: string;
  /** 카테고리 상세분류 영문명 (매핑 그룹 속성 부가속성 영문명) */
  aimsAttributeEnglishName?: string;
  /** 카테고리 상세분류 한글명 (매핑 그룹 속성 부가속성 한글명) */
  aimsAttributeName?: string;
  /** 매핑 그룹 카테고리 코드 */
  aimsCategory: string;
  /** 매핑 그룹 카테고리 명 */
  aimsCategoryName: string;
  /** 매핑 그룹 속성의 그룹 코드 */
  groupCategory: string;
  /** 매핑 그룹 속성 그룹 그룹명 (상의, 하의, 아우터 ... 등) */
  groupCategoryName: string;
}

export interface DomainMappingRuleResponse {
  /** 매핑 규칙이 속한 AIMS 속성 */
  aimsAttribute?: string;
  /** 매핑 규칙이 속한 AIMS 속성명 */
  aimsAttributeName?: string;
  /** 매핑 규칙이 속한 AIMS 카테고리 */
  aimsCategory: string;
  /** 매핑 규칙이 속한 AIMS 카테고리명 */
  aimsCategoryName: string;
  /** 매핑 규칙이 속한 사용자 지정 속성 */
  customAttribute?: DomainCustomAttributeResponse;
  /** 매핑 그룹 속성의 그룹 코드 */
  groupCategory: string;
  /** 매핑 그룹 속성 그룹 그룹명 (상의, 하의, 아우터 ... 등) */
  groupCategoryName: string;
  /** 매핑 규칙이 속한 플랫폼 카테고리 리스트 */
  platformCategories: DomainPlatformCategoryResponse[];
  /** 매핑 규칙 ID */
  ruleID: string;
}

export interface DomainMarketItemLogixPrice {
  jeju?: number;
  normal?: number;
  outlyingArea?: number;
}

export interface DomainMarketItemLogixPriceRequest {
  /** 제주 추가 배송비 */
  jeju?: number;
  /** 기본 배송비 */
  normal?: number;
  /** 도서 산간 추가 배송비 */
  outlyingArea?: number;
}

export interface DomainMarketItemReviewImageResponse {
  /**
   * 이미지 높이
   * @example 100
   */
  height: number;
  /** @example true */
  isMain: boolean;
  /** @example 1 */
  order: number;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  url: string;
  /**
   * 이미지 폭
   * @example 100
   */
  width: number;
}

export interface DomainMarketItemReviewResponse {
  /**
   * 리뷰 내용
   * @example "1시간 늦게 나왔네요"
   */
  comment: string;
  /**
   * 리뷰 답글
   * @example "죄송합니다. 다음에는 더 빨리 배송하겠습니다."
   */
  commentReply?: string;
  /**
   * 리뷰 답글 작성 일시
   * @example "2024-04-05T04:24:25.966Z"
   */
  commentReplyDate?: string;
  /**
   * 리뷰 생성일시
   * @example 1668080178342
   */
  createDate: number;
  /** 리뷰 이미지 */
  images: DomainMarketItemReviewImageResponse[];
  /**
   * 리뷰 수정 여부
   * @example false
   */
  isModified: boolean;
  /**
   * 리뷰를 하는 사람의 회원탈퇴 여부
   * @example false
   */
  isReviewerDeleted: boolean;
  /**
   * 리뷰와 연결된 중고 ID
   * @example 125156
   */
  marketItemID: number;
  /**
   * 리뷰와 연결된 중고 상품 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  marketItemImageURL: string;
  /**
   * 리뷰와 연결된 중고 상품 썸네일 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  marketItemThumbnailURL: string;
  /**
   * 로그인 한 유저가 답글 리뷰를 작성한 경우 해당 리뷰 ID (작성하지 않은 경우 null)
   * @example 12512563
   */
  myReviewID?: number;
  /**
   * 주문 ID
   * @example 1
   */
  orderID: number;
  /**
   * 주문 상품 ID
   * @example 1
   */
  orderItemID: number;
  /**
   * 리뷰 평점
   * @example 0.5
   */
  rating: number;
  /**
   * 리뷰 ID (PK)
   * @example 24521
   */
  reviewID: number;
  /** 컨디션 태그 */
  reviewTags: string[];
  /**
   * 리뷰의 타입 (BUYING: 구매자가 작성한 리뷰, SELLING: 판매자가 작성한 리뷰)
   * @example "MARKET-ITEM_REVIEW-TYPE_SELLING"
   */
  reviewType: 'MARKET-ITEM_REVIEW-TYPE_SELLING' | 'MARKET-ITEM_REVIEW-TYPE_BUYING';
  /** 리뷰를 받는 사람 */
  reviewee: DomainReviewUserResponse;
  /** 리뷰를 하는 사람 */
  reviewer: DomainReviewUserResponse;
  sizeTags: string[];
  /**
   * 리뷰 상태
   * @example "MARKET-ITEM-REVIEW_INSPECTION_REJECTED"
   */
  status:
    | 'MARKET-ITEM-REVIEW_INSPECTION_PENDING'
    | 'MARKET-ITEM-REVIEW_INSPECTION_APPROVED'
    | 'MARKET-ITEM-REVIEW_INSPECTION_REJECTED';
  /** 컬러 태그 */
  treasureTags: string[];
}

export interface DomainMeasureProperty {
  height?: number;
  ratio?: number;
  width?: number;
}

export interface DomainMetadataDescriptionResponse {
  en?: string;
  es?: string;
  fr?: string;
  ko?: string;
  ru?: string;
}

export interface DomainMetadataResponse {
  code: string;
  description?: DomainMetadataDescriptionResponse;
  domain?: string;
  subDomain?: string;
}

export interface DomainMigrateAclosetMarketItemShippingFeeRequest {
  shopIDs?: string[];
}

export interface DomainMigrateDeleteCafe24ProductAdditionalImagesRequest {
  shopID?: string;
}

export interface DomainMigrateModifySaleItemsRequest {
  itemIDs?: string[];
  platformTypes?: string[];
}

export interface DomainMigrateNaverTemplateFixedImageURLRequest {
  shopIDs?: string[];
}

export interface DomainMigrationTemplatesRequest {
  shopIDs: string[];
}

export interface DomainModifyExcelShopOrdersFromExcelResponse {
  /**
   * 업데이트 된 아이템 개수
   * @example 100
   */
  orderCount?: number;
}

export interface DomainModifyPasswordRequest {
  /** @example "abc@naver.com" */
  email: string;
  /** @example "123456" */
  password: string;
  /**
   * 인증코드
   * @example "123456"
   */
  verificationCode: string;
}

export interface DomainModifySaleItemDiscountsRequest {
  /** 적용할 플랫폼-할인율 리스트 */
  platformDiscounts: DomainPlatformModifyDiscountRequest[];
  /** 할인율을 변경할 아이템 ID 리스트 */
  saleItemIDs: string[];
}

export interface DomainModifySaleItemDiscountsResponse {
  /** 작업 ID (실 사용 예 없음) */
  saleTaskID?: string;
}

export interface DomainModifySaleItemInstagramDescriptionRequest {
  /** 인스타그램 설명 */
  instagramDescription: string;
  /** 상품 ID */
  saleItemID: string;
}

export interface DomainModifySaleItemPlatformCategoriesRequest {
  /** 수정할 세컨솔드 의류 구분(ACLOSET ONLY) (market-item, genderwear 메타데이터 참조) */
  aclosetGenderWear?: string;
  /** 플랫폼 카테고리 ID 리스트 (⚠️ 네이버는 업로드가 된 경우 같은 대분류 내에서만 수정 가능함, 카페24만 복수 선택 가능) */
  platformCategoryIDs: string[];
  /** 플랫폼 타입 (shop, platform-type 메타데이터 참조) */
  platformType: string;
}

export interface DomainModifySaleItemRequest {
  /** 수정할 플랫폼 타입 (shop, platform-type 메타데이터 참조) */
  platformTypes?: string[];
  /** 이미지 업데이트 여부 (기본값 false) */
  updateImage?: boolean;
}

export interface DomainModifyShopPlanRequest {
  /** 플랜 ID */
  planID?: string;
}

export interface DomainModifyShopTaskItemImageRequest {
  cropBox: DomainCropBoxRequest;
  /**
   * 수정된 마스크 이미지
   * @example "mask.webp"
   */
  maskImageURL: string;
  /**
   * 수정된 원본 이미지
   * @example "original.jpg"
   */
  originalImageURL: string;
}

export interface DomainModifyUserEmailPasswordRequest {
  newEmail: string;
  newPassword: string;
  /** 상점명 */
  shopName: string;
}

export interface DomainModifyUserEmailRequest {
  email: string;
}

export interface DomainModifyUserPasswordRequest {
  newPassword: string;
  oldPassword: string;
}

export interface DomainMultiClassProperty {
  class_id?: number[];
  class_name?: string[];
  topk_probs?: DomainTopKProbability[];
  version?: string;
}

export interface DomainMultiModelRequest {
  image_info?: DomainImageInfo[];
  inference_properties?: string[];
}

export interface DomainMultiModelResponse {
  fail_count?: number;
  msg?: string;
  result?: DomainAIProperty[];
  status?: number;
  total_count?: number;
}

export interface DomainNaverItemLoadSetting {
  /** 블랙리스트 URL 리스트 */
  blackListURLs?: string[];
  /** 디폴트 성별 설정 */
  defaultGender?: string;
  /** 활성화여부 */
  enable?: boolean;
  /** 추가할 이미지 소스 설정 */
  imageSources?: string[];
  /** 최초 동기화 기간 */
  loadDuration?: string;
  /** 대체 문구 리스트 */
  replaceTexts?: DomainReplaceText[];
}

export interface DomainNaverSmartStoreOption {
  /** 옵션명 (필수) */
  groupName?: string;
  /** 옵션 일련번호 (입력 시 기존 옵션 수정) */
  id?: number;
  /** 옵션값 */
  name?: string;
  /** 사용 여부 */
  usable?: boolean;
}

export interface DomainNaverpayCancelReasonResponse {
  naverpayCancelReasonCode?: string;
  naverpayCancelReasonMessage?: string;
}

export interface DomainOpenSaleItemsRequest {
  /**
   * 게시할 판매 상태 (메타데이터 sale, platform-status 참조)
   * @default "SALE_PLATFORM-STATUS_OPEN-SALE"
   * @example "SALE_PLATFORM-STATUS_ON-SALE"
   */
  destinationPlatformStatus: 'SALE_PLATFORM-STATUS_ON-SALE' | 'SALE_PLATFORM-STATUS_STOP-SALE';
  /** 적용할 플랫폼-할인율 리스트 */
  platformDiscounts: DomainPlatformModifyDiscountRequest[];
  platformTypes: string[];
  saleItemIDs: string[];
}

export interface DomainOpenSaleItemsResponse {
  /** 작업 ID (실 사용 예 없음) */
  saleTaskID?: string;
}

export interface DomainOptionCombination {
  /** 조합형 옵션 ID (입력 시 기존 옵션 수정) */
  id?: number;
  /** 조합형 옵션값1 (필수) */
  optionName1?: string;
  /** 조합형 옵션값2 */
  optionName2?: string;
  /** 조합형 옵션값3 */
  optionName3?: string;
  /** 조합형 옵션값4 */
  optionName4?: string;
  /** 옵션가 <= 999999990 */
  price?: number;
  /** 판매자 관리 코드 */
  sellerManagerCode?: string;
  /** 재고 수량 <= 99999999 */
  stockQuantity?: number;
  /** 사용 여부 (Default: true) */
  usable?: boolean;
}

export interface DomainOptionInfo {
  /** 조합형 옵션 정렬 순서 (Enum: CREATE, ABC, LOW_PRICE, HIGH_PRICE CREATE, ABC만 입력 가능) (Default: CREATE) */
  optionCombinationSortType?: string;
  /** 조합형 옵션 (최대 3개까지 등록 가능) */
  optionCombinations?: DomainOptionCombination[];
  /** 직접 입력형 옵션 (최대 5개까지 등록 가능) */
  optionCustom?: DomainNaverSmartStoreOption[];
  /** 옵션별 배송 속성 옵션값 목록 (옵션별 배송 속성인 경우 최소 한 개는 입력. 첫 번째 옵션명에 해당하는 옵션값만 입력 가능. 미입력시 기존값 유지) */
  optionDeliveryAttributes?: string[];
  /**
   * 표준형 옵션, 단독형 옵션, 조합형 옵션, 직접 입력형 옵션 중 최소 한개는 입력해야 합니다.
   * 표준형 옵션, 단독형 옵션과 조합형 옵션은 함께 사용할 수 없습니다.
   */
  optionSimple?: DomainNaverSmartStoreOption[];
  /** 표준형 옵션 */
  optionStandards?: DomainOptionStandard[];
  /** 단독형 옵션 정렬 순서 (Enum: CREATE, ABC, LOW_PRICE, HIGH_PRICE CREATE, ABC만 입력 가능) (Default: CREATE) */
  simpleOptionSortType?: string;
  /** 표준형 옵션 그룹 (색상, 사이즈를 등록 필요) */
  standardOptionGroups?: DomainStandardOptionGroup[];
  /** 옵션 재고 수량 관리 사용 여부 (Default: true) */
  useStockManagement?: boolean;
}

export interface DomainOptionStandard {
  /** 표준형 옵션 ID (입력 시 기존 옵션 수정) */
  id?: number;
  /** 표준형 옵션값1 (필수) */
  optionName1?: string;
  /** 표준형 옵션값2 */
  optionName2?: string;
  /** 판매자 관리 코드 */
  sellerManagerCode?: string;
  /** 재고 수량 <= 99999999 */
  stockQuantity?: number;
  /** 사용 여부 (Default: true) */
  usable?: boolean;
}

export interface DomainOrderAfterPlatformStatusRequest {
  /** 변경 후 상태 (sale, platform-status 메타데이터 참조) */
  afterPlatformStatus: string;
  /** 주문 ID */
  orderID: string;
}

export interface DomainOrderDashboardResponse {
  dashboardItems?: DomainDashboardItemResponse[];
  /** 주문 상태별 주문 수 */
  orderCount?: number;
  /** 주문 상태(메타데이터 order, status 참조) */
  orderStatus?: string;
}

export interface DomainOriginAreaInfo {
  /** 원산지 표시 내용 */
  content?: string;
  /** 원산지 상세 지역 코드 04 고정 */
  originAreaCode?: string;
}

export interface DomainPaginationResponse {
  /** 현재 페이지 번호 */
  pageNumber?: number;
  /** 페이지 당 크기 */
  pageSize?: number;
  /** 총 아이템 수 */
  totalCount?: number;
  /** 총 페이지 수 */
  totalPageCount?: number;
}

export interface DomainPartnerShopInfoStoreLocations {
  /** 주소지 */
  address?: string;
  /** 상세 주소 */
  detailedAddress?: string;
  /** 지번 */
  lotNumberAddress?: string;
  /** 도, 특별시, 광역시 */
  region?: string;
  /** Region에 해당하는 지역범위 */
  subRegion?: string;
}

export interface DomainPartnerShopStoreCouponResponse {
  /** 매장 쿠폰 이름 */
  couponName?: string;
  /** 할인 금액 */
  discountAmount?: number;
  /** 최소 결제 금액 */
  txAmountMin?: number;
}

export interface DomainPatchBunjangShopRequest {
  /** 계정 설정 */
  accountSettings?: DomainBunjangAccountSettingRequest[];
  /** 영업상태 (bunjang, business-status 메타데이터 참조) */
  businessStatus?: string;
  /** 카카오톡 상태 (bunjang, kakaotalk-status 메타데이터 참조) */
  kakaotalkStatus?: string;
  /** 메모 */
  memo?: string;
  /** 샵 상태 (bunjang, status 메타데이터 참조) */
  status?: string;
}

export interface DomainPatchItemConsistencyReportRequest {
  /**
   * 수정할 상태 (item-consistency-report, status 메타데이터 참조)
   * @example "REPORT_STATUS_DONE"
   */
  status: string;
}

export interface DomainPatchMappingGroupRequest {
  /**
   * 맵핑그룹 상태
   * @example "MAPPING_GROUP_STATUS_DONE"
   */
  status?: string;
}

export interface DomainPatchMappingRuleRequest {
  /** 수정할 플랫폼 카테고리 ID 리스트 */
  platformCategoryIDs?: string[];
}

export interface DomainPatchNoticeRequest {
  /** 공지사항 상태 (메타데이터 app, notice-status 참조) */
  status?: string;
  /** 공지사항 제목 */
  title?: string;
  /** 공지사항 URL */
  url?: string;
}

export interface DomainPatchPaymentCardRequest {
  /** 기본 설정여부 */
  isDefault?: boolean;
}

export interface DomainPatchShopBlockRequest {
  /** 차단/차단 해제 여부 */
  isBlocked: boolean;
}

export interface DomainPatchShopBusinessRequest {
  /** 계좌주명 */
  accountHolder?: string;
  /** 계좌번호 */
  accountNumber?: string;
  /** 사업장 주소 */
  address?: string;
  /** 계좌 은행 */
  bankName?: string;
  /** 사업자 이메일 */
  businessEmail?: string;
  /** 사업자 전화번호 */
  businessMobile?: string;
  /** 회사 법인명 */
  businessName?: string;
  /** 사업자 등록증 파일명 */
  businessRegistrationFileName?: string;
  /** 사업자 등록증 파일 URL */
  businessRegistrationFileURL?: string;
  /** 사업자 등록번호 */
  businessRegistrationNumber?: string;
  /** 업태/업종 (별도의 메타데이터 존재하지 않음) */
  businessType?: string;
  /** 통신판매신고증 사본 이름 */
  mailOrderSalesRegistrationFileName?: string;
  /** 통신판매신고증 사본 URL */
  mailOrderSalesRegistrationFileURL?: string;
  /** 통신판매신고번호 */
  mailOrderSalesRegistrationNumber?: string;
  /** 오너 전화번호 */
  ownerMobile?: string;
  /** 대표명 */
  ownerName?: string;
  /** 사업자 유형 (별도의 메타데이터 존재하지 않음) */
  ownerType?: string;
}

export interface DomainPatchShopCafe24AuthRequest {
  /** @example "apiKey" */
  apiKey?: string;
  /** @example "clientID" */
  clientID?: string;
  /** @example "clientSecret" */
  clientSecret?: string;
  /**
   * 카페 24 대표운영자 ID
   * @example "mallID"
   */
  mallID: string;
}

export interface DomainPatchShopHTMLTemplateRequest {
  acloset?: DomainDescriptionJsonDOMRequest;
  bunjang?: DomainDescriptionJsonDOMRequest;
  cafe24?: DomainDescriptionJsonDOMRequest;
  instagram?: DomainDescriptionJsonDOMRequest;
  naverSmartStore?: DomainDescriptionJsonDOMRequest;
}

export interface DomainPatchShopItemsRequest {
  items: DomainShopItemRequest[];
}

export interface DomainPatchShopOrdersRequest {
  /** 변경할 운송장 번호 (⚠️ 택배사 코드와 함께 입력할 것) */
  invoiceNumber?: string;
  /** 변경할 OrderIDs 리스트 */
  orderIDs: string[];
  /** 수행 상태(메타데이터 order, operation 참조) */
  orderOperation?: string;
  /** 변경할 처리 상태 */
  processStatus?: string;
  /** 변경할 택배사 코드 (⚠️ 운송장 번호와 함께 입력할 것) */
  shippingCompanyCode?: string;
}

export interface DomainPatchShopPlatformCategoriesRequest {
  /** 카테고리 수정사항 */
  categories: DomainShopPlatformCategoryRequest[];
  /** 플랫폼 타입 (메타 데이터 shop, platform-type 참조) */
  platformType: string;
}

export interface DomainPatchShopPriceBrandGroupRequest {
  /**
   * 브랜드 ID 리스트
   * @example ["5f9f1b5b9b9b9b9b9b9b9b9b"]
   */
  brandIDs?: string[];
  name?: string;
}

export interface DomainPatchShopRequest {
  /** 예금주 */
  accountHolder?: string;
  /** 계좌번호 */
  accountNumber?: string;
  /** 샵 정보 (step4) - 추가 정보 */
  aclosetShopDescription?: DomainAclosetShopDescription;
  /** AI 상품 설명 설정 */
  aiDescriptionSetting?: DomainShopAIDescriptionSetting;
  /** 자동 판매개시 플랫폼 타입 */
  autoOpenSalePlatformTypes?: string[];
  /** 가격 자동생성 시, 소비자가, 판매가 타입, 메타데이터 sale item-price 참고 */
  autoPriceType?: string;
  /** 배경색 설정 색상 헥스 코드 */
  backgroundColorHexCode?: string;
  backgroundRemovedImageSetting?: DomainShopBackgroundRemovedImageSettingRequest;
  /** 정산 정보 (step2) */
  bankName?: string;
  /** 번개장터 샵 정보 */
  bunjang?: DomainShopBunjangStaticRequest;
  /** 사업자 주소 */
  businessAddress?: string;
  /** 사업자 연락처 */
  businessContact?: string;
  /** 회사명 */
  businessName?: string;
  /** 사업자 등록증 파일명 */
  businessRegistrationFileName?: string;
  /** 사업자 등록증 파일 URL */
  businessRegistrationFileURL?: string;
  /** 사업자 등록번호 */
  businessRegistrationNumber?: string;
  /** 사업자 정보 (step1) - 통신판매업자 여부 */
  businessType?: string;
  /** 카페24 샵 정보 */
  cafe24?: DomainShopCafe24StaticRequest;
  /** 촬영 프리셋 정보 */
  cameraSettingPresets?: DomainShopCameraSettingPresetRequest[];
  /**
   * 촬영 환경
   * @example "SHOP_SHOOTING-ENVIRONMENT_ENABLE-BACKLIGHT"
   */
  cameraShootingEnvironment?: string;
  /** 치수 유형 설정 */
  clothesSizeType?: DomainShopClothesSizeTypeRequest;
  /**
   * 입점 쇼핑몰 리스트 (메타 데이터 platform-type 참조)
   * @example ["SHOP_PLATFORM-TYPE_CAFE24","SHOP_PLATFORM-TYPE_NAVER-SMART-STORE"]
   */
  connectedPlatformTypes?: string[];
  /** 사용자 정의 입력 필드 스키마 */
  customInputFieldSchemas?: DomainCustomInputFieldSchemaRequest[];
  /** 치수 사용 타입. (치수 자동추출을 할지 말지에 대해서 설정. 메터데이터 shop, deriving-clothes-size-type 참조) */
  derivingClothesSizeType?: string;
  detailImageSetting?: DomainShopDetailImageSettingRequest[];
  /** @example ["SHOP_IMAGE-TYPE_FRONT"] */
  detailImageTypes?: string[];
  /** 샵 접속 디바이스 */
  devices?: DomainShopDevice[];
  /**
   * 실제 변경을 수행하지 않고 검증만을 수행합니다.
   * @example true
   */
  dryRun?: boolean;
  /** AI 소재 분류 자동화 활성화 여부 */
  enableAutoFabricClassification?: boolean;
  /**
   * 상품명 자동 생성 여부
   * @example true
   */
  enableAutoGenerateTitle?: boolean;
  /** AI 상품정보 자동입력 활성화 여부 */
  enableAutoInput?: boolean;
  /** 가격 자동생성 활성화 여부 */
  enableAutoPrice?: boolean;
  /**
   * 상품명 자동 새로고침 여부
   * @example true
   */
  enableAutoRefreshTitle?: boolean;
  /** 이미지 자동 수평 보정 활성화 여부 */
  enableAutoRotateImage?: boolean;
  /**
   * 치수로부터 사이즈 자동 계산 여부
   * @example true
   */
  enableAutoSizeAssignment?: boolean;
  /**
   * 치수로부터 맵핑 자동 계산 여부
   * @example true
   */
  enableAutoSizeMapping?: boolean;
  /**
   * 배경제거 활성화 여부
   * @example true
   */
  enableBackgroundRemoved?: boolean;
  /**
   * 상세 이미지 사용 여부
   * @example true
   */
  enableDetailImage?: boolean;
  /**
   * 디테일 이미지 배경제거 활성화 여부
   * @example true
   */
  enableDetailImageBackgroundRemoved?: boolean;
  /**
   * 카페24 카테고리 직접 입력 여부
   * @example true
   */
  enableDirectInputCafe24Category?: boolean;
  /** 검색 키워드 템플릿 사용 여부 */
  enableSearchKeywordTemplate?: boolean;
  /**
   * 섬유의 소재 표기법, (GET: /shops/metadata의 fabric-notation 참고)
   * @example "METADATA-ALIAS_FABRIC-NOTATION_FIRST-AND-MIXED"
   */
  fabricNotation?: string;
  /** 소재 정렬 우선순위 (metadata.yaml의 SHOP, fabric-order-priority 참조) */
  fabricOrderPriority?: string;
  /** 조건별 배송비 부과시, 무료배송 조건금액 */
  freeShippingThreshold?: number;
  /**
   * HTML 타입 (메타 데이터 shop, html 참조)
   * @example "SHOP_HTML_SIMPLE, SHOP_HTML_MAPPING-GROUP"
   */
  htmlType?: string;
  imageCropOption?: DomainShopImageCropOptionRequest;
  /** 이미지 프리셋 정보 */
  imageEditorPresets?: DomainImageEditorPresetRequest[];
  /** 상세페이지의 이미지 여백 설정 */
  imageGapOption?: DomainShopImageGapOptionRequest;
  imageRatioOption?: DomainShopImageRatioOptionRequest;
  /** 이미지 고급 보정 */
  imageRetouchingOption?: DomainImageRetouchingOptionRequest;
  imageSortOption?: DomainShopImageSortOptionRequest;
  /** 이미지 타입 순서 규칙 설정 */
  imageTypeOrders?: string[];
  /** CS 담당자 연락처 */
  inquiryContact?: string;
  /** 채팅 가능시간 소개 */
  inquiryPossibleTime?: string;
  integratedImageSetting?: DomainShopIntegratedImageSettingRequest;
  /** 파트너샵 활성화 여부 */
  isPartnerShop?: boolean;
  itemCodeRules?: DomainShopItemCodeRuleRequest[];
  /** 상품 상태 항목 설정 */
  itemConditionFieldSetting?: DomainItemConditionField[];
  /** 상품 정보 항목 설정 */
  itemInputFieldSetting?: DomainItemInputField[];
  /** 카카오 알림 설정 */
  kakaoNotificationSetting?: DomainKakaoNotificationSetting;
  /** 로드할 플랫폼 타입 */
  loadPlatformType?: string;
  /** 배송 정책 */
  logixPolicy?: string;
  /** 배송/반품 정보 (step3) - 배송 정보 */
  logixPriceType?: string;
  /** 통신판매신고증 사본 이름 */
  mailOrderSalesRegistrationFileName?: string;
  /** 통신판매신고증 사본 URL */
  mailOrderSalesRegistrationFileURL?: string;
  /** 통신판매신고번호 */
  mailOrderSalesRegistrationNumber?: string;
  /** 관리자 계정에서 해당 샵에 대해 남기는 메모 (ex. 세금계산서 발행 여부 등) */
  memo?: string;
  /**
   * 온보딩이 어디까지 마무리되었는지를 보여주는 값, (GET: /shops/metadata의 shop, onboard-status 참고)
   * @example "SHOP_ONBOARD-STATUS_FINISHED"
   */
  onboardStatus?: string;
  /** 주문 배송비 (기본 배송비, 도서 산간 추가 배송비, 제주 추가 배송비), '추가 배송비 있음/없음'는 not nil/nil */
  orderShippingFee?: DomainMarketItemLogixPriceRequest;
  /** 자주 사용하는 원산지 리스트 */
  originPresets?: string[];
  /** 원산지 설정 */
  originSetting?: DomainShopOriginSettingRequest;
  /**
   * ----- 회원가입 시 받았던 필드들 -----
   * 사업자 정보 (step1) - 사업 정보
   */
  ownerName?: string;
  /** 사업자 유형 (별도의 메타데이터 존재하지 않음) */
  ownerType?: string;
  /** 쇼핑몰 게시 시 업로드 되는 이미지의 비율 */
  platformImageOption?: DomainPlatformImageOptionRequest;
  /** 플레이오토 샵 정보 */
  playAuto?: DomainShopPlayAutoStaticRequest;
  /**
   * 가격 절삭 단위 (ex 1000의 경우 53,000 -> 53)
   * @example 100
   */
  priceCuttingUnit?: number;
  /**
   * 자주 사용하는 가격
   * @example [1000,4000]
   */
  pricePresets?: number[];
  /** 장바구니에 담을 수 있는 최대개수 */
  purchaseQuantityLimit?: number;
  /** 반품 주소 정보 (받는 사람 포함) */
  refundAddressInfo?: DomainAclosetReturnAddressRequest;
  /** 반품 택배사 */
  refundCourierName?: string;
  /** 배송/반품 정보 (step3) - 반품 정보 */
  refundLogixType?: string;
  /** 반품 정책 */
  refundPolicy?: string;
  /** 반품 배송비 */
  refundShippingFee?: DomainMarketItemLogixPriceRequest;
  removeBackgroundOption?: DomainShopRemoveBackgroundOptionRequest;
  /** 자동 검색 키워드 포멧 템플릿 토큰 리스트 */
  searchKeywordTemplates?: DomainTemplateToken[][];
  /** 서비스 목록 설정 여부 */
  servicePricingAgreed?: boolean;
  /** 샵 설정 단계 */
  settingSteps?: DomainSettingStep[];
  /**
   * 샵 정보 (step4) - 샵 정보
   * @example "스토어 쟈넬"
   */
  shopName?: string;
  /** 샵 서비스 정보 */
  shopService?: DomainShopServiceRequest;
  /** 치수 표기법 (메타데이터 shop, size-notation 참조) */
  sizeNotation?: string;
  /** 특수 치수 표기법 (메타데이터 shop, special-size-notation 참조) */
  specialSizeNotations?: string[];
  /** 공급사 설정 */
  supplierSetting?: DomainShopSupplierSettingRequest;
  /** 상품명 설정을 위해 필요한 토큰 (기존의 TitleTemplate의 역할 일부 수행)                                                                                 // 자동 상품명 타입 (메타 데이터 참조) */
  templateTokens?: DomainTemplateToken[];
  /** 상품명 템플릿 */
  titleTemplate?: string;
  /** 온보딩 프로세스 */
  uploadOnboardingSteps?: DomainShopUploadOnboardingStepRequest[];
}

export interface DomainPatchShopTaskItemPlayAutoRequest {
  /** 추가 정보 */
  additionalInformation?: string;
  /** 사용자 분류명 */
  clientCategoryName?: string;
  /** 키워드 */
  keyword?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 업체 상품 코드 */
  productCode?: string;
}

export interface DomainPatchShopTaskItemRequest {
  /** 추가정보 Additional Field Schema API참고, Format: map ({fieldName}:{enums 에 속한 값 중 하나}) (단, text인 경우 자유 입력) */
  additionalFields?: Record<string, string[]>;
  /** AI 상품 설명 */
  aiDescription?: string;
  /** @example "OUTDOOR" */
  aimsAttribute?: string;
  /**
   * 수정할 AIMS 브랜드 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  aimsBrandID?: string;
  /** 자동 가격 입력 적용 여부 */
  autoPriceApplied?: boolean;
  /** 상품명 새로고침 자동, 수동 여부 */
  autoRefreshTitle?: boolean;
  /** 자동 기입 완성 여부 (true면 사이즈를 자동 기입) */
  autoSizeAssignment?: boolean;
  /**
   * 수정할 브랜드
   * @example "누이비통"
   */
  brand?: string;
  /**
   * 카페24 카테고리 아이디 리스트 (/shops/:shopID/platform-categories 참조)
   * @example ["1","2","3"]
   */
  cafe24CategoryIDs?: string[];
  /**
   * TODO 추후 프론트 협의 후 키값 aimsCategory로 변경
   * @example "SHIRTS"
   */
  category?: string;
  /**
   * 옷 특징 리스트 (메타데이터 shop, item-clothes-feature 참고)
   * @example ["SHOP_ITEM-CLOTHES-FEATURE_RAGLAN"]
   */
  clothesFeatures?: string[];
  /** @example "SHIRTS" */
  clothesSizeType?: string;
  /** @example "SHIRTS" */
  clothesType?: string;
  /**
   * 수정할 색상
   * @example ["BLACK","RED"]
   */
  colors?: string[];
  customAttribute?: DomainCustomAttributeRequest;
  /**
   * 사용자 입력 재질
   * @example ["고무"]
   */
  customFabrics?: string[];
  /** 사용자 정의 입력 필드 */
  customInputFields?: DomainCustomInputFieldRequest[];
  /**
   * 수정할 설명
   * @minLength 1
   * @maxLength 1000
   * @example "누가봐도 루이비통"
   */
  description?: string;
  /** @example ["COTTON"] */
  fabrics?: string[];
  /** 성별(shop, item-gender 메타데이터 참조) */
  gender?: string;
  /**
   * 상품명
   * @example "AA-135"
   */
  itemAlias?: string;
  /**
   * 상품 컨디션
   * @example 3
   */
  itemConditionLevel?: number;
  /**
   * 상품 원산지
   * @example "일본"
   */
  itemOrigin?: string;
  /** 수정할 키 포인트 정보 */
  keyPointLength?: DomainKeyPointLengthRequest;
  /**
   * 키워드
   * @example ["키워드1","키워드2"]
   */
  keywords?: string[];
  /**
   * 의류 구분(맵핑 그룹 아이디)
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  mappingGroupID?: string;
  /** 수정할 플레이오토 정보 */
  playAuto?: DomainPatchShopTaskItemPlayAutoRequest;
  /**
   * 수정할 가격
   * @min 10
   * @max 1000000000
   * @example 100
   */
  price?: number;
  /**
   * 수정할 소비자가
   * @min 10
   * @max 1000000000
   * @example 100
   */
  retailPrice?: number;
  /** 추가 정보 필드 */
  shopAdditionalFields?: DomainAdditionalField[];
  /**
   * 수정할 사이즈
   * @example "XXL"
   */
  size?: string;
  sizeLength?: DomainPatchShopTaskItemSizeLengthRequest[];
  /**
   * 수정할 제목
   * @minLength 1
   * @maxLength 80
   * @example "개쩌는 A급 짝퉁 팜"
   */
  title?: string;
}

export interface DomainPatchShopTaskItemSizeLengthRequest {
  prefix?: string;
  sizeTarget: string;
  tag?: string;
  value?: number;
}

export interface DomainPatchShopTaskRequest {
  /**
   * 수정할 AI 분석 타입  (메타 데이터 참조)
   * @example ["SHOP_AI-ANALYSIS_SIZE"]
   */
  aiAnalyses?: string[];
  /**
   * AI 정밀도 분석
   * @example "SHOP_AI-PRECISION_SIMPLE_ANALYSIS"
   */
  aiPrecision?: string;
  /** 의류 구분 상품별 선택시, 아이템에 디폴트로 들어가는 값 */
  defaultMappingGroupID?: string;
  /** 이미지 자르기 설정 */
  imageCropOption?: DomainShopImageCropOptionRequest;
  /**
   * 검수 시작일
   * @example "time"
   */
  inspectionStartDate?: string;
  /**
   * 검수자 ID
   * @example 2
   */
  inspectorID?: number;
  /** 상품 코드 규칙 */
  itemCodeRule?: DomainShopTaskItemCodeRuleRequest;
  /** 상품 정보 항목 설정 */
  itemInputFieldSetting?: DomainItemInputField[];
  /**
   * 의류 구분(맵핑 그룹 아이디)
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  mappingGroupID?: string;
  /** 배경제거 설정 여부 */
  removeBackgroundOption?: DomainShopRemoveBackgroundOptionRequest;
  /**
   * 수정할 작업 상태 (SHOP_TASK-STATUS_IN-PROGRESS, SHOP_TASK-STATUS_DONE)
   * @example "SHOP_TASK-STATUS_IN-PROGRESS"
   */
  status?: string;
  /** 공급사 설정 */
  supplier?: DomainShopSupplierRequest;
  /**
   * 수정할 작업명
   * @example "task"
   */
  taskName?: string;
}

export interface DomainPatchSizeTargetKeywordRequest {
  /** 키워드 목록 */
  keywords?: string[];
  /**
   * 우선순위
   * @example 1
   */
  priority?: number;
}

export interface DomainPauseBunjangShopLoadTaskRequest {
  /** 작업 ID */
  shopLoadTaskID: string;
}

export interface DomainPaymentCardResponse {
  /**
   * 카드 ID
   * @example "63eb6df3f45b6fc2c1045af1"
   */
  cardID?: string;
  /**
   * 카드명
   * @example "신한카드"
   */
  cardName?: string;
  /**
   * 카드 번호 (마스킹)
   * @example "55941000****725*"
   */
  cardNumber?: string;
  /**
   * 카드 등록일시
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  createDate?: string;
  /**
   * 이메일
   * @example "penguin@acloset.app"
   */
  email?: string;
  /**
   * 기본 설정여부
   * @example true
   */
  isDefault?: boolean;
  /**
   * 샵 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  shopID?: string;
}

export interface DomainPaymentDetailResponse {
  /**
   * 청구 금액 (우리가 청구한 금액)
   * @example 53000
   */
  billingAmount: number;
  /**
   * 결제 생성일
   * @example "2023-10-24T09:29:34.229Z"
   */
  createDate: string;
  /**
   * 결제 월 (예: 202303)
   * @example "202303"
   */
  month: string;
  /**
   * 결제 금액 (실제로 결제된 금액)
   * @example 53000
   */
  paymentAmount: number;
  /**
   * 결제 일시
   * @example "2023-10-24T09:29:34.229Z"
   */
  paymentDate: string;
  /**
   * 결제내역 ID
   * @example "65378b60f9505804b23cdaff"
   */
  paymentDetailID: string;
  /**
   * 결제 수단
   * @example "신한카드"
   */
  paymentMethod: string;
  /**
   * 2024년 구 정산 데이터까지만 사용되는 필드 - v6.3.0
   * @example "65378b60f9505804b23cdaf6"
   */
  planID?: string;
  /**
   * 사용한 서비스명 표기
   * @example "AI 업로드 + 판매관리"
   */
  serviceName: string;
  /**
   * 정산 타입 (GET: /shops/metadata의 settlement, type 참고)
   * @example "SETTLEMENT_TYPE_NORMAL"
   */
  settleType: string;
  /**
   * 결제 상태 (GET: /shops/metadata의 payment, status 참고)
   * @example "PAYMENT_STATUS_PENDING"
   */
  status: string;
  /**
   * 결제 시도 횟수
   * @example 5
   */
  tryCount: number;
  /**
   * 부가세
   * @example 3000
   */
  vat: number;
}

export interface DomainPaymentDetailTaskResponse {
  /**
   * 작업 등록일
   * @example "2023-10-24T09:29:34.229Z"
   */
  createDate?: string;
  /**
   * 작업당 상품 개수
   * @example 5
   */
  itemCount?: number;
  /**
   * 작업 이름
   * @example "결제"
   */
  taskName?: string;
}

export interface DomainPaymentMethodResponse {
  /**
   * 결제 수단 코드 (platform 도메인의 결제 수단 코드 참조. 플랫폼이 내려주는 코드로 적용함)
   * @example "cash"
   */
  code?: string;
  /**
   * 결제 수단 이름 (별도의 메타데이터 없음)
   * @example "무통장입금"
   */
  name?: string;
}

export interface DomainPlanResponse {
  /** 사용가능한 기능들 사용이 불가한 기능은 해당 리스트에 포함되지 않음 */
  availableFeatures?: DomainAvailableFeatureResponse[];
  /**
   * 할인 아이템당 가격
   * @example 70
   */
  discountPricePerItem?: number;
  /**
   * 프로모션 여부
   * @example true
   */
  isPromotion?: boolean;
  /**
   * 월 가격
   * @example 50000
   */
  monthlyPrice?: number;
  /**
   * 플랜 코드 (메타데이터 plan, code 참고)
   * @example "PLAN_CODE_PREMIUM"
   */
  planCode?: string;
  /**
   * 플랜 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  planID?: string;
  /**
   * 플랜명
   * @example "프리미엄 플랜"
   */
  planName?: string;
  /**
   * 아이템당 가격
   * @example 100
   */
  pricePerItem?: number;
}

export interface DomainPlatformBankResponse {
  /** 플랫폼의 은행 코드 */
  bankCode?: string;
  /** 플랫폼의 은행 이름 */
  bankName?: string;
}

export interface DomainPlatformCancelReasonResponse {
  /** 취소사유 코드 */
  cancelReasonCode?: string;
  /** 취소사유 메시지 */
  cancelReasonMessage?: string;
}

export interface DomainPlatformCategoryResponse {
  id?: string;
  name?: string;
}

export interface DomainPlatformCategoryRuleMappingRequest {
  brandGroupIDs?: string[];
  fabrics?: string[];
  mappingGroupType: string;
  /** 수정할 매핑그룹 속성 리스트 */
  properties: DomainMappingGroupPropertyRequest[];
}

export interface DomainPlatformCategoryRuleMappingResponse {
  brandGroupIDs?: string[];
  fabrics?: string[];
  mappingGroupType: string;
  mappingID: string;
  properties?: DomainMappingGroupPropertyResponse[];
}

export interface DomainPlatformCategoryRuleResponse {
  mappings?: DomainPlatformCategoryRuleMappingResponse[];
  platformCategory: DomainShopPlatformCategoryResponse;
  platformCategoryRuleID: string;
  useUnifiedRules: boolean;
}

export interface DomainPlatformImageOptionRequest {
  /** 쇼핑몰 게시 시 업로드 되는 이미지의 비율 활성화 여부 */
  enableUploadImageRatio?: boolean;
  /** 쇼핑몰 게시 시 업로드 되는 이미지의 비율 */
  uploadImageRatio?: string;
}

export interface DomainPlatformImageOptionResponse {
  /** 쇼핑몰 게시 시 업로드 되는 이미지의 비율 활성화 여부 */
  enableUploadImageRatio?: boolean;
  /** 쇼핑몰 게시 시 업로드 되는 이미지의 비율 (메타데이터 shop, ) */
  uploadImageRatio?: string;
}

export interface DomainPlatformModifyDiscountRequest {
  /** 할인율 (1 ~ 100) */
  discountRate: number;
  /** 플랫폼 타입 (shop, platform-type 메타데이터 참조) */
  platformType: string;
}

export interface DomainPlatformOriginAreaResponse {
  /** 플랫폼의 지역 코드 */
  areaCode?: string;
  /** 플랫폼의 지역 이름 */
  areaName?: string;
}

export interface DomainPlatformPendingModifyingReasonResponse {
  platformType?: string;
  reason?: string;
}

export interface DomainPlatformRefundMethodCodeResponse {
  refundMethodCode?: string;
  refundMethodMessage?: string;
}

export interface DomainPlatformRejectCancelReasonResponse {
  rejectCancelReasonCode?: string;
  rejectCancelReasonMessage?: string;
}

export interface DomainPlatformRejectReturnReasonResponse {
  requestRejectReasonCode?: string;
  requestRejectReasonMessage?: string;
}

export interface DomainPlatformRequestReturnReasonResponse {
  requestReturnReasonCode?: string;
  requestReturnReasonMessage?: string;
}

export interface DomainPlatformShippingCompanyResponse {
  shippingCompanyCode?: string;
  shippingCompanyName?: string;
}

export interface DomainPopupResponse {
  /** 액션 버튼 이름 */
  actionButtonName: string;
  /** 앱 버젼 */
  appVersion: string;
  /** 생성일 */
  createDate: string;
  /** 설명 */
  description: string;
  /** 액션 버튼 활성화 유무 */
  hasActionButton: boolean;
  /** 팝업 이미지 이름 */
  imageName: string;
  /** 팝업 이미지 URL */
  imageURL: string;
  /** 팝업 아이디 */
  popupID: string;
  /** 팝업 대상 */
  popupTargets: string[];
  /** 팝업 URL */
  popupURL: string;
  /** 제목 */
  title: string;
}

export interface DomainPreprocessImageRequest {
  /** @example "image.jpg" */
  imageURL: string;
}

export interface DomainPriceBrandGroupResponse {
  brands?: DomainPriceBrandResponse[];
  name?: string;
  priceBrandGroupID?: string;
}

export interface DomainPriceBrandResponse {
  /**
   * 브랜드 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  brandID?: string;
  /**
   * 영문 브랜드이름
   * @example "NIKE"
   */
  englishName?: string;
}

export interface DomainPricingPerItemUsageResponse {
  /** 요금 */
  fee: number;
  /** N개까지 적용되는 요금 */
  maxItemRange?: number;
  /** N개부터 적용되는 요금 */
  minItemRange?: number;
  /** 사용 타입 */
  usageType: string;
}

export interface DomainProSellerPartnerShopResponse {
  /** 매장 영업시간 */
  businessHours?: string;
  /** 매장 소개 컨텐츠 글 */
  contentDescription?: string;
  /** 매장소개 컨텐츠 이미지들 */
  contentImages?: string[];
  /** 매장 소개 활성화 여부 */
  enabled?: boolean;
  /** 대표 이미지 URL */
  mainImageUrl?: string;
  /** 지도 이미지 URL */
  mapImageUrl?: string;
  /** 닉네임 */
  nickname?: string;
  /** 파트너 샵 정보 ID */
  partnerShopInfoID?: number;
  /** 프로셀러 키워드 */
  prosellerKeywords?: string[];
  /** 한줄소개 */
  shortIntroduction?: string;
  /** 매장 쿠폰 */
  storeCoupons?: DomainPartnerShopStoreCouponResponse[];
  /** 간략 위치 */
  storeLocations?: DomainPartnerShopInfoStoreLocations;
  /** 유저 아이디 */
  userID?: number;
}

export interface DomainProcessedImageResponse {
  cropBox?: DomainCropBoxResponse;
  croppedImageURL?: string;
  maskedCroppedImageURL?: string;
  maskedImageURL?: string;
  originalImageURL?: string;
}

export interface DomainProductOption {
  /** 추가입력 옵션 리스트 */
  additionalOptions?: DomainCafe24AdditionalOption[];
  /** 파일 첨부 옵션 */
  attachedFileOption?: DomainCafe24AttachedFileOption;
  /** 옵션 사용여부 (T, F) */
  hasOption?: string;
  /** 옵션 표시방식 (C: 일체형, S: 분리형) */
  optionListType?: string;
  /** 옵션세트 코드 (형식: [A-Z0-9] 글자수: 최소 8자~최대 8자) */
  optionPresetCode?: string;
  /** 연동형 옵션 세트명 (상품연동형 옵션을 사용할 경우, 옵션 세트의 이름 입력) */
  optionPresetName?: string;
  /** 옵션 타입 (T: 조합형, E: 연동형, F: 독립형) */
  optionType?: string;
  /** 옵션 리스트 */
  options?: DomainCafe24Option[];
  /** 옵션별로 한 개씩 선택 (독립형 옵션) (T: 사용함, F: 사용안함) */
  selectOneByOption?: string;
  /** 추가입력 옵션 사용 여부 (T: 사용함, F: 사용안함) */
  useAdditionalOption?: string;
  /** 파일 첨부 옵션 사용 여부 (T: 사용함, F: 사용안함) */
  useAttachedFileOption?: string;
}

export interface DomainProductSEOTemplate {
  metaAlt?: string;
  metaAuthor?: string;
  metaDescription?: string;
  metaKeywords?: string;
  metaTitle?: string;
}

export interface DomainProperty {
  code: string;
  /**
   * 영어
   * @example "black"
   */
  en?: string;
  /** 스페인어 */
  es?: string;
  /**
   * 프랑스어
   * @example "noir"
   */
  fr?: string;
  /**
   * 한국어
   * @example "검정"
   */
  ko?: string;
  /** 러시아어 */
  ru?: string;
}

export interface DomainProxyRequest {
  /** 요청할 바디 (쌩 문자열로) */
  body: string;
  /** 요청할 헤더 (오브젝트 형태) */
  header: Record<string, string>;
  /** 요청할 메소드 (대문자) */
  method: string;
  /** 요청할 전체 URL */
  url: string;
}

export interface DomainProxyResponse {
  body?: string;
  header?: Record<string, string[]>;
  statusCode?: number;
}

export interface DomainPublishUpdateSaleItemsRequest {
  /** 동기화할  업데이트 할 플랫폼 타입 리스트 (빈 경우 연동된 플랫폼 전체 동기화) */
  platformTypes?: string[];
}

export interface DomainRealtimeSettlementV2Response {
  /**
   * 자동 결제된 크레딧 금액
   * @example 10000
   */
  chargedCreditAmount: number;
  /** 쿠폰 목록 */
  coupons?: DomainShopCouponResponse[];
  /**
   * 정산 종료일
   * @example "2023-11-24T09:29:34.229Z"
   */
  endDate: string;
  /**
   * 쿠폰 적용 여부
   * @example true
   */
  isCouponApplied: boolean;
  /** 추가 이용료 상세 내역 - New */
  itemUsageDetails?: DomainItemUsageDetailResponse[];
  /**
   * 추가 이용료 총 금액
   * @example 10000
   */
  itemUsagePrice: number;
  /**
   * 정산 월 (예: 202303)
   * @example "202306"
   */
  month: string;
  /**
   * 월 고정 구독료
   * @example 50000
   */
  monthlyPrice: number;
  /**
   * 사용한 서비스명 표기
   * @example "AI 업로드 + 판매관리"
   */
  serviceName: string;
  /**
   * 정산 시작일
   * @example "2023-10-24T09:29:34.229Z"
   */
  startDate: string;
  /**
   * 정산 총 금액 (추가 이용료 + 월 고정 구독료)
   * @example 90000
   */
  totalPrice: number;
  /**
   * 사용된 크레딧 금액
   * @example 10000
   */
  usedCreditAmount: number;
}

export interface DomainRealtimeShopSaleItemResponse {
  /** 아이템 등록일 */
  createDate: string;
  /** 이미지 */
  images: DomainShopTaskItemImageResponse[];
  /** 상품코드 */
  itemAlias: string;
  /** 실시간 세컨드솔드 플랫폼판매 상태 (메타데이터 sale-platform, status 참조) */
  realtimeSecondSoldStatus?: string;
  /** 아이템 ID */
  saleItemID: string;
  /** 상품 플랫폼 상태 */
  saleItemPlatforms: DomainSaleItemPlatformResponse[];
  /** 판매 상태 (메타데이터 sale, status 참조) */
  saleStatus: string;
  /** 샵이름 */
  shopName: string;
  /** 상품명 */
  title: string;
}

export interface DomainReceiverAddressResponse {
  /**
   * 기본 주소
   * @example "서울시 테헤란로 43번길 12"
   */
  baseAddress?: string;
  /**
   * 상세 주소
   * @example "6층 룩코 삼겹살집 아 삼겹살 먹고싶다 ~~"
   */
  detailAddress?: string;
  /**
   * 우편번호
   * @example "13601"
   */
  zipCode?: string;
}

export interface DomainRecoverDeletedSaleItemsRequest {
  itemIDs: string[];
}

export interface DomainRecoverInvalidCafe24ProductVariantRequest {
  shopIDs?: string[];
}

export interface DomainRefreshTokenResponse {
  accessToken?: string;
}

export interface DomainRejectAclosetOfferRequest {
  /** 할인요청 거절 사유 (/shops/acloset-reject-price-offer-reasons 참조) */
  offerRejectReason?: string;
  /** 거절 사유 타입 (/shops/acloset-reject-price-offer-reasons 참조) */
  offerRejectReasonType?: string;
  /** 거절 후 상품 주문 별 상태 리스트 */
  orderAfterPlatformStatuses: DomainOrderAfterPlatformStatusRequest[];
  platformOrderID: string;
}

export interface DomainRejectCancelOrdersRequest {
  /** 운송장 번호 (⚠️네이버에서 필수) */
  invoiceNumber?: string;
  /** 취소 거부할 OrderIDs 리스트 (⚠️ 네이버의 경우 단건만 가능) */
  orderIDs: string[];
  /** 택배사 코드 (⚠️네이버에서 필수) */
  shippingCompanyCode?: string;
}

export interface DomainRejectCancelOrdersResponse {
  /** 작업 ID (실 사용 예 없음) */
  saleTaskID?: string;
}

export interface DomainRejectReturnClaimAclosetRequest {
  /**
   * 반품거부사유 타입
   * @example "OTHER_REASON"
   */
  rejectReturnReason?: string;
  /**
   * 반품거부사유 직접입력 (기타)
   * @example "이거 반품해주세요!"
   */
  rejectReturnReasonDetails?: string;
}

export interface DomainRejectReturnClaimCafe24Request {
  /**
   * 반품사유 구분 (platform 도메인의 반품사유 구분 코드 참조)
   * @example "F"
   */
  claimReasonType: string;
  /**
   * 주문상세내역 노출설정
   * @example true
   */
  isDisplayRejectReason: boolean;
  /**
   * 반품사유 (최대 2000자)
   * @example "상품이 잘못 온 것 같아 반품을 신청합니다."
   */
  reason: string;
  /**
   * 거부사유 (최대 2000자)
   * @example "훼손이 심해 반품을 거부함."
   */
  rejectReason: string;
}

export interface DomainRejectReturnClaimNaverSmartStoreRequest {
  /** @example "훼손이 심해 반품을 거부함." */
  rejectReturnReason: string;
}

export interface DomainRejectReturnClaimRequest {
  /** ⚠️ 현재는 세컨솔드 반품이 개발되어 있지 않습니다. */
  acloset?: DomainRejectReturnClaimAclosetRequest;
  cafe24?: DomainRejectReturnClaimCafe24Request;
  naverSmartStore?: DomainRejectReturnClaimNaverSmartStoreRequest;
}

export interface DomainRemappingSaleItemsPlatformCategoriesRequest {
  /** 리매핑 할 상품 아이디 리스트 (비어 있으면 판매 전 상태인 아이템에 대해 플랫폼 카테고리가 빈 아이템을 대상으로 리매핑 수행) */
  itemIDs?: string[];
}

export interface DomainRemoveBackgroundImageRequest {
  /** 이미지 URL */
  imageURL?: string;
}

export interface DomainRemoveBackgroundImageResponse {
  imageURL: string;
  maskImageURL: string;
}

export interface DomainReopenSaleItemsRequest {
  platformTypes: string[];
  saleItemIDs: string[];
}

export interface DomainReopenSaleItemsResponse {
  /** 작업 ID (실 사용 예 없음) */
  saleTaskID?: string;
}

export interface DomainReplaceShopTaskItemImageRequest {
  /**
   * 대체 이미지
   * @example "image.jpg"
   */
  replaceImageURL: string;
  /**
   * 리사이즈 길이
   * @example 1024
   */
  targetLength: number;
}

export interface DomainReplaceText {
  from?: string;
  to?: string;
}

export interface DomainRequestReturnClaimCafe24Request {
  /**
   * 반품사유 구분 (platform 도메인의 반품요청 사유 구분 코드 참조)
   * @example "F"
   */
  claimReasonType: string;
  /**
   * 수거완료 여부
   * @example true
   */
  isPickupCompleted: boolean;
  /**
   * 수거신청 여부
   * @example true
   */
  isRequestPickUp: boolean;
  /**
   * 반품사유 (최대 2000자)
   * @example "상품하자"
   */
  reason: string;
  /** 환불 계좌 예금주 ⚠️ 무통장입금에만 해당 필드를 요구 */
  refundBankAccountHolder?: string;
  /** 환불 계좌 번호 ⚠️ 무통장입금에만 해당 필드를 요구 */
  refundBankAccountNo?: string;
  /** 환불 은행 코드 (platform 도메인의 은행 코드 참조) ⚠️ 무통장입금에만 해당 필드를 요구 */
  refundBankCode?: string;
  /**
   * 환불 방식 (platform 도메인의 환불방식 코드 참조)
   * @example "F"
   */
  refundMethodCode: string;
}

export interface DomainRequestReturnClaimRequest {
  acloset?: boolean;
  cafe24?: DomainRequestReturnClaimCafe24Request;
}

export interface DomainResumeBunjangShopLoadTaskRequest {
  /** 작업 ID */
  shopLoadTaskID: string;
}

export interface DomainRetryPayByUserRequest {
  /** 카드 ID */
  cardID: string;
  /** 결제내역 ID */
  paymentDetailID: string;
}

export interface DomainReturnClaimRequest {
  /**
   * 주문 취소 후 상품의 플랫폼 상태
   * @default "SALE_PLATFORM-STATUS_ON-SALE"
   */
  afterPlatformStatus: 'SALE_PLATFORM-STATUS_ON-SALE' | 'SALE_PLATFORM-STATUS_STOP-SALE';
}

export interface DomainReturnProcessingDay {
  /** 평균 반품처리 속도 (일 단위) */
  days?: number;
  /** 등급 (A, B, C, D, E) */
  grade?: string;
  /** 상위 5%의 점수 */
  top5Days?: number;
}

export interface DomainReturnReasonRate {
  /** 반품사유 태그별 개수 */
  count?: number;
  /** 반품사유 태그 */
  returnReasonTag?: string;
}

export interface DomainReviewUserResponse {
  /**
   * 리뷰를 하는/받는 유저 닉네임
   * @example "GiraffeWithCode"
   */
  nickname: string;
  /**
   * 리뷰를 하는/받는 유저 프로필 이미지 URL
   * @example "https://s3.ap-northeast-2.amazonaws.com/brandi-static/brandi_profile_image/162615/162615_2019-11-27_15:00:00.000000.png"
   */
  profileImageURL?: string;
  /**
   * 리뷰를 하는/받는 유저 ID
   * @example 162615
   */
  userID: number;
}

export interface DomainSaleDashboardResponse {
  dashboardItems?: DomainDashboardItemResponse[];
  /** 주문 상태별 주문 수 */
  itemCount?: number;
  /** 주문 상태(메타데이터 sale, status 참조) */
  saleStatus?: string;
}

export interface DomainSaleItemPlatformCategoryResponse {
  /** 세컨솔드 의류 구분 (market-item, genderwear 메타데이터 참조) */
  aclosetGenderWear?: string;
  /** 카테고리 코드 (플랫폼 별 카테고리 코드) */
  platformCategoryID: string;
  /** 카테고리명 (플랫폼 별 카테고리 국문명) */
  platformCategoryName: string;
}

export interface DomainSaleItemPlatformErrorResponse {
  /** 작업액션 (메타데이터 sale, task-action 참조) */
  action?: string;
  /** FIXME: 작업 당시 시간문제로 서버에서 에러 메시지를 반환함. 메타데이터를 이용한 형태로 변경 필요 */
  errorCode?: string;
  /** 작업액션 이벤트 */
  event?: string;
  /** 에러메세지 */
  message?: string;
  /** 판매작업 상세ID */
  saleTaskDetailID?: string;
  /** 판매작업 ID */
  saleTaskID?: string;
}

export interface DomainSaleItemPlatformResponse {
  /** 세컨솔드 의류 구분 */
  aclosetGenderWear?: string;
  /** 할인율 (0~100) */
  discountRate?: number;
  /** 엑셀 사용 플랫폼 엑셀 다운로드 수 */
  excelDownloadCount?: number;
  /** 엑셀 사용 플랫폼 엑셀 다운로드 일시 */
  excelDownloadDate?: string;
  /** 마지막 동기화 일시 */
  lastSyncDate?: string;
  /** 게시 일시 (판매 중으로 넘긴 시점. 플랫폼에 게시된 일자) */
  openSaleDate?: string;
  /** 플랫폼의 카테고리 정보 */
  platformCategories: DomainSaleItemPlatformCategoryResponse[];
  /** 플랫폼에서 현재 판매되고 있는 상품 설명 */
  platformDescription?: string;
  /** 플랫폼에서 현재 판매되고 있는 할인 후 가격 */
  platformDiscountPrice?: number;
  /** 플랫폼 별 에러 정보 (SaleOperation 값이 SALE_OPERATION_FAILED 일 경우에만 유효) */
  platformError: DomainSaleItemPlatformErrorResponse;
  /** 플랫폼에서 현재 판매되고 있는 할인 전 가격 */
  platformPrice: number;
  /** 플랫폼의 상품 코드 (네이버 스마트 스토어는 AIMS의 상품코드를 따름.) */
  platformProductCode?: string;
  /** 플랫폼의 상품 ID */
  platformProductID?: string;
  /** 플랫폼 별 상품 상태 (메타데이터 sale, platform-status 참고) */
  platformStatus: string;
  /** 플랫폼 타입 (메타데이터 shop, platform-type 참고) */
  platformType: string;
  /** 플랫폼 별 액션 진행 상황 (판매 게시, 판매 중지, 품절 등) (메타데이터 sale, operation 참고) */
  saleOperation: string;
}

export interface DomainSaleTaskDetailResponse {
  event?: string;
  itemID?: string;
  modifyDate?: string;
  next?: string;
  /** API 한번 호출 시 여러 개의 주문을 처리 가능할 때 사용 */
  orderIDs?: string[];
  platformType?: string;
  request?: any;
  response?: any;
  saleTaskDetailID?: string;
  saleTaskID?: string;
  shopID?: string;
  status?: string;
  taskAction?: string;
}

export interface DomainSaleTaskResponse {
  action?: string;
  createDate?: string;
  failureCount?: number;
  itemIDs?: string[];
  modifyDate?: string;
  orderIDs?: string[];
  platformTypes?: string[];
  saleTaskID?: string;
  shopID?: string;
  status?: string;
  successCount?: number;
  totalCount?: number;
}

export interface DomainScore {
  iconFilled?: string;
  iconNotFilled?: string;
  score?: number;
  total?: number;
}

export interface DomainSelect {
  delimiter?: string;
  fieldValues?: DomainFieldValue[];
}

export interface DomainSendAclosetUserInquiryResponseHistoryRequest {
  /**
   * 문의 최초 답변 시간
   * @example "2024-04-05T04:24:25.966Z"
   */
  inquiryFirstResponseDate: string;
  /**
   * 문의 시작 시간
   * @example "2024-04-05T04:24:25.966Z"
   */
  inquiryStartDate: string;
}

export interface DomainSendEmailVerificationCodeRequest {
  /** @example "abc@naver.com" */
  email: string;
}

export interface DomainSendKakaotalkNotificationRequest {
  /** 템플릿 빌드 Argument */
  args?: DomainKakaotalkNotificationArgs;
  /** 번개장터 샵 아이디 */
  bunjangShopID?: string;
  /** 전화번호 */
  mobileNumber?: string;
  /** 템플릿 코드` */
  templateCode?: string;
}

export interface DomainServicePricingResponse {
  /** 사용가능한 기능들 사용이 불가한 기능은 해당 리스트에 포함되지 않음 */
  availableFeatures: DomainAvailableFeatureResponse[];
  /**
   * 코드. 메타데이터 service-pricing, code 참조
   * @example "SERVICE-PRICING_CODE_AUTO-REFINE"
   */
  code: string;
  /** 무료 체험 여부 */
  isFreeTrial: boolean;
  /** 월 최대 기본료 */
  maxFee: number;
  /** 월 최소 기본료 */
  minFee: number;
  /** 이름 */
  name: string;
  /** 사용 타입별 비용 정보 */
  pricingPerItemUsages: DomainPricingPerItemUsageResponse[];
  /** 서비스 가격의 고유 ID */
  servicePricingID: string;
}

export interface DomainSettingStep {
  ownerConfirm: boolean;
  /** 샵 계정 설정 타입 코드 */
  shopAccountSettingType: string;
}

export interface DomainSettingStepResponse {
  ownerConfirm: boolean;
  /** 샵 계정 설정 타입 코드 */
  shopAccountSettingType: string;
}

export interface DomainSettlementResponse {
  /**
   * 자동 결제된 크레딧 금액
   * @example 10000
   */
  chargedCreditAmount: number;
  /** 쿠폰 목록 */
  coupons?: DomainShopCouponResponse[];
  /**
   * Deprecated: 아이템 업로드 1개당 할인가
   * @example 200
   */
  discountPricePerItem: number;
  /**
   * Deprecated: 상품 업로드 할인가
   * @example 40000
   */
  discountUploadPrice: number;
  /**
   * 정산 종료일
   * @example "2023-11-24T09:29:34.229Z"
   */
  endDate: string;
  /**
   * 쿠폰 적용 여부
   * @example true
   */
  isCouponApplied: boolean;
  /** Deprecated: 아이템 업로드 히스토리 ID 목록 (이 리스트 개수가 업로드 개수입니다.) 쿠폰 사용과 별개입니다. */
  itemUploadHistoryIDs?: string[];
  /** Deprecated: 아이템 업로드 히스토리 ID 목록 (이 리스트 개수가 업로드 개수입니다.) 쿠폰 사용과 별개입니다. */
  itemUploadHistoryIDsInBucket?: string[];
  /** 추가 이용료 상세 내역 - New */
  itemUsageDetails?: DomainItemUsageDetailResponse[];
  /**
   * 추가 이용료 총 금액
   * @example 10000
   */
  itemUsagePrice: number;
  /**
   * 정산 월 (예: 202303)
   * @example "202306"
   */
  month: string;
  /**
   * 월 고정 구독료
   * @example 50000
   */
  monthlyPrice: number;
  /**
   * 결제내역 ID
   * @example "65378b60f9505804b23cd444"
   */
  paymentDetailID?: string;
  /**
   * Deprecated: 플랜 ID
   * @example "65378b60f9505804b23cd666"
   */
  planID: string;
  /**
   * Deprecated: 아이템 업로드 1개당 가격
   * @example 300
   */
  pricePerItem: number;
  /**
   * 사용한 서비스명 표기
   * @example "AI 업로드 + 판매관리"
   */
  serviceName: string;
  /**
   * 정산 타입 (GET: /shops/metadata의 settlement, type 참고)
   * @example "SETTLEMENT_TYPE_NORMAL"
   */
  settleType: string;
  /** 정산 ID */
  settlementID: string;
  /**
   * 샵 ID
   * @example "65378b60f9505804b23cdaf6"
   */
  shopID: string;
  /**
   * 정산 시작일
   * @example "2023-10-24T09:29:34.229Z"
   */
  startDate: string;
  /**
   * 정산 총 금액 (추가 이용료 + 월 고정 구독료)
   * @example 90000
   */
  totalPrice: number;
  /**
   * Deprecated: 부가세 포함 총 금액 (정산 총 금액 + 부가세)
   * @example 99000
   */
  totalPriceWithVAT: number;
  /**
   * Deprecated: 상품 업로드 원가
   * @example 60000
   */
  uploadPrice: number;
  /**
   * 사용된 크레딧 금액
   * @example 10000
   */
  usedCreditAmount: number;
  /**
   * 2024년 구 정산 데이터까지만 사용하는 필드 - v6.3.0
   * @example 9000
   */
  vat: number;
}

export interface DomainShipStartOrderRate {
  /** 등급 (A, B, C, D, E) */
  grade?: string;
  /** 배송시작 점수 (2일 이내 처리된 비율. 0-100 범위) */
  rating?: number;
  /** 1일 이내 처리된 개수 */
  shipStartIn1D?: number;
  /** 1일 초과 2일 이내 처리된 개수 */
  shipStartIn2D?: number;
  /** 2일 초과 3일 이내 처리된 개수 */
  shipStartIn3D?: number;
  /** 3일 초과 4일 이내 처리된 개수 */
  shipStartIn4D?: number;
  /** 4일 초과로 처리된 개수 */
  shipStartIn5D?: number;
  /** 상위 5%의 점수 */
  top5Rating?: number;
}

export interface DomainShippingCompanyResponse {
  code?: string;
  name?: string;
  platformShippingCompanies?: DomainEmbedPlatformShippingCompanyResponse[];
}

export interface DomainShopAIDescriptionSetting {
  /** 글머리를 사용할까요? */
  bulletPointSetting: DomainBulletPointSetting;
  /** 이모지를 사용할까요? (ai-description, emoji 메타데이터 참조) */
  includedEmojis: string[];
  /** 상품 설명에 어떤 내용을 포함할까요? (ai-description, info 메타데이터 참조) */
  includedInfos: string[];
  /** AI 상품 설명 사용에 동의를 받을 필요 있음 */
  usageAgreed: boolean;
  /** 어떤 문체로 작성할까요? (ai-description, writing-style 메타데이터 참조) */
  writingStyle: string;
}

export interface DomainShopAclosetAdditionalImages {
  bottom?: DomainAclosetAdditionalImage[];
  top?: DomainAclosetAdditionalImage[];
}

export interface DomainShopAclosetAddress {
  /** 주소 */
  addressLine1?: string;
  /** 상세주소 */
  addressLine2?: string;
  /** 받을 사람 */
  name?: string;
  /** 우편 번호 */
  zipCode?: string;
}

export interface DomainShopAclosetLogixPrice {
  /** 제주 배송비 */
  jeju?: number;
  /** 기본 배송비 */
  normal?: number;
  /** 도서 산간 배송비 */
  outlyingArea?: number;
}

export interface DomainShopAclosetNotificationResponse {
  createDate?: string;
  id?: string;
  imageURL?: string;
  isRead?: boolean;
  message?: string;
  type?: string;
}

export interface DomainShopAclosetStaticRequest {
  /** 세컨솔드 추가 이미지 */
  additionalImages?: DomainShopAclosetAdditionalImages;
  /** 운영가능 시간 설명 */
  availableHoursDescription?: string;
  /** 배경 이미지 URL */
  backgroundImageURL?: string;
  /** 소개글 */
  bio?: string;
  /** 조건별 배송비 부과시, 무료배송 조건금액 */
  freeShippingThreshold?: number;
  /** 문의 연락처 */
  inquiryContact?: string;
  /** 배송 공지사항 게시 여부 */
  isLogixNoticePublished: boolean;
  /** 파트너샵 활성화 여부 */
  isPartnerShop?: boolean;
  /** 배송 공지사항 */
  logixNotice: string;
  /** 배송 정책 */
  logixPolicy?: string;
  /** 배송 타입 EX) "무료배송":"MARKET-ITEM_LOGIX-TYPE_FREE", "유료배송": "MARKET-ITEM_LOGIX-TYPE_PAY", "조건부 무료 배송": "MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT" */
  logixPriceType?: string;
  /** 할인 요청 시 최소 주문 금액 */
  minOrderAmountForOffer?: number;
  /** 주문 배송 가격 */
  orderLogixPrice?: DomainShopAclosetLogixPrice;
  /** 프로필 이미지 URL */
  profileImageURL?: string;
  /** 장바구니에 담을 수 있는 최대개수 */
  purchaseQuantityLimit?: number;
  /** 반품 주소 */
  returnAddress?: DomainShopAclosetAddress;
  /** 반품 지정 택배사 이름 (REFUND_LOGIX-TYPE_ALL | REFUND_LOGIX-TYPE_BUYER_DIRECT 일 때 필수) */
  returnLogixName?: string;
  /** 반품 배송 가격 */
  returnLogixPrice?: DomainShopAclosetLogixPrice;
  /** 반품 규정 설명 */
  returnPolicyDescription?: string;
  /** 반품 규정 타입 (REFUND_LOGIX-TYPE_ALL | REFUND_LOGIX-TYPE_BUYER_DIRECT | REFUND_LOGIX-TYPE_SELLER_DIRECT) */
  returnPolicyType?: string;
  /** 샵 소개 */
  shopDescription?: DomainAclosetShopDescription;
}

export interface DomainShopAclosetStaticResponse {
  /** 세컨솔드 추가 이미지 */
  additionalImages?: DomainShopAclosetAdditionalImages;
  /** 문의가능시간 설명 */
  availableHoursDescription?: string;
  /** 평균 배송일 */
  avgDaysFromOrderConfirmToShipStart?: number;
  /** 배경이미지 */
  backgroundImageURL?: string;
  /** 소개 */
  bio?: string;
  /** 조건별 배송비 부과시, 무료배송 조건금액 */
  freeShippingThreshold?: number;
  /** 문의 연락처 */
  inquiryContact?: string;
  /** 배송 공지사항 게시 여부 */
  isLogixNoticePublished: boolean;
  /** 파트너 샵 여부 */
  isPartnerShop?: boolean;
  /** 배송 공지사항 */
  logixNotice: string;
  /** 배송정책 */
  logixPolicy?: string;
  /** 배송 타입 EX) "무료배송":"MARKET-ITEM_LOGIX-TYPE_FREE", "유료배송": "MARKET-ITEM_LOGIX-TYPE_PAY", "조건부 무료 배송": "MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT" */
  logixPriceType?: string;
  /**
   * 할인 요청 받을 최소 주문액
   * @default 10000
   * @example 10000
   */
  minOrderAmountForOffer?: number;
  /** 주문 배송 가격 */
  orderLogixPrice?: DomainShopAclosetLogixPrice;
  /** 프로필이미지 */
  profileImageURL?: string;
  /** 장바구니에 담을 수 있는 최대개수 */
  purchaseQuantityLimit?: number;
  /** 반품주소 */
  returnAddress?: DomainShopAclosetAddress;
  /** 반품택배사 */
  returnLogixName?: string;
  /** 반품 배송 가격 */
  returnLogixPrice?: DomainShopAclosetLogixPrice;
  /** 반품정책 설명 */
  returnPolicyDescription?: string;
  /** 반품정책 타입 */
  returnPolicyType?: string;
  /** 샵 소개 */
  shopDescription?: DomainAclosetShopDescription;
}

export interface DomainShopAdditionalFieldMappingResponse {
  /** 매핑할 필드 명 */
  fieldName: string;
  /** 매핑할 옷의 속성 */
  from: DomainAclosetMappingPropertyResponse;
  /** 매핑할 도메인 라벨 값 */
  to: string;
}

export interface DomainShopAdditionalFieldResponse {
  fieldCheckBoxValue?: DomainCheckBox;
  /** default or custom 키 */
  fieldName?: string;
  fieldScoreValue?: DomainScore;
  fieldSelectValue?: DomainSelect;
  id?: string;
  /** "select", "checkbox", "score" */
  inputType?: string;
  /** TODO 사장님들 순서 변경을 원할 때 추가 필요 */
  order?: number;
  shopID?: string;
}

export interface DomainShopBackgroundRemovedImageSettingRequest {
  /** 배경제거 이미지 하단 여백 (deprecated) */
  bottomMargin?: string;
  /** 배경제거 이미지 하단 여백 */
  bottomMarginNumeric?: number;
  /** 배경제거 이미지 상단 여백 (deprecated) */
  topMargin?: string;
  /** 배경제거 이미지 상단 여백 */
  topMarginNumeric?: number;
}

export interface DomainShopBackgroundRemovedImageSettingResponse {
  /**
   * 배경제거 이미지 하단 여백 (deprecated)
   * @example "SHOP_ITEM-IMAGE-MARGIN_WIDE"
   */
  bottomMargin: string;
  /**
   * 배경제거 이미지 하단 여백
   * @example 20
   */
  bottomMarginNumeric: number;
  /**
   * 배경제거 이미지 상단 여백 (deprecated)
   * @example "SHOP_ITEM-IMAGE-MARGIN_NARROW"
   */
  topMargin: string;
  /**
   * 배경제거 이미지 상단 여백
   * @example 10
   */
  topMarginNumeric: number;
}

export interface DomainShopBrandGroupResponse {
  /** 그룹ID 리스트 */
  groupID?: string;
  /** 그룹이름 */
  groupName?: string;
}

export interface DomainShopBrandResponse {
  /**
   * 북마크 여부
   * @example true
   */
  bookmarked?: boolean;
  /**
   * 브랜드 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  brandID?: string;
  /**
   * 이미지 원본 이름
   * @example "세컨솔드"
   */
  brandImageName?: string;
  /**
   * 이미지 URL 주소
   * @example "https://acloset-kr-s3.s3.amazonaws.com/shops/6426a9c8105476fadf465159_168025716884256354514.jpg"
   */
  brandImageURL?: string;
  /**
   * 브랜드 소개 문구
   * @example "브랜드 소개문구"
   */
  content?: string;
  /**
   * 브랜드 생성 날짜
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  createDate?: string;
  /**
   * 영문 브랜드이름
   * @example "NIKE"
   */
  englishName?: string;
  /**
   * 그룹ID 리스트
   * @example ["63eb6df3f45b6fc2c1045aff"]
   */
  groupIDs?: string[];
  /** 키워드 */
  keywords?: string[];
  /**
   * 한글 브랜드이름
   * @example "나이키"
   */
  koreanName?: string;
}

export interface DomainShopBunjangStaticRequest {
  /** 번개장터 상품 로드 설정 */
  bunjangItemLoadSetting?: DomainBunjangItemLoadSetting;
  /**
   * 배송비
   * @example 3000
   */
  deliveryFee?: number;
  /**
   * 교환 가능 여부 (교환 가능, 교환 불가)
   * @example false
   */
  isExchange?: boolean;
  /**
   * 배송비 포함/별도 여부 (포함, 별도)
   * @example false
   */
  isIncludeDeliveryFee?: boolean;
  /**
   * 새상품 여부 (새상품, 중고상품)
   * @example false
   */
  isNewItem?: boolean;
}

export interface DomainShopBunjangStaticResponse {
  /** 번개장터 상품 로드 설정 */
  bunjangItemLoadSetting?: DomainBunjangItemLoadSetting;
  /**
   * 배송비
   * @example 3000
   */
  deliveryFee?: number;
  /**
   * 교환 가능 여부 (교환 가능, 교환 불가)
   * @example false
   */
  isExchange?: boolean;
  /**
   * 배송비 포함/별도 여부 (포함, 별도)
   * @example false
   */
  isIncludeDeliveryFee?: boolean;
  /**
   * 새상품 여부 (새상품, 중고상품)
   * @example false
   */
  isNewItem?: boolean;
}

export interface DomainShopBusinessResponse {
  /** 계좌주명 */
  accountHolder: string;
  /** 계좌번호 */
  accountNumber: string;
  /** 사업장 주소 */
  address: string;
  /** 계좌 은행 */
  bankName: string;
  /** 사업자 이메일 */
  businessEmail: string;
  /** 사업자 전화번호 */
  businessMobile: string;
  /** 회사 법인명 */
  businessName: string;
  /** 사업자 등록증 파일명 */
  businessRegistrationFileName?: string;
  /** 사업자 등록증 파일 URL */
  businessRegistrationFileURL?: string;
  /** 사업자 등록번호 */
  businessRegistrationNumber?: string;
  /** 업태/업종 (별도의 메타데이터 존재하지 않음) */
  businessType?: string;
  /** 통신판매신고증 사본 이름 */
  mailOrderSalesRegistrationFileName?: string;
  /** 통신판매신고증 사본 URL */
  mailOrderSalesRegistrationFileURL?: string;
  /** 통신판매신고번호 */
  mailOrderSalesRegistrationNumber?: string;
  /** 오너 전화번호 */
  ownerMobile: string;
  /** 대표명 */
  ownerName: string;
  /** 사업자 유형 (별도의 메타데이터 존재하지 않음) */
  ownerType?: string;
}

export interface DomainShopCafe24CategoryRuleStep {
  categoryRuleStep?: string;
  finished?: boolean;
}

export interface DomainShopCafe24DiscountSettingRequest {
  /** 할인 방식 (shop, cafe24-discount-method 참고) */
  discountMethod?: string;
  /** 할인율 (10이면 10%) */
  discountRate?: number;
}

export interface DomainShopCafe24DiscountSettingResponse {
  /** 할인 방식 (shop, cafe24-discount-method 참고) */
  discountMethod?: string;
  /** 할인율 (10이면 10%) */
  discountRate?: number;
}

export interface DomainShopCafe24PlatformCategoryRequest {
  /** @example true */
  enabled: boolean;
}

export interface DomainShopCafe24PlatformCategoryResponse {
  /** Looko-AI 맵핑 사용 여부 */
  enabled?: boolean;
  /** 플랫폼 카테고리 이름 (현재 카테고리 이름 ex. 원피스) */
  platformCurrentCategoryName?: string;
  /** 플랫폼 카테고리 순서 */
  platformDisplayOrder?: number;
  /** 플랫폼 상위 카테고리 ID */
  platformParentCategoryID?: string;
  /** 플랫폼 카테고리 사용 여부 */
  platformUseDisplay?: boolean;
}

export interface DomainShopCafe24ServiceRequest {
  /** 카페24 설정 요청 전화번호 */
  settingRequestPhoneNumber?: string;
  /** 카페24 설정 요청 상태 */
  settingRequestStatus?: string;
}

export interface DomainShopCafe24ServiceResponse {
  /** 카페24 설정 요청 전화번호 */
  settingRequestPhoneNumber?: string;
  /** 카페24 설정 요청 상태 */
  settingRequestStatus?: string;
}

export interface DomainShopCafe24StaticRequest {
  /** 상품에 추가할 카테고리 번호 */
  addCategoryNo?: DomainStaticCafe24AddCategoryNo;
  /** 추가항목 리스트 */
  additionalInformationList?: DomainStaticCafe24AdditionalInformation[];
  /** 성인 인증 (default: "F")} */
  adultCertification?: string;
  /** 브랜드 코드 (shop, cafe24-brand-code-input-type 참고) */
  brandCodeInputType?: string;
  /** 카페24 상품 로드 설정 */
  cafe24ItemLoadSetting?: DomainCafe24ItemLoadSetting;
  /** 상품 분류 연결 단계 */
  categoryRuleSteps?: DomainShopCafe24CategoryRuleStep[];
  /** 할인 설정 */
  discountSetting?: DomainShopCafe24DiscountSettingRequest;
  /** 진열 상태 (default: "F") */
  display?: string;
  /**
   * 추가 이미지 사용 여부
   * @example true
   */
  enableAdditionalImage?: boolean;
  /** 활성화된 카페24 추가 설명섹션 목록 */
  enabledDescriptionSections?: string[];
  /** 고정항목의 영문상품명 */
  englishProductNameTemplate?: string;
  /** 고정항목의 상품명(관리용) */
  internalProductNameTemplate?: string;
  /** 최대 구매 수량 (default: 1) */
  maximumQuantity?: number;
  /** 최소 구매 수량 (default: 1) */
  minimumQuantity?: number;
  /** 고정항목의 모델명 */
  modelNameTemplate?: string;
  /** 원산지 국내/국외/기타 (default: "F") */
  originClassification?: string;
  /** 원산지 번호 (default: 1798) */
  originPlaceNo?: number;
  /** 상품 상태 (상세 값은 /shops/cafe24-product-conditions 참조) */
  productCondition?: string;
  /** 상품 옵션 */
  productOption?: DomainProductOption;
  /** SEO 설정 */
  productSEOTemplate?: DomainProductSEOTemplate;
  /** 상품 무게 (default: 1) */
  productWeight?: string;
  /**
   * 판매 플랫폼 확장 전용
   * @example true
   */
  salePlatformExtensionOnly?: boolean;
  /** 판매 상태 (default: "F") */
  selling?: string;
  /** 고정항목의 요약설명 */
  summaryDescriptionTemplate?: string;
  /** 공급가 (default: 0) */
  supplyPrice?: string;
  /** 고정항목의 공급상품명 */
  supplyProductNameTemplate?: string;
  /** 과세율 (default: 10) */
  taxRate?: number;
  /** 과세 구분 (default: "A") */
  taxType?: string;
}

export interface DomainShopCafe24StaticResponse {
  /** 상품에 추가할 카테고리 번호 */
  addCategoryNo?: DomainStaticCafe24AddCategoryNo;
  /** 추가항목 리스트 */
  additionalInformationList?: DomainStaticCafe24AdditionalInformation[];
  /** 성인 인증 (default: "F")} */
  adultCertification?: string;
  /** 브랜드 코드 입력 타입 (shop, cafe24-brand-code-input-type 참고) */
  brandCodeInputType?: string;
  /** 카페24 상품 로드 설정 */
  cafe24ItemLoadSetting?: DomainCafe24ItemLoadSetting;
  /** 상품 분류 연결 단계 */
  categoryRuleSteps?: DomainShopCafe24CategoryRuleStep[];
  /** 할인 설정 */
  discountSetting?: DomainShopCafe24DiscountSettingResponse;
  /** 진열 상태 (default: "F") */
  display?: string;
  /**
   * 추가 이미지 사용 여부
   * @example true
   */
  enableAdditionalImage?: boolean;
  /** 활성화된 카페24 추가 설명섹션 목록 */
  enabledDescriptionSections?: string[];
  /** 고정항목의 영문상품명 */
  englishProductNameTemplate?: string;
  /** 고정항목의 상품명(관리용) */
  internalProductNameTemplate?: string;
  /** 최대 구매 수량 (default: 1) */
  maximumQuantity?: number;
  /** 최소 구매 수량 (default: 1) */
  minimumQuantity?: number;
  /** 고정항목의 모델명 */
  modelNameTemplate?: string;
  /** 원산지 국내/국외/기타 (default: "F") */
  originClassification?: string;
  /** 원산지 번호 (default: 1798) */
  originPlaceNo?: number;
  /** 상품 상태 (상세 값은 /shops/cafe24-product-conditions 참조) */
  productCondition?: string;
  /** 상품 옵션 */
  productOption?: DomainProductOption;
  /** SEO 설정 */
  productSEOTemplate?: DomainProductSEOTemplate;
  /** 상품 무게 (default: 1) */
  productWeight?: string;
  /**
   * 판매 플랫폼 확장 전용 여부
   * @example true
   */
  salePlatformExtensionOnly?: boolean;
  /** 판매 상태 (default: "F") */
  selling?: string;
  /** 고정항목의 요약설명 */
  summaryDescriptionTemplate?: string;
  /** 공급가 (default: 0) */
  supplyPrice?: string;
  /** 고정항목의 공급상품명 */
  supplyProductNameTemplate?: string;
  /** 과세율 (default: 10) */
  taxRate?: number;
  /** 과세 구분 (default: "A") */
  taxType?: string;
}

export interface DomainShopCameraSetting {
  /** @example "auto" */
  mode?: string;
  /** @example 53 */
  value?: number;
}

export interface DomainShopCameraSettingPresetRequest {
  exposureISO?: DomainShopCameraSetting;
  /** @example "프리셋 이름" */
  name?: string;
  shutterSpeed?: DomainShopCameraSetting;
  whiteBalance?: DomainShopCameraSetting;
}

export interface DomainShopCameraSettingPresetResponse {
  exposureISO?: DomainShopCameraSetting;
  /** @example "프리셋 이름" */
  name?: string;
  shutterSpeed?: DomainShopCameraSetting;
  whiteBalance?: DomainShopCameraSetting;
}

export interface DomainShopClothesSizeTypeRequest {
  /**
   * 치수 유형 (상의/아우터, ..)
   * @example "SHOP_ITEM-CLOTHES-SIZE-TYPE_DRESS"
   */
  clothesSizeType: string;
  /**
   * 미사용 항목
   * @example ["SHOP_ITEM-SIZE-TARGET_WAIST"]
   */
  disableSizeTargets: string[];
  /**
   * 사용 항목
   * @example ["SHOP_ITEM-SIZE-TARGET_HIP"]
   */
  enableSizeTargets: string[];
}

export interface DomainShopClothesSizeTypeResponse {
  /**
   * 치수 유형 (상의/아우터, ..)
   * @example "SHOP_ITEM-CLOTHES-SIZE-TYPE_DRESS"
   */
  clothesSizeType: string;
  /** @example "원피스" */
  clothesSizeTypeName: string;
  /** 사용 항목 */
  disableSizeTargets?: DomainShopSizeTargetResponse[];
  /** 사용 항목 */
  enableSizeTargets?: DomainShopSizeTargetResponse[];
}

export interface DomainShopCouponResponse {
  /** 쿠폰 사용을 시작한 날짜 */
  applyDate?: string;
  /** 쿠폰 사용이 끝나는 날짜 */
  applyEndDate?: string;
  /** 쿠폰 사용이 만료되는 날짜 (day 기준) */
  applyPeriod?: number;
  /** 쿠폰 사용을 시작한 날짜 */
  applyStartDate?: string;
  /** 쿠폰의 id */
  couponID?: string;
  /** 쿠폰이 발행된 날짜 */
  createDate?: string;
  /** 쿠폰 자동 만료 날짜 */
  expireDate?: string;
  /** 쿠폰 이름 */
  name?: string;
  /** 쿠폰을 등록한 날짜 */
  registerDate?: string;
  /** 쿠폰이 적용될 shop의 id */
  shopID?: string;
  /** 쿠폰 상태 */
  status?: string;
  /** 쿠폰 타입 */
  type?: string;
}

export interface DomainShopCreditResponse {
  /**
   * 금액
   * @example 10000
   */
  amount: number;
  /**
   * 내용
   * @example "content"
   */
  content: string;
  /**
   * 생성일
   * @example "2023-04-08T00:00:00.000Z"
   */
  createDate: string;
  /**
   * 사용/충전 월
   * @example "202306"
   */
  month?: string;
  /**
   * 사유
   * @example "reason"
   */
  reason?: string;
  /**
   * 샵 크레딧 ID
   * @example "65378b60f9505804b23cdaf6"
   */
  shopCreditID: string;
  /**
   * 샵 ID
   * @example "65378b60f9505804b23cdaf6"
   */
  shopID: string;
  /**
   * 샵 이름
   * @example "shopName"
   */
  shopName: string;
  /**
   * 타입
   * @example "CREDIT_TYPE_ISSUED"
   */
  type: string;
}

export interface DomainShopDetailImageSettingRequest {
  backDetailImageTypes?: DomainShopDetailImageTypeRequest[];
  /** @example "SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER" */
  clothesType: string;
  frontDetailImageTypes?: DomainShopDetailImageTypeRequest[];
}

export interface DomainShopDetailImageSettingResponse {
  backDetailImageTypes?: DomainShopDetailImageTypeResponse[];
  /** @example "SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER" */
  clothesType: string;
  frontDetailImageTypes?: DomainShopDetailImageTypeResponse[];
}

export interface DomainShopDetailImageTypeRequest {
  /** @example "SHOP_DETAIL-IMAGE-TYPE_CENTER" */
  detailImageType: string;
  /** @example true */
  enable: boolean;
}

export interface DomainShopDetailImageTypeResponse {
  /** @example "SHOP_DETAIL-IMAGE-TYPE_CENTER" */
  detailImageType: string;
  /** @example true */
  enable: boolean;
}

export interface DomainShopDevice {
  /** 디바이스 아이디 */
  deviceID?: string;
  /** 푸시 알림 활성화 여부 */
  enablePushNotification?: boolean;
  /** 모바일 앱 FCM 토큰 */
  mobileAppFCMToken?: string;
}

export interface DomainShopHTMLTemplateResponse {
  acloset: DomainDescriptionJsonDOMResponse;
  bunjang: DomainDescriptionJsonDOMResponse;
  cafe24: DomainDescriptionJsonDOMResponse;
  /** TODO Deprecated */
  domTreeJSON?: string;
  /** TODO Deprecated */
  htmlTemplate?: string;
  instagram: DomainDescriptionJsonDOMResponse;
  isDelete?: boolean;
  /** @example "MAPPING-GROUP_TYPE_MEN" */
  mappingGroupType: string;
  naverSmartStore: DomainDescriptionJsonDOMResponse;
  /** TODO Deprecated */
  plainTemplate?: string;
  /** @example "shopID" */
  shopID: string;
  templateID?: string;
  /** TODO Deprecated */
  templateType?: string;
}

export interface DomainShopImageCropOptionRequest {
  /** @example false */
  enableCropBackImage: boolean;
  /** @example true */
  enableCropFrontImage: boolean;
}

export interface DomainShopImageCropOptionResponse {
  /** @example false */
  enableCropBackImage: boolean;
  /** @example true */
  enableCropFrontImage: boolean;
}

export interface DomainShopImageGapOptionRequest {
  /** 여백 */
  height?: number;
}

export interface DomainShopImageGapOptionResponse {
  /** 여백 */
  height?: number;
}

export interface DomainShopImageRatioOptionRequest {
  /** @example "SHOP_DETAIL-IMAGE-RATIO_FOUR-TO-FIVE" */
  detailImageRatio: string;
  /** @example "SHOP_IMAGE-RATIO_FOUR-TO-FIVE" */
  imageRatio: string;
}

export interface DomainShopImageRatioOptionResponse {
  /** @example "SHOP_DETAIL-IMAGE-RATIO_FOUR-TO-FIVE" */
  detailImageRatio: string;
  /** @example "SHOP_IMAGE-RATIO_FOUR-TO-FIVE" */
  imageRatio: string;
}

export interface DomainShopImageSortOptionRequest {
  /** 이미지 정렬 타입 (GET: /shops/metadata의 metadata-alias, shop / sort-image-type 참고) */
  sortImageType?: string;
}

export interface DomainShopImageSortOptionResponse {
  /** 이미지 정렬 타입 (GET: /shops/metadata의 metadata-alias, shop / sort-image-type 참고) */
  sortImageType?: string;
}

export interface DomainShopIntegratedImageSettingRequest {
  enableWidthAdjustment?: boolean;
  width?: number;
}

export interface DomainShopIntegratedImageSettingResponse {
  /** @example false */
  enableWidthAdjustment: boolean;
  /** @example 1000 */
  width: number;
}

export interface DomainShopItemCodeRuleRequest {
  /** @example 1000 */
  baseNumberCode: number;
  /** @example 5 */
  digitNumber: number;
  /** @example "PM" */
  letterCode: string;
}

export interface DomainShopItemCodeRuleResponse {
  /**
   * 숫자 코드
   * @example 1000
   */
  baseNumberCode: number;
  /**
   * 숫자 코드 자릿수
   * @example 5
   */
  digitNumber: number;
  /**
   * 영문 코드
   * @example "PM"
   */
  letterCode: string;
}

export interface DomainShopItemRequest {
  /** 아이템 코드 */
  itemAlias?: string;
  /** 아이템 ID */
  itemID: string;
  /** 가격 */
  price?: number;
  /** 아이템명 */
  title?: string;
}

export interface DomainShopNaverSmartStoreStaticRequest {
  /** A/S 책임자와 전화번호 */
  afterServiceDirector?: string;
  /** A/S 정보 */
  afterServiceInfo?: DomainAfterServiceInfo;
  /** 상품 진열 상태 (ON: 판매중, SUSPENSION: 판매 중지) */
  channelProductDisplayStatusType?: string;
  /** 구매 혜택 조건 */
  customerBenefit?: DomainStaticCustomerBenefit;
  /** 배송 정보 */
  deliveryInfo?: DomainDeliveryInfo;
  /**
   * 추가 이미지 사용 여부
   * @example true
   */
  enableAdditionalImage?: boolean;
  /** 네이버 상품 로드 설정 */
  naverItemLoadSetting?: DomainNaverItemLoadSetting;
  /** 옵션 정보 */
  optionInfo?: DomainOptionInfo;
  /** 원산지 정보 */
  originAreaInfo?: DomainOriginAreaInfo;
  /** 스마트스토어전용 상품명 사용 여부 */
  useChannelProductName?: boolean;
  /** 품질 보증 기준 */
  warrantyPolicy?: string;
}

export interface DomainShopNaverSmartStoreStaticResponse {
  /** A/S 책임자와 전화번호 */
  afterServiceDirector?: string;
  /** A/S 정보 */
  afterServiceInfo?: DomainAfterServiceInfo;
  /** 판매 게시 시 초기 상품 전시 상태 (ON: 판매 중, SUSPENSION: 판매 중지) */
  channelProductDisplayStatusType?: string;
  /** 구매 혜택 조건 */
  customerBenefit?: DomainStaticCustomerBenefit;
  /** 배송 정보 */
  deliveryInfo?: DomainDeliveryInfo;
  /** 추가 이미지 사용 여부 */
  enableAdditionalImage?: boolean;
  /** 네이버 상품 로드 설정 */
  naverItemLoadSetting?: DomainNaverItemLoadSetting;
  /** 옵션 정보 */
  optionInfo?: DomainOptionInfo;
  /** 원산지 정보 */
  originAreaInfo?: DomainOriginAreaInfo;
  /** 스마트스토어전용 상품명 사용 여부 */
  useChannelProductName?: boolean;
  /** 품질 보증 기준 */
  warrantyPolicy?: string;
}

export interface DomainShopNotificationResponse {
  /** 알림 필요한 부가 데이터 (성공 개수, 성공한 아이템, 주문 ID, 에러 등) */
  additionalField?: Record<string, any>;
  /** 알림 생성 일시 */
  createDate?: string;
  /** 알림 이미지 URL */
  imageURL?: string;
  /** 알림 읽음 여부 */
  isRead?: boolean;
  /** 알림 ID */
  notificationID?: string;
  /** 알림 타입 (notification, type 메타데이터 참조) */
  type?: string;
}

export interface DomainShopOrderCountResponse {
  /** 할인 요청 여부 */
  isOffer?: boolean;
  /** 주문 상태별 주문 수 */
  orderCount?: number;
  /** 주문 상태(메타데이터 order, status 참조) */
  orderStatus?: string;
  /** 처리 상태(메타데이터 order, process-status 참조) */
  processStatus?: string;
}

export interface DomainShopOrderResponse {
  /** 세컨솔드 주문 상세 정보 */
  acloset?: DomainAclosetOrderDetailResponse;
  /** 구매자 ID */
  buyerID?: string;
  /** 방해고객 여부 */
  buyerIsBlackConsumer: boolean;
  /** 구매자명 */
  buyerName?: string;
  /** 구매자 연락처 */
  buyerPhone?: string;
  /** 구매자 회원 아이디 */
  buyerUserID?: string;
  /** 간편결제 시 간편결제 유형 ( 메타데이터 sale, easy-payment 참조) */
  easyPayment?: string;
  /** 구매 확정 예정 일시 */
  estimatePurchaseDoneDate?: string;
  /** 교환 요청 일시 */
  exchangeRequestDate?: string;
  /** 이미지 */
  images?: DomainShopTaskItemImageResponse[];
  /** 운송장 번호 */
  invoiceNumber?: string;
  /** 중복 주문 여부 */
  isDuplicated?: boolean;
  /** 상품 코드 (Looko AI) */
  itemAlias?: string;
  /** 상품 가격 (플랫폼) */
  itemPrice?: number;
  /** 상품 썸네일 URL */
  itemThumbnailURL?: string;
  /** 판매 시작 일시 */
  openSaleDate?: string;
  /** 결제 취소 일시 */
  orderCancelDate?: string;
  /** 취소 유형(메타데이터 order, order-cancel-type 참조) */
  orderCancelType?: string;
  /** 결제 대기 일시 */
  orderDate?: string;
  orderID?: string;
  /** 수행 상태(메타데이터 order, operation 참조) */
  orderOperation?: string;
  /** 주문 상태(메타데이터 order, status 참조) */
  orderStatus?: string;
  /** 결제 완료 일시 */
  paymentDoneDate?: string;
  /** 결제수단 목록 */
  paymentMethods?: DomainPaymentMethodResponse[];
  /** 주문 번호 (플랫폼) */
  platformOrderID?: string;
  /** 상품 코드 (플랫폼) */
  platformProductCode?: string;
  /** 상품 ID (플랫폼) */
  platformProductID?: string;
  /** 상품 주문 번호 (플랫폼) */
  platformProductOrderID?: string;
  /** 결제 플랫폼 (메타데이터 shop, platform-type 참조) */
  platformType?: string;
  /** 처리 상태(메타데이터 order, process-status 참조) */
  processStatus?: string;
  /** 구매 확정 일시 */
  purchaseDoneDate?: string;
  /** 배송주소 */
  receiverAddress?: DomainReceiverAddressResponse;
  /** 수취인명 */
  receiverName?: string;
  /** 수취인 연락처 */
  receiverPhone?: string;
  /** 반품 요청 일시 */
  returnRequestDate?: string;
  /** 반품 클레임 상태 (메타데이터 claim return-status 참조) */
  returnStatus?: string;
  /** 아이템 ID (Looko AI) */
  saleItemID?: string;
  /** 택배사 코드 */
  shippingCompanyCode?: string;
  /** 택배사명 */
  shippingCompanyName?: string;
  /** 배송 완료 일시 */
  shippingDoneDate?: string;
  /** 배송비 */
  shippingFee?: number;
  /** 배송 중 일시 */
  shippingInProgressDate?: string;
  /** 배송 메시지 */
  shippingMessage?: string;
  /** 배송 준비 중 일시 */
  shippingPendingDate?: string;
  shopID?: string;
  /** 공급사 */
  supplier?: DomainShopSupplierResponse;
  /** 상품 제목 */
  title?: string;
  /** 총 결제 금액 (플랫폼) */
  totalPaymentAmount?: number;
}

export interface DomainShopOriginSettingRequest {
  /** 원산지 자동 입력 시 사용할 국가 타입 (메타데이터 shop, origin-setting-auto-country-type 참조) */
  autoOriginType?: string;
  /** 원산지 자동 입력 여부 */
  isAutoInputOrigin?: boolean;
  /** 원산지 표기 방식 (메타데이터 shop, origin-setting-notation-type 참조) */
  notationType?: string;
}

export interface DomainShopOriginSettingResponse {
  /** 원산지 자동 입력 시 사용할 국가 타입 (메타데이터 shop, origin-setting-auto-country-type 참조) */
  autoOriginType?: string;
  /** 원산지 자동 입력 여부 */
  isAutoInputOrigin?: boolean;
  /** 원산지 표기 방식 (메타데이터 shop, origin-setting-notation-type 참조) */
  notationType?: string;
}

export interface DomainShopOverview {
  /** 상품 미확인 건수 */
  itemNotConfirmed?: number;
  /** 불러오기한 상품 수 */
  loadedItemCount?: number;
  /** 가격제안 미확인 건수 */
  priceOfferNotConfirmed?: number;
  /** 반품 미처리 건수 */
  returnNotProcessed?: number;
  /** 세컨솔드 구매확정 주문 건수 */
  secondSoldOrderPurchaseDoneCount?: number;
  /** 배송 미처리 건수 */
  shippingNotProcessed?: number;
  /** 업로드한 상품 수 */
  uploadedItemCount?: number;
}

export interface DomainShopPlanResponse {
  /**
   * 플랜 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  planID?: string;
  /**
   * 플랜명
   * @example "프리미엄 플랜"
   */
  planName?: string;
}

export interface DomainShopPlatformCategoryRequest {
  cafe24?: DomainShopCafe24PlatformCategoryRequest;
  platformCategoryID?: string;
}

export interface DomainShopPlatformCategoryResponse {
  /** 카페24 에서만 사용 */
  cafe24?: DomainShopCafe24PlatformCategoryResponse;
  /** 플랫폼 카테고리 ID */
  platformCategoryID?: string;
  /** 플랫폼 카테고리 이름 (전체 카테고리 이름 ex. 여성의류>원피스) */
  platformCategoryName?: string;
}

export interface DomainShopPlayAutoStaticRequest {
  /** 추가 정보 템플릿 */
  additionalInformationTemplate?: string;
  /** 인증 정보: 신고대상으로 인증유형을 입력해야 하는 경우, 인증코드=인증기관=인증번호=인증모델=인증일=인증만료일=인증상호 형태로 '=' 기호로 구분하여 입력 */
  certificationInformation?: string;
  /** 인증 구분 (A: 신고대상, B: 상세내용 내 등록 C: 신고대상 아님 */
  certificationType?: string;
  /** 거래처: 관리하는 거래처에서 취급하는 상품의 경우 해당 거래처 ID를 입력하실 수 있음. Ex) playauto01 */
  clientCompany?: string;
  /** 유효일자 (yyyy-mm-dd) */
  expirationDate?: string;
  /** 사은품 내용 */
  gifts?: string;
  /** 키워드 템플릿 */
  keywordTemplate?: string;
  /** 제조일자 (yyyy-mm-dd) */
  manufactureDate?: string;
  /** 시중가 */
  marketPrice?: number;
  /** 한줄 메모 */
  oneLineMemo?: string;
  /** 원산지 */
  origin?: string;
  /** 원산지 국가 */
  originCountry?: string;
  /** 포장 방법 */
  packageMethod?: string;
  /** 원가 */
  primeCost?: number;
  /** 상품 상세1 */
  productDetail1?: string;
  /** 상품 상세10 */
  productDetail10?: string;
  /** 상품 상세11 */
  productDetail11?: string;
  /** 상품 상세12 */
  productDetail12?: string;
  /** 상품 상세13 */
  productDetail13?: string;
  /** 상품 상세14 */
  productDetail14?: string;
  /** 상품 상세15 */
  productDetail15?: string;
  /** 상품 상세16 */
  productDetail16?: string;
  /** 상품 상세17 */
  productDetail17?: string;
  /** 상품 상세18 */
  productDetail18?: string;
  /** 상품 상세19 */
  productDetail19?: string;
  /** 상품 상세2 */
  productDetail2?: string;
  /** 상품 상세20 */
  productDetail20?: string;
  /** 상품 상세21 */
  productDetail21?: string;
  /** 상품 상세22 */
  productDetail22?: string;
  /** 상품 상세23 */
  productDetail23?: string;
  /** 상품 상세24 */
  productDetail24?: string;
  /** 상품 상세25 */
  productDetail25?: string;
  /** 상품 상세26 */
  productDetail26?: string;
  /** 상품 상세3 */
  productDetail3?: string;
  /** 상품 상세4 */
  productDetail4?: string;
  /** 상품 상세5 */
  productDetail5?: string;
  /** 상품 상세6 */
  productDetail6?: string;
  /** 상품 상세7 */
  productDetail7?: string;
  /** 상품 상세8 */
  productDetail8?: string;
  /** 상품 상세9 */
  productDetail9?: string;
  /** 상품 상세 코드: 상품정보제공고시 분류코드를 입력 */
  productDetailCode?: string;
  /** 상품 사이즈 */
  productSize?: string;
  /** 상품무게 */
  productWeight?: number;
  /** 광고/홍보 */
  promotionDescription?: string;
  /** 홍보 문구 */
  promotionText?: string;
  /** 판매 수량 */
  sellingQuantity?: number;
  /** 배송비 */
  shippingFee?: number;
  /** 배송 방법 */
  shippingMethod?: string;
  /** 쇼핑몰 카테고리: 오픈마켓 각 계정별 개별카테고리를 지정하실 경우 '='구분 기호로 입력 Ex) "쇼핑몰코드=쇼핑몰ID=대>중>소>세" */
  shoppingMallCategory?: string;
  /** 공급가 */
  supplyPrice?: number;
  /** 과세 여부 */
  useTax?: string;
}

export interface DomainShopPlayAutoStaticResponse {
  /** 추가 정보 템플릿 */
  additionalInformationTemplate?: string;
  /** 인증 정보: 신고대상으로 인증유형을 입력해야 하는 경우, 인증코드=인증기관=인증번호=인증모델=인증일=인증만료일=인증상호 형태로 '=' 기호로 구분하여 입력 */
  certificationInformation?: string;
  /** 인증 구분 (A: 신고대상, B: 상세내용 내 등록 C: 신고대상 아님 */
  certificationType?: string;
  /** 거래처: 관리하는 거래처에서 취급하는 상품의 경우 해당 거래처 ID를 입력하실 수 있음. Ex) playauto01 */
  clientCompany?: string;
  /** 유효일자 (yyyy-mm-dd) */
  expirationDate?: string;
  /** 사은품 내용 */
  gifts?: string;
  /** 키워드 템플릿 */
  keywordTemplate?: string;
  /** 제조일자 (yyyy-mm-dd) */
  manufactureDate?: string;
  /** 시중가 */
  marketPrice?: number;
  /** 한줄 메모 */
  oneLineMemo?: string;
  /** 원산지 */
  origin?: string;
  /** 원산지 국가 */
  originCountry?: string;
  /** 포장 방법 */
  packageMethod?: string;
  /** 원가 */
  primeCost?: number;
  /** 상품 상세1 */
  productDetail1?: string;
  /** 상품 상세10 */
  productDetail10?: string;
  /** 상품 상세11 */
  productDetail11?: string;
  /** 상품 상세12 */
  productDetail12?: string;
  /** 상품 상세13 */
  productDetail13?: string;
  /** 상품 상세14 */
  productDetail14?: string;
  /** 상품 상세15 */
  productDetail15?: string;
  /** 상품 상세16 */
  productDetail16?: string;
  /** 상품 상세17 */
  productDetail17?: string;
  /** 상품 상세18 */
  productDetail18?: string;
  /** 상품 상세19 */
  productDetail19?: string;
  /** 상품 상세2 */
  productDetail2?: string;
  /** 상품 상세20 */
  productDetail20?: string;
  /** 상품 상세21 */
  productDetail21?: string;
  /** 상품 상세22 */
  productDetail22?: string;
  /** 상품 상세23 */
  productDetail23?: string;
  /** 상품 상세24 */
  productDetail24?: string;
  /** 상품 상세25 */
  productDetail25?: string;
  /** 상품 상세26 */
  productDetail26?: string;
  /** 상품 상세3 */
  productDetail3?: string;
  /** 상품 상세4 */
  productDetail4?: string;
  /** 상품 상세5 */
  productDetail5?: string;
  /** 상품 상세6 */
  productDetail6?: string;
  /** 상품 상세7 */
  productDetail7?: string;
  /** 상품 상세8 */
  productDetail8?: string;
  /** 상품 상세9 */
  productDetail9?: string;
  /** 상품 상세 코드: 상품정보제공고시 분류코드를 입력 */
  productDetailCode?: string;
  /** 상품 사이즈 */
  productSize?: string;
  /** 상품무게 */
  productWeight?: number;
  /** 광고/홍보 */
  promotionDescription?: string;
  /** 홍보 문구 */
  promotionText?: string;
  /** 판매 수량 */
  sellingQuantity?: number;
  /** 배송비 */
  shippingFee?: number;
  /** 배송 방법 */
  shippingMethod?: string;
  /** 쇼핑몰 카테고리: 오픈마켓 각 계정별 개별카테고리를 지정하실 경우 '='구분 기호로 입력 Ex) "쇼핑몰코드=쇼핑몰ID=대>중>소>세" */
  shoppingMallCategory?: string;
  /** 공급가 */
  supplyPrice?: number;
  /** 과세 여부 (Y: 과세, N: 비과세) */
  useTax?: string;
}

export interface DomainShopPreSignedURLsRequest {
  /**
   * 콘텐츠 타입
   * @example "image/jpeg"
   */
  contentType: string;
  /**
   * 파일 경로
   * @example "image.jpg"
   */
  path: string;
}

export interface DomainShopPriceRuleRequest {
  /** 가격이 적용될 카테고리 (예: COATS) */
  category?: string;
  /** 가격 금액 (예: 3000) */
  price?: number;
  /** 브랜드 그룹 ID */
  priceBrandGroupID?: string;
}

export interface DomainShopPriceRuleResponse {
  /** 가격이 적용될 카테고리 (예: 상의, 반바지) */
  category?: string;
  /** 가격 금액 (예: 3000) */
  price?: number;
  /**
   * 브랜드 ID 리스트
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  priceBrandGroupID?: string;
  /** 기본키 */
  priceRuleID?: string;
}

export interface DomainShopRegionResponse {
  /** 상위 지역 */
  region: string;
  /** 하위 지역 */
  subRegions: string[];
}

export interface DomainShopRemoveBackgroundOptionRequest {
  enableRemoveBackgroundBack?: boolean;
  enableRemoveBackgroundFront?: boolean;
}

export interface DomainShopRemoveBackgroundOptionResponse {
  /** @example true */
  enableRemoveBackgroundBack: boolean;
  /** @example false */
  enableRemoveBackgroundFront: boolean;
}

export interface DomainShopResponse {
  /** 샵 계정 설정 완료 여부 */
  accountSettingCompleted?: boolean;
  /** 세컨솔드 샵 정보 */
  acloset: DomainShopAclosetStaticResponse;
  /** AI 상품 설명 설정 */
  aiDescriptionSetting?: DomainShopAIDescriptionSetting;
  /** 자동 오픈 판매 플랫폼 타입 */
  autoOpenSalePlatformTypes?: string[];
  /** 가격 자동생성 시, 소비자가, 판매가 타입, 메타데이터 sale item-price 참고 */
  autoPriceType?: string;
  /** 배경색 설정 색상 헥스 코드 */
  backgroundColorHexCode: string;
  /** 배경제거 이미지 여백 설정 (메타데이터 item-image-margin 참조) */
  backgroundRemovedImageSetting: DomainShopBackgroundRemovedImageSettingResponse;
  /** 샵 비활성화 일자 (활성화 일 시 null) */
  blockedDate?: string;
  /** 번개장터 샵 정보 */
  bunjang: DomainShopBunjangStaticResponse;
  /** 번장 최근 불러오기 동기화 일자 */
  bunjangLastLoadDate?: string;
  /** 번장 상품 불러오기 상태 */
  bunjangLoadStatus?: string;
  /** 번장 상품 불러오기 태스크 ID */
  bunjangLoadTaskID?: string;
  /** 사업자 정보 */
  business: DomainShopBusinessResponse;
  /** 카페24 샵 정보 */
  cafe24: DomainShopCafe24StaticResponse;
  /** 카페24 최근 불러오기 동기화 일자 */
  cafe24LastLoadDate?: string;
  /** 카페24 상품 불러오기 상태 (GET: /shops/metadata의 metadata-alias, cafe24 / load-status 참고) */
  cafe24LoadStatus?: string;
  /** 카페24 상품 불러오기 태스크 ID */
  cafe24LoadTaskID?: string;
  /** 촬영 프리셋 설정 */
  cameraSettingPresets: DomainShopCameraSettingPresetResponse[];
  /**
   * 촬영 환경
   * @example "SHOP_SHOOTING-ENVIRONMENT_ENABLE-BACKLIGHT"
   */
  cameraShootingEnvironment: string;
  /**
   * 치수 타입 설정
   * @desc 샵에서 사용하는 치수 타입
   */
  clothesSizeTypes: DomainShopClothesSizeTypeResponse[];
  /**
   * 입점 쇼핑몰 리스트 (메타 데이터 platform-type 참조)
   * @example ["SHOP_PLATFORM-TYPE_CAFE24","SHOP_PLATFORM-TYPE_NAVER-SMART-STORE"]
   */
  connectedPlatformTypes: string[];
  /** 샵 생성일 */
  createDate: string;
  /** 아이디/패스워드 설정 필요 */
  credentialRequired?: boolean;
  /** 샵 크레딧 */
  creditAmount: number;
  /** 자유 입력 필드 스키마 */
  customInputFieldSchemas?: DomainCustomInputFieldSchemaResponse[];
  /**
   * 플랫폼 삭제 진행중 여부
   * @example false
   */
  deletePlatformInProgress: boolean;
  /** 치수 사용 타입. (치수 자동추출을 할지 말지에 대해서 설정. 메터데이터 shop, deriving-clothes-size-type 참조) */
  derivingClothesSizeType: string;
  /** 디테일 이미지 타입 설정 */
  detailImageSetting: DomainShopDetailImageSettingResponse[];
  /**
   * 디테일 이미지 타입
   * @example ["SHOP_IMAGE-TYPE_FRONT"]
   */
  detailImageTypes: string[];
  /** 샵 접속 디바이스 */
  devices?: DomainShopDevice[];
  /**
   * AI 소재 분석 사용 여부 (AI 소재 자동 입력)
   * @example true
   */
  enableAutoFabricClassification: boolean;
  /**
   * 상품명 자동 생성 여부
   * @example true
   */
  enableAutoGenerateTitle: boolean;
  /** AI 상품정보 자동입력 활성화 여부 */
  enableAutoInput?: boolean;
  /** 가격 자동생성 규칙 사용여부 */
  enableAutoPrice: boolean;
  /**
   * 상품명 자동 새로고침 여부
   * @example true
   */
  enableAutoRefreshTitle: boolean;
  /** 이미지 자동 수평 보정 활성화 여부 */
  enableAutoRotateImage?: boolean;
  /**
   * 치수로부터 사이즈 자동 계산 여부
   * @example true
   */
  enableAutoSizeAssignment: boolean;
  /**
   * 치수로부터 맵핑 자동 계산 여부
   * @example true
   */
  enableAutoSizeMapping: boolean;
  /**
   * 배경제거 활성화 여부
   * @example false
   */
  enableBackgroundRemoved: boolean;
  /**
   * 디테일 이미지 사용 여부
   * @example true
   */
  enableDetailImage: boolean;
  /**
   * 디테일 이미지 배경제거 사용 여부
   * @example true
   */
  enableDetailImageBackgroundRemoved: boolean;
  /**
   * 카페24 카테고리 직접 입력 여부
   * @example true
   */
  enableDirectInputCafe24Category: boolean;
  /**
   * 자동 검색 키워드 포멧 사용 여부
   * @example true
   */
  enableSearchKeywordTemplate: boolean;
  /**
   * 섬유의 소재 표기법, (GET: /shops/metadata의 metadata-alias, fabric-notation 참고)
   * @example "METADATA-ALIAS_FABRIC-NOTATION_FIRST-AND-MIXED"
   */
  fabricNotation: string;
  /** 소재 정렬 우선순위 (metadata.yaml의 SHOP, FABRIC-ORDER-PRIORITY 참조) */
  fabricOrderPriority?: string;
  /**
   * HTML 타입
   * @example "SHOP_HTML_SIMPLE, SHOP_HTML_MAPPING-TYPE"
   */
  htmlType: string;
  /** 배경제거 여백 제거 설정 */
  imageCropOption: DomainShopImageCropOptionResponse;
  /** 이미지 에디터 프리셋 설정 */
  imageEditorPresets: DomainImageEditorPresetResponse[];
  /** 상세페이지의 이미지 여백 설정 */
  imageGapOption?: DomainShopImageGapOptionResponse;
  /** 이미지 비율 설정 */
  imageRatioOption: DomainShopImageRatioOptionResponse;
  /** 이미지 고급 보정 */
  imageRetouchingOption?: DomainImageRetouchingOptionResponse;
  /** 이미지 정렬 설정 */
  imageSortOption: DomainShopImageSortOptionResponse;
  /** 이미지 타입 순서 규칙 설정 */
  imageTypeOrders: string[];
  /** 유입경로 */
  inflowChannel?: string;
  /** 통합 이미지 설정 */
  integratedImageSetting: DomainShopIntegratedImageSettingResponse;
  /**
   * 테스트 샵 여부
   * @example false
   */
  isTest: boolean;
  /** 상품코드 규칙 설정 */
  itemCodeRules: DomainShopItemCodeRuleResponse[];
  /** 상품 상태 항목 설정 */
  itemConditionFieldSetting?: DomainItemConditionField[];
  /** 상품 정보 항목 설정 */
  itemInputFieldSetting?: DomainItemInputField[];
  /** 카카오 알림 설정 */
  kakaoNotificationSetting?: DomainKakaoNotificationSetting;
  /** 불러오기 플랫폼 타입 */
  loadPlatformType?: string;
  /** 맵핑 그룹 타입(의류 구분) */
  mappingGroupTypes: DomainMappingGroupTypeResponse[];
  /** 관리자 계정에서 해당 샵에 대해 남기는 메모 (ex. 세금계산서 발행 여부 등) */
  memo?: string;
  /** 네이버 최근 불러오기 동기화 일자 */
  naverLastLoadDate?: string;
  /** 네이버 상품 불러오기 상태 (GET: /shops/metadata의 metadata-alias, naver / load-status 참고) */
  naverLoadStatus?: string;
  /** 네이버 상품 불러오기 태스크 ID */
  naverLoadTaskID?: string;
  /** 네이버 스마트스토어 샵 정보 */
  naverSmartStore: DomainShopNaverSmartStoreStaticResponse;
  /**
   * 온보딩이 어디까지 마무리되었는지를 보여주는 값, (GET: /shops/metadata의 shop, onboard-status 참고)
   * @example "SHOP_ONBOARD-STATUS_FINISHED"
   */
  onboardStatus: string;
  /**
   * 자주 사용하는 원산지 리스트
   * @example ["Designed by california"," Apple"]
   */
  originPresets?: string[];
  /** 원산지 설정 */
  originSetting?: DomainShopOriginSettingResponse;
  /** 샵 이름 */
  ownerID: number;
  /** 샵 플랜 */
  plan?: DomainShopPlanResponse;
  /** 쇼핑몰 게시 관련 이미지 옵션 */
  platformImageOption?: DomainPlatformImageOptionResponse;
  /** 플레이오토 샵 정보 */
  playAuto: DomainShopPlayAutoStaticResponse;
  /**
   * 가격 절삭 단위 (ex 1000의 경우 53,000 -> 53)
   * @example 100
   */
  priceCuttingUnit: number;
  /**
   * 자주 사용하는 가격
   * @example [1000,4000]
   */
  pricePresets: number[];
  /** 최근 접속 일자 */
  recentAccessDate?: string;
  /** 배경제거 여부 설정 */
  removeBackgroundOption: DomainShopRemoveBackgroundOptionResponse;
  /** 자동 검색 키워드 포멧 템플릿 토큰 리스트 */
  searchKeywordTemplate?: DomainTemplateToken[][];
  /**
   * 샵 계정의 세컨솔드 이메일
   * @example "123@naver.com"
   */
  secondSoldEmail: string;
  /** 서비스 목록 설정 여부 */
  servicePricingAgreed: boolean;
  /** 서비스 목록 코드 (메타데이터 service-pricing, code 참조) */
  servicePricingCodes?: string[];
  /** 샵 설정 단계 */
  settingSteps?: DomainSettingStepResponse[];
  /**
   * 샵 ID
   * @example "63ec5ccff19921e0414902b7"
   */
  shopID: string;
  /**
   * 샵 이름
   * @example "스토어 쟈넬"
   */
  shopName: string;
  /** 상태별 주문 건수 */
  shopOverview?: DomainShopOverview;
  /** 샵 설정 요청 */
  shopService?: DomainShopServiceResponse;
  /** 치수 표기법 (메타데이터 shop, size-notation 참조) */
  sizeNotation: string;
  /** 특수 치수 표기법 (메타데이터 shop, special-size-notation 참조) */
  specialSizeNotations?: string[];
  /** 샵 공급사 설정 */
  supplierSetting: DomainShopSupplierSettingResponse;
  /** 상품명 설정을 위해 필요한 토큰 (기존의 TitleTemplate의 역할 일부 수행)                                                                                 // 자동 상품명 타입 (메타 데이터 참조) */
  templateTokens?: DomainTemplateToken[];
  /** 자동 상품명 포멧 */
  titleTemplate?: string;
  uploadOnboardingSteps: DomainShopUploadOnboardingStepResponse[];
}

export interface DomainShopSaleFieldRequest {
  /** 컬럼명 */
  field?: string;
  /** 컬럼 사용 여부 */
  used?: boolean;
}

export interface DomainShopSaleFieldResponse {
  /** 컬럼 비활성화 여부 */
  disabled?: boolean;
  /** 컬럼 명 */
  field?: string;
  /** 컬럼 숨김 여부 */
  hidden?: boolean;
  /** 컬럼 사용 여부 */
  used?: boolean;
}

export interface DomainShopSaleItemCountResponse {
  /** 상품 상태별 상품 수 */
  itemCount?: number;
  /** 상품 판매 상태(메타데이터 order, status 참조) */
  saleStatus?: string;
}

export interface DomainShopSaleItemResponse {
  /** 카테고리 속성 (AIMS 속성) */
  aimsAttribute: string;
  /** 카테고리 속성명 (AIMS 속성 국문명) */
  aimsAttributeName: string;
  /** 카테고리 코드 (AIMS 카테고리 코드) */
  aimsCategory: string;
  /** 카테고리 코드명 (AIMS 카테고리 코드 국문명) */
  aimsCategoryName: string;
  /** 아이템 등록일 */
  createDate: string;
  /** 이미지 */
  images?: DomainShopTaskItemImageResponse[];
  /** 상품 코드 */
  itemAlias: string;
  /** 어떤 플랫폼에서 로드되었는지 확인하기 위한 필드 */
  loadedPlatformType?: string;
  /** 아이템 수정일 */
  modifyDate: string;
  /** 상품 등록일 (판매 대기로 넘긴 시점) */
  postDate?: string;
  /** 판매가 */
  price: number;
  /** 소비자가 */
  retailPrice: number;
  /** 아이템 ID */
  saleItemID: string;
  saleItemPlatforms: DomainSaleItemPlatformResponse[];
  /** 주요 상태 (메타데이터 sale, status 참고) */
  saleStatus: string;
  /** 아이템의 작업 ID PatchShopTaskItem 호출 시 필요 파라미터 */
  shopTaskID: string;
  /** FIXME ShopTaskItemID은 판매관리 1.4.0에서 제거 */
  shopTaskItemID: string;
  /** 공급사 */
  supplier: DomainShopSupplierResponse;
  /** 썸네일 URL */
  thumbnailURL?: string;
  /** 상품명 */
  title: string;
}

export interface DomainShopSaleTaskSummaryResponse {
  /** 생성 일시 */
  createDate?: string;
  /** 실패 아이템 수 */
  failureCount?: number;
  /** 판매 작업 구분 (메타데이터 sale, task-action 참조) */
  saleTaskAction?: string;
  /** 판매 작업 ID */
  saleTaskID?: string;
  /** 성공 아이템 수 */
  successCount?: number;
  /** 전체 아이템 수 */
  totalCount?: number;
}

export interface DomainShopServiceRequest {
  cafe24Service?: DomainShopCafe24ServiceRequest;
}

export interface DomainShopServiceResponse {
  cafe24Service?: DomainShopCafe24ServiceResponse;
}

export interface DomainShopSizeTargetResponse {
  /** @example "SIZE-TARGET_SHOULDER" */
  sizeTarget: string;
  /** @example "어깨" */
  sizeTargetName: string;
}

export interface DomainShopSupplierCodeRequest {
  code?: string;
  enable?: boolean;
  hasShippingInfo?: boolean;
}

export interface DomainShopSupplierCodeResponse {
  code?: string;
  enable?: boolean;
  hasShippingInfo?: boolean;
}

export interface DomainShopSupplierRequest {
  acloset?: DomainShopSupplierCodeRequest;
  cafe24?: DomainShopSupplierCodeRequest;
  naverSmartStore?: DomainShopSupplierCodeRequest;
  supplierName?: string;
}

export interface DomainShopSupplierResponse {
  acloset?: DomainShopSupplierCodeResponse;
  cafe24?: DomainShopSupplierCodeResponse;
  naverSmartStore?: DomainShopSupplierCodeResponse;
  supplierName?: string;
}

export interface DomainShopSupplierSettingRequest {
  enable?: boolean;
  suppliers?: DomainShopSupplierRequest[];
}

export interface DomainShopSupplierSettingResponse {
  enable?: boolean;
  suppliers?: DomainShopSupplierResponse[];
}

export interface DomainShopTaskItemCodeRuleRequest {
  /** @example 1000 */
  baseNumberCode?: number;
  /** @example 1000 */
  currentNumberCode?: number;
  /** @example 5 */
  digitNumber?: number;
  /** @example "PM" */
  letterCode: string;
}

export interface DomainShopTaskItemCodeRuleResponse {
  /**
   * 숫자 코드
   * @example 1000
   */
  baseNumberCode?: number;
  /** @example 1000 */
  currentNumberCode?: number;
  /**
   * 숫자 코드 자릿수
   * @example 5
   */
  digitNumber?: number;
  /**
   * 영문 코드
   * @example "PM"
   */
  letterCode: string;
}

export interface DomainShopTaskItemImageRequest {
  /** @example 1024 */
  height: number;
  /** @example "63eb6df3f45b6fc2c1045aff" */
  imageID?: string;
  /** @example "https://example.com" */
  imageURL: string;
  /** @example 1 */
  order: number;
  /** @example ["SHOP_ITEM-IMAGE_MAIN"] */
  types: string[];
  /** @example 512 */
  width: number;
}

export interface DomainShopTaskItemImageResponse {
  /** @example 1024 */
  height: number;
  /** @example "63eb6df3f45b6fc2c1045aff" */
  imageID: string;
  /** @example "https://example.com" */
  imageURL: string;
  /** @example true */
  isBackgroundRemoved: boolean;
  /** @example true */
  isRefined: boolean;
  /** @example 1 */
  order: number;
  processedImage: DomainProcessedImageResponse;
  /** @example "https://example.com" */
  thumbnailURL: string;
  /** @example ["SHOP_ITEM-IMAGE_MAIN"] */
  types: string[];
  /** @example 512 */
  width: number;
}

export interface DomainShopTaskItemKeyPointResponse {
  keyPoints?: DomainKeyPointWithClothesTypeResponse[];
  type?: string;
}

export interface DomainShopTaskItemResponse {
  /** 세컨솔드 속성 (AI 추론 속성) projectionFields에 aclosetProperty를 전달하면 반환됩니다. */
  aclosetProperty?: DomainAclosetProperty;
  /** 추가 정보 필드 */
  additionalField?: Record<string, string[]>;
  /** 추가 정보 필드 */
  additionalFields: DomainAdditionalField[];
  /** AI 상품 설명 */
  aiDescription: string;
  /** AI 상품 설명 생성 상태 (ai-description, status 메타데이터 참조) */
  aiDescriptionStatus: string;
  /**
   * AIMS 속성
   * @example "OUTDOOR"
   */
  aimsAttribute?: string;
  /** AIMS 브랜드 */
  aimsBrand?: DomainAIMSBrandResponse;
  /**
   * 패턴
   * @example "SOLID-COLOR"
   */
  aimsPattern?: string;
  /** 자동 가격 입력 적용 여부 */
  autoPriceApplied?: boolean;
  /** 상품명 자동 새로고침 여부 */
  autoRefreshTitle: boolean;
  /** 사이즈 자동 기입 여부 */
  autoSizeAssignment: boolean;
  /**
   * 브랜드
   * @example "쟈넬"
   */
  brand?: string;
  /** 카페24 카테고리 아이디 리스트 (/shops/:shopID/platform-categories 참조) */
  cafe24CategoryIDs?: string[];
  /**
   * 카테고리
   * @desc AIMS 카테고리.
   * @example "SHIRTS"
   */
  category?: string;
  /**
   * 옷 특징 리스트 (메타데이터 shop, item-clothes-feature 참고)
   * @example ["SHOP_ITEM-CLOTHES-FEATURE_RAGLAN"]
   */
  clothesFeatures?: string[];
  /**
   * 옷 치수 타입
   * @desc AIMS 서비스에서 사용하는 치수 타입
   * @example "SHIRTS (FE: ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TYPE_CODE_LIST 값들.)"
   */
  clothesSizeType?: string;
  /**
   * 옷 종류
   * @desc AI 에서 사용하는 치수 타입
   * @example "SHIRTS (FE: ACLOSET_SHOP_ITEM_CLOTHES_TYPE_CODE_LIST 값들.)"
   */
  clothesType?: string;
  /**
   * 색상
   * @example ["BLACK","RED"]
   */
  colors?: string[];
  /** 생성일 */
  createDate: string;
  /** 사용자 정의 속성 */
  customAttribute?: DomainCustomAttributeResponse;
  /**
   * 사용자 입력 재질
   * @example ["고무"]
   */
  customFabrics?: string[];
  /** 사용자 정의 입력 필드 */
  customInputFields?: DomainCustomInputFieldResponse[];
  /**
   * 설명
   * @example "엄청 좋은 샤넬 백"
   */
  description?: string;
  /**
   * 재질
   * @example ["COTTON"]
   */
  fabrics?: string[];
  /** 이미지 */
  images: DomainShopTaskItemImageResponse[];
  /** 불러오기 기능으로 생성한 아이템인 지 확인 여부 */
  isLoaded: boolean;
  /**
   * 상품 고유번호
   * @example "P_A00001"
   */
  itemAlias: string;
  /** 상품 컨디션 */
  itemConditionLevel?: number;
  /** 상품 원산지 */
  itemOrigin?: string;
  /** 키 포인트 길이 */
  keyPointLength: DomainKeyPointLengthResponse;
  /**
   * 키포인트 정보
   * @desc AI 에서 추정한 키포인트 데이터들. AI 에서는 확률적으로 모든 타입에 대해서 키포인트를 추정합니다.
   */
  keyPoints: DomainShopTaskItemKeyPointResponse[];
  /**
   * 키워드
   * @example ["키워드1","키워드2"]
   */
  keywords?: string[];
  /** 어떤 플랫폼에서 로드되었는지 확인하기 위한 필드 */
  loadedPlatformType: string;
  /** 의류 구분(맵핑 그룹 아이디) */
  mappingGroupType: DomainMappingGroupTypeResponse;
  /** 통합이미지 */
  mergedImageURL?: string;
  /**
   * 목어깨
   * @example "민소매"
   */
  neckShoulder: string;
  /**
   * 가격
   * @example 10000
   */
  price?: number;
  /** 배경제거 관련 이미지 */
  processedImage: DomainProcessedImageResponse;
  /**
   * 소비자가
   * @example 10000
   */
  retailPrice?: number;
  /**
   * 샵 태스크 아이템 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  shopTaskItemID: string;
  /**
   * 사이즈
   * @example "FREE"
   */
  size?: string;
  /**
   * 옷 치수 길이
   * @desc AI 및 AIMS 서비스로 노출되는 치수 타입
   */
  sizeLength?: DomainSizeLengthResponse[];
  /** 상품 분석 상태 */
  status: string;
  /**
   * 제목
   * @example "어제 산 샤넬 백 팝니다."
   */
  title?: string;
}

export interface DomainShopTaskResponse {
  /**
   * AI 분석 목록 (메타 데이터 참조)
   * @example ["SHOP_AI-ANALYSIS_SIZE"]
   */
  aiAnalyses?: string[];
  /**
   * AI 정밀도
   * @example "SHOP_AI-PRECISION_SIMPLE-ANALYSIS"
   */
  aiPrecision?: string;
  /**
   * 진행된 작업 개수
   * @example 5
   */
  completedInspectionCount?: number;
  /**
   * 작업에 포함된 아이템 개수
   * @example 1000
   */
  count?: number;
  /**
   * 작업 생성일
   * @example 1634243434234
   */
  createDate?: number;
  /** 자유 입력 필드 스키마 */
  customInputFieldSchemas?: DomainCustomInputFieldSchemaResponse[];
  /** 의류 구분 상품별 선택시, 아이템에 디폴트로 들어가는 값 */
  defaultMappingGroupID?: string;
  /**
   * 작업 종료일
   * @example 1676338846176
   */
  endDate?: number;
  /**
   * 작업 시작일 (의뢰날짜)
   * @example 1634243434234
   */
  inspectionStartDate?: number;
  /**
   * 검수자 ID
   * @example 1
   */
  inspectorID?: number;
  /** 상품코드 규칙 설정 */
  itemCodeRule?: DomainShopTaskItemCodeRuleResponse;
  /** 의류 구분 */
  mappingGroupType?: DomainMappingGroupTypeResponse;
  /**
   * 작업 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  shopTaskID?: string;
  /**
   * 작업 상태
   * @example "SHOP_TASK-STATUS_DONE"
   */
  status?: string;
  /**
   * 작업명
   * @example "스토어 쟈넬"
   */
  taskName?: string;
  /**
   * 전체 작업 개수
   * @example 8
   */
  totalInspectionCount?: number;
}

export interface DomainShopUploadOnboardingStepRequest {
  finished?: boolean;
  onboardingStep?: string;
}

export interface DomainShopUploadOnboardingStepResponse {
  finished?: boolean;
  onboardingStep?: string;
}

export interface DomainSignInAsGuestRequest {
  /**
   * 디바이스 아이디 (현재는 사용되지 않습니다.)
   * @example "deviceID"
   */
  deviceID?: string;
}

export interface DomainSignInAsGuestResponse {
  /** @example "accessToken" */
  accessToken: string;
  /** @example "refreshToken" */
  refreshToken: string;
  /** @example 620687 */
  userID: number;
  /** @example "owner,user" */
  userRole?: string;
}

export interface DomainSignInRequest {
  /** 카페24 연동 요청값 */
  cafe24Auth?: DomainCreateShopCafe24AuthRequest;
  /** @example "test@acloset.net" */
  email: string;
  /** @example "password123" */
  password: string;
}

export interface DomainSignInResponse {
  /** @example "accessToken" */
  accessToken: string;
  /** @example "refreshToken" */
  refreshToken: string;
  /** @example 620687 */
  userID: number;
  /** @example "owner,user" */
  userRole?: string;
}

export interface DomainSignUpLoadOwnerRequest {
  /** 카페24 연동 요청값 */
  cafe24Auth: DomainCreateShopCafe24AuthRequest;
  /** @example "aims12345@acloset.app" */
  email: string;
  /** @example "qwerty" */
  password: string;
  /** 상점명 */
  shopName: string;
}

export interface DomainSignUpOwnerRequest {
  /** 예금주 */
  accountHolder?: string;
  /** 계좌번호 */
  accountNumber?: string;
  /** 샵 설명 */
  aclosetShopDescription?: DomainAclosetShopDescription;
  /** 은행명 */
  bankName?: string;
  /** 사업자 주소 */
  businessAddress?: string;
  /** 사업자 연락처 */
  businessContact: string;
  /** 사업자정보란 (Acloset+Looko-AI) */
  businessName?: string;
  /** 사업자 등록증 파일명 */
  businessRegistrationFileName?: string;
  /** 사업자 등록증 파일 URL */
  businessRegistrationFileURL?: string;
  /** 사업자 등록번호 */
  businessRegistrationNumber?: string;
  /** 카페24 연동 요청값 */
  cafe24Auth?: DomainCreateShopCafe24AuthRequest;
  /** 공식 입점여부 */
  credentialRequired?: boolean;
  /**
   * 이메일
   * @example "email@acloset.appp"
   */
  email: string;
  /** 조건별 배송비 부과시, 무료배송 조건금액 */
  freeShippingThreshold?: number;
  /** 유입 경로 */
  inflowChannel?: string;
  /** CS 담당자 연락처 */
  inquiryContact?: string;
  /** Acloset 관련 정보 (배송/반품, 세컨솔드 샵 정보) */
  inquiryPossibleTime?: string;
  /** 샵 상세정보 입력 생략 여부 */
  isSkipShopDetail: boolean;
  /** 카카오톡 알림 설정 */
  kakaoNotificationSetting?: DomainKakaoNotificationSetting;
  /** 배송 정책 */
  logixPolicy?: string;
  /** 배송 타입 EX) "무료배송":"MARKET-ITEM_LOGIX-TYPE_FREE", "유료배송": "MARKET-ITEM_LOGIX-TYPE_PAY", "조건부 무료 배송": "MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT" */
  logixPriceType?: string;
  /** 통신판매신고증 사본 이름 */
  mailOrderSalesRegistrationFileName?: string;
  /** 통신판매신고증 사본 URL */
  mailOrderSalesRegistrationFileURL?: string;
  /** 통신판매신고번호 */
  mailOrderSalesRegistrationNumber?: string;
  /** 주문 배송비 */
  orderShippingFee?: DomainMarketItemLogixPriceRequest;
  /** 대표명 */
  ownerName: string;
  /** 사업자 유형 (별도의 메타데이터 존재하지 않음) */
  ownerType?: string;
  /**
   * 비밀번호
   * @example "password123!"
   */
  password: string;
  /** 장바구니에 담을 수 있는 최대개수 */
  purchaseQuantityLimit?: number;
  /** 반품 주소 정보 */
  refundAddressInfo?: DomainAclosetReturnAddressRequest;
  /** 반품 택배사 */
  refundCourierName?: string;
  /** 배송/반품 정보 (step3) - 반품 정보 */
  refundLogixType?: string;
  /** 반품 정책 */
  refundPolicy?: string;
  /** 반품 배송비 */
  refundShippingFee?: DomainMarketItemLogixPriceRequest;
  /**
   * 샵 이름
   * @example "빈토리샵"
   */
  shopName: string;
}

export interface DomainSingleClassProperty {
  class_id?: number;
  class_name?: string;
  topk_probs?: DomainTopKProbability[];
  version?: string;
}

export interface DomainSizeLengthResponse {
  prefix?: string;
  sizeTarget: string;
  sizeTargetName: string;
  tag?: string;
  value?: number;
}

export interface DomainSizeMappingGroupResponse {
  /** 통합 사이즈 규칙 리스트 */
  integratedSizeMappings?: DomainIntegratedSizeMappingResponse[];
  /** 메타데이터 (mapping-group, size-mapping-group-type 참고) */
  mappingGroupType?: string;
  /** 사이즈 매핑 그룹 내 매핑 리스트 */
  mappings?: DomainSizeMappingResponse[];
  /** 사이즈 매핑 그룹 ID */
  sizeMappingGroupID?: string;
}

export interface DomainSizeMappingRequest {
  /** 실제 룰에 매핑될 AIMS 카테고리 목록 (/shops/metadata/properties 참조) */
  aimsCategories?: string[];
  /** 적용될 치수 타겟 (메타데이터 shop, item-clothes-size-target 참고) */
  clothesSizeTarget?: string;
  /** 사이즈 매핑 이름 */
  name?: string;
  /** 치수 매핑 룰 */
  rules?: DomainSizeMappingRuleRequest[];
}

export interface DomainSizeMappingResponse {
  /** 실제 룰에 매핑될 AIMS 카테고리 목록 (/shops/metadata/properties 참조) */
  aimsCategories?: string[];
  /** 적용될 치수 타겟 (메타데이터 shop, item-clothes-size-target 참고) */
  clothesSizeTarget?: string;
  /** 사이즈 매핑 이름 */
  name?: string;
  /** 치수 매핑 룰 */
  rules?: DomainSizeMappingRuleResponse[];
}

export interface DomainSizeMappingRuleRequest {
  /** 매핑 될 치수명 */
  sizeName?: string;
  /** 미만 기준 */
  under?: string;
}

export interface DomainSizeMappingRuleResponse {
  /** 매핑 될 치수명 */
  sizeName?: string;
  /** 미만 기준 */
  under?: string;
}

export interface DomainSizeTargetKeywordResponse {
  /** 키워드 목록 */
  keywords?: string[];
  /** 우선순위 */
  priority?: number;
  /** 사이즈 타겟 (메타데이터 shop, item-clothes-size-target 참조) */
  sizeTarget?: string;
  /** 기본키 */
  sizeTargetKeywordID?: string;
}

export interface DomainSplitShopTaskItemRequest {
  /** 이미지 ID 리스트 */
  imageIDs?: string[];
}

export interface DomainSplitShopTaskItemResponse {
  shopTaskItemID?: string;
}

export interface DomainStandardOptionAttribute {
  /** 속성 ID (필수) */
  attributeId?: number;
  /** 속성값 ID (필수) */
  attributeValueId?: number;
  /** 속성값 이름 (필수) */
  attributeValueName?: string;
  /** 표준형 옵션에서 사용할 이미지 URL 목록 (이미지 URL은 반드시 상품 이미지 다건 등록 API로 이미지를 업로드하고 반환받은 URL 값을 입력해야 합니다.) */
  imageUrls?: string[];
}

export interface DomainStandardOptionGroup {
  /** 표준형 옵션 그룹 타입 (필수) */
  groupName?: string;
  /** 표준형 옵션 속성 */
  standardOptionAttributes?: DomainStandardOptionAttribute[];
}

export interface DomainStaticCafe24AddCategoryNo {
  /** 신상품 (T,F) (default: F) */
  new?: string;
  /** 추천상품 (T,F) (default: F) */
  recommend?: string;
}

export interface DomainStaticCafe24AdditionalInformation {
  /**
   * 카페24 에서 사용하는 추가항목 키
   * @example "custom_option1"
   */
  key: string;
  /**
   * 카페24 에서 사용하는 추가항목 이름
   * @example "브랜드"
   */
  name: string;
  /**
   * 카페24 에서 사용하는 추가항목 템플릿
   * @example "${브랜드.국문}"
   */
  template: string;
}

export interface DomainStaticCustomerBenefit {
  /** 상품 구매 포인트 정책 */
  purchasePointPolicy?: DomainStaticPurchasePointPolicy;
}

export interface DomainStaticPurchasePointPolicy {
  /** 상품 구매 포인트 사용 여부 */
  enabled?: boolean;
  /** 상품 구매 포인트 단위 PERCENT(정율), WON(정액) */
  unitType?: string;
  /** 상품 구매 포인트 값 <= 100 (정율 10%이면 10, 정액 100원이면 100) */
  value?: number;
}

export interface DomainStopSaleItemsRequest {
  platformTypes: string[];
  saleItemIDs: string[];
}

export interface DomainStopSaleItemsResponse {
  /** 작업 ID (실 사용 예 없음) */
  saleTaskID?: string;
}

export interface DomainStoreCouponResponse {
  /** 쿠폰 이름 */
  couponName: string;
  /** 생성일 */
  createdAt: string;
  /** 할인 금액 */
  discountAmount: number;
  /** 파트너 샵 ID */
  partnerShopInfoID: number;
  /** 판매자 userID */
  sellerID: number;
  /** 매장 쿠폰 ID */
  storeCouponID: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
}

export interface DomainStreamChangedShopNotificationResponse {
  /** mongo watch에 의해 감지된 변경 작업 목록 */
  changedNotification?: DomainShopNotificationResponse;
  /** 문서의 ObjectId */
  id?: string;
  /** 데이터 변경의 타입. 예: insert, update, delete, ... */
  operationType?: string;
}

export interface DomainStreamChangedShopTaskItemResponse {
  /** mongo watch에 의해 감지된 변경 작업 목록 */
  changedShopTaskItem?: DomainShopTaskItemResponse;
  /** 문서의 ObjectId */
  id?: string;
  /** 데이터 변경의 타입. 예: insert, update, delete, ... */
  operationType?: string;
}

export interface DomainSyncShopPlatformCategoriesRequest {
  platformType?: string;
}

export interface DomainTaskResponse {
  /**
   * AI 정밀도
   * @example "SHOP_AI-PRECISION_SIMPLE-ANALYSIS"
   */
  aiPrecision?: string;
  /**
   * 진행된 작업 개수
   * @example 5
   */
  completedInspectionCount?: number;
  /**
   * 작업에 포함된 아이템 개수
   * @example 1000
   */
  count?: number;
  /**
   * 작업 생성일
   * @example 1634243434234
   */
  createDate?: number;
  /**
   * 작업 종료일
   * @example 1676338846176
   */
  endDate?: number;
  /**
   * 작업 시작일 (의뢰날짜)
   * @example 1634243434234
   */
  inspectionStartDate?: number;
  /**
   * 검수자 ID
   * @example 1
   */
  inspectorID?: number;
  /**
   * 샵 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  shopID?: string;
  /**
   * 샵 이름
   * @example "빈토리"
   */
  shopName?: string;
  /**
   * 작업 ID
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  shopTaskID?: string;
  /**
   * 작업 상태
   * @example "SHOP_TASK-STATUS_DONE"
   */
  status?: string;
  /**
   * 작업명
   * @example "스토어 쟈넬"
   */
  taskName?: string;
  /**
   * 전체 작업 개수
   * @example 8
   */
  totalInspectionCount?: number;
}

export interface DomainTemplateFieldResponse {
  /**
   * 필드 코드
   * @example "platformProductOrderID"
   */
  fieldCode?: string;
  /**
   * 필드 국문명
   * @example "상품 주문 번호"
   */
  fieldName?: string;
}

export interface DomainTemplateToken {
  /** Bold가 true일 때, 해당하는 토큰은 볼드 처리 */
  bold?: boolean;
  /** 토큰의 값, 예: "상품코드", "공백", "[" ... */
  data?: string;
  /** 토큰의 타입, 예: "expression"(람다에서 별도의 처리를 하여 사용하는 토큰의 타입), "string"(문자열 그대로 사용되는 값) */
  type?: string;
}

export interface DomainTopKProbability {
  idx?: number;
  name?: string;
  prob?: number;
}

export interface DomainTotalSettlementResponse {
  /**
   * 충전할 크레딧 금액
   * @example 10000
   */
  chargedCreditAmount: number;
  /** 추가 이용료 상세 내역 - New */
  itemUsageDetails?: DomainItemUsageDetailResponse[];
  /**
   * 월 고정 구독료
   * @example 50000
   */
  monthlyPrice: number;
  /**
   * 정산 총 금액 (부가세 제외)
   * @example 90000
   */
  totalPaymentAmount: number;
  /**
   * 사용된 크레딧 금액
   * @example 10000
   */
  usedCreditAmount: number;
  /**
   * 부가세
   * @example 9000
   */
  vat: number;
}

export interface DomainUnMappedMappingGroupMappingRule {
  /** 매핑 규칙이 속한 AIMS 속성 */
  aimsAttribute?: string;
  /** 매핑 규칙이 속한 AIMS 속성명 */
  aimsAttributeName?: string;
  /** 매핑 규칙이 속한 AIMS 카테고리 */
  aimsCategory: string;
  /** 매핑 규칙이 속한 AIMS 카테고리명 */
  aimsCategoryName: string;
  /** 브랜드 그룹 아이디 */
  brandGroupIDs?: string[];
  /** 매핑 규칙이 속한 사용자 지정 속성 */
  customAttribute?: DomainCustomAttributeResponse;
  /** 소재 그룹 */
  fabrics?: string[];
  /** 매핑 그룹 속성의 그룹 코드 */
  groupCategory: string;
  /** 매핑 그룹 속성 그룹 그룹명 (상의, 하의, 아우터 ... 등) */
  groupCategoryName: string;
  /** 매핑그룹 ID */
  mappingGroupID?: string;
  /** 맵핑 그룹 타입 (남성, 여성) */
  mappingGroupType?: string;
  /** 매핑 ID */
  mappingID?: string;
  /** 매핑의 타입, 메타데이터 (mapping-group, mapping-type  참고) */
  mappingType?: string;
  /** 매핑 규칙이 속한 플랫폼 카테고리 리스트 */
  platformCategoryIDs: string[];
  /** 매핑 규칙 ID */
  ruleID: string;
}

export interface DomainUndoShippingInProgressOrdersRequest {
  orderIDs: string[];
}

export interface DomainUpdateAclosetMarketItemReviewReplyRequest {
  /** @example 125156 */
  marketItemID: number;
  /**
   * 빈 문자열이면 삭제한 것으로 처리됩니다
   * @example "답글 내용"
   */
  reply: string;
}

export interface DomainUpdateAclosetPartnerShopInfoRequest {
  /** 매장 영업시간 */
  businessHours?: string;
  /** 매장 소개 컨텐츠 글 */
  contentDescription?: string;
  /** 매장소개 컨텐츠 이미지들 */
  contentImages?: string[];
  /** 매장 소개 활성화 여부 */
  enabled?: boolean;
  /** 대표 이미지 URL */
  mainImageUrl?: string;
  /** 지도 이미지 URL */
  mapImageUrl?: string;
  /** 닉네임 */
  nickname?: string;
  /** 프로셀러 키워드 */
  prosellerKeywords?: string[];
  /** 한줄소개 */
  shortIntroduction?: string;
  /** 간략 위치 */
  storeLocations?: DomainPartnerShopInfoStoreLocations;
  /** 유저 아이디 */
  userID?: number;
}

export interface DomainUpdateAclosetStoreCouponRequest {
  /** 쿠폰 이름 */
  couponName: string;
  /** 할인 금액 */
  discountAmount: number;
  /** 파트너 샵 ID */
  partnerShopInfoID: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
}

export interface DomainUpdateAclosetSupplierRequest {
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeShippingThreshold: number;
  /** CS 담당 연락처 */
  inquiryContact: string;
  /** 공급사명(지점명) 노출 여부 */
  isVisible: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea: boolean;
  /** 공급사명(지점명) */
  logixName: string;
  /** 배송 정책 */
  logixPolicy?: string;
  /** 배송 타입 */
  logixPriceType: string;
  /** 배송비 */
  orderLogixPrice: DomainMarketItemLogixPrice;
  /** 최대 구매 수량 */
  purchaseQuantityLimit: number;
  /** 반품 주소 */
  returnAddress: DomainShopAclosetAddress;
  /** 택배사 */
  returnLogixName: string;
  /** 반품 배송비 */
  returnLogixPrice: DomainMarketItemLogixPrice;
  /** 반품 정책 */
  returnPolicyDescription: string;
  /** 수거 방법 */
  returnPolicyType: string;
}

export interface DomainUpdateCategoryAliasesRequest {
  categoryAliases: DomainCategoryAliasRequest[];
  /** 전체 별칭의 사용 여부 */
  enable: boolean;
}

export interface DomainUpdateColorAliasesRequest {
  colorAliases: DomainColorAliasRequest[];
  enable: boolean;
}

export interface DomainUpdateExcelTemplateRequest {
  /** 직접 입력 항목 */
  customFields?: DomainExcelTemplateCustomFieldRequest[];
  /** 엑셀 포멧 확장자 (메타데이터 template, extension 참조) */
  extension?: string;
  /** 선택 항목 */
  fields?: DomainExcelTemplateFieldRequest[];
  /** 기본 템플릿 여부 */
  isDefault?: boolean;
  /** 택배사 코드 */
  shippingCompanyCode?: string;
  /** 정렬 순서 */
  sorts?: DomainExcelTemplateSortRequest[];
  /** 템플릿 이름 */
  templateName: string;
  /** 템플릿 타입 (메타데이터 template, type 참조) */
  templateType: string;
  /** 상품명에 HTML 태그 제거 여부 */
  withoutHTMLTag?: boolean;
}

export interface DomainUpdateFabricAliasesRequest {
  /** 전체 별칭의 사용 여부 */
  enable: boolean;
  fabricAliases: DomainFabricAliasRequest[];
}

export interface DomainUpdateFabricPriceCalculator {
  /** 소재목록 */
  fabrics?: string[];
  /** 곱셈치 */
  multiply?: number;
  /** 증가치 */
  plus?: number;
}

export interface DomainUpdateFabricPriceCalculatorsRequest {
  fabricPriceCalculators?: DomainUpdateFabricPriceCalculator[];
}

export interface DomainUpdateMaintenanceRequest {
  /** 점검 종료 시간 */
  endTime?: string;
  /** 점검중 여부 */
  isMaintenance?: boolean;
  /** 업데이트 내용 */
  updateDetails?: string;
}

export interface DomainUpdateMappingGroupMappingRuleRequest {
  /** 매핑 규칙이 속한 AIMS 속성 */
  aimsAttribute?: string;
  /** 매핑 규칙이 속한 AIMS 카테고리 */
  aimsCategory: string;
  /** 브랜드 그룹 아이디 */
  brandGroupIDs?: string[];
  /** 매핑 규칙이 속한 사용자 지정 속성 */
  customAttribute?: DomainCustomAttributeRequest;
  /** 소재 그룹 */
  fabrics?: string[];
  /** 매핑 그룹 속성의 그룹 코드 */
  groupCategory: string;
  /** 매핑그룹 ID */
  mappingGroupID?: string;
  /** 매핑 ID */
  mappingID?: string;
  /** 매핑 규칙이 속한 플랫폼 카테고리 리스트 */
  platformCategoryIDs: string[];
  /** 매핑 규칙 ID */
  ruleID: string;
}

export interface DomainUpdateMappingGroupMappingsRequest {
  /** 생성할 매핑 리스트 */
  mappings: DomainMappingGroupMappingRequest[];
}

export interface DomainUpdateMappingGroupPropertiesRequest {
  /** 수정할 매핑그룹 속성 리스트 */
  properties: DomainMappingGroupPropertyRequest[];
}

export interface DomainUpdateServicePricingWithSettlementRequest {
  /**
   * 카드 ID
   * @example "65378b60f9505804b23cdaf6"
   */
  cardID?: string;
  /**
   * 서비스 가격 코드 목록
   * @example ["SERVICE-PRICING_CODE_AUTO-REFINE"]
   */
  servicePricingCodes: string[];
}

export interface DomainUpdateShopBrandImageRequest {
  brandImageName?: string;
  brandImageURL?: string;
}

export interface DomainUpdateShopBrandImagesRequest {
  brands?: DomainUpdateShopBrandImageRequest[];
}

export interface DomainUpdateShopBrandRequest {
  bookmarked?: boolean;
  brandID?: string;
  brandImageName?: string;
  brandImageURL?: string;
  content?: string;
  createDate?: string;
  englishName?: string;
  groupIDs?: string[];
  /** 키워드 */
  keywords?: string[];
  koreanName?: string;
}

export interface DomainUpdateShopBrandsRequest {
  brands?: DomainUpdateShopBrandRequest[];
}

export interface DomainUpdateShopBusinessRequest {
  /** 계좌주명 */
  accountHolder: string;
  /** 계좌번호 */
  accountNumber: string;
  /** 사업장 주소 */
  address: string;
  /** 계좌 은행 */
  bankName: string;
  /** 사업자 이메일 */
  businessEmail: string;
  /** 사업자 전화번호 */
  businessMobile: string;
  /** 회사 법인명 */
  businessName?: string;
  /** 사업자 등록증 파일명 */
  businessRegistrationFileName: string;
  /** 사업자 등록증 파일 URL */
  businessRegistrationFileURL: string;
  /** 사업자 등록번호 */
  businessRegistrationNumber: string;
  /** 업태/업종 (별도의 메타데이터 존재하지 않음) */
  businessType: string;
  /** 통신판매신고증 사본 이름 */
  mailOrderSalesRegistrationFileName?: string;
  /** 통신판매신고증 사본 URL */
  mailOrderSalesRegistrationFileURL?: string;
  /** 통신판매신고번호 */
  mailOrderSalesRegistrationNumber?: string;
  /** 오너 전화번호 */
  ownerMobile: string;
  /** 대표명 */
  ownerName: string;
  /** 사업자 유형 (별도의 메타데이터 존재하지 않음) */
  ownerType: string;
}

export interface DomainUpdateShopHTMLTemplateRequest {
  acloset: DomainDescriptionJsonDOMRequest;
  bunjang: DomainDescriptionJsonDOMRequest;
  cafe24: DomainDescriptionJsonDOMRequest;
  /** TODO Deprecated */
  domTreeJSON: string;
  /** TODO Deprecated */
  htmlTemplate: string;
  naverSmartStore: DomainDescriptionJsonDOMRequest;
  /** TODO Deprecated */
  plainTemplate: string;
}

export interface DomainUpdateShopMappingPropertiesRequest {
  /** 수정할 매핑그룹 속성 리스트 */
  properties: DomainMappingGroupPropertyRequest[];
}

export interface DomainUpdateShopPriceRulesRequest {
  priceRules: DomainShopPriceRuleRequest[];
}

export interface DomainUpdateShopSaleFieldsRequest {
  /** 업데이트할 필드 리스트 (순서대로 넣으면 백엔드에서 순서 보장) */
  fields: DomainShopSaleFieldRequest[];
}

export interface DomainUpdateShopStaticRequest {
  acloset?: DomainShopAclosetStaticRequest;
  bunjang?: DomainShopBunjangStaticRequest;
  cafe24?: DomainShopCafe24StaticRequest;
  naverSmartStore?: DomainShopNaverSmartStoreStaticRequest;
}

export interface DomainUpdateShopTaskItemCodesRequest {
  /** 상품 코드 규칙 */
  itemCodeRule: DomainShopTaskItemCodeRuleRequest;
}

export interface DomainUpdateShopTaskItemImagesRequest {
  /** @example ["https://example.com"] */
  deleteImages?: string[];
  /** 이미지 파일 */
  insertImages?: DomainShopTaskItemImageRequest[];
  /** 이미지 파일 */
  putImages?: DomainShopTaskItemImageRequest[];
  /** 이미지 파일 */
  updateImages?: DomainShopTaskItemImageRequest[];
}

export interface DomainUpdateSizeMappingGroupRequest {
  /** 통합 사이즈 규칙 리스트 */
  integratedSizeMappings?: DomainIntegratedSizeMappingRequest[];
  mappingGroupType?: string;
  mappings?: DomainSizeMappingRequest[];
}

export interface DomainUpdateUnMappedMappingGroupMappingRulesRequest {
  rules: DomainUpdateMappingGroupMappingRuleRequest[];
}

export interface DomainUploadFileResponse {
  /** 업로드된 파일의 URL */
  uploadedURL: string;
}

export interface DomainUploadNaverImagesResponse {
  imageURLs?: string[];
}

export interface DomainUploadShopFileResponse {
  /** 업로드된 파일의 URL */
  uploadedURL: string;
}

export interface DomainUpsertPlatformCategoryRulesRequest {
  mappings: DomainPlatformCategoryRuleMappingRequest[];
  platformCategoryID: string;
  platformCategoryRuleID?: string;
  useUnifiedRules: boolean;
}

export interface DomainVerifyEmailVerificationCodeRequest {
  /** @example "abc@naver.com" */
  email: string;
  /**
   * 인증코드
   * @example "123456"
   */
  verificationCode: string;
}

export interface DomainVerifyInvitationCodeRequest {
  invitationCode: string;
}

export interface DomainVerifyInvitationCodeResponse {
  verified?: boolean;
}

export interface ShopsListParams {
  /**
   * 사업자 전화번호 포함 검색
   * @example "010"
   */
  containsBusinessMobile?: string;
  /**
   * 사업자 이름 포함 검색
   * @example "사업자"
   */
  containsBusinessName?: string;
  /**
   * 사업자 소유쥬? 전화번호 포함 검색
   * @example "010"
   */
  containsBusinessOwnerMobile?: string;
  /**
   * 샵 소유자 이름 포함 검색
   * @example "사용자"
   */
  containsOwnerName?: string;
  /**
   * 샵 이름 포함 검색
   * @example "샵"
   */
  containsShopName?: string;
  /**
   * 유입 채널
   * @example "SHOP_INFLOW-CHANNEL_BUNJANG-LOAD"
   */
  inflowChannel?: string;
  /**
   * 비활성화된 샵 조회 여부
   * @example true
   */
  isBlocked?: boolean;
  /**
   * 공식입점 샵 조회 여부
   * @example true
   */
  isOfficiallyEntered?: boolean;
  /**
   * 파트너 샵 조회 여부
   * @example true
   */
  isPartnerShop?: boolean;
  /**
   * 테스트 샵 포함 여부
   * @example true
   */
  isTest?: boolean;
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  /**
   * 조회할 필드 목록. 미전달시 전체 필드를 조회합니다.
   * @example ["shopName","ownerName"]
   */
  projectionFields?: string[];
}

export interface BunjangShopLoadTasksListParams {
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /** 샵 상태 */
  status?: string[];
}

export interface BunjangShopsListParams {
  /** 샵 영업 상태 */
  businessStatus?: string[];
  /** 회사 법인명 */
  containsBusinessName?: string;
  /** 대표명 (like 검색) */
  containsOwnerName?: string;
  /** 상점명 */
  containsShopName?: string;
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /** 팔로워수 최소 */
  gteFollowerCount?: number;
  /** 판매 상품수 최소 */
  gteSaleProductCount?: number;
  /** 카카오톡 상태 */
  kakaotalkStatus?: string[];
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /** 기간 필터 타입 (recentUploadDate: 최근 상품 등록일, createDate: 번개장터 샵 생성일) */
  searchPeriodType?: 'recentUploadDate' | ' createDate';
  /** 특정 샵의 bunjang 정보만 조회 */
  shopID?: string[];
  /**
   * 정렬방법 (asc: 오름차순 , desc: 내림차순)
   * @example "asc"
   */
  sort?: 'asc' | 'desc';
  /** 정렬타입 (recentUploadDate: 상품 등록 일시, modifyDate: 상점 업데이트 일시) */
  sortType?: 'recentUploadDate' | 'modifyDate';
  /** 샵 상태 */
  status?: string[];
  /** @example "2023-04-14T23:59:59.999+09:00" */
  to?: string;
}

export interface ClaimStatusesFsmListParams {
  /**
   * 조회할 주문 상태(비어있으면 전체 주문 상태로 조회)
   * @example ["CLAIM_RETURN-STATUS_REQUEST"]
   */
  claimStatuses?: string[];
  /** @example "SHOP_PLATFORM-TYPE_CAFE24" */
  platformType: string;
}

export interface CreditsListParams {
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /**
   * 샵 ID 목록
   * @example ["65378b60f9505804b23cdaf6"]
   */
  shopID?: string[];
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
  /** 타입 */
  type?: string[];
}

export interface LabelingItemsListParams {
  /** 조회할 세컨솔드 성별 (리스트 가능) (market-item, genderwear 메타데이터 참조) */
  aclosetGenderWear?: string[];
  /** 조회할 브랜드 명 (Exact Match) */
  brandName?: string;
  /** 조회할 AIMS 카테고리 (/shops/metadata/properties API 반환 값 참조) (리스트 가능) */
  category?: string[];
  /** 조회할 색상 (리스트 가능) (/shops/metadata/properties API 반환 값 참조) */
  color?: string[];
  /** 조회할 기간 시작일시 */
  from: string;
  /** 조회할 성별 (리스트 가능) (shop, item-gender 메타데이터 참조) */
  gender?: string[];
  /** 조회할 라벨링 상태 (labeling, status 메타데이터 참조) (리스트 가능) */
  labelingStatus?: string[];
  /** 조회할 라벨링 타입 (labeling, type 메타데이터 참조) (리스트 가능) */
  labelingType?: string[];
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /** 조회할 판매 상태 (sale, status 메타데이터 참조) (리스트 가능) */
  saleStatus?: string[];
  /** 조회할 기간 필드 (postDate: 상품 등록일) */
  searchPeriodType: string;
  /** 조회할 샵 ID (리스트 가능) (라벨링 타입이 브랜드인 경우 */
  shopID?: string[];
  /** 조회할 상품명 (Like Match) */
  title?: string;
  /** 조회할 기간 종료일시 */
  to: string;
}

export interface MetadataListParams {
  /**
   * 도메인
   * @example "outfit"
   */
  domain?: string;
  /**
   * 서브 도메인
   * @example "content"
   */
  subDomain?: string;
}

export interface MetadataMapListParams {
  /**
   * 도메인
   * @example "outfit"
   */
  domain?: string;
  /**
   * 언어
   * @example "ko"
   */
  language: 'ko' | 'en' | 'ru' | 'fr' | 'es';
  /**
   * 서브 도메인
   * @example "content"
   */
  subDomain?: string;
}

export interface MetadataPropertiesListParams {
  /** 그룹 코드 */
  groupCode: string;
  /** 조회할 서브 그룹 코드 리스트 (`groupCode=="CATEGORY, AIMSCATEGORY"`인 경우에만 적용) `null`인 경우 전체 조회 */
  subGroupCodes?: string[];
}

export interface NotificationsKakaotalkTemplatesListParams {
  /** 템플릿 타입 */
  templateType?: string;
}

export interface OrderStatusesFsmListParams {
  /**
   * 조회할 주문 상태(비어있으면 전체 주문 상태로 조회)
   * @example ["ORDER_STATUS_PAYMENT-DONE"]
   */
  orderStatuses?: string[];
  /** @example "SHOP_PLATFORM-TYPE_CAFE24" */
  platformType: string;
}

export interface PlatformBanksListParams {
  /** ⚠️현재는 카페 24, 세컨솔드만 해당 (shop, platform-type 메타데이터 참조) */
  platformType: string;
}

export interface PlatformCancelReasonsListParams {
  /** 취소사유를 조회할 플랫폼 종류 (shop, platform-type 메타데이터 참조) */
  platformType: string;
}

export interface PlatformOriginAreasListParams {
  /** ⚠️현재는 스마트 스토어만 해당 (shop, platform-type 메타데이터 참조) */
  platformType: string;
}

export interface PlatformRefundMethodCodesListParams {
  /** ⚠️현재는 카페 24만 해당 (shop, platform-type 메타데이터 참조) */
  platformType: string;
}

export interface PlatformRejectCancelReasonsListParams {
  /** ⚠️현재는 카페 24만 해당 (shop, platform-type 메타데이터 참조) */
  platformType: string;
}

export interface PlatformRejectReturnReasonsListParams {
  /** 현재는 세컨솔드만 해당 (shop, platform-type 메타데이터 참조) */
  platformType: string;
}

export interface PlatformRequestReturnReasonsListParams {
  /** ⚠️현재는 네이버, 카페24만 해당 (shop, platform-type 메타데이터 참조) */
  platformType?: string;
  /** ⚠️현재는 카페24만 해당 (claim, transaction-type 메타데이터 참조) */
  transactionType?: string;
}

export interface PlatformShippingCompaniesListParams {
  /** 배송사를 조회할 플랫폼 종류 (shop, platform-type 메타데이터 참조) */
  platformType: string;
}

export interface PopupsListParams {
  /** 팝업 대상입니다. popup, target 메타데이어 참조 */
  popupTargets?: string[];
}

export interface SaleItemsConsistencyReportsListParams {
  /**
   * 오류코드 (item-consistency-report, error-code 메타데이터 참조)
   * @example "ERROR_CODE_1001"
   */
  errorCode?: string;
  /**
   * 상품코드
   * @example "상품코드"
   */
  itemCode?: string;
  /**
   * 상품명
   * @example "상품명"
   */
  itemTitle?: string;
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /**
   * 샵 아이디
   * @example ["5f7b1b7b7b7b7b7b7b7b7b7b"]
   */
  shopID?: string[];
  /**
   * 상태 (리스트 허용)
   * @example ["REPORT_STATUS_DONE"]
   */
  status?: string[];
}

export interface SalePlatformStatusesFsmListParams {
  /**
   * 조회할 주문 상태(비어있으면 전체 주문 상태로 조회)
   * @example ["ORDER_STATUS_PAYMENT-DONE"]
   */
  orderStatuses?: string[];
  /** @example "SHOP_PLATFORM-TYPE_CAFE24" */
  platformType: string;
}

export interface SaleStatusesFsmListParams {
  /**
   * 조회할 주문 상태(비어있으면 전체 주문 상태로 조회)
   * @example ["ORDER_STATUS_PAYMENT-DONE"]
   */
  orderStatuses?: string[];
}

export interface ShippingCompaniesListParams {
  /** 배송사를 조회할 플랫폼 종류 (shop, platform-type 메타데이터 참조) */
  platformType?: string;
  /** 검색 필드(code, name)에 대해 Hard Match Search */
  search?: string;
}

export interface TasksListParams {
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
}

export interface TemplateFieldsListParams {
  /** 템플릿 타입 (메타데이터 template, type 참조) */
  templateType: string;
}

export interface UploadFileCreatePayload {
  /**
   * 파일
   * @format binary
   */
  file: File;
}

export interface AclosetSettlementsDetailParams {
  /** 필터 종료 기간 UTC */
  createDateEnd?: number;
  /** 필터 시작 기간 UTC */
  createDateStart?: number;
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  paymentType?: 'ONLINE' | 'STORE';
  /** @example [1,2,3] */
  settlementID?: number[];
  /**
   * 세컨솔드 정산 상태값
   * @example ["SETTLEMENT_STATUS_UNAUDITED"]
   */
  status?: string[];
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface AclosetSettlementsAmountDetailParams {
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2025-01-01T00:00:00.000Z"
   */
  from: string;
  /**
   * 세컨솔드 정산 상태값
   * @example ["SETTLEMENT_STATUS_UNAUDITED"]
   */
  status?: string[];
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2025-01-05T00:00:00.000Z"
   */
  to: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface AclosetPartnerShopsDetailParams {
  limit?: number;
  /** 내 정보만 조회하기 */
  myInfo?: boolean;
  offset?: number;
  /** 지역 */
  region?: string;
  /** 사용자 ID */
  userID?: number;
  shopId: string;
}

export interface AclosetReviewsDetailParams {
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface BlackConsumersDetailParams {
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface BlackConsumersDeleteParams {
  /** 방해고객의 ID */
  blackConsumerID?: string;
  /** 방해고객의 userID (세컨솔드) */
  userID?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface BrandGroupsDeleteParams {
  /**
   * 브랜드 그룹 ID 리스트
   * @example ["5f9f1b5b9b9b9b9b9b9b9b9b"]
   */
  groupID?: string[];
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface BrandsDetailParams {
  /**
   * 북마크 브랜드 조회 여부
   * @example true
   */
  bookmarked?: boolean;
  /**
   * 브랜드 ID 리스트
   * @example ["5f9f1b5b9b9b9b9b9b9b9b9b"]
   */
  brandID?: string[];
  /**
   * 그룹ID 필터링
   * @example "63eb6df3f45b6fc2c1045aff"
   */
  groupID?: string;
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  /** @example "ZARA" */
  searchKeyword?: string;
  /** @example "ko" */
  searchKeywordType?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface BrandsDeleteParams {
  /**
   * 브랜드 ID 리스트
   * @example ["5f9f1b5b9b9b9b9b9b9b9b9b"]
   */
  brandID?: string[];
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface ClaimCountsDetailParams {
  /** 조회할 주문 상태 [복수 가능] [빈 값인 경우 전체] (order, status 메타데이터 참조) */
  claimStatus?: string[];
  /** 조회할 주문 타입 [복수 가능] [빈 값인 경우 전체] (order, type 메타데이터 참조) */
  claimType?: string;
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from: string;
  /** 조회할 주문 상태 [복수 가능] [빈 값인 경우 전체] (order, status 메타데이터 참조) */
  inOrderStatus?: string[];
  /** 조회하지 않을 주문 상태 [복수 가능] [빈 값인 경우 전체] (order, status 메타데이터 참조) */
  notInOrderStatus?: string[];
  /**
   * 플랫폼 타입 [빈 값인 경우 전체] (metadata shop, platform-type 참조)
   * @example ["SHOP_PLATFORM-TYPE_CAFE24"]
   */
  platformType?: string[];
  /** 기간 필터 타입 (orderRequestDate: 주문일, returnRequestDate: 반품 요청일, returnDoneDate: 반품 완료일) */
  searchPeriodType?: 'orderRequestDate' | 'returnRequestDate' | 'returnDoneDate';
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface ClaimsDetailParams {
  /**
   * 구매자명 (LIKE 검색)
   * @example "구매자명"
   */
  buyerName?: string;
  /**
   * 구매자 전화번호 (하이픈 없이) (LIKE 검색)
   * @example "01012345678"
   */
  buyerPhone?: string;
  /**
   * 클레임 상태 (metadata claim, return-status 참조) (metadata claim, exchange-status 참조)
   * @example ["CLAIM_RETURN-STATUS_REQUEST"]
   */
  claimStatus?: string[];
  /**
   * 클레임 타입 (metadata claim, type 참조)
   * @example "CLAIM_TYPE_RETURN"
   */
  claimType: 'CLAIM_TYPE_RETURN' | 'CLAIM_TYPE_EXCHANGE';
  /**
   * 상품코드가 입력과 부분일치하는 주문만 조회 (LIKE '%text%' 검색)                    // 상품코드 (LIKE 검색)
   * @example "A"
   */
  containsItemAlias?: string;
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /**
   * 송장번호 (IN 검색)
   * @example ["123712378123"]
   */
  invoiceNumber?: string[];
  /**
   * 상품코드 (IN 검색)
   * @example ["12738273"]
   */
  itemCode?: string[];
  /**
   * 상품명 (LIKE 검색)
   * @example "상품명"
   */
  itemTitle?: string;
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /**
   * 플랫폼 주문 ID (IN 검색)
   * @example ["12738273"]
   */
  platformOrderID?: string[];
  /**
   * 플랫폼 상품주문 ID (IN 검색)
   * @example ["12738274"]
   */
  platformProductOrderID?: string[];
  /**
   * 플랫폼 타입 (metadata platform, type 참조)`
   * @example ["PLATFORM_TYPE_CAFE24"]
   */
  platformType?: string[];
  /**
   * 수취인명 (LIKE 검색)
   * @example "받는사람"
   */
  receiverName?: string;
  /**
   * 수취인 전화번호 (하이픈 없이) (LIKE 검색)
   * @example "01012345678"
   */
  receiverPhone?: string;
  /**
   * 반송 송장번호 (IN 검색)
   * @example ["123712378123"]
   */
  returnInvoiceNumber?: string[];
  /** 기간 필터 타입 (orderRequestDate: 주문 요청 일시, returnRequestDate: 반품 요청 일시, returnRequestDate: 교환 요청 일시) */
  searchPeriodType?: 'orderRequestDate' | 'returnRequestDate' | 'exchangeRequestDate';
  /**
   * 정렬방법 (asc: 오름차순 , desc: 내림차순)
   * @example "asc"
   */
  sort?: 'asc' | 'desc';
  /** 정렬타입 (orderRequestDate: 주문 요청 일시, returnRequestDate: 반품 요청 일시, returnRequestDate: 교환 요청 일시) */
  sortType?: 'orderRequestDate' | 'returnRequestDate' | 'exchangeRequestDate';
  /** @example "공급사" */
  supplierName?: string;
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface ClaimsDetailDetailParams {
  /** 현재는 세컨솔드만 해당, 메타데이터 (shop, platform-type 참고) */
  platformType: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
  /**
   * 클레임 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  claimId: string;
}

export interface CouponsDetailParams {
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  /**
   * 쿠폰 상태값
   * @example ["COUPON_STATUS_USING"]
   */
  status?: string[];
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface CouponsAclosetCouponsDetailParams {
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface CreditsDetailParams {
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface ExcelTemplatesDetailParams {
  /** 템플릿 ID (복수 가능) */
  excelTemplateID?: string[];
  /** 기본 템플릿 여부 */
  isDefault?: boolean;
  /** 템플릿 타입 (메타데이터 template, type 참조) */
  templateType: string;
  /** 샵 ID */
  shopId: string;
}

export interface ExcelTemplatesModifyShopOrdersCreatePayload {
  /** 엑셀 파일 */
  excelFile: File;
}

export interface MappingGroupsMappingsDetailParams {
  /** 메타데이터 (shop, platform-type 참고) 빈 값의 경우 전체 조회 */
  platformType?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
  /**
   * 샵 매핑 그룹 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  mappingGroupId: string;
}

export interface NotificationsDetailParams {
  isPolling?: boolean;
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  withoutRead?: boolean;
  /** 샵 ID */
  shopId: string;
}

export interface NotificationsAclosetDetailParams {
  isPolling?: boolean;
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /** 샵 ID */
  shopId: string;
}

export interface NotificationsAclosetCountDetailParams {
  isRead?: boolean;
  /** 샵 ID */
  shopId: string;
}

export interface NotificationsCountDetailParams {
  isRead?: boolean;
  /** 샵 ID */
  shopId: string;
}

export interface OrderCountsDetailParams {
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  isDuplicated?: boolean;
  /** 할인 요청 여부 (true: 할인 요청 주문만, false: 할인 요청 포함 주문, null: 할인 요청 필터링 안함) */
  isOffer?: boolean;
  /** 조회할 주문 상태 [복수 가능] (order, status 메타데이터 참조) */
  orderStatus?: string[];
  /**
   * 플랫폼 타입 (metadata shop, platform-type 참조)
   * @example ["SHOP_PLATFORM-TYPE_CAFE24"]
   */
  platformType?: string[];
  /** 조회할 처리 상태 [복수 가능] (order, process-status 메타데이터 참조) */
  processStatus?: string[];
  /** 기간 필터 타입 (orderDate: 주문 일시, paymentDoneDate: 결제완료일, shippingPendingDate: 주문 확인일, shippingDoneDate: 배송 완료일, purchaseDoneDate: 구매 확정일, returnRequestDate: 반품 요청일) */
  searchPeriodType?:
    | 'orderDate'
    | 'paymentDoneDate'
    | 'shippingPendingDate'
    | 'shippingDoneDate'
    | 'purchaseDoneDate'
    | 'returnRequestDate';
  /** @example "2023-04-14T23:59:59.999+09:00" */
  to?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface OrdersDetailParams {
  /**
   * 구매자명 (LIKE 검색)
   * @example "구매자명"
   */
  buyerName?: string;
  /**
   * 구매자 전화번호 (하이픈 없이) (LIKE 검색)
   * @example "01012345678"
   */
  buyerPhone?: string;
  /** 상품코드 부분일치 주문 조회 (LIKE '%text%' 검색) */
  containsItemAlias?: string;
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /** 운송장 번호 필터링 여부 (true: 운송장 번호가 있는 주문만, false: 운송장 번호가 없는 주문만, null: 운송장 번호 필터링 안함) */
  hasInvoiceNumber?: boolean;
  /**
   * 송장번호 (IN 검색)
   * @example ["123712378123"]
   */
  invoiceNumber?: string[];
  /** 중복 주문 필터링 여부 (true: 중복 주문만, false: 중복 주문 포함, null: 중복 주문 필터링 안함) ⚠️ 해당 필드로 필터링 시 정렬 기준이 변경됩니다. */
  isDuplicated?: boolean;
  /** 할인 요청 여부 (true: 할인 요청 주문만, false: 할인 요청 포함 주문, null: 할인 요청 필터링 안함) */
  isOffer?: boolean;
  /**
   * 상품코드 (IN 검색)
   * @example ["12738273"]
   */
  itemAlias?: string[];
  /**
   * 상품명 (LIKE 검색)
   * @example "상품명"
   */
  itemTitle?: string;
  /** 주문 ID는 리스트로 요청이 가능합니다. 	// 조회할 주문 상태 (order, status 메타데이터 참조) */
  orderID?: string[];
  /**
   * 주문 상태 (metadata order, status 참조)
   * @example ["ORDER_STATUS_PAYMENT-DONE"]
   */
  orderStatus?: string[];
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  /**
   * 플랫폼 주문 ID (IN 검색)
   * @example ["12738273"]
   */
  platformOrderID?: string[];
  /**
   * 플랫폼 상품주문 ID (IN 검색)
   * @example ["12738274"]
   */
  platformProductOrderID?: string[];
  /**
   * 플랫폼 타입 (metadata platform, type 참조)
   * @example ["PLATFORM_TYPE_CAFE24"]
   */
  platformType?: string[];
  /** 조회할 처리 상태 (order, process-status 메타데이터 참조) */
  processStatus?: string[];
  /**
   * 수취인명 (LIKE 검색)
   * @example "받는사람"
   */
  receiverName?: string;
  /**
   * 수취인 전화번호 (하이픈 없이) (LIKE 검색)
   * @example "01012345678"
   */
  receiverPhone?: string;
  /** 기간 필터 타입 (orderDate: 주문일, paymentDone: 결제일, shippingInProgressDate: 발송확인일, purchaseDoneDate: 구매확정일) */
  searchPeriodType?: 'orderDate' | 'paymentDoneDate' | 'shippingInProgressDate' | 'purchaseDoneDate';
  /**
   * 공급사
   * @example "공급사"
   */
  supplierName?: string;
  /** @example "2023-04-14T23:59:59.999+09:00" */
  to?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface OrdersIdDetailParams {
  /**
   * 구매자명 (LIKE 검색)
   * @example "구매자명"
   */
  buyerName?: string;
  /**
   * 구매자 전화번호 (하이픈 없이) (LIKE 검색)
   * @example "01012345678"
   */
  buyerPhone?: string;
  /** 상품코드 부분일치 주문 조회 (LIKE '%text%' 검색) */
  containsItemAlias?: string;
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /** 운송장 번호 필터링 여부 (true: 운송장 번호가 있는 주문만, false: 운송장 번호가 없는 주문만, null: 운송장 번호 필터링 안함) */
  hasInvoiceNumber?: boolean;
  /**
   * 송장번호 (IN 검색)
   * @example ["123712378123"]
   */
  invoiceNumber?: string[];
  /** 중복 주문 필터링 여부 (true: 중복 주문만, false: 중복 주문 포함, null: 중복 주문 필터링 안함) ⚠️ 해당 필드로 필터링 시 정렬 기준이 변경됩니다. */
  isDuplicated?: boolean;
  /** 할인 요청 여부 (true: 할인 요청 주문만, false: 할인 요청 포함 주문, null: 할인 요청 필터링 안함) */
  isOffer?: boolean;
  /**
   * 상품코드 (IN 검색)
   * @example ["12738273"]
   */
  itemAlias?: string[];
  /**
   * 상품명 (LIKE 검색)
   * @example "상품명"
   */
  itemTitle?: string;
  /** 주문 ID는 리스트로 요청이 가능합니다. 	// 조회할 주문 상태 (order, status 메타데이터 참조) */
  orderID?: string[];
  /**
   * 주문 상태 (metadata order, status 참조)
   * @example ["ORDER_STATUS_PAYMENT-DONE"]
   */
  orderStatus?: string[];
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  /**
   * 플랫폼 주문 ID (IN 검색)
   * @example ["12738273"]
   */
  platformOrderID?: string[];
  /**
   * 플랫폼 상품주문 ID (IN 검색)
   * @example ["12738274"]
   */
  platformProductOrderID?: string[];
  /**
   * 플랫폼 타입 (metadata platform, type 참조)
   * @example ["PLATFORM_TYPE_CAFE24"]
   */
  platformType?: string[];
  /** 조회할 처리 상태 (order, process-status 메타데이터 참조) */
  processStatus?: string[];
  /**
   * 수취인명 (LIKE 검색)
   * @example "받는사람"
   */
  receiverName?: string;
  /**
   * 수취인 전화번호 (하이픈 없이) (LIKE 검색)
   * @example "01012345678"
   */
  receiverPhone?: string;
  /** 기간 필터 타입 (orderDate: 주문일, paymentDone: 결제일, shippingInProgressDate: 발송확인일, purchaseDoneDate: 구매확정일) */
  searchPeriodType?: 'orderDate' | 'paymentDoneDate' | 'shippingInProgressDate' | 'purchaseDoneDate';
  /**
   * 공급사
   * @example "공급사"
   */
  supplierName?: string;
  /** @example "2023-04-14T23:59:59.999+09:00" */
  to?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface PaymentsDetailsDetailParams {
  /**
   * 결제 월 (예: 202303)
   * @example "202303"
   */
  month?: string;
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  /**
   * 결제내역 ID
   * @example "65378b60f9505804b23cdaff"
   */
  paymentDetailID?: string;
  /**
   * 정렬방법 (asc: 오름차순 , desc: 내림차순)
   * @example "asc"
   */
  sort?: 'asc' | 'desc';
  /**
   * 정렬타입 (createDate: 생성일시)
   * @example "createDate"
   */
  sortType?: 'createDate';
  /**
   * 결제 상태 (GET: /shops/metadata의 payment, status 참고)
   * @example "PAYMENT_STATUS_PENDING"
   */
  status?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface PlatformCategoriesDetailParams {
  /** 플랫폼 타입 (메타 데이터 shop, platform-type 참조) */
  platformType: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface PlatformsDeleteParams {
  /** 연동 해제 할 플랫폼 타입 (리스트 허용) */
  platformType: string[];
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface RealtimeSaleItemsDetailParams {
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /** 상품코드|상품명 둘 중 하나는 필수 */
  itemAlias?: string;
  /** 기간 필터 타입 (createDate: 아이템 생성일, modifyDate: 아이템 수정일, postDate: 상품 등록일) */
  searchPeriodType?: 'createDate' | 'modifyDate' | 'postDate';
  /** 상품코드|상품명 둘 중 하나는 필수 */
  title?: string;
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface SaleItemCountsDetailParams {
  /**
   * AIMS 카테고리 ID 목록
   * @example ["SWEATERS"]
   */
  aimsCategory?: string[];
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /** 각 쇼핑몰의 상태값에 판매중과 판매중지가 혼합되어 있는지 여부 */
  isPlatformStatusOnSaleAndStopSale?: boolean;
  /** 상품 코드 */
  itemAlias?: string;
  /**
   * 상품 코드 목록
   * @example ["12738273"]
   */
  itemAliases?: string[];
  /** 판매 상태 (메타데이터 sale, platform-status 참조) */
  platformStatus?: string[];
  /** 플랫폼 타입 (메타데이터 shop, platform-type 참조) */
  platformType?: string;
  /** 상품 ID 목록 (리스트를 허용합니다.) */
  saleItemID?: string[];
  /** 진행 상태를 조회하고자 할 때 사용 (진행 중, 실패, 대기) (메타데이터 sale, operation 참고) */
  saleOperation?: string;
  /** 판매 상태 (메타데이터 sale, status 참조) */
  saleStatus?: string[];
  /** 기간 필터 타입 (createDate: 아이템 생성일, modifyDate: 아이템 수정일, postDate: 상품 등록일) */
  searchPeriodType?: 'createDate' | 'modifyDate' | 'postDate';
  /** 공급사 (contains 검색) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
  supplierName?: string;
  /** 공급사 목록 (exact match) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
  supplierNames?: string[];
  /** 상품명 */
  title?: string;
  /**
   * 상품명 목록
   * @example ["테스트 상품"]
   */
  titles?: string[];
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface SaleItemsDetailParams {
  /**
   * AIMS 카테고리 ID 목록
   * @example ["SWEATERS"]
   */
  aimsCategory?: string[];
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /** 각 쇼핑몰의 상태값에 판매중과 판매중지가 혼합되어 있는지 여부 */
  isPlatformStatusOnSaleAndStopSale?: boolean;
  /** 상품 코드 */
  itemAlias?: string;
  /**
   * 상품 코드 목록
   * @example ["12738273"]
   */
  itemAliases?: string[];
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  /** 플랫폼의 상품 ID */
  platformProductID?: string[];
  /** 판매 상태 (메타데이터 sale, platform-status 참조) */
  platformStatus?: string[];
  /** 플랫폼 타입 (메타데이터 shop, platform-type 참조) */
  platformType?: string;
  /** 상품 ID 목록 (리스트를 허용합니다.) */
  saleItemID?: string[];
  /** 진행 상태를 조회하고자 할 때 사용 (진행 중, 실패, 대기) (메타데이터 sale, operation 참고) */
  saleOperation?: string;
  /** 판매 상태 (메타데이터 sale, status 참조) */
  saleStatus?: string[];
  /** 기간 필터 타입 (createDate: 아이템 생성일, modifyDate: 아이템 수정일, postDate: 상품 등록일) */
  searchPeriodType?: 'createDate' | 'modifyDate' | 'postDate';
  /**
   * 정렬방법 (asc: 오름차순 , desc: 내림차순)
   * @example "asc"
   */
  sort?: 'asc' | 'desc';
  /** 정렬타입 (postDate: 등록일, price: 가격) */
  sortType?: 'postDate' | 'price';
  /** 공급사 (contains 검색) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
  supplierName?: string;
  /** 공급사 목록 (exact match) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
  supplierNames?: string[];
  /** 상품명 */
  title?: string;
  /**
   * 상품명 목록
   * @example ["테스트 상품"]
   */
  titles?: string[];
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface SaleItemsIdDetailParams {
  /**
   * AIMS 카테고리 ID 목록
   * @example ["SWEATERS"]
   */
  aimsCategory?: string[];
  /**
   * 필터 시작 기간 (타임존 포함)
   * @example "2023-04-08T00:00:00.000+09:00"
   */
  from?: string;
  /** 각 쇼핑몰의 상태값에 판매중과 판매중지가 혼합되어 있는지 여부 */
  isPlatformStatusOnSaleAndStopSale?: boolean;
  /** 상품 코드 */
  itemAlias?: string;
  /**
   * 상품 코드 목록
   * @example ["12738273"]
   */
  itemAliases?: string[];
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  /** 플랫폼의 상품 ID */
  platformProductID?: string[];
  /** 판매 상태 (메타데이터 sale, platform-status 참조) */
  platformStatus?: string[];
  /** 플랫폼 타입 (메타데이터 shop, platform-type 참조) */
  platformType?: string;
  /** 상품 ID 목록 (리스트를 허용합니다.) */
  saleItemID?: string[];
  /** 진행 상태를 조회하고자 할 때 사용 (진행 중, 실패, 대기) (메타데이터 sale, operation 참고) */
  saleOperation?: string;
  /** 판매 상태 (메타데이터 sale, status 참조) */
  saleStatus?: string[];
  /** 기간 필터 타입 (createDate: 아이템 생성일, modifyDate: 아이템 수정일, postDate: 상품 등록일) */
  searchPeriodType?: 'createDate' | 'modifyDate' | 'postDate';
  /**
   * 정렬방법 (asc: 오름차순 , desc: 내림차순)
   * @example "asc"
   */
  sort?: 'asc' | 'desc';
  /** 정렬타입 (postDate: 등록일, price: 가격) */
  sortType?: 'postDate' | 'price';
  /** 공급사 (contains 검색) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
  supplierName?: string;
  /** 공급사 목록 (exact match) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
  supplierNames?: string[];
  /** 상품명 */
  title?: string;
  /**
   * 상품명 목록
   * @example ["테스트 상품"]
   */
  titles?: string[];
  /**
   * 필터 종료 기간 (타임존 포함)
   * @example "2023-04-14T23:59:59.999+09:00"
   */
  to?: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface SaleItemsPlatformPendingModifyingReasonsDetailParams {
  /** 플랫폼 타입 (shop, platform-type 메타데이터 참조) (리스트 가능) (비어 있을 시 전체 조회) */
  platformType?: string[];
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
  /**
   * 판매아이템 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  saleItemId: string;
}

export interface SettlementsDetailParams {
  /** 정산 월 (예: 202303) */
  month?: string;
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
  /** 결제내역 ID */
  paymentDetailID?: string;
  /** 정산 ID */
  settlementID?: string;
  /**
   * 정렬방법 (asc: 오름차순 , desc: 내림차순)
   * @example "asc"
   */
  sort?: 'asc' | 'desc';
  /** 정렬타입 (createDate: 생성일시) */
  sortType?: 'createDate';
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface ShopAuthExistsDetailParams {
  /** 인증 제공자 */
  platformType: string;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface TasksDetailParams {
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /**
   * 작업 상태
   * @example ["SHOP_TASK-STATUS_DONE"]
   */
  status?: string[];
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
}

export interface TasksDetail2Params {
  /**
   * 삭제된 작업 포함 여부
   * @example false
   */
  isDelete?: boolean;
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
  /**
   * 작업 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopTaskId: string;
}

export interface TasksItemsDetailParams {
  /**
   * 추가로 조회할 필드 요청
   * @example ["aclosetProperty"]
   */
  projectionFields?: string[];
  /**
   * 작업 아이템 ID
   * @example ["63eb6df3f45b6fc2c1045aff"]
   */
  shopTaskItemID?: string[];
  /**
   * 샵 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopId: string;
  /**
   * 작업 ID
   * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
   */
  shopTaskId: string;
}

export interface UploadBrandsCreatePayload {
  /** 브랜드 엑셀 파일 */
  brandExcelFile: File;
}

export interface UploadFileCreate2Payload {
  /** 파일 */
  shopFile: File;
}

export interface UploadNaverImagesCreatePayload {
  /** 이미지 파일 */
  imageFiles: File[];
}

export namespace Shops {
  /**
   * @description 샵 목록을 조회하는 API 입니다.
   * @tags Shops
   * @name ShopsList
   * @summary 샵 목록 조회 ✅
   * @request GET:/shops
   * @secure
   * @response `200` `DomainListShopsResponse` 샵 목록 응답 값
   */
  export namespace ShopsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 사업자 전화번호 포함 검색
       * @example "010"
       */
      containsBusinessMobile?: string;
      /**
       * 사업자 이름 포함 검색
       * @example "사업자"
       */
      containsBusinessName?: string;
      /**
       * 사업자 소유쥬? 전화번호 포함 검색
       * @example "010"
       */
      containsBusinessOwnerMobile?: string;
      /**
       * 샵 소유자 이름 포함 검색
       * @example "사용자"
       */
      containsOwnerName?: string;
      /**
       * 샵 이름 포함 검색
       * @example "샵"
       */
      containsShopName?: string;
      /**
       * 유입 채널
       * @example "SHOP_INFLOW-CHANNEL_BUNJANG-LOAD"
       */
      inflowChannel?: string;
      /**
       * 비활성화된 샵 조회 여부
       * @example true
       */
      isBlocked?: boolean;
      /**
       * 공식입점 샵 조회 여부
       * @example true
       */
      isOfficiallyEntered?: boolean;
      /**
       * 파트너 샵 조회 여부
       * @example true
       */
      isPartnerShop?: boolean;
      /**
       * 테스트 샵 포함 여부
       * @example true
       */
      isTest?: boolean;
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      /**
       * 조회할 필드 목록. 미전달시 전체 필드를 조회합니다.
       * @example ["shopName","ownerName"]
       */
      projectionFields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopsResponse;
  }

  /**
   * @description 샵을 생성하는 API 입니다. 백엔드가 직접 사용하기 때문에 OwnerID 는 Body 에 넣습니다.
   * @tags Shops
   * @name ShopsCreate
   * @summary 샵 생성 ✅
   * @request POST:/shops
   * @secure
   * @response `200` `DomainCreateShopResponse` 샵 생성 응답 값
   */
  export namespace ShopsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateShopResponse;
  }

  /**
   * @description 가격 제안 거절 사유 목록을 조회하는 API
   * @tags Platforms
   * @name AclosetRejectPriceOfferReasonsList
   * @summary 가격 제안 거절 사유 목록 조회 ✅
   * @request GET:/shops/acloset-reject-price-offer-reasons
   * @secure
   * @response `200` `DomainListAclosetRejectPriceOfferReasonsResponse` OK
   */
  export namespace AclosetRejectPriceOfferReasonsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListAclosetRejectPriceOfferReasonsResponse;
  }

  /**
   * @description 강제 업데이트 기준 앱 버젼 조회 API입니다.
   * @tags Shops
   * @name AppVersionList
   * @summary 강제 업데이트 기준 앱 버젼 조회 ✅
   * @request GET:/shops/app-version
   * @secure
   * @response `200` `DomainGetAppVersionResponse` OK
   */
  export namespace AppVersionList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetAppVersionResponse;
  }

  /**
   * @description 크롤링을 통해 번개장터 상품을 불러옵니다.
   * @tags Bunjang
   * @name BunjangLoadBunjangProductsCreate
   * @summary 번개장터 상품 불러오기 ✅
   * @request POST:/shops/bunjang/load-bunjang-products
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BunjangLoadBunjangProductsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainLoadBunjangProductsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 크롤링을 통해 번개장터 상품을 리셋합니다.
   * @tags Bunjang
   * @name BunjangLoadBunjangProductsCancelCreate
   * @summary 번개장터 상품 리셋하기 ✅
   * @request POST:/shops/bunjang/load-bunjang-products/cancel
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BunjangLoadBunjangProductsCancelCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCancelBunjangProductsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 번개장터 샵 불러오기 작업을 다건 조회합니다.
   * @tags Bunjang
   * @name BunjangShopLoadTasksList
   * @summary 번개장터 샵 불러오기 작업 다건 조회  ✅
   * @request GET:/shops/bunjang/shop-load-tasks
   * @secure
   * @response `200` `DomainListBunjangShopLoadTasksResponse` OK
   */
  export namespace BunjangShopLoadTasksList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
      /** 샵 상태 */
      status?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListBunjangShopLoadTasksResponse;
  }

  /**
   * @description 크롤링을 통해 번개장터 샵을 불러옵니다. 비동기 API입니다. 관리자 계정만 사용이 가능합니다.
   * @tags Bunjang
   * @name BunjangShopLoadTasksCreate
   * @summary 번개장터 샵 불러오기 ✅
   * @request POST:/shops/bunjang/shop-load-tasks
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BunjangShopLoadTasksCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainLoadBunjangShopLoadTaskRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 크롤링을 통힌 번개장터 샵 불러오기를 중단합니다.
   * @tags Bunjang
   * @name BunjangShopLoadTasksPauseCreate
   * @summary 번개장터 샵 불러오기 중단 ✅
   * @request POST:/shops/bunjang/shop-load-tasks/pause
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BunjangShopLoadTasksPauseCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainPauseBunjangShopLoadTaskRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 크롤링을 통해 번개장터 샵을 다시 불러옵니다.
   * @tags Bunjang
   * @name BunjangShopLoadTasksResumeCreate
   * @summary 번개장터 샵 다시 불러오기 ✅
   * @request POST:/shops/bunjang/shop-load-tasks/resume
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BunjangShopLoadTasksResumeCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainResumeBunjangShopLoadTaskRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 번개장터 샵을 다건 조회합니다.
   * @tags Bunjang
   * @name BunjangShopsList
   * @summary 번개장터 샵 다건 조회  ✅
   * @request GET:/shops/bunjang/shops
   * @secure
   * @response `200` `DomainListBunjangShopsResponse` OK
   */
  export namespace BunjangShopsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 샵 영업 상태 */
      businessStatus?: string[];
      /** 회사 법인명 */
      containsBusinessName?: string;
      /** 대표명 (like 검색) */
      containsOwnerName?: string;
      /** 상점명 */
      containsShopName?: string;
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /** 팔로워수 최소 */
      gteFollowerCount?: number;
      /** 판매 상품수 최소 */
      gteSaleProductCount?: number;
      /** 카카오톡 상태 */
      kakaotalkStatus?: string[];
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
      /** 기간 필터 타입 (recentUploadDate: 최근 상품 등록일, createDate: 번개장터 샵 생성일) */
      searchPeriodType?: 'recentUploadDate' | ' createDate';
      /** 특정 샵의 bunjang 정보만 조회 */
      shopID?: string[];
      /**
       * 정렬방법 (asc: 오름차순 , desc: 내림차순)
       * @example "asc"
       */
      sort?: 'asc' | 'desc';
      /** 정렬타입 (recentUploadDate: 상품 등록 일시, modifyDate: 상점 업데이트 일시) */
      sortType?: 'recentUploadDate' | 'modifyDate';
      /** 샵 상태 */
      status?: string[];
      /** @example "2023-04-14T23:59:59.999+09:00" */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListBunjangShopsResponse;
  }

  /**
   * @description 기존 샵에 번개장터 샵을 생성합니다. 현재는 기존 샵에 불러오기 정보를 초기화하는 용도로 사용합니다.
   * @tags Bunjang
   * @name BunjangShopsCreate
   * @summary 기존 샵에 번개장터 샵 생성 ✅
   * @request POST:/shops/bunjang/shops
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BunjangShopsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCreateBunjangShopRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 기존 샵에 번개장터 샵을 제거합니다. 불러오기 연동 해제입니다.
   * @tags Bunjang
   * @name BunjangShopsDelete
   * @summary 번개장터 샵 제거 ✅
   * @request DELETE:/shops/bunjang/shops/{bunjangShopID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BunjangShopsDelete {
    export type RequestParams = {
      /** 작업 ID */
      bunjangShopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 번개장터 샵을 수정합니다.
   * @tags Bunjang
   * @name BunjangShopsPartialUpdate
   * @summary 번개장터 샵 수정 ✅
   * @request PATCH:/shops/bunjang/shops/{bunjangShopID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BunjangShopsPartialUpdate {
    export type RequestParams = {
      /** 작업 ID */
      bunjangShopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchBunjangShopRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 카페24 OAuth 토큰 정보 조회 API
   * @tags Platforms
   * @name Cafe24AuthTokenCreate
   * @summary 카페24 OAuth 토큰 정보 조회✅
   * @request POST:/shops/cafe24-auth-token
   * @secure
   * @response `200` `DomainGetCafe24AuthTokenResponse` 카페24 OAuth 토큰 정보 반환값
   */
  export namespace Cafe24AuthTokenCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainGetCafe24AuthTokenRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetCafe24AuthTokenResponse;
  }

  /**
   * @description Cafe24 상품 상태 목록을 조회하는 API
   * @tags Platforms
   * @name Cafe24ProductConditionsList
   * @summary Cafe24 상품 상태 목록 조회 ✅
   * @request GET:/shops/cafe24-product-conditions
   * @secure
   * @response `200` `DomainListCafe24ProductConditionsResponse` OK
   */
  export namespace Cafe24ProductConditionsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListCafe24ProductConditionsResponse;
  }

  /**
   * @description Cafe24에서 인증을 하였을 때 허용되는 API Scope 목록을 조회하는 API
   * @tags Platforms
   * @name Cafe24ScopesList
   * @summary Cafe24 API Scope 조회 ✅
   * @request GET:/shops/cafe24-scopes
   * @secure
   * @response `200` `DomainListCafe24ScopesResponse` OK
   */
  export namespace Cafe24ScopesList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListCafe24ScopesResponse;
  }

  /**
   * @description 클레임 상태 FSM 시각화를 위한 API입니다.
   * @tags Claims
   * @name ClaimStatusesFsmList
   * @summary 클레임 상태 FSM 시각화 ✅
   * @request GET:/shops/claim-statuses/fsm
   * @response `200` `void` OK
   */
  export namespace ClaimStatusesFsmList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 조회할 주문 상태(비어있으면 전체 주문 상태로 조회)
       * @example ["CLAIM_RETURN-STATUS_REQUEST"]
       */
      claimStatuses?: string[];
      /** @example "SHOP_PLATFORM-TYPE_CAFE24" */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsCreate
   * @summary 쿠폰을 생성합니다. ✅
   * @request POST:/shops/coupons
   * @secure
   * @response `200` `DomainCreateShopCouponsResponse` OK
   */
  export namespace CouponsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopCouponsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateShopCouponsResponse;
  }

  /**
   * @description 크레딧을 리스트로 조회합니다. 여러 샵의 크레딧을 조회할 수 있습니다.
   * @tags Settlements
   * @name CreditsList
   * @summary 크레딧을 리스트로 조회합니다. (마스터용) ✅
   * @request GET:/shops/credits
   * @secure
   * @response `200` `DomainListShopCreditsForManagerResponse` OK
   */
  export namespace CreditsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
      /**
       * 샵 ID 목록
       * @example ["65378b60f9505804b23cdaf6"]
       */
      shopID?: string[];
      /**
       * 필터 종료 기간 (타임존 포함)
       * @example "2023-04-14T23:59:59.999+09:00"
       */
      to?: string;
      /** 타입 */
      type?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopCreditsForManagerResponse;
  }

  /**
   * @description 샵 크레딧을 생성합니다. 복수의 샵 크레딧을 생성할 수 있습니다. Amount는 양수여야 합니다. Type으로 크레딧 타입을 지정하여 지급할지 차감할지 결정할 수 있습니다.
   * @tags Settlements
   * @name CreditsCreate
   * @summary 샵 크레딧을 생성합니다. ✅
   * @request POST:/shops/credits
   * @secure
   * @response `204` `void` No Content
   */
  export namespace CreditsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopCreditsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 셀러에 대한 데이터를 엑셀로 다운로드합니다.
   * @tags Shops
   * @name ExportShopsCreate
   * @summary 샵 엑셀 다운로드 ✅
   * @request POST:/shops/export-shops
   * @secure
   * @response `200` `DomainExportExcelShopsResponse` OK
   */
  export namespace ExportShopsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainExportExcelShopsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExportExcelShopsResponse;
  }

  /**
   * @description 전역 상태 조회
   * @tags App
   * @name GlobalStatesList
   * @summary 전역 상태 조회 ✅
   * @request GET:/shops/global-states
   * @secure
   * @response `200` `DomainListGlobalStatesResponse` OK
   */
  export namespace GlobalStatesList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListGlobalStatesResponse;
  }

  /**
   * @description Instagram에서 인증을 하였을 때 허용되는 API Scope 목록을 조회하는 API
   * @tags Platforms
   * @name InstagramScopesList
   * @summary Instagram API Scope 조회 ✅
   * @request GET:/shops/instagram-scopes
   * @secure
   * @response `200` `DomainListInstagramScopesResponse` OK
   */
  export namespace InstagramScopesList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListInstagramScopesResponse;
  }

  /**
   * @description 카카오페이 취소 사유 목록을 조회하는 API
   * @tags Platforms
   * @name KakaopayCancelReasonsList
   * @summary 카카오페이 취소 사유 목록 조회 ✅
   * @request GET:/shops/kakaopay-cancel-reasons
   * @secure
   * @response `200` `DomainListKakaopayCancelReasonsResponse` OK
   */
  export namespace KakaopayCancelReasonsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListKakaopayCancelReasonsResponse;
  }

  /**
   * @description 라벨링된 아이템에 대해 확인 완료 처리합니다. # Validation |HTTP Status|Code|Description| |:---:|:---:|---| |404|`SHOP_TASK_ITEM_NOT_FOUND`|수정할 아이템이 존재하지 않을 경우 에러를 반환합니다.| |400|`N/A`| `types`가 빈 경우 에러를 반환합니다.| |400|`N/A`| `types`에 중복된 타입으로 요청하는 경우 에러를 반환합니다.| |400|`N/A`|`items`가 빈 경우 에러를 반환합니다.| |400|`N/A`|`items`에 중복된 아이템 ID로 요청하는 경우 에러를 반환합니다.| |400|`CATEGORY_CODE_INVALID`|`items.category`가 유효하지 않은 값으로 수정 요청한 경우 에러를 반환합니다.| |400|`COLOR_CODE_INVALID`|`items.colors` 내 요소가 유효하지 않은 값을 포함한 경우 에러를 반환합니다.| |400|`GENDER_INVALID`|`items.gender`가 유효하지 않은 값을 포함한 경우 에러를 반환합니다.| |404|`BRAND_NOT_FOUND`|수정할 브랜드 ID에 해당하는 브랜드 정보를 샵에서 찾을 수 없을 경우 에러를 반환합니다.| |409|`SHOP_ITEM_NOT_MATCHED`|수정할 아이템이 요청한 샵에 속해있지 않을 경우 에러를 반환합니다.|
   * @tags Labeling
   * @name LabelingConfirmCreate
   * @summary 라벨링 확인 완료 API ✅
   * @request POST:/shops/labeling/confirm
   * @secure
   * @response `204` `void` No Content
   */
  export namespace LabelingConfirmCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainConfirmLabelingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 라벨링 대상 상품 목록을 조회합니다.
   * @tags Labeling
   * @name LabelingItemsList
   * @summary 라벨링 대상 상품 목록 조회 API ✅
   * @request GET:/shops/labeling/items
   * @secure
   * @response `200` `DomainListLabelingItemsResponse` 성공
   */
  export namespace LabelingItemsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 조회할 세컨솔드 성별 (리스트 가능) (market-item, genderwear 메타데이터 참조) */
      aclosetGenderWear?: string[];
      /** 조회할 브랜드 명 (Exact Match) */
      brandName?: string;
      /** 조회할 AIMS 카테고리 (/shops/metadata/properties API 반환 값 참조) (리스트 가능) */
      category?: string[];
      /** 조회할 색상 (리스트 가능) (/shops/metadata/properties API 반환 값 참조) */
      color?: string[];
      /** 조회할 기간 시작일시 */
      from: string;
      /** 조회할 성별 (리스트 가능) (shop, item-gender 메타데이터 참조) */
      gender?: string[];
      /** 조회할 라벨링 상태 (labeling, status 메타데이터 참조) (리스트 가능) */
      labelingStatus?: string[];
      /** 조회할 라벨링 타입 (labeling, type 메타데이터 참조) (리스트 가능) */
      labelingType?: string[];
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
      /** 조회할 판매 상태 (sale, status 메타데이터 참조) (리스트 가능) */
      saleStatus?: string[];
      /** 조회할 기간 필드 (postDate: 상품 등록일) */
      searchPeriodType: string;
      /** 조회할 샵 ID (리스트 가능) (라벨링 타입이 브랜드인 경우 */
      shopID?: string[];
      /** 조회할 상품명 (Like Match) */
      title?: string;
      /** 조회할 기간 종료일시 */
      to: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListLabelingItemsResponse;
  }

  /**
   * @description 점검 여부를 조회하는 API 입니다.
   * @tags Shops
   * @name MaintenanceList
   * @summary 점검 여부 조회 API ✅️
   * @request GET:/shops/maintenance
   * @secure
   * @response `200` `DomainGetMaintenanceResponse` OK
   */
  export namespace MaintenanceList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMaintenanceResponse;
  }

  /**
   * @description 점검 여부를 수정하는 API 입니다. (마스터 계정만 접근 가능)
   * @tags Shops
   * @name MaintenanceUpdate
   * @summary 점검 여부 수정 API ✅️
   * @request PUT:/shops/maintenance
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MaintenanceUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateMaintenanceRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 속성 리스트를 조회하는 API
   * @tags MappingGroups
   * @name MappingPropertiesList
   * @summary 샵 매핑 속성 리스트 조회 ✅
   * @request GET:/shops/mapping-properties
   * @secure
   * @response `200` `DomainListMappingPropertiesResponse` OK
   */
  export namespace MappingPropertiesList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMappingPropertiesResponse;
  }

  /**
   * @description Metadata 조회 https://github.com/looko-corp/aims-api/issues/126
   * @tags Metadata
   * @name MetadataList
   * @summary 메타데이터 조회 ✅
   * @request GET:/shops/metadata
   * @response `200` `DomainListMetadataResponse` 메타데이터 응답값
   */
  export namespace MetadataList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 도메인
       * @example "outfit"
       */
      domain?: string;
      /**
       * 서브 도메인
       * @example "content"
       */
      subDomain?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMetadataResponse;
  }

  /**
   * @description Metadata 맵 조회
   * @tags Metadata
   * @name MetadataMapList
   * @summary 메타데이터 맵 조회 ✅
   * @request GET:/shops/metadata-map
   * @response `200` `DomainGetMetadataMapResponse` 메타데이터 맵 응답값
   */
  export namespace MetadataMapList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 도메인
       * @example "outfit"
       */
      domain?: string;
      /**
       * 언어
       * @example "ko"
       */
      language: 'ko' | 'en' | 'ru' | 'fr' | 'es';
      /**
       * 서브 도메인
       * @example "content"
       */
      subDomain?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMetadataMapResponse;
  }

  /**
   * @description 샵 카테고리 치수타입 맵핑 정보를 조회하는 API
   * @tags Metadata
   * @name MetadataCategorySizeTypesList
   * @summary 샵 카테고리 치수타입 맵핑 정보 조회 ✅
   * @request GET:/shops/metadata/category-size-types
   * @secure
   * @response `200` `DomainListCategorySizeTypesResponse` OK
   */
  export namespace MetadataCategorySizeTypesList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListCategorySizeTypesResponse;
  }

  /**
   * @description 선진국 국가 목록 조회 - 원산지 자동 입력 시 사용됩니다
   * @tags Metadata
   * @name MetadataDevelopedCountriesList
   * @summary 선진국 국가 목록 조회
   * @request GET:/shops/metadata/developed-countries
   * @response `200` `DomainListDevelopedCountriesResponse` 선진국 국가 목록 응답값
   */
  export namespace MetadataDevelopedCountriesList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListDevelopedCountriesResponse;
  }

  /**
   * @description 그룹 속성 코드에 따른 하위 속성 코드를 반환합니다.<br> ## 사용 가능한 `groupCode`는 다음과 같습니다. - `CATEGORY`: 카테고리, `COLOR`: 색상, `NECK-SHOULDER`: 넥 어깨 타입 `AIMS_CATEGORY` : AIMS 카테고리, `AIMS_FABRIC` : AIMS 재질, `AIMS_ATTRIBUTE`: AIMS 속성 ## 사용 가능한 `subGroupCodes`는 다음과 같은 코드가 속할 수 있습니다. - `GROUP`: 대분류 코드, `HEADWEAR`:모자, `OUTERWEAR`: 아우터, `TOPS`: 상의, `DRESSES`: 원피스 , `PANTS`: 바지, `SKIRTS`: 스커트
   * @tags Metadata
   * @name MetadataPropertiesList
   * @summary 그룹 속성 코드에 따른 하위 속성 코드 조회 ✅
   * @request GET:/shops/metadata/properties
   * @response `200` `DomainListShopPropertiesResponse` 프로퍼티 응답 값
   */
  export namespace MetadataPropertiesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 그룹 코드 */
      groupCode: string;
      /** 조회할 서브 그룹 코드 리스트 (`groupCode=="CATEGORY, AIMSCATEGORY"`인 경우에만 적용) `null`인 경우 전체 조회 */
      subGroupCodes?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopPropertiesResponse;
  }

  /**
   * @description 샵 지역 조회 - 프론트 정적 데이터로 이관할 예정입니다.
   * @tags Metadata
   * @name MetadataShopRegionsList
   * @summary 샵 지역 조회
   * @request GET:/shops/metadata/shop-regions
   * @deprecated
   * @response `200` `DomainListShopRegionsResponse` 샵 지역 응답값
   */
  export namespace MetadataShopRegionsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopRegionsResponse;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 아이클로젯 마켓 상품 배송비 마이그레이션
   * @tags Migrate
   * @name MigrateAclosetMarketItemShippingFeeCreate
   * @summary [DEV-ONLY] 아이클로젯 마켓 상품 배송비 마이그레이션 ⚙️
   * @request POST:/shops/migrate/acloset-market-item-shipping-fee
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateAclosetMarketItemShippingFeeCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainMigrateAclosetMarketItemShippingFeeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 아이클로젯 주문 아이템 ID 마이그레이션
   * @tags Migrate
   * @name MigrateAclosetOrderItemIdCreate
   * @summary [DEV-ONLY] 아이클로젯 주문 아이템 ID 마이그레이션 ⚙️
   * @request POST:/shops/migrate/acloset-order-item-id
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateAclosetOrderItemIdCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 아이클로젯 주문 총 결제 금액 마이그레이션
   * @tags Migrate
   * @name MigrateAclosetOrderTotalPaymentAmountCreate
   * @summary [DEV-ONLY] 아이클로젯 주문 총 결제 금액 마이그레이션 ⚙️
   * @request POST:/shops/migrate/acloset-order-total-payment-amount
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateAclosetOrderTotalPaymentAmountCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 아이클로젯 잘못된 후드티 매핑
   * @tags Migrate
   * @name MigrateAclosetWrongHoodieMappingCreate
   * @summary [DEV-ONLY] 아이클로젯 잘못된 후드티 매핑 ⚙️
   * @request POST:/shops/migrate/acloset-wrong-hoodie-mapping
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateAclosetWrongHoodieMappingCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 샵에 대한 모든 정보를 삭제합니다. (MANAGER-ONLY)
   * @tags Migrate
   * @name MigrateDestroyShopsCreate
   * @summary [DEV-ONLY] 샵에 대한 모든 정보를 삭제합니다. ⚙️
   * @request POST:/shops/migrate/destroy-shops
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateDestroyShopsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainDestroyShopsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 네이버 템플릿 고정 이미지 URL 마이그레이션
   * @tags Migrate
   * @name MigrateNaverTemplateFixedImageUrlCreate
   * @summary [DEV-ONLY] 네이버 템플릿 고정 이미지 URL 마이그레이션 ⚙️
   * @request POST:/shops/migrate/naver-template-fixed-image-url
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateNaverTemplateFixedImageUrlCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainMigrateNaverTemplateFixedImageURLRequest;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 샵 브랜드 이름 정규화 마이그레이션
   * @tags Migrate
   * @name MigrateNormalizeShopBrandsCreate
   * @summary [DEV-ONLY] 샵 브랜드 이름 정규화 마이그레이션 ⚙️
   * @request POST:/shops/migrate/normalize-shop-brands
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateNormalizeShopBrandsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 주문 제목이 없는 주문을 아이템 제목으로 주문 제목을 변경
   * @tags Migrate
   * @name MigrateOrderTitleCreate
   * @summary [DEV-ONLY] 주문 제목을 아이템 제목으로 변경 ⚙️
   * @request POST:/shops/migrate/order-title
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateOrderTitleCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 재고가 설정되지 않은 상품을 감지하여 옵션을 재생성합니다.
   * @tags Migrate
   * @name MigrateRecoverInvalidCafe24ProductVariantCreate
   * @summary [DEV-ONLY] 카페24 상품 옵션 재생성 ⚙️
   * @request POST:/shops/migrate/recover-invalid-cafe24-product-variant
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateRecoverInvalidCafe24ProductVariantCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainRecoverInvalidCafe24ProductVariantRequest;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 네이버페이 취소 사유 목록을 조회하는 API
   * @tags Platforms
   * @name NaverpayCancelReasonsList
   * @summary 네이버페이 취소 사유 목록 조회 ✅
   * @request GET:/shops/naverpay-cancel-reasons
   * @secure
   * @response `200` `DomainListNaverpayCancelReasonsResponse` OK
   */
  export namespace NaverpayCancelReasonsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListNaverpayCancelReasonsResponse;
  }

  /**
   * @description 공지사항 조회
   * @tags App
   * @name NoticeList
   * @summary 공지사항 조회 ✅
   * @request GET:/shops/notice
   * @secure
   * @response `200` `DomainGetNoticeResponse` OK
   */
  export namespace NoticeList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetNoticeResponse;
  }

  /**
   * @description 공지사항 수정
   * @tags App
   * @name NoticePartialUpdate
   * @summary 공지사항 수정 ✅
   * @request PATCH:/shops/notice
   * @secure
   * @response `200` `void` OK
   */
  export namespace NoticePartialUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainPatchNoticeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 알림톡 템플릿 조회
   * @tags Notifications
   * @name NotificationsKakaotalkTemplatesList
   * @summary 알림톡 템플릿 조회 ✅
   * @request GET:/shops/notifications/kakaotalk-templates
   * @secure
   * @response `200` `DomainListKakaotalkTemplatesResponse` OK
   */
  export namespace NotificationsKakaotalkTemplatesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 템플릿 타입 */
      templateType?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListKakaotalkTemplatesResponse;
  }

  /**
   * @description 주문 상태 FSM 시각화를 위한 API입니다.
   * @tags Orders
   * @name OrderStatusesFsmList
   * @summary 주문 상태 FSM 시각화 ✅
   * @request GET:/shops/order-statuses/fsm
   * @response `200` `void` OK
   */
  export namespace OrderStatusesFsmList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 조회할 주문 상태(비어있으면 전체 주문 상태로 조회)
       * @example ["ORDER_STATUS_PAYMENT-DONE"]
       */
      orderStatuses?: string[];
      /** @example "SHOP_PLATFORM-TYPE_CAFE24" */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 해당 플랜은 샵과 상관없는 플랜의 프리셋 속성을 가지고 있습니다.
   * @tags Plans
   * @name PlansList
   * @summary 플랜을 조회합니다. ✅
   * @request GET:/shops/plans
   * @deprecated
   * @secure
   * @response `200` `DomainListPlansResponse` OK
   */
  export namespace PlansList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlansResponse;
  }

  /**
   * @description 은행 목록을 조회하는 API
   * @tags Platforms
   * @name PlatformBanksList
   * @summary 플랫폼 별 은행 목록 조회 ✅
   * @request GET:/shops/platform-banks
   * @secure
   * @response `200` `DomainListPlatformBanksResponse` OK
   */
  export namespace PlatformBanksList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** ⚠️현재는 카페 24, 세컨솔드만 해당 (shop, platform-type 메타데이터 참조) */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlatformBanksResponse;
  }

  /**
   * @description 플랫폼 별 취소 사유 목록을 조회하는 API
   * @tags Platforms
   * @name PlatformCancelReasonsList
   * @summary 플랫폼 별 취소 사유 목록 조회 ✅
   * @request GET:/shops/platform-cancel-reasons
   * @secure
   * @response `200` `DomainListPlatformCancelReasonsResponse` OK
   */
  export namespace PlatformCancelReasonsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 취소사유를 조회할 플랫폼 종류 (shop, platform-type 메타데이터 참조) */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlatformCancelReasonsResponse;
  }

  /**
   * @description 원산지 목록을 조회하는 API
   * @tags Platforms
   * @name PlatformOriginAreasList
   * @summary 플랫폼 별 원산지 목록 조회 ✅
   * @request GET:/shops/platform-origin-areas
   * @secure
   * @response `200` `DomainListPlatformOriginAreasResponse` OK
   */
  export namespace PlatformOriginAreasList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** ⚠️현재는 스마트 스토어만 해당 (shop, platform-type 메타데이터 참조) */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlatformOriginAreasResponse;
  }

  /**
   * @description 환불 수단 목록을 조회하는 API
   * @tags Platforms
   * @name PlatformRefundMethodCodesList
   * @summary 플랫폼 별 환불 수단 목록 조회 ✅
   * @request GET:/shops/platform-refund-method-codes
   * @secure
   * @response `200` `DomainListPlatformRefundMethodCodesResponse` OK
   */
  export namespace PlatformRefundMethodCodesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** ⚠️현재는 카페 24만 해당 (shop, platform-type 메타데이터 참조) */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlatformRefundMethodCodesResponse;
  }

  /**
   * @description 취소 거절 사유 목록을 조회하는 API
   * @tags Platforms
   * @name PlatformRejectCancelReasonsList
   * @summary 플랫폼 별 취소 거절 사유 목록 조회 ✅
   * @request GET:/shops/platform-reject-cancel-reasons
   * @secure
   * @response `200` `DomainListPlatformRejectCancelReasonsResponse` OK
   */
  export namespace PlatformRejectCancelReasonsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** ⚠️현재는 카페 24만 해당 (shop, platform-type 메타데이터 참조) */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlatformRejectCancelReasonsResponse;
  }

  /**
   * @description 반품 거절 사유 목록을 조회하는 API
   * @tags Platforms
   * @name PlatformRejectReturnReasonsList
   * @summary 플랫폼 별 반품 거절 사유 목록 조회 🛠
   * @request GET:/shops/platform-reject-return-reasons
   * @secure
   * @response `200` `DomainListPlatformRejectReturnReasonsResponse` OK
   */
  export namespace PlatformRejectReturnReasonsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 현재는 세컨솔드만 해당 (shop, platform-type 메타데이터 참조) */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlatformRejectReturnReasonsResponse;
  }

  /**
   * @description 반품 요청 사유 목록을 조회하는 API
   * @tags Platforms
   * @name PlatformRequestReturnReasonsList
   * @summary 플랫폼 별 반품 요청 사유 목록 조회 ✅
   * @request GET:/shops/platform-request-return-reasons
   * @secure
   * @response `200` `DomainListPlatformRequestReturnReasonsResponse` OK
   */
  export namespace PlatformRequestReturnReasonsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** ⚠️현재는 네이버, 카페24만 해당 (shop, platform-type 메타데이터 참조) */
      platformType?: string;
      /** ⚠️현재는 카페24만 해당 (claim, transaction-type 메타데이터 참조) */
      transactionType?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlatformRequestReturnReasonsResponse;
  }

  /**
   * @description 배송 업체 목록을 조회하는 API
   * @tags Platforms
   * @name PlatformShippingCompaniesList
   * @summary 플랫폼 별 배송 업체 목록 조회 ✅
   * @request GET:/shops/platform-shipping-companies
   * @secure
   * @response `200` `DomainListPlatformShippingCompaniesResponse` OK
   */
  export namespace PlatformShippingCompaniesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 배송사를 조회할 플랫폼 종류 (shop, platform-type 메타데이터 참조) */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlatformShippingCompaniesResponse;
  }

  /**
   * @description 팝업 목록을 조회하는 API 입니다.
   * @tags Shops
   * @name PopupsList
   * @summary 팝업 목록 조회 API ✅
   * @request GET:/shops/popups
   * @response `200` `DomainListPopupsResponse` OK
   */
  export namespace PopupsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 팝업 대상입니다. popup, target 메타데이어 참조 */
      popupTargets?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPopupsResponse;
  }

  /**
   * @description 팝업을 생성하는 API 입니다. (마스터 계정만 접근 가능)
   * @tags Shops
   * @name PopupsCreate
   * @summary 팝업 생성 API ✅
   * @request POST:/shops/popups
   * @secure
   * @response `204` `void` No Content
   */
  export namespace PopupsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCreatePopupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 팝업을 삭제하는 API 입니다. (마스터 계정만 접근 가능)
   * @tags Shops
   * @name PopupsDelete
   * @summary 팝업 삭제 API ✅
   * @request DELETE:/shops/popups/{popupID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace PopupsDelete {
    export type RequestParams = {
      /**
       * 삭제할 팝업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      popupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 범용 프록시 API입니다. API를 대신 실행시켜주는 단순한 기능만을 담당합니다.
   * @tags Platforms
   * @name ProxyCreate
   * @summary 범용 프록시 API입니다. ✅
   * @request POST:/shops/proxy
   * @secure
   * @response `200` `DomainProxyResponse` OK
   */
  export namespace ProxyCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainProxyRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainProxyResponse;
  }

  /**
   * @description 모든 상점 큐 메시지 소진 여부 확인 해당 API는 개발용 API로 서비스에서의 사용을 금합니다.
   * @tags RabbitMQ
   * @name RabbitmqCheckAllShopQueuesConsumedList
   * @summary [DEV-ONLY] 모든 상점 큐 메시지 소진 여부 확인 ⚙️
   * @request GET:/shops/rabbitmq/check-all-shop-queues-consumed
   * @response `200` `DomainCheckAllShopQueueConsumedResponse` OK
   */
  export namespace RabbitmqCheckAllShopQueuesConsumedList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCheckAllShopQueueConsumedResponse;
  }

  /**
   * @description 판매 아이템의 정합성 보고서 목록을 조회합니다.
   * @tags Sales
   * @name SaleItemsConsistencyReportsList
   * @summary 판매 아이템 정합성 보고서 목록 조회 API ✅
   * @request GET:/shops/sale-items/consistency-reports
   * @secure
   * @response `200` `DomainListItemConsistencyReportsResponse` OK
   */
  export namespace SaleItemsConsistencyReportsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 오류코드 (item-consistency-report, error-code 메타데이터 참조)
       * @example "ERROR_CODE_1001"
       */
      errorCode?: string;
      /**
       * 상품코드
       * @example "상품코드"
       */
      itemCode?: string;
      /**
       * 상품명
       * @example "상품명"
       */
      itemTitle?: string;
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
      /**
       * 샵 아이디
       * @example ["5f7b1b7b7b7b7b7b7b7b7b7b"]
       */
      shopID?: string[];
      /**
       * 상태 (리스트 허용)
       * @example ["REPORT_STATUS_DONE"]
       */
      status?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * API 버전
       * @default "legacy"
       */
      'api-version'?: string;
    };
    export type ResponseBody = DomainListItemConsistencyReportsResponse;
  }

  /**
   * @description 판매 아이템의 정합성 보고서를 수정합니다. (Master Only)
   * @tags Sales
   * @name SaleItemsConsistencyReportsPartialUpdate
   * @summary 판매 아이템 정합성 보고서 수정 API ✅
   * @request PATCH:/shops/sale-items/consistency-reports/{reportID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleItemsConsistencyReportsPartialUpdate {
    export type RequestParams = {
      /**
       * 보고서 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      reportId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchItemConsistencyReportRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 상품 상태만 강제 업데이트합니다. 상품 플랫폼의 상태까지 변경하지 않고 내부 상태만 변경합니다. (Master Only)
   * @tags Sales
   * @name SaleItemsForceChangeStatusCreate
   * @summary 상품 상태 강제 업데이트 API ✅
   * @request POST:/shops/sale-items/force-change-status
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleItemsForceChangeStatusCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainForceChangeSaleItemsStatusRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 판매중인 세컨솔드 상품을 강제로 판매중지합니다. (Master Only)
   * @tags Sales
   * @name SaleItemsForceStopAclosetItemsCreate
   * @summary 판매중인 세컨솔드 상품 강제 판매중지 API ✅
   * @request POST:/shops/sale-items/force-stop-acloset-items
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleItemsForceStopAclosetItemsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainForceStopSaleAclosetItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 상품 플랫폼 상태 FSM 시각화를 위한 API입니다.
   * @tags Sales
   * @name SalePlatformStatusesFsmList
   * @summary 상품 플랫폼 상태 FSM 시각화 ✅
   * @request GET:/shops/sale-platform-statuses/fsm
   * @response `200` `void` OK
   */
  export namespace SalePlatformStatusesFsmList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 조회할 주문 상태(비어있으면 전체 주문 상태로 조회)
       * @example ["ORDER_STATUS_PAYMENT-DONE"]
       */
      orderStatuses?: string[];
      /** @example "SHOP_PLATFORM-TYPE_CAFE24" */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 상품 주요 상태 FSM 시각화를 위한 API입니다.
   * @tags Sales
   * @name SaleStatusesFsmList
   * @summary 상품 주요 상태 FSM 시각화 ✅
   * @request GET:/shops/sale-statuses/fsm
   * @response `200` `void` OK
   */
  export namespace SaleStatusesFsmList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 조회할 주문 상태(비어있으면 전체 주문 상태로 조회)
       * @example ["ORDER_STATUS_PAYMENT-DONE"]
       */
      orderStatuses?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 서비스 가격 목록을 리스트로 조회합니다.
   * @tags Settlements
   * @name ServicePricingsList
   * @summary 서비스 가격 목록을 리스트로 조회합니다. ✅
   * @request GET:/shops/service-pricings
   * @response `200` `DomainListServicePricingsResponse` OK
   */
  export namespace ServicePricingsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListServicePricingsResponse;
  }

  /**
   * @description 배송 업체 매핑 목록을 조회하는 API
   * @tags Platforms
   * @name ShippingCompaniesList
   * @summary 배송 업체 매핑 목록 조회 ✅
   * @request GET:/shops/shipping-companies
   * @secure
   * @response `200` `DomainListShippingCompaniesResponse` OK
   */
  export namespace ShippingCompaniesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 배송사를 조회할 플랫폼 종류 (shop, platform-type 메타데이터 참조) */
      platformType?: string;
      /** 검색 필드(code, name)에 대해 Hard Match Search */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShippingCompaniesResponse;
  }

  /**
   * @description 검수자 작업 목록을 조회하는 API 입니다.
   * @tags Tasks
   * @name TasksList
   * @summary 검수자 작업 목록 조회 ✅
   * @request GET:/shops/tasks
   * @secure
   * @response `200` `DomainListTasksResponse` 검수자 작업 목록 응답 값
   */
  export namespace TasksList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListTasksResponse;
  }

  /**
   * @description 미리보기용 AI 설명을 생성하는 API입니다.
   * @tags Tasks
   * @name TasksGenerateAiDescriptionPreviewCreate
   * @summary 미리보기용 AI 설명 생성 ✅
   * @request POST:/shops/tasks/generate-ai-description/preview
   * @secure
   * @response `200` `DomainGenerateAIDescriptionPreviewResponse` 미리보기용 AI 설명 생성 반환 값
   */
  export namespace TasksGenerateAiDescriptionPreviewCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainGenerateAIDescriptionPreviewRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGenerateAIDescriptionPreviewResponse;
  }

  /**
   * @description 사이즈 타겟 키워드 목록을 조회하는 API 입니다. 관리자만 사용 가능합니다.
   * @tags Tasks
   * @name TasksSizeTargetKeywordsList
   * @summary 치수추출 사이즈 타겟 키워드 목록 조회 ✅ (MASTER Only)
   * @request GET:/shops/tasks/size-target-keywords
   * @secure
   * @response `200` `DomainListSizeTargetKeywordsResponse` 사이즈 타겟 키워드 목록 조회 반환 값
   */
  export namespace TasksSizeTargetKeywordsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListSizeTargetKeywordsResponse;
  }

  /**
   * @description 사이즈 타겟 키워드를 수정하는 API 입니다. 관리자만 사용 가능합니다.
   * @tags Tasks
   * @name TasksSizeTargetKeywordsPartialUpdate
   * @summary 치수추출 사이즈 타겟 키워드 수정 ✅ (MASTER Only)
   * @request PATCH:/shops/tasks/size-target-keywords/{sizeTargetKeywordID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksSizeTargetKeywordsPartialUpdate {
    export type RequestParams = {
      /**
       * 키워드 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      sizeTargetKeywordId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchSizeTargetKeywordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 템플릿 필드 목록 조회 API
   * @tags Templates
   * @name TemplateFieldsList
   * @summary [DEV] 템플릿 필드 목록 조회 ✅
   * @request GET:/shops/template-fields
   * @secure
   * @response `200` `DomainListTemplateFieldsResponse` OK
   */
  export namespace TemplateFieldsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** 템플릿 타입 (메타데이터 template, type 참조) */
      templateType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListTemplateFieldsResponse;
  }

  /**
   * @description 기본 템플릿 없으면 생성 (있으면 무시)
   * @tags Templates
   * @name TemplatesMigrationCreate
   * @summary [DEV] 기존 샵에 템플릿 마이그레이션하기 ✅️
   * @request POST:/shops/templates/migration
   * @secure
   */
  export namespace TemplatesMigrationCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainMigrationTemplatesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description 파일을 업로드하는 API
   * @tags Shops
   * @name UploadFileCreate
   * @summary 파일 업로드 ✅
   * @request POST:/shops/upload-file
   * @secure
   * @response `200` `DomainUploadFileResponse` OK
   */
  export namespace UploadFileCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UploadFileCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = DomainUploadFileResponse;
  }

  /**
   * @description AIMS 자동 계정 생성 API
   * @tags Users
   * @name UsersAutoCreateAccountCreate
   * @summary AIMS 자동 계정 생성  ✅
   * @request POST:/shops/users/auto-create-account
   * @secure
   * @response `204` `void` No Content
   */
  export namespace UsersAutoCreateAccountCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainAutoCreateAccountRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Users
   * @name UsersExistsCreate
   * @summary AIMS 회원가입 중복 확인 ✅
   * @request POST:/shops/users/exists
   * @secure
   * @response `200` `DomainExistsUserResponse` 회원가입 중복 확인 응답 값
   */
  export namespace UsersExistsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainExistsUserRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExistsUserResponse;
  }

  /**
   * @description 영업용 초대 토큰을 생성하는 API입니다. 해당 토큰은 일반 액세스토큰처럼 사용할 수 있으며, 리프레시토큰 발급이 가능합니다. 24시간동안 유효합니다.
   * @tags Users
   * @name UsersInvitationTokenCreate
   * @summary 영업용 초대 토큰 생성 API ✅
   * @request POST:/shops/users/invitation-token
   * @secure
   * @response `200` `DomainGenerateInvitationTokenResponse` 새로 발급 된 액세스 토큰
   */
  export namespace UsersInvitationTokenCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainGenerateInvitationTokenRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGenerateInvitationTokenResponse;
  }

  /**
   * @description AIMS 비밀번호 변경 API
   * @tags Users
   * @name UsersModifyPasswordCreate
   * @summary AIMS 비밀번호 변경 ✅
   * @request POST:/shops/users/modify-password
   * @secure
   * @response `204` `void` No Content
   */
  export namespace UsersModifyPasswordCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainModifyPasswordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 리프레시 토큰을 생성하는 API입니다. 현재는 초대 토큰의 경우에만 사용 가능합니다.
   * @tags Users
   * @name UsersRefreshTokenCreate
   * @summary 리프레시 토큰 생성 API ✅
   * @request POST:/shops/users/refresh-token
   * @secure
   * @response `200` `DomainGenerateRefreshTokenResponse` 새로 발급 된 리프레시 토큰
   */
  export namespace UsersRefreshTokenCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainGenerateRefreshTokenRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGenerateRefreshTokenResponse;
  }

  /**
   * @description 업로드 사이트 로그인 API 입니다. |code|status|description| |---|---|---| ||400|입력한 이메일이 없는 경우| |`USER_PASSWORD_INCORRECT`|401|비밀번호가 유효하지 않은 경우| |`USER_NOT_FOUND`|404|해당하는 유저가 없으면|
   * @tags Users
   * @name UsersSignInCreate
   * @summary AIMS 로그인 ✅
   * @request POST:/shops/users/sign-in
   * @secure
   * @response `200` `DomainSignInResponse` 로그인 응답 값
   */
  export namespace UsersSignInCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainSignInRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainSignInResponse;
  }

  /**
   * @description 게스트 로그인 API 입니다.
   * @tags Users
   * @name UsersSignInGuestCreate
   * @summary AIMS 게스트 로그인 ✅
   * @request POST:/shops/users/sign-in/guest
   * @response `200` `DomainSignInAsGuestResponse` 게스트 로그인 응답 값
   */
  export namespace UsersSignInGuestCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainSignInAsGuestRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainSignInAsGuestResponse;
  }

  /**
   * @description AIMS 사이트 회원가입 API 입니다. 카페24 같이 데이터를 가져올 때 사용합니다.
   * @tags Users
   * @name UsersSignUpLoadOwnerCreate
   * @summary AIMS 회원가입 ✅
   * @request POST:/shops/users/sign-up/load-owner
   * @response `204` `void` No Content
   */
  export namespace UsersSignUpLoadOwnerCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainSignUpLoadOwnerRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description AIMS 사이트 회원가입 API 입니다.
   * @tags Users
   * @name UsersSignUpOwnerCreate
   * @summary AIMS 회원가입 ✅
   * @request POST:/shops/users/sign-up/owner
   * @response `204` `void` No Content
   */
  export namespace UsersSignUpOwnerCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainSignUpOwnerRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description |code|status|description| |---|---|---| |`USER_TOKEN_INVALID`|401|토큰이 유효하지 않은 경우|
   * @tags Users
   * @name UsersTokenCreate
   * @summary 액세스 토큰 리프레시 API ✅
   * @request POST:/shops/users/token
   * @secure
   * @response `200` `DomainRefreshTokenResponse` 새로 발급 된 액세스 토큰
   * @response `500` `void` Internal Server Error
   */
  export namespace UsersTokenCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainRefreshTokenResponse;
  }

  /**
   * @description 토큰 검증만을 수행하는 API입니다.
   * @tags Users
   * @name UsersVerifyTokenList
   * @summary VerifyToken 토큰 검증
   * @request GET:/shops/users/verify-token
   * @secure
   * @response `204` `void` No Content
   */
  export namespace UsersVerifyTokenList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 실시간 정산내역을 리스트로 조회합니다.
   * @tags Settlements
   * @name V2SettlementsRealtimeDetail
   * @summary 실시간 정산내역을 리스트로 조회합니다. ✅
   * @request GET:/shops/v2/{shopID}/settlements/realtime
   * @secure
   * @response `200` `DomainListRealtimeSettlementsV2Response` OK
   */
  export namespace V2SettlementsRealtimeDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListRealtimeSettlementsV2Response;
  }

  /**
   * @description 이메일 인증 코드를 발송하는 API입니다.
   * @tags Users
   * @name VerificationEmailSendCreate
   * @summary 이메일 인증 코드 발송 ✅
   * @request POST:/shops/verification/email/send
   * @secure
   * @response `204` `void` No Content
   */
  export namespace VerificationEmailSendCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainSendEmailVerificationCodeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 이메일 인증 코드를 검증하는 API입니다.
   * @tags Users
   * @name VerificationEmailVerifyCreate
   * @summary 이메일 인증 코드 검증 ✅
   * @request POST:/shops/verification/email/verify
   * @secure
   * @response `204` `void` No Content
   */
  export namespace VerificationEmailVerifyCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainVerifyEmailVerificationCodeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description AIMS 초대코드를 검증하는 API
   * @tags Users
   * @name VerifyInvitationCodeCreate
   * @summary AIMS 초대코드 검증 ✅
   * @request POST:/shops/verify-invitation-code
   * @secure
   * @response `200` `DomainVerifyInvitationCodeResponse` AIMS 초대코드 검증 응답값
   */
  export namespace VerifyInvitationCodeCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainVerifyInvitationCodeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainVerifyInvitationCodeResponse;
  }

  /**
   * @description 세컨솔드 웹훅 처리 핸들러
   * @tags Webhooks
   * @name WebhooksAclosetCreate
   * @summary 세컨솔드 웹훅 핸들러🚨 (세컨솔드 접근 전용) (일반적인 테스트 용도로 사용 금지)
   * @request POST:/shops/webhooks/acloset
   * @response `204` `void` No Content
   */
  export namespace WebhooksAclosetCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainAclosetWebhookRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 세컨솔드 크롤링 웹훅 처리 핸들러
   * @tags Webhooks
   * @name WebhooksAclosetCrawlingCreate
   * @summary 세컨솔드 크롤링 웹훅 핸들러🚨 (세컨솔드 접근 전용) (일반적인 테스트 용도로 사용 금지)
   * @request POST:/shops/webhooks/acloset-crawling
   * @deprecated
   * @response `200` `DomainAclosetCrawlingWebhookResponse` OK
   */
  export namespace WebhooksAclosetCrawlingCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainAclosetCrawlingWebhookRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainAclosetCrawlingWebhookResponse;
  }

  /**
   * @description 카페24 웹훅 처리 핸들러
   * @tags Webhooks
   * @name WebhooksCafe24Create
   * @summary 카페24 웹훅 핸들러🚨 (카페 24 접근 전용) (일반적인 테스트 용도로 사용 금지)
   * @request POST:/shops/webhooks/cafe24
   * @response `202` `string` Accepted
   */
  export namespace WebhooksCafe24Create {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCafe24WebhookRequest;
    export type RequestHeaders = {
      /** API Key */
      'X-API-Key': string;
      /** Trace ID */
      'X-Trace-ID': string;
    };
    export type ResponseBody = string;
  }

  /**
   * @description 샵을 조회하는 API 입니다.
   * @tags Shops
   * @name ShopsDetail
   * @summary 샵 조회 ✅
   * @request GET:/shops/{shopID}
   * @secure
   * @response `200` `DomainShopResponse` 샵 조회 응답 값
   */
  export namespace ShopsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainShopResponse;
  }

  /**
   * @description 웹에서 샵의 정보를 부분 수정하는 API fabricNotation은 GET: /shops/metadata의 metadata-alias, fabric-notation 참고
   * @tags Shops
   * @name ShopsPartialUpdate
   * @summary 샵 부분 수정 ✅
   * @request PATCH:/shops/{shopID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ShopsPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Settlements
   * @name AclosetSettlementsDetail
   * @summary 세컨솔드 정산내역을 리스트로 조회합니다. ✅
   * @request GET:/shops/{shopID}/acloset-settlements
   * @secure
   * @response `200` `DomainListAclosetSettlementsResponse` OK
   */
  export namespace AclosetSettlementsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /** 필터 종료 기간 UTC */
      createDateEnd?: number;
      /** 필터 시작 기간 UTC */
      createDateStart?: number;
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      paymentType?: 'ONLINE' | 'STORE';
      /** @example [1,2,3] */
      settlementID?: number[];
      /**
       * 세컨솔드 정산 상태값
       * @example ["SETTLEMENT_STATUS_UNAUDITED"]
       */
      status?: string[];
      /**
       * 필터 종료 기간 (타임존 포함)
       * @example "2023-04-14T23:59:59.999+09:00"
       */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListAclosetSettlementsResponse;
  }

  /**
   * @description 세컨솔드 정산 금액을 조회합니다.
   * @tags Settlements
   * @name AclosetSettlementsAmountDetail
   * @summary 세컨솔드 정산 금액을 조회합니다. ✅
   * @request GET:/shops/{shopID}/acloset-settlements/amount
   * @secure
   * @response `200` `DomainGetAclosetSettlementAmountResponse` OK
   */
  export namespace AclosetSettlementsAmountDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2025-01-01T00:00:00.000Z"
       */
      from: string;
      /**
       * 세컨솔드 정산 상태값
       * @example ["SETTLEMENT_STATUS_UNAUDITED"]
       */
      status?: string[];
      /**
       * 필터 종료 기간 (타임존 포함)
       * @example "2025-01-05T00:00:00.000Z"
       */
      to: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetAclosetSettlementAmountResponse;
  }

  /**
   * No description
   * @tags Settlements
   * @name AclosetSettlementsExportExcelCreate
   * @summary 세컨솔드 정산내역을 엑셀로 다운로드합니다. ✅
   * @request POST:/shops/{shopID}/acloset-settlements/export-excel
   * @secure
   * @response `200` `DomainExportExcelAclosetSettlementsResponse` OK
   */
  export namespace AclosetSettlementsExportExcelCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainExportExcelAclosetSettlementsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExportExcelAclosetSettlementsResponse;
  }

  /**
   * @description 세컨솔드 파트너 샵 정보를 수정하는 API 입니다.
   * @tags Platforms
   * @name AclosetPartnerShopInfoUpdate
   * @summary 세컨솔드 파트너 샵 수정 API ✅
   * @request PUT:/shops/{shopID}/acloset/partner-shop-info/{partnerShopInfoID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace AclosetPartnerShopInfoUpdate {
    export type RequestParams = {
      shopId: string;
      partnerShopInfoId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateAclosetPartnerShopInfoRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 세컨솔드 파트너 샵 목록을 조회하는 API 입니다.
   * @tags Platforms
   * @name AclosetPartnerShopsDetail
   * @summary 세컨솔드 파트너 샵 목록 조회 API ✅
   * @request GET:/shops/{shopID}/acloset/partner-shops
   * @secure
   * @response `200` `DomainListAclosetPartnerShopsResponse` OK
   */
  export namespace AclosetPartnerShopsDetail {
    export type RequestParams = {
      shopId: string;
    };
    export type RequestQuery = {
      limit?: number;
      /** 내 정보만 조회하기 */
      myInfo?: boolean;
      offset?: number;
      /** 지역 */
      region?: string;
      /** 사용자 ID */
      userID?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListAclosetPartnerShopsResponse;
  }

  /**
   * @description 세컨솔드 리뷰 목록을 조회하는 API 입니다.
   * @tags Platforms
   * @name AclosetReviewsDetail
   * @summary 세컨솔드 리뷰 목록 조회 API ✅
   * @request GET:/shops/{shopID}/acloset/reviews
   * @secure
   * @response `200` `DomainListAclosetMarketItemReviewsResponse` OK
   */
  export namespace AclosetReviewsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListAclosetMarketItemReviewsResponse;
  }

  /**
   * @description 세컨솔드 리뷰 답글을 수정하는 API 입니다.
   * @tags Platforms
   * @name AclosetReviewsReplyUpdate
   * @summary 세컨솔드 리뷰 답글 수정 API ✅
   * @request PUT:/shops/{shopID}/acloset/reviews/{reviewID}/reply
   * @secure
   * @response `204` `void` No Content
   */
  export namespace AclosetReviewsReplyUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 리뷰 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      reviewId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateAclosetMarketItemReviewReplyRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 세컨솔드 고객대응 점수를 조회하는 API 입니다.
   * @tags Platforms
   * @name AclosetServiceScoreDetail
   * @summary 세컨솔드 고객대응 점수 조회 API ✅
   * @request GET:/shops/{shopID}/acloset/service-score
   * @secure
   * @response `200` `DomainGetShopServiceScoreResponse` OK
   */
  export namespace AclosetServiceScoreDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetShopServiceScoreResponse;
  }

  /**
   * @description 세컨솔드 공급사 목록을 조회하는 API 입니다.
   * @tags Platforms
   * @name AclosetSuppliersDetail
   * @summary 세컨솔드 공급사 목록 조회 API ✅
   * @request GET:/shops/{shopID}/acloset/suppliers
   * @secure
   * @response `200` `DomainListAclosetSuppliersResponse` OK
   */
  export namespace AclosetSuppliersDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListAclosetSuppliersResponse;
  }

  /**
   * @description 세컨솔드 공급사를 생성하는 API 입니다.
   * @tags Platforms
   * @name AclosetSuppliersCreate
   * @summary 세컨솔드 공급사 생성 API ✅
   * @request POST:/shops/{shopID}/acloset/suppliers
   * @secure
   * @response `200` `DomainCreateAclosetSupplierResponse` OK
   */
  export namespace AclosetSuppliersCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateAclosetSupplierRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateAclosetSupplierResponse;
  }

  /**
   * @description 세컨솔드 공급사를 조회하는 API 입니다.
   * @tags Platforms
   * @name AclosetSuppliersDetail2
   * @summary 세컨솔드 공급사 조회 API ✅
   * @request GET:/shops/{shopID}/acloset/suppliers/{supplierID}
   * @originalName aclosetSuppliersDetail
   * @duplicate
   * @secure
   * @response `200` `DomainGetAclosetSupplierResponse` 응답값
   */
  export namespace AclosetSuppliersDetail2 {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 공급사 ID
       * @example 123232
       */
      supplierId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetAclosetSupplierResponse;
  }

  /**
   * @description 세컨솔드 공급사를 수정하는 API 입니다.
   * @tags Platforms
   * @name AclosetSuppliersUpdate
   * @summary 세컨솔드 공급사 수정 API ✅
   * @request PUT:/shops/{shopID}/acloset/suppliers/{supplierID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace AclosetSuppliersUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 공급사 ID
       * @example 123232
       */
      supplierId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateAclosetSupplierRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 세컨솔드 공급사를 삭제하는 API 입니다.
   * @tags Platforms
   * @name AclosetSuppliersDelete
   * @summary 세컨솔드 공급사 삭제 API ✅
   * @request DELETE:/shops/{shopID}/acloset/suppliers/{supplierID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace AclosetSuppliersDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 공급사 ID
       * @example 123232
       */
      supplierId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 통계 데이터 누적을 위해 세컨솔드 문의 답변 이력을 전송하는 API 입니다.
   * @tags Platforms
   * @name AclosetUserInquiryResponseHistoryCreate
   * @summary 세컨솔드 문의 답변 이력 전송 API ✅
   * @request POST:/shops/{shopID}/acloset/user-inquiry-response-history
   * @secure
   * @response `204` `void` No Content
   */
  export namespace AclosetUserInquiryResponseHistoryCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainSendAclosetUserInquiryResponseHistoryRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 추가 필드 맵핑 스키마를 조회하는 API
   * @tags Shops
   * @name AdditionalFieldMappingsDetail
   * @summary 샵의 추가 필드 맵핑 스키마 조회 ✅
   * @request GET:/shops/{shopID}/additional-field-mappings
   * @secure
   * @response `200` `DomainListShopAdditionalFieldMappingsResponse` OK
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
   */
  export namespace AdditionalFieldMappingsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainListShopAdditionalFieldMappingsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopAdditionalFieldMappingsResponse;
  }

  /**
   * @description 샵의 추가 필드 스키마를 조회하는 API
   * @tags Shops
   * @name AdditionalFieldsDetail
   * @summary 샵의 추가 필드 스키마 조회 ✅
   * @request GET:/shops/{shopID}/additional-fields
   * @secure
   * @response `200` `(DomainShopAdditionalFieldResponse)[]` OK
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
   */
  export namespace AdditionalFieldsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainListShopAdditionalFieldsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainShopAdditionalFieldResponse[];
  }

  /**
   * @description 샵의 모든 추가 필드를 덮어쓰는 API
   * @tags Shops
   * @name AdditionalFieldsCreate
   * @summary 샵의 추가 필드 전체 덮어쓰기 ✅
   * @request POST:/shops/{shopID}/additional-fields
   * @secure
   * @response `204` `void` No Content
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
   */
  export namespace AdditionalFieldsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopAdditionalFieldsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 주문 취소를 승인합니다.
   * @tags Orders
   * @name ApproveCancelOrdersCreate
   * @summary 샵 주문 취소 승인 (다건) ✅
   * @request POST:/shops/{shopID}/approve-cancel-orders
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ApproveCancelOrdersCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainApproveCancelOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 인증 정보를 생성하는 API 입니다.
   * @tags Platforms
   * @name AuthCreate
   * @summary 샵 인증 정보 생성 API ✅
   * @request POST:/shops/{shopID}/auth
   * @secure
   * @response `204` `void` No Content
   */
  export namespace AuthCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopAuthRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 방해고객 리스트를 조회합니다.
   * @tags Orders
   * @name BlackConsumersDetail
   * @summary 방해고객 리스트 조회 ✅
   * @request GET:/shops/{shopID}/black-consumers
   * @secure
   * @response `200` `DomainListBlackConsumersResponse` OK
   */
  export namespace BlackConsumersDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListBlackConsumersResponse;
  }

  /**
   * @description 방해고객을 추가합니다.
   * @tags Orders
   * @name BlackConsumersCreate
   * @summary 방해고객 추가 ✅
   * @request POST:/shops/{shopID}/black-consumers
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BlackConsumersCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainAddBlackConsumerRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 방해고객을 삭제합니다.
   * @tags Orders
   * @name BlackConsumersDelete
   * @summary 방해고객 삭제 ✅
   * @request DELETE:/shops/{shopID}/black-consumers
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BlackConsumersDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /** 방해고객의 ID */
      blackConsumerID?: string;
      /** 방해고객의 userID (세컨솔드) */
      userID?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵을 차단/차단해제하는 API 입니다.
   * @tags Shops
   * @name BlockPartialUpdate
   * @summary 샵 차단/차단해제 API ✅
   * @request PATCH:/shops/{shopID}/block
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BlockPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopBlockRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 별로 관리하고 있는 브랜드 그룹들을 조회합니다.
   * @tags Brands
   * @name BrandGroupsDetail
   * @summary 샵 브랜드 그룹 리스트 조회 ✅
   * @request GET:/shops/{shopID}/brand-groups
   * @secure
   * @response `200` `DomainListShopBrandGroupsResponse` OK
   */
  export namespace BrandGroupsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopBrandGroupsResponse;
  }

  /**
   * @description 샵 별로 관리하고 있는 브랜드 그룹을 생성합니다.
   * @tags Brands
   * @name BrandGroupsCreate
   * @summary 샵 브랜드 그룹 생성 ✅
   * @request POST:/shops/{shopID}/brand-groups
   * @secure
   * @response `201` `DomainCreateShopBrandGroupResponse` 샵 브랜드 그룹 생성 반환 값
   */
  export namespace BrandGroupsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopBrandGroupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateShopBrandGroupResponse;
  }

  /**
   * @description 샵 별로 관리하고 있는 브랜드 그룹들을 삭제합니다.
   * @tags Brands
   * @name BrandGroupsDelete
   * @summary 샵 브랜드 그룹 삭제 ✅
   * @request DELETE:/shops/{shopID}/brand-groups
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BrandGroupsDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 브랜드 그룹 ID 리스트
       * @example ["5f9f1b5b9b9b9b9b9b9b9b9b"]
       */
      groupID?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 별로 관리하고 있는 브랜드 그룹을 브랜드 그룹 아이디로 조회합니다.
   * @tags Brands
   * @name BrandGroupsDetail2
   * @summary 샵 브랜드 그룹 단일 조회 ✅
   * @request GET:/shops/{shopID}/brand-groups/{brandGroupID}
   * @originalName brandGroupsDetail
   * @duplicate
   * @secure
   * @response `200` `DomainGetShopBrandGroupResponse` OK
   */
  export namespace BrandGroupsDetail2 {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 브랜드 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      brandGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetShopBrandGroupResponse;
  }

  /**
   * @description 샵 별로 관리하고 있는 브랜드 이미지 정보들을 업데이트 합니다. (없을 시 생성, 있을 시 덮어쓰기)
   * @tags Brands
   * @name BrandImagesUpdate
   * @summary 샵 브랜드 이미지 업데이트 ✅
   * @request PUT:/shops/{shopID}/brand-images
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BrandImagesUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopBrandImagesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 별로 관리하고 있는 브랜드 리스트를 조회합니다. (Acloset Brand x)
   * @tags Brands
   * @name BrandsDetail
   * @summary 샵 브랜드 리스트 조회 ✅
   * @request GET:/shops/{shopID}/brands
   * @secure
   * @response `200` `DomainListShopBrandsResponse` OK
   */
  export namespace BrandsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 북마크 브랜드 조회 여부
       * @example true
       */
      bookmarked?: boolean;
      /**
       * 브랜드 ID 리스트
       * @example ["5f9f1b5b9b9b9b9b9b9b9b9b"]
       */
      brandID?: string[];
      /**
       * 그룹ID 필터링
       * @example "63eb6df3f45b6fc2c1045aff"
       */
      groupID?: string;
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      /** @example "ZARA" */
      searchKeyword?: string;
      /** @example "ko" */
      searchKeywordType?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopBrandsResponse;
  }

  /**
   * @description 샵 별로 관리하고 있는 브랜드 리스트 정보를 업데이트 합니다. (덮어쓰기)
   * @tags Brands
   * @name BrandsUpdate
   * @summary 샵 브랜드 업데이트 ✅
   * @request PUT:/shops/{shopID}/brands
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BrandsUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopBrandsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 별로 관리하고 있는 브랜드를 생성합니다. (한/영 별도로 입력)
   * @tags Brands
   * @name BrandsCreate
   * @summary 샵 브랜드 생성 ✅
   * @request POST:/shops/{shopID}/brands
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BrandsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopBrandRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 별로 관리하고 있는 브랜드를 삭제합니다. 여러개를 삭제할 수 있습니다
   * @tags Brands
   * @name BrandsDelete
   * @summary 샵 브랜드 삭제 ✅
   * @request DELETE:/shops/{shopID}/brands
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BrandsDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 브랜드 ID 리스트
       * @example ["5f9f1b5b9b9b9b9b9b9b9b9b"]
       */
      brandID?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 사업자 정보를 조회하는 API (단건)
   * @tags Business
   * @name BusinessDetail
   * @summary 샵의 사업자 정보 조회 ✅
   * @request GET:/shops/{shopID}/business
   * @secure
   * @response `200` `DomainGetShopBusinessResponse` OK
   */
  export namespace BusinessDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetShopBusinessResponse;
  }

  /**
   * @description 샵의 사업자 정보를 수정하는 API
   * @tags Business
   * @name BusinessUpdate
   * @summary 샵의 사업자 정보 수정 ✅
   * @request PUT:/shops/{shopID}/business
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BusinessUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopBusinessRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 사업자 정보를 등록하는 API
   * @tags Business
   * @name BusinessCreate
   * @summary 샵의 사업자 정보 등록 ✅
   * @request POST:/shops/{shopID}/business
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BusinessCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopBusinessRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 사업자 정보를 부분 수정하는 API
   * @tags Business
   * @name BusinessPartialUpdate
   * @summary 샵의 사업자 정보 부분 수정 ✅
   * @request PATCH:/shops/{shopID}/business
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BusinessPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopBusinessRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 카페24 정보를 조회하는 API
   * @tags Platforms
   * @name Cafe24AuthDetail
   * @summary 샵의 카페24 정보 조회 ✅
   * @request GET:/shops/{shopID}/cafe24-auth
   * @secure
   * @response `200` `DomainGetShopCafe24AuthResponse` 카페24 정보 응답 값
   */
  export namespace Cafe24AuthDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetShopCafe24AuthResponse;
  }

  /**
   * @description 샵의 카페24 토큰 정보를 부분 수정하는 API ⚠️ 유효하지 않은 `mallID` 입력 시 토큰이 제대로 Refresh 되지 않으며, **카페 24 관련 모든 API가 정상 작동 하지 않게 됨.** 반드시 유효한 `mallID`로만 테스트 할 것.
   * @tags Platforms
   * @name Cafe24AuthPartialUpdate
   * @summary 샵의 카페24 토큰 정보 부분 수정 ✅
   * @request PATCH:/shops/{shopID}/cafe24-auth
   * @secure
   * @response `204` `void` No Content
   */
  export namespace Cafe24AuthPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopCafe24AuthRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 설정에 있는 카페24 추가항목을 갱신해주는 API 입니다. 카페24 최신 상품 하나를 조회하여 추가항목을 가져옵니다.
   * @tags Shops
   * @name Cafe24AdditionalInformationCreate
   * @summary 샵의 카페24 추가항목을 갱신하는 API ✅
   * @request POST:/shops/{shopID}/cafe24/additional-information
   * @secure
   * @response `204` `void` No Content
   */
  export namespace Cafe24AdditionalInformationCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 주문을 취소합니다.
   * @tags Orders
   * @name CancelOrdersCreate
   * @summary 샵 주문 취소 (다건)
   * @request POST:/shops/{shopID}/cancel-orders
   * @secure
   * @response `204` `void` No Content
   */
  export namespace CancelOrdersCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCancelOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵이 등록했던 카드를 조회합니다.
   * @tags Cards
   * @name CardsDetail
   * @summary 카드를 조회합니다. ✅
   * @request GET:/shops/{shopID}/cards
   * @secure
   * @response `200` `DomainListPaymentCardsResponse` OK
   */
  export namespace CardsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPaymentCardsResponse;
  }

  /**
   * No description
   * @tags Cards
   * @name CardsCreate
   * @summary 카드를 생성합니다. ✅
   * @request POST:/shops/{shopID}/cards
   * @secure
   * @response `204` `void` No Content
   */
  export namespace CardsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreatePaymentCardRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 카드를 ID로 단건 조회합니다. 리스트와는 응답이 다릅니다.
   * @tags Cards
   * @name CardsDetail2
   * @summary 카드를 단건 조회합니다. ✅
   * @request GET:/shops/{shopID}/cards/{cardID}
   * @originalName cardsDetail
   * @duplicate
   * @secure
   * @response `200` `DomainGetPaymentCardResponse` OK
   */
  export namespace CardsDetail2 {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 카드 ID
       * @example "5f9f1b5c9c9c9c9c9c9c9c9c"
       */
      cardId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetPaymentCardResponse;
  }

  /**
   * @description 카드를 삭제합니다. 내부적으로는 Soft Delete를 수행합니다.
   * @tags Cards
   * @name CardsDelete
   * @summary 카드를 삭제합니다. ✅
   * @request DELETE:/shops/{shopID}/cards/{cardID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace CardsDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 카드 ID
       * @example "5f9f1b5c9c9c9c9c9c9c9c9c"
       */
      cardId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 카드의 정보를 업데이트 합니다. 현재는 기본값 여부만 업데이트 가능합니다.
   * @tags Cards
   * @name CardsPartialUpdate
   * @summary 카드의 정보를 업데이트합니다. ✅
   * @request PATCH:/shops/{shopID}/cards/{cardID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace CardsPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 카드 ID
       * @example "5f9f1b5c9c9c9c9c9c9c9c9c"
       */
      cardId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchPaymentCardRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description **(주의)** 웹소켓 프로토콜을 이용하여 스웨거에서는 테스트 불가능합니다. 변경된 샵 알람 데이터를 웹소켓을 이용해 전송한다.
   * @tags Notifications
   * @name ChangedNotificationsWsDetail
   * @summary (웹소켓) 변경된 샵 알람 데이터를 웹소켓을 이용해 전송 ✅
   * @request GET:/shops/{shopID}/changed-notifications/ws
   * @secure
   * @response `200` `DomainStreamChangedShopNotificationResponse` OK
   */
  export namespace ChangedNotificationsWsDetail {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainStreamChangedShopNotificationResponse;
  }

  /**
   * @description **(주의)** 웹소켓 프로토콜을 이용하여 스웨거에서는 테스트 불가능합니다. 변경된 아이템 데이터를 웹소켓을 이용해 전송한다.
   * @tags Tasks
   * @name ChangedShopTaskItemWsDetail
   * @summary (웹소켓) 변경된 아이템 데이터를 웹소켓을 이용해 전송 ✅
   * @request GET:/shops/{shopID}/changed-shop-task-item/ws
   * @secure
   * @response `200` `DomainStreamChangedShopTaskItemResponse` OK
   */
  export namespace ChangedShopTaskItemWsDetail {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainStreamChangedShopTaskItemResponse;
  }

  /**
   * @description 클레임 카운트를 조회하는 API 입니다.
   * @tags Claims
   * @name ClaimCountsDetail
   * @summary 클레임 카운트 조회 API ✅
   * @request GET:/shops/{shopID}/claim-counts
   * @secure
   * @response `200` `DomainListClaimCountsResponse` OK
   */
  export namespace ClaimCountsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /** 조회할 주문 상태 [복수 가능] [빈 값인 경우 전체] (order, status 메타데이터 참조) */
      claimStatus?: string[];
      /** 조회할 주문 타입 [복수 가능] [빈 값인 경우 전체] (order, type 메타데이터 참조) */
      claimType?: string;
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from: string;
      /** 조회할 주문 상태 [복수 가능] [빈 값인 경우 전체] (order, status 메타데이터 참조) */
      inOrderStatus?: string[];
      /** 조회하지 않을 주문 상태 [복수 가능] [빈 값인 경우 전체] (order, status 메타데이터 참조) */
      notInOrderStatus?: string[];
      /**
       * 플랫폼 타입 [빈 값인 경우 전체] (metadata shop, platform-type 참조)
       * @example ["SHOP_PLATFORM-TYPE_CAFE24"]
       */
      platformType?: string[];
      /** 기간 필터 타입 (orderRequestDate: 주문일, returnRequestDate: 반품 요청일, returnDoneDate: 반품 완료일) */
      searchPeriodType?: 'orderRequestDate' | 'returnRequestDate' | 'returnDoneDate';
      /**
       * 필터 종료 기간 (타임존 포함)
       * @example "2023-04-14T23:59:59.999+09:00"
       */
      to: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListClaimCountsResponse;
  }

  /**
   * @description 클레임 리스트를 조회하는 API 입니다. (반품, 교환관련)
   * @tags Claims
   * @name ClaimsDetail
   * @summary 클레임 리스트 조회 API ✅
   * @request GET:/shops/{shopID}/claims
   * @secure
   * @response `200` `DomainListClaimsResponse` 클레임 리스트 응답값
   */
  export namespace ClaimsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 구매자명 (LIKE 검색)
       * @example "구매자명"
       */
      buyerName?: string;
      /**
       * 구매자 전화번호 (하이픈 없이) (LIKE 검색)
       * @example "01012345678"
       */
      buyerPhone?: string;
      /**
       * 클레임 상태 (metadata claim, return-status 참조) (metadata claim, exchange-status 참조)
       * @example ["CLAIM_RETURN-STATUS_REQUEST"]
       */
      claimStatus?: string[];
      /**
       * 클레임 타입 (metadata claim, type 참조)
       * @example "CLAIM_TYPE_RETURN"
       */
      claimType: 'CLAIM_TYPE_RETURN' | 'CLAIM_TYPE_EXCHANGE';
      /**
       * 상품코드가 입력과 부분일치하는 주문만 조회 (LIKE '%text%' 검색)                    // 상품코드 (LIKE 검색)
       * @example "A"
       */
      containsItemAlias?: string;
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /**
       * 송장번호 (IN 검색)
       * @example ["123712378123"]
       */
      invoiceNumber?: string[];
      /**
       * 상품코드 (IN 검색)
       * @example ["12738273"]
       */
      itemCode?: string[];
      /**
       * 상품명 (LIKE 검색)
       * @example "상품명"
       */
      itemTitle?: string;
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
      /**
       * 플랫폼 주문 ID (IN 검색)
       * @example ["12738273"]
       */
      platformOrderID?: string[];
      /**
       * 플랫폼 상품주문 ID (IN 검색)
       * @example ["12738274"]
       */
      platformProductOrderID?: string[];
      /**
       * 플랫폼 타입 (metadata platform, type 참조)`
       * @example ["PLATFORM_TYPE_CAFE24"]
       */
      platformType?: string[];
      /**
       * 수취인명 (LIKE 검색)
       * @example "받는사람"
       */
      receiverName?: string;
      /**
       * 수취인 전화번호 (하이픈 없이) (LIKE 검색)
       * @example "01012345678"
       */
      receiverPhone?: string;
      /**
       * 반송 송장번호 (IN 검색)
       * @example ["123712378123"]
       */
      returnInvoiceNumber?: string[];
      /** 기간 필터 타입 (orderRequestDate: 주문 요청 일시, returnRequestDate: 반품 요청 일시, returnRequestDate: 교환 요청 일시) */
      searchPeriodType?: 'orderRequestDate' | 'returnRequestDate' | 'exchangeRequestDate';
      /**
       * 정렬방법 (asc: 오름차순 , desc: 내림차순)
       * @example "asc"
       */
      sort?: 'asc' | 'desc';
      /** 정렬타입 (orderRequestDate: 주문 요청 일시, returnRequestDate: 반품 요청 일시, returnRequestDate: 교환 요청 일시) */
      sortType?: 'orderRequestDate' | 'returnRequestDate' | 'exchangeRequestDate';
      /** @example "공급사" */
      supplierName?: string;
      /**
       * 필터 종료 기간 (타임존 포함)
       * @example "2023-04-14T23:59:59.999+09:00"
       */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListClaimsResponse;
  }

  /**
   * @description 클레임 단건을 조회하는 API 입니다. (반품, 교환관련)
   * @tags Claims
   * @name ClaimsDetail2
   * @summary 클레임 단건 조회 API ✅
   * @request GET:/shops/{shopID}/claims/{claimID}
   * @originalName claimsDetail
   * @duplicate
   * @secure
   * @response `200` `DomainGetClaimResponse` 클레임 단건 응답값
   */
  export namespace ClaimsDetail2 {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 클레임 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      claimId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetClaimResponse;
  }

  /**
   * @description 플랫폼별 클레임 단건을 상세 조회하는 API 입니다. (현재는 Acloset만 지원)
   * @tags Claims
   * @name ClaimsDetailDetail
   * @summary 클레임 단건 조회 상세 API ✅
   * @request GET:/shops/{shopID}/claims/{claimID}/detail
   * @secure
   * @response `200` `DomainGetClaimDetailResponse` 클레임 단건 상세 응답값
   */
  export namespace ClaimsDetailDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 클레임 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      claimId: string;
    };
    export type RequestQuery = {
      /** 현재는 세컨솔드만 해당, 메타데이터 (shop, platform-type 참고) */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetClaimDetailResponse;
  }

  /**
   * @description 반품 클레임을 수거 완료하는 API 입니다. (카페24에서만 사용 중)
   * @tags Claims
   * @name ClaimsPickupCreate
   * @summary 수거 완료 API ✅
   * @request POST:/shops/{shopID}/claims/{claimID}/pickup
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ClaimsPickupCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 클레임 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      claimId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 반품 클레임을 거부하는 API 입니다.
   * @tags Claims
   * @name ClaimsRejectReturnCreate
   * @summary 반품 거부 API ✅
   * @request POST:/shops/{shopID}/claims/{claimID}/reject-return
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ClaimsRejectReturnCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 클레임 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      claimId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainRejectReturnClaimRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 반품 요청 클레임을 접수하는 API 입니다. (카페24 에서만 사용 중)
   * @tags Claims
   * @name ClaimsRequestReturnCreate
   * @summary 반품 요청 클레임 접수 API ✅
   * @request POST:/shops/{shopID}/claims/{claimID}/request-return
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ClaimsRequestReturnCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 클레임 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      claimId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainRequestReturnClaimRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 반품 클레임을 완료 처리하는 API 입니다.
   * @tags Claims
   * @name ClaimsReturnCreate
   * @summary 반품 완료 API ✅
   * @request POST:/shops/{shopID}/claims/{claimID}/return
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ClaimsReturnCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 클레임 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      claimId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainReturnClaimRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 이미지 리스트를 받아 타입을 분류하는 API 입니다.
   * @tags Tasks
   * @name ClassifyImageTypesCreate
   * @summary AIMS 타입 분류 ✅
   * @request POST:/shops/{shopID}/classify-image-types
   * @secure
   * @response `200` `DomainClassifyImageTypesResponse` 이미지 타입 분류 반환 값
   */
  export namespace ClassifyImageTypesCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainClassifyImageTypesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainClassifyImageTypesResponse;
  }

  /**
   * @description 샵의 주문을 배송확인합니다. 해당 API를 호출하면 배송중으로 변경이 됩니다.
   * @tags Orders
   * @name ConfirmOrderShippingsCreate
   * @summary 샵 주문 배송확인 (다건) ✅
   * @request POST:/shops/{shopID}/confirm-order-shippings
   * @secure
   * @response `202` `DomainConfirmOrderShippingsResponse` Accepted
   */
  export namespace ConfirmOrderShippingsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainConfirmOrderShippingsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainConfirmOrderShippingsResponse;
  }

  /**
   * @description 샵의 주문을 확인합니다. 해당 API를 호출하면 배송준비중으로 상태값이 변경됩니다.
   * @tags Orders
   * @name ConfirmOrdersCreate
   * @summary 샵 주문 확인 (다건) ✅
   * @request POST:/shops/{shopID}/confirm-orders
   * @secure
   * @response `202` `DomainConfirmOrdersResponse` Accepted
   */
  export namespace ConfirmOrdersCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainConfirmOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainConfirmOrdersResponse;
  }

  /**
   * @description 새로운 플랫폼을 연동하는 API 입니다. ### 존재하는 맵핑 그룹에 디폴트 카테고리 맵핑을 추가하고 등록한 아이템에 플랫폼 정보를 추가합니다.
   * @tags Platforms
   * @name ConnectPlatformCreate
   * @summary 플랫폼 연동 API ✅
   * @request POST:/shops/{shopID}/connect-platform
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ConnectPlatformCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainConnectPlatformRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 수정대기 아이템 갯수를 반환합니다. 필터에 영향을 받지 않습니다.
   * @tags Sales
   * @name CountPendingModifyingDetail
   * @summary 수정대기 아이템 계수 API ✅
   * @request GET:/shops/{shopID}/count-pending-modifying
   * @secure
   * @response `200` `DomainCountPendingModifyingResponse` OK
   */
  export namespace CountPendingModifyingDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCountPendingModifyingResponse;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsDetail
   * @summary 쿠폰을 리스트로 조회합니다. ✅
   * @request GET:/shops/{shopID}/coupons
   * @secure
   * @response `200` `DomainListShopCouponsResponse` OK
   */
  export namespace CouponsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      /**
       * 쿠폰 상태값
       * @example ["COUPON_STATUS_USING"]
       */
      status?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopCouponsResponse;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsAclosetCouponsDetail
   * @summary 세컨솔드 쿠폰을 조회합니다.
   * @request GET:/shops/{shopID}/coupons/acloset-coupons
   * @secure
   * @response `200` `DomainListAclosetCouponsResponse` 세컨솔드 쿠폰 목록 조회 응답값
   */
  export namespace CouponsAclosetCouponsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListAclosetCouponsResponse;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsAclosetCouponsCreate
   * @summary 세컨솔드 쿠폰을 생성합니다.
   * @request POST:/shops/{shopID}/coupons/acloset-coupons
   * @secure
   * @response `204` `void` No Content
   */
  export namespace CouponsAclosetCouponsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateAclosetCouponRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsAclosetCouponsDelete
   * @summary 세컨솔드 쿠폰을 삭제합니다.
   * @request DELETE:/shops/{shopID}/coupons/acloset-coupons/{aclosetCouponID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace CouponsAclosetCouponsDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 쿠폰 ID
       * @example "1232"
       */
      aclosetCouponId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsAclosetStoreCouponsDetail
   * @summary 세컨솔드 매장전용(현장결제) 쿠폰을 조회합니다. ✅
   * @request GET:/shops/{shopID}/coupons/acloset-store-coupons
   * @secure
   * @response `200` `DomainListAclosetStoreCouponsResponse` 세컨솔드 매장전용(현장결제) 쿠폰 목록 조회 응답값
   */
  export namespace CouponsAclosetStoreCouponsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListAclosetStoreCouponsResponse;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsAclosetStoreCouponsCreate
   * @summary 세컨솔드 매장전용(현장결제) 쿠폰을 생성합니다. ✅
   * @request POST:/shops/{shopID}/coupons/acloset-store-coupons
   * @secure
   * @response `204` `void` No Content
   */
  export namespace CouponsAclosetStoreCouponsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateAclosetStoreCouponRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsAclosetStoreCouponsUpdate
   * @summary 세컨솔드 매장전용(현장결제) 쿠폰을 수정합니다. ✅
   * @request PUT:/shops/{shopID}/coupons/acloset-store-coupons/{storeCouponID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace CouponsAclosetStoreCouponsUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 매장전용 쿠폰 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      storeCouponId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateAclosetStoreCouponRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsApplyPartialUpdate
   * @summary 쿠폰을 사용합니다. ✅
   * @request PATCH:/shops/{shopID}/coupons/{couponID}/apply
   * @secure
   * @response `204` `void` No Content
   * @response `400` `void` 사용하려는 쿠폰이 등록할 수 있는 상태가 아닌 경우 Code: SHOP_COUPON_IS_NOT_APPLICABLE, SHOP_COUPON_ALREADY_APPLIED, FREE_TRIAL_ALREADY_APPLIED
   * @response `404` `void` 사용하려는 쿠폰이 존재하지 않는 경우 Code: SHOP_COUPON_NOT_FOUND
   */
  export namespace CouponsApplyPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 쿠폰 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      couponId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Coupon
   * @name CouponsRegisterPartialUpdate
   * @summary 쿠폰을 등록합니다. ✅
   * @request PATCH:/shops/{shopID}/coupons/{couponID}/register
   * @secure
   * @response `204` `void` No Content
   * @response `400` `void` 등록하려는 쿠폰이 등록할 수 있는 상태가 아닌 경우 Code: SHOP_COUPON_IS_NOT_REGISTRABLE
   * @response `404` `void` 등록하려는 쿠폰이 존재하지 않는 경우 Code: SHOP_COUPON_NOT_FOUND
   */
  export namespace CouponsRegisterPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 쿠폰 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      couponId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 특정 샵의 크레딧을 리스트로 조회합니다.
   * @tags Settlements
   * @name CreditsDetail
   * @summary 크레딧을 리스트로 조회합니다. ✅
   * @request GET:/shops/{shopID}/credits
   * @secure
   * @response `200` `DomainListShopCreditsResponse` OK
   */
  export namespace CreditsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopCreditsResponse;
  }

  /**
   * @description 판매 아이템들을 삭제합니다. 해당 API는 판매중지, 판매중, 수정대기 상태에서만 호출이 가능합니다.
   * @tags Sales
   * @name DeleteSaleItemsCreate
   * @summary 판매 아이템 삭제 API ✅
   * @request POST:/shops/{shopID}/delete-sale-items
   * @secure
   * @response `202` `DomainDeleteSaleItemsResponse` Accepted
   */
  export namespace DeleteSaleItemsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainDeleteSaleItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainDeleteSaleItemsResponse;
  }

  /**
   * @description 엑셀 템플릿 목록 조회 API
   * @tags Templates
   * @name ExcelTemplatesDetail
   * @summary 엑셀 템플릿 목록 조회 ✅
   * @request GET:/shops/{shopID}/excel-templates
   * @secure
   * @response `200` `DomainListExcelTemplatesResponse` OK
   */
  export namespace ExcelTemplatesDetail {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {
      /** 템플릿 ID (복수 가능) */
      excelTemplateID?: string[];
      /** 기본 템플릿 여부 */
      isDefault?: boolean;
      /** 템플릿 타입 (메타데이터 template, type 참조) */
      templateType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListExcelTemplatesResponse;
  }

  /**
   * @description 엑셀 템플릿 생성 API
   * @tags Templates
   * @name ExcelTemplatesCreate
   * @summary 엑셀 템플릿 생성 ✅
   * @request POST:/shops/{shopID}/excel-templates
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ExcelTemplatesCreate {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateExcelTemplateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 엑셀 템플릿 수정 API
   * @tags Templates
   * @name ExcelTemplatesUpdate
   * @summary 엑셀 템플릿 수정 ✅
   * @request PUT:/shops/{shopID}/excel-templates/{excelTemplateID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ExcelTemplatesUpdate {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
      /** 엑셀 템플릿 ID */
      excelTemplateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateExcelTemplateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 엑셀 템플릿 삭제 API
   * @tags Templates
   * @name ExcelTemplatesDelete
   * @summary 엑셀 템플릿 삭제 ✅
   * @request DELETE:/shops/{shopID}/excel-templates/{excelTemplateID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ExcelTemplatesDelete {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
      /** 엑셀 템플릿 ID */
      excelTemplateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 엑셀 상품 목록 내보내기 API
   * @tags Templates
   * @name ExcelTemplatesExportSaleItemsCreate
   * @summary 엑셀 상품 목록 내보내기 ✅️
   * @request POST:/shops/{shopID}/excel-templates/{excelTemplateID}/export-sale-items
   * @secure
   * @response `200` `DomainExportExcelSaleItemsResponse` OK
   */
  export namespace ExcelTemplatesExportSaleItemsCreate {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
      /** 엑셀 템플릿 ID */
      excelTemplateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainExportExcelSaleItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExportExcelSaleItemsResponse;
  }

  /**
   * @description 엑셀 주문 목록 내보내기 API
   * @tags Templates
   * @name ExcelTemplatesExportShopOrdersCreate
   * @summary 엑셀 주문 목록 내보내기 ✅️
   * @request POST:/shops/{shopID}/excel-templates/{excelTemplateID}/export-shop-orders
   * @secure
   * @response `200` `DomainExportExcelShopOrdersResponse` OK
   */
  export namespace ExcelTemplatesExportShopOrdersCreate {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
      /** 엑셀 템플릿 ID */
      excelTemplateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainExportExcelShopOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExportExcelShopOrdersResponse;
  }

  /**
   * @description 엑셀을 기반으로 주문 목록을 단체로 업데이트 하는 정말 대단한 API
   * @tags Templates
   * @name ExcelTemplatesModifyShopOrdersCreate
   * @summary 엑셀을 가져와 주문 목록 수정하기 ✅️
   * @request POST:/shops/{shopID}/excel-templates/{excelTemplateID}/modify-shop-orders
   * @secure
   * @response `200` `DomainModifyExcelShopOrdersFromExcelResponse` OK
   */
  export namespace ExcelTemplatesModifyShopOrdersCreate {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
      /** 엑셀 템플릿 ID */
      excelTemplateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ExcelTemplatesModifyShopOrdersCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = DomainModifyExcelShopOrdersFromExcelResponse;
  }

  /**
   * @description 샵 패브릭 가격 계산기 리스트를 조회하는 API
   * @tags MappingGroups
   * @name FabricPriceCalculatorsDetail
   * @summary 샵 패브릭 가격 계산기 리스트 조회 ✅
   * @request GET:/shops/{shopID}/fabric-price-calculators
   * @secure
   * @response `200` `DomainListFabricPriceCalculatorsResponse` OK
   */
  export namespace FabricPriceCalculatorsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListFabricPriceCalculatorsResponse;
  }

  /**
   * @description 소재 가격 정보를 전부 지우고 재생성합니다. |**code**|**status**|**description**| |---|---|---| |400|N/A|샵 ID가 없음| |400|N/A|소재가 중복됨| |400|N/A|plus나 multiply가 누락됨|
   * @tags MappingGroups
   * @name FabricPriceCalculatorsUpdate
   * @summary 샵 소재 가격 계산기 수정 ✅
   * @request PUT:/shops/{shopID}/fabric-price-calculators
   * @secure
   * @response `204` `void` No Content
   */
  export namespace FabricPriceCalculatorsUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateFabricPriceCalculatorsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Inference
   * @name InferenceAutoLiquifyImageCreate
   * @summary 이미지에 대한 픽셀 자동 유동화를 수행합니다. ✅
   * @request POST:/shops/{shopID}/inference/auto-liquify-image
   * @secure
   * @response `200` `DomainAutoLiquifyImageResponse` OK
   */
  export namespace InferenceAutoLiquifyImageCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainAutoLiquifyImageRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainAutoLiquifyImageResponse;
  }

  /**
   * No description
   * @tags Inference
   * @name InferenceMultiModelCreate
   * @summary 여러가지 모델을 사용할 수 있는 API입니다. ✅
   * @request POST:/shops/{shopID}/inference/multi-model
   * @secure
   * @response `200` `DomainMultiModelResponse` OK
   */
  export namespace InferenceMultiModelCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainMultiModelRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainMultiModelResponse;
  }

  /**
   * @description 인스타그램 게시물 제한을 조회하는 API 입니다.
   * @tags Platforms
   * @name InstagramPublishLimitDetail
   * @summary 인스타그램 게시물 제한 조회 API ✅
   * @request GET:/shops/{shopID}/instagram-publish-limit
   * @secure
   * @response `200` `DomainGetInstagramPublishLimitResponse` OK
   * @response `404` `void` INSTAGRAM_SHOP_NOT_FOUND: Shop Not Found
   */
  export namespace InstagramPublishLimitDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetInstagramPublishLimitResponse;
  }

  /**
   * @description 샵의 카페24 OAuth 인증을 요청하는 API
   * @tags Platforms
   * @name IssueCafe24AuthCreate
   * @summary 샵 카페24 OAuth 인증 ✅
   * @request POST:/shops/{shopID}/issue-cafe24-auth
   * @secure
   * @response `204` `void` No Content
   */
  export namespace IssueCafe24AuthCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainIssueShopCafe24AuthRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 인스타그램 OAuth 인증을 요청하는 API
   * @tags Platforms
   * @name IssueInstagramAuthCreate
   * @summary 샵 인스타그램 OAuth 인증 ✅
   * @request POST:/shops/{shopID}/issue-instagram-auth
   * @secure
   * @response `204` `void` No Content
   */
  export namespace IssueInstagramAuthCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainIssueShopInstagramAuthRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 네이버 스마트 스토어 OAuth 인증을 요청하는 API
   * @tags Platforms
   * @name IssueNaverAuthCreate
   * @summary 샵 네이버 스마트 스토어 OAuth 인증 ✅
   * @request POST:/shops/{shopID}/issue-naver-auth
   * @secure
   * @response `204` `void` No Content
   */
  export namespace IssueNaverAuthCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainIssueShopNaverSmartStoreAuthRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 아이템 목록을 수정하는 API 입니다.
   * @tags Shops
   * @name ItemsPartialUpdate
   * @summary 샵의 아이템 다건 수정 ✅
   * @request PATCH:/shops/{shopID}/items
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ItemsPartialUpdate {
    export type RequestParams = {
      /**
       * 수정할 아이템이 속한 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 카페24 아이템을 불러오는 API 입니다.
   * @tags Shops
   * @name LoadCafe24ProductsCreate
   * @summary 카페24 아이템 불러오기  ✅️
   * @request POST:/shops/{shopID}/load-cafe24-products
   * @secure
   */
  export namespace LoadCafe24ProductsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description 카페24 아이템을 불러오기를 강제로 취소하고 관계된 데이터를 전부 삭제합니다. (큐 강제 제거, 상품 제거, 작업 제거, Shop 상태 데이터 초기화)
   * @tags Shops
   * @name LoadCafe24ProductsCancelCreate
   * @summary [MANAGER-ONLY] 카페24 아이템 불러오기 취소 ✅️
   * @request POST:/shops/{shopID}/load-cafe24-products/cancel
   * @secure
   */
  export namespace LoadCafe24ProductsCancelCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description 네이버 아이템을 불러오는 API 입니다.
   * @tags Shops
   * @name LoadNaverProductsCreate
   * @summary 네이버 아이템 불러오기 ✅
   * @request POST:/shops/{shopID}/load-naver-products
   * @secure
   */
  export namespace LoadNaverProductsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description 네이버 아이템을 불러오기를 강제로 취소하고 관계된 데이터를 전부 삭제합니다. (큐 강제 제거, 상품 제거, 작업 제거, Shop 상태 데이터 초기화)
   * @tags Shops
   * @name LoadNaverProductsCancelCreate
   * @summary [MANAGER-ONLY] 네이버 아이템 불러오기 취소 ✅
   * @request POST:/shops/{shopID}/load-naver-products/cancel
   * @secure
   */
  export namespace LoadNaverProductsCancelCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description 외부 플랫폼의 카테고리를 수동으로 동기화하는 API (커스텀 카테고리를 사용하는 플랫폼만 해당 함)
   * @tags Platforms
   * @name ManualSyncPlatformCategoriesCreate
   * @summary 샵 카테고리 수동 동기화 ✅
   * @request POST:/shops/{shopID}/manual-sync-platform-categories
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ManualSyncPlatformCategoriesCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainSyncShopPlatformCategoriesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 그룹 리스트를 조회하는 API
   * @tags MappingGroups
   * @name MappingGroupsDetail
   * @summary 샵 매핑 그룹 리스트 조회 ✅
   * @request GET:/shops/{shopID}/mapping-groups
   * @secure
   * @response `200` `DomainListMappingGroupsResponse` OK
   */
  export namespace MappingGroupsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMappingGroupsResponse;
  }

  /**
   * @description 샵 매핑 그룹을 생성하는 API
   * @tags MappingGroups
   * @name MappingGroupsCreate
   * @summary 샵 매핑 그룹 생성 ✅
   * @request POST:/shops/{shopID}/mapping-groups
   * @secure
   * @response `200` `DomainCreateMappingGroupResponse` OK
   */
  export namespace MappingGroupsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateMappingGroupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateMappingGroupResponse;
  }

  /**
   * @description 새로운 플랫폼에 대해 맵핑그룹 맵핑 추가 API 입니다. ### 존재하는 맵핑 그룹에 디폴트 카테고리 맵핑을 추가합니다.
   * @tags MappingGroups
   * @name MappingGroupsAddDefaultMappingCreate
   * @summary 맵핑그룹 맵핑 추가 API ✅
   * @request POST:/shops/{shopID}/mapping-groups/add-default-mapping
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsAddDefaultMappingCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainAddDefaultMappingGroupMappingsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 연결되지 않은 상품분류 조회
   * @tags MappingGroups
   * @name MappingGroupsUnMappedRulesDetail
   * @summary 연결되지 않은 상품분류 조회
   * @request GET:/shops/{shopID}/mapping-groups/un-mapped-rules
   * @secure
   * @response `200` `DomainListUnMappedMappingGroupMappingRulesResponse` OK
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsUnMappedRulesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListUnMappedMappingGroupMappingRulesResponse;
  }

  /**
   * @description 연결되지 않은 상품분류 수
   * @tags MappingGroups
   * @name MappingGroupsUnMappedRulesPartialUpdate
   * @summary 연결되지 않은 상품분류 수정
   * @request PATCH:/shops/{shopID}/mapping-groups/un-mapped-rules
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsUnMappedRulesPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateUnMappedMappingGroupMappingRulesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 그룹을 조회하는 API
   * @tags MappingGroups
   * @name MappingGroupsDetail2
   * @summary 샵 매핑 그룹 조회 (단건) ✅
   * @request GET:/shops/{shopID}/mapping-groups/{mappingGroupID}
   * @originalName mappingGroupsDetail
   * @duplicate
   * @secure
   * @response `200` `DomainGetMappingGroupResponse` OK
   */
  export namespace MappingGroupsDetail2 {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMappingGroupResponse;
  }

  /**
   * @description 샵 매핑 그룹을 삭제하는 API
   * @tags MappingGroups
   * @name MappingGroupsDelete
   * @summary 샵 매핑 그룹 삭제 ✅
   * @request DELETE:/shops/{shopID}/mapping-groups/{mappingGroupID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 삭제할 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 그룹을 수정하는 API
   * @tags MappingGroups
   * @name MappingGroupsPartialUpdate
   * @summary 샵 매핑 그룹 수정 ✅
   * @request PATCH:/shops/{shopID}/mapping-groups/{mappingGroupID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 수정할 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchMappingGroupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 그룹에 기존 매핑을 삭제하고 기본 매핑을 밀어넣는 API ### 🚨 해당 API는 개발용 API로, 서비스 용도로 사용을 금합니다. - 해당 API는 매핑 그룹 상태를 무시하므로, 서비스 용도로 적합하지 않습니다. - 디버깅 상황에서 매핑 그룹 자원이 통제되었을 때에만 사용해주세요.
   * @tags MappingGroups
   * @name MappingGroupsAddDefaultMappingCreate2
   * @summary [DEV] 샵 매핑 그룹 기본 매핑 추가 ⚙️
   * @request POST:/shops/{shopID}/mapping-groups/{mappingGroupID}/add-default-mapping
   * @originalName mappingGroupsAddDefaultMappingCreate
   * @duplicate
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsAddDefaultMappingCreate2 {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainAddDefaultMappingGroupMappingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 그룹 매핑 리스트를 조회하는 API
   * @tags MappingGroups
   * @name MappingGroupsMappingsDetail
   * @summary 샵 매핑 그룹 매핑 리스트 조회 ✅
   * @request GET:/shops/{shopID}/mapping-groups/{mappingGroupID}/mappings
   * @secure
   * @response `200` `DomainListMappingGroupMappingsResponse` OK
   */
  export namespace MappingGroupsMappingsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
    };
    export type RequestQuery = {
      /** 메타데이터 (shop, platform-type 참고) 빈 값의 경우 전체 조회 */
      platformType?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMappingGroupMappingsResponse;
  }

  /**
   * @description 샵 매핑 그룹 매핑을 수정하는 API
   * @tags MappingGroups
   * @name MappingGroupsMappingsUpdate
   * @summary 샵 매핑 그룹 매핑 전체 수정 ✅
   * @request PUT:/shops/{shopID}/mapping-groups/{mappingGroupID}/mappings
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsMappingsUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateMappingGroupMappingsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 그룹 매핑을 생성하는 API ⚠️ 카페 24 커스텀 매핑을 사용할 시 호출해주세요.
   * @tags MappingGroups
   * @name MappingGroupsMappingsCreate
   * @summary 샵 매핑 그룹 매핑 생성 (단건) ✅
   * @request POST:/shops/{shopID}/mapping-groups/{mappingGroupID}/mappings
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsMappingsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateMappingGroupMappingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 그룹 내 매핑 내 규칙을 부분 수정하는 API
   * @tags MappingGroups
   * @name MappingGroupsMappingsRulesPartialUpdate
   * @summary 샵 매핑 그룹 내 매핑 내 규칙 부분 수정 ✅
   * @request PATCH:/shops/{shopID}/mapping-groups/{mappingGroupID}/mappings/{mappingID}/rules/{ruleID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsMappingsRulesPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
      /**
       * 샵 매핑 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingId: string;
      /**
       * 수정할 샵 매핑 그룹 매핑 규칙 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      ruleId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchMappingRuleRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 그룹 속성 리스트를 조회하는 API
   * @tags MappingGroups
   * @name MappingGroupsPropertiesDetail
   * @summary 샵 매핑 그룹 속성 리스트 조회 ✅
   * @request GET:/shops/{shopID}/mapping-groups/{mappingGroupID}/properties
   * @secure
   * @response `200` `DomainListMappingGroupPropertiesResponse` OK
   */
  export namespace MappingGroupsPropertiesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMappingGroupPropertiesResponse;
  }

  /**
   * @description 샵 매핑 그룹 속성을 수정하는 API
   * @tags MappingGroups
   * @name MappingGroupsPropertiesUpdate
   * @summary 샵 매핑 그룹 속성 전체 수정 ✅
   * @request PUT:/shops/{shopID}/mapping-groups/{mappingGroupID}/properties
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingGroupsPropertiesUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 수정할 샵 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      mappingGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateMappingGroupPropertiesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 매핑 속성 리스트를 조회하는 API
   * @tags MappingGroups
   * @name MappingPropertiesDetail
   * @summary 샵 매핑 속성 리스트 조회
   * @request GET:/shops/{shopID}/mapping-properties
   * @secure
   * @response `200` `DomainListMappingGroupPropertiesResponse` OK
   */
  export namespace MappingPropertiesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMappingGroupPropertiesResponse;
  }

  /**
   * @description 샵 매핑 속성을 수정하는 API
   * @tags MappingGroups
   * @name MappingPropertiesUpdate
   * @summary 샵 매핑 속성 전체 수정
   * @request PUT:/shops/{shopID}/mapping-properties
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MappingPropertiesUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopMappingPropertiesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 별 카테고리 속성 별칭 조회
   * @tags Metadata
   * @name MetadataCategoryAliasesDetail
   * @summary 샵 별 카테고리 속성 별칭 조회 ✅
   * @request GET:/shops/{shopID}/metadata/category-aliases
   * @secure
   * @response `200` `DomainListCategoryAliasResponse` 샵 별 카테고리 속성 별칭 응답값
   */
  export namespace MetadataCategoryAliasesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListCategoryAliasResponse;
  }

  /**
   * @description 샵 별 카테고리 속성 별칭 수정
   * @tags Metadata
   * @name MetadataCategoryAliasesUpdate
   * @summary 샵 별 카테고리 속성 별칭 수정 ✅
   * @request PUT:/shops/{shopID}/metadata/category-aliases
   * @secure
   * @response `204` `void` No Content
   * @response `404` `void` 해당 매핑 그룹ID가 없는 경우
   */
  export namespace MetadataCategoryAliasesUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateCategoryAliasesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 별 컬러 별칭 조회
   * @tags Metadata
   * @name MetadataColorAliasesDetail
   * @summary 샵 별 컬러 별칭 조회 ✅
   * @request GET:/shops/{shopID}/metadata/color-aliases
   * @secure
   * @response `200` `DomainListColorAliasesResponse` 샵 별 컬러 별칭 응답값
   */
  export namespace MetadataColorAliasesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListColorAliasesResponse;
  }

  /**
   * @description 샵 별 컬러 별칭 수정
   * @tags Metadata
   * @name MetadataColorAliasesUpdate
   * @summary 샵 별 컬러 별칭 수정 ✅
   * @request PUT:/shops/{shopID}/metadata/color-aliases
   * @secure
   * @response `204` `void` No Content
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: METADATA_ALIAS_NOT_FOUND
   */
  export namespace MetadataColorAliasesUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateColorAliasesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 별 소재 별칭 조회
   * @tags Metadata
   * @name MetadataFabricAliasesDetail
   * @summary 샵 별 소재 별칭 조회 ✅
   * @request GET:/shops/{shopID}/metadata/fabric-aliases
   * @secure
   * @response `200` `DomainListFabricAliasesResponse` 샵 별 소재 별칭 응답값
   */
  export namespace MetadataFabricAliasesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListFabricAliasesResponse;
  }

  /**
   * @description 샵 별 소재 별칭 수정
   * @tags Metadata
   * @name MetadataFabricAliasesUpdate
   * @summary 샵 별 소재 별칭 수정 ✅
   * @request PUT:/shops/{shopID}/metadata/fabric-aliases
   * @secure
   * @response `204` `void` No Content
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: METADATA_ALIAS_NOT_FOUND
   */
  export namespace MetadataFabricAliasesUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateFabricAliasesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 카페24 상품 추가 이미지 삭제
   * @tags Migrate
   * @name MigrateDeleteCafe24ProductAdditionalImagesCreate
   * @summary [DEV-ONLY] 카페24 상품 추가 이미지 삭제 ⚙️
   * @request POST:/shops/{shopID}/migrate/delete-cafe24-product-additional-images
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateDeleteCafe24ProductAdditionalImagesCreate {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainMigrateDeleteCafe24ProductAdditionalImagesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 상품 수정 사항 반영
   * @tags Migrate
   * @name MigrateModifySaleItemsCreate
   * @summary [DEV-ONLY] 상품 수정 사항 반영 ⚙️
   * @request POST:/shops/{shopID}/migrate/modify-sale-items
   * @secure
   * @response `204` `string` ok
   */
  export namespace MigrateModifySaleItemsCreate {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainMigrateModifySaleItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description 이메일 변경 API
   * @tags Users
   * @name ModifyEmailCreate
   * @summary 이메일 변경 ✅
   * @request POST:/shops/{shopID}/modify-email
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ModifyEmailCreate {
    export type RequestParams = {
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainModifyUserEmailRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 해당 API를 요청하면 다른 플랜으로 변경합니다. 같은 플랜으로는 변경이 불가능합니다.
   * @tags Plans
   * @name ModifyPlanCreate
   * @summary 샵 플랜의 값을 변경합니다. ✅
   * @request POST:/shops/{shopID}/modify-plan
   * @deprecated
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ModifyPlanCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainModifyShopPlanRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 아이템들의 각 플랫폼 별 할인율을 수정합니다. 해당 API는 수정대기, 판매중지, 판매중 상태에서만 호출이 가능합니다.
   * @tags Sales
   * @name ModifySaleItemDiscountsCreate
   * @summary 할인율 수정 API ✅
   * @request POST:/shops/{shopID}/modify-sale-item-discounts
   * @secure
   * @response `202` `DomainModifySaleItemDiscountsResponse` Accepted
   */
  export namespace ModifySaleItemDiscountsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainModifySaleItemDiscountsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainModifySaleItemDiscountsResponse;
  }

  /**
   * @description 판매 아이템의 인스타그램 설명을 수정합니다. 해당 API는 판매중지, 판매중, 수정대기 상태에서만 호출이 가능합니다.
   * @tags Sales
   * @name ModifySaleItemInstagramDescriptionCreate
   * @summary 판매 아이템 인스타그램 설명 수정 API ✅
   * @request POST:/shops/{shopID}/modify-sale-item-instagram-description
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ModifySaleItemInstagramDescriptionCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainModifySaleItemInstagramDescriptionRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description AIMS 이메일과 비밀번호 변경 API
   * @tags Users
   * @name ModifyUserEmailPasswordCreate
   * @summary AIMS 이메일과 비밀번호 변경 ✅
   * @request POST:/shops/{shopID}/modify-user-email-password
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ModifyUserEmailPasswordCreate {
    export type RequestParams = {
      /** 쇼핑몰 ID */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainModifyUserEmailPasswordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description AIMS 비밀번호 변경 API
   * @tags Users
   * @name ModifyUserPasswordCreate
   * @summary AIMS 비밀번호 변경 ✅
   * @request POST:/shops/{shopID}/modify-user-password
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ModifyUserPasswordCreate {
    export type RequestParams = {
      /** 쇼핑몰 ID */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainModifyUserPasswordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 알람을 가져온다. ### 판매 게시 실패 시 오류 처리 (in `additionalField`) #### 포맷 ```json { "errors": [{ "errorCode": "에러 코드", "errorMessage": "메시지", "platformType": "플랫폼 타입", "saleItemID": "실패한 아이템 ID", "itemAlias": "실패한 아이템 코드" }] } ``` #### 에러 코드 | 코드 | 설명 | | --- | --- | | `PLATFORM_CATEGORY_NOT_FOUND` | `플랫폼 카테고리가 비어있어 업로드 실패` |
   * @tags Notifications
   * @name NotificationsDetail
   * @summary 샵 알람 리스트 ✅
   * @request GET:/shops/{shopID}/notifications
   * @secure
   * @response `200` `DomainListShopNotificationsResponse` OK
   */
  export namespace NotificationsDetail {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {
      isPolling?: boolean;
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
      withoutRead?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopNotificationsResponse;
  }

  /**
   * @description 샵의 세컨솔드 주문 알람을 가져온다.
   * @tags Notifications
   * @name NotificationsAclosetDetail
   * @summary 세컨솔드 알람 리스트 ✅
   * @request GET:/shops/{shopID}/notifications/acloset
   * @secure
   * @response `200` `DomainListAclosetNotificationsResponse` OK
   */
  export namespace NotificationsAclosetDetail {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {
      isPolling?: boolean;
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListAclosetNotificationsResponse;
  }

  /**
   * @description 샵의 세컨솔드 주문 알람 카운트를 가져온다.
   * @tags Notifications
   * @name NotificationsAclosetCountDetail
   * @summary 세컨솔드 알람 카운트 ✅
   * @request GET:/shops/{shopID}/notifications/acloset/count
   * @secure
   * @response `200` `DomainCountAclosetNotificationsResponse` OK
   */
  export namespace NotificationsAclosetCountDetail {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {
      isRead?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCountAclosetNotificationsResponse;
  }

  /**
   * @description 샵의 알람 카운트를 가져온다.
   * @tags Notifications
   * @name NotificationsCountDetail
   * @summary 알람 카운트 ✅
   * @request GET:/shops/{shopID}/notifications/count
   * @secure
   * @response `200` `DomainCountShopNotificationsResponse` OK
   */
  export namespace NotificationsCountDetail {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {
      isRead?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCountShopNotificationsResponse;
  }

  /**
   * @description 알림톡 보내기
   * @tags Notifications
   * @name NotificationsKakaotalkCreate
   * @summary 카카오 알림톡 생성 ✅
   * @request POST:/shops/{shopID}/notifications/kakaotalk
   * @secure
   * @response `204` `void` No Content
   */
  export namespace NotificationsKakaotalkCreate {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainSendKakaotalkNotificationRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 알람을 삭제한다.
   * @tags Notifications
   * @name NotificationsDelete
   * @summary 샵 알람 삭제 ✅
   * @request DELETE:/shops/{shopID}/notifications/{notificationID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace NotificationsDelete {
    export type RequestParams = {
      /** 샵 ID */
      shopId: string;
      /** 알람 ID */
      notificationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 각 플랫폼에 아이템들을 판매게시합니다. 해당 API를 호출하면 판매중 상태로 변환됩니다. |code|status|description| |---|---|---| |`SHOP_PLATFORM_CATEGORY_NOT_FOUND`|409|게시하고자 하는 플랫폼의 카테고리가 비어있습니다.| |`SHOP_TEMPLATE_NOT_FOUND`|409|게시하고자 하는 플랫폼의 템플릿이 비어있습니다.| |`SHOP_AVAILABLE-FEATURES_INACTIVE`|403|샵 사용 가능한 기능이 비활성화 되어 있습니다.|
   * @tags Sales
   * @name OpenSaleItemsCreate
   * @summary 판매 개시 API ✅
   * @request POST:/shops/{shopID}/open-sale-items
   * @secure
   * @response `202` `DomainOpenSaleItemsResponse` Accepted
   */
  export namespace OpenSaleItemsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainOpenSaleItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainOpenSaleItemsResponse;
  }

  /**
   * @description 샵의 주문의 상태별 카운트를 조회합니다. ## 유효성 검사 > 해당 API 유효성 검사가 많아 아래에 해당 내역을 명세합니다. - `shopID`가 존재하는지 형식에 맞는지 확인합니다. - `platformType`이 비어있지 않은 경우 메타데이터 shop, platform-type에 명시된 값이 아니면 오류를 반환합니다. - `orderStatus`값이 메타데이터에 포함되어 있지 않은 값이면 오류를 반환합니다. - `searchPeriodType`값이 빈 값이면 에러를 반환하며, 해당 값이 enum에 설정된 값이 아닌 경우 오류를 반환합니다. - `searchPeriodType`값이 존재하나, to, from 중 하나라도 값이 채워져 있다면 오류를 반환합니다. - `searchKeywordType`이 있는 경우 해당 값이 enum에 설정된 값이 아닌 경우 오류를 반환합니다. - `searchKeyword`가 있으나 `searchKeywordType` 값이 없는 경우 오류를 반환합니다. = `to`, `from` 중 하나만 채워져 있는 경우 오류를 반환합니다. - `to`가 `from`보다 이전인 경우 에러를 반환합니다.
   * @tags Orders
   * @name OrderCountsDetail
   * @summary 샵 주문 상태별 카운트 조회 ✅
   * @request GET:/shops/{shopID}/order-counts
   * @secure
   * @response `200` `DomainListShopOrderCountsResponse` OK
   */
  export namespace OrderCountsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      isDuplicated?: boolean;
      /** 할인 요청 여부 (true: 할인 요청 주문만, false: 할인 요청 포함 주문, null: 할인 요청 필터링 안함) */
      isOffer?: boolean;
      /** 조회할 주문 상태 [복수 가능] (order, status 메타데이터 참조) */
      orderStatus?: string[];
      /**
       * 플랫폼 타입 (metadata shop, platform-type 참조)
       * @example ["SHOP_PLATFORM-TYPE_CAFE24"]
       */
      platformType?: string[];
      /** 조회할 처리 상태 [복수 가능] (order, process-status 메타데이터 참조) */
      processStatus?: string[];
      /** 기간 필터 타입 (orderDate: 주문 일시, paymentDoneDate: 결제완료일, shippingPendingDate: 주문 확인일, shippingDoneDate: 배송 완료일, purchaseDoneDate: 구매 확정일, returnRequestDate: 반품 요청일) */
      searchPeriodType?:
        | 'orderDate'
        | 'paymentDoneDate'
        | 'shippingPendingDate'
        | 'shippingDoneDate'
        | 'purchaseDoneDate'
        | 'returnRequestDate';
      /** @example "2023-04-14T23:59:59.999+09:00" */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopOrderCountsResponse;
  }

  /**
   * @description 샵의 주문 대시보드를 조회합니다. dashboardItems는 상태별로 최대 5개씩만 조회됩니다.
   * @tags Orders
   * @name OrderDashboardsDetail
   * @summary 샵 주문 대시보드 조회 ✅
   * @request GET:/shops/{shopID}/order-dashboards
   * @secure
   * @response `200` `DomainListShopOrderDashboardsResponse` OK
   */
  export namespace OrderDashboardsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopOrderDashboardsResponse;
  }

  /**
   * @description 샵의 주문 리스트를 조회합니다.
   * @tags Orders
   * @name OrdersDetail
   * @summary 샵 주문 리스트 조회 ✅
   * @request GET:/shops/{shopID}/orders
   * @secure
   * @response `200` `DomainListShopOrdersResponse` OK
   */
  export namespace OrdersDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 구매자명 (LIKE 검색)
       * @example "구매자명"
       */
      buyerName?: string;
      /**
       * 구매자 전화번호 (하이픈 없이) (LIKE 검색)
       * @example "01012345678"
       */
      buyerPhone?: string;
      /** 상품코드 부분일치 주문 조회 (LIKE '%text%' 검색) */
      containsItemAlias?: string;
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /** 운송장 번호 필터링 여부 (true: 운송장 번호가 있는 주문만, false: 운송장 번호가 없는 주문만, null: 운송장 번호 필터링 안함) */
      hasInvoiceNumber?: boolean;
      /**
       * 송장번호 (IN 검색)
       * @example ["123712378123"]
       */
      invoiceNumber?: string[];
      /** 중복 주문 필터링 여부 (true: 중복 주문만, false: 중복 주문 포함, null: 중복 주문 필터링 안함) ⚠️ 해당 필드로 필터링 시 정렬 기준이 변경됩니다. */
      isDuplicated?: boolean;
      /** 할인 요청 여부 (true: 할인 요청 주문만, false: 할인 요청 포함 주문, null: 할인 요청 필터링 안함) */
      isOffer?: boolean;
      /**
       * 상품코드 (IN 검색)
       * @example ["12738273"]
       */
      itemAlias?: string[];
      /**
       * 상품명 (LIKE 검색)
       * @example "상품명"
       */
      itemTitle?: string;
      /** 주문 ID는 리스트로 요청이 가능합니다. 	// 조회할 주문 상태 (order, status 메타데이터 참조) */
      orderID?: string[];
      /**
       * 주문 상태 (metadata order, status 참조)
       * @example ["ORDER_STATUS_PAYMENT-DONE"]
       */
      orderStatus?: string[];
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      /**
       * 플랫폼 주문 ID (IN 검색)
       * @example ["12738273"]
       */
      platformOrderID?: string[];
      /**
       * 플랫폼 상품주문 ID (IN 검색)
       * @example ["12738274"]
       */
      platformProductOrderID?: string[];
      /**
       * 플랫폼 타입 (metadata platform, type 참조)
       * @example ["PLATFORM_TYPE_CAFE24"]
       */
      platformType?: string[];
      /** 조회할 처리 상태 (order, process-status 메타데이터 참조) */
      processStatus?: string[];
      /**
       * 수취인명 (LIKE 검색)
       * @example "받는사람"
       */
      receiverName?: string;
      /**
       * 수취인 전화번호 (하이픈 없이) (LIKE 검색)
       * @example "01012345678"
       */
      receiverPhone?: string;
      /** 기간 필터 타입 (orderDate: 주문일, paymentDone: 결제일, shippingInProgressDate: 발송확인일, purchaseDoneDate: 구매확정일) */
      searchPeriodType?: 'orderDate' | 'paymentDoneDate' | 'shippingInProgressDate' | 'purchaseDoneDate';
      /**
       * 공급사
       * @example "공급사"
       */
      supplierName?: string;
      /** @example "2023-04-14T23:59:59.999+09:00" */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopOrdersResponse;
  }

  /**
   * @description 샵의 주문 리스트를 수정합니다.
   * @tags Orders
   * @name OrdersPartialUpdate
   * @summary 샵 주문 리스트 수정 ✅
   * @request PATCH:/shops/{shopID}/orders
   * @secure
   * @response `204` `void` No Content
   */
  export namespace OrdersPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 주문 ID 리스트를 조회합니다.
   * @tags Orders
   * @name OrdersIdDetail
   * @summary 샵 주문 ID 리스트 조회 ✅
   * @request GET:/shops/{shopID}/orders/id
   * @secure
   * @response `200` `DomainListShopOrderIDsResponse` OK
   */
  export namespace OrdersIdDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 구매자명 (LIKE 검색)
       * @example "구매자명"
       */
      buyerName?: string;
      /**
       * 구매자 전화번호 (하이픈 없이) (LIKE 검색)
       * @example "01012345678"
       */
      buyerPhone?: string;
      /** 상품코드 부분일치 주문 조회 (LIKE '%text%' 검색) */
      containsItemAlias?: string;
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /** 운송장 번호 필터링 여부 (true: 운송장 번호가 있는 주문만, false: 운송장 번호가 없는 주문만, null: 운송장 번호 필터링 안함) */
      hasInvoiceNumber?: boolean;
      /**
       * 송장번호 (IN 검색)
       * @example ["123712378123"]
       */
      invoiceNumber?: string[];
      /** 중복 주문 필터링 여부 (true: 중복 주문만, false: 중복 주문 포함, null: 중복 주문 필터링 안함) ⚠️ 해당 필드로 필터링 시 정렬 기준이 변경됩니다. */
      isDuplicated?: boolean;
      /** 할인 요청 여부 (true: 할인 요청 주문만, false: 할인 요청 포함 주문, null: 할인 요청 필터링 안함) */
      isOffer?: boolean;
      /**
       * 상품코드 (IN 검색)
       * @example ["12738273"]
       */
      itemAlias?: string[];
      /**
       * 상품명 (LIKE 검색)
       * @example "상품명"
       */
      itemTitle?: string;
      /** 주문 ID는 리스트로 요청이 가능합니다. 	// 조회할 주문 상태 (order, status 메타데이터 참조) */
      orderID?: string[];
      /**
       * 주문 상태 (metadata order, status 참조)
       * @example ["ORDER_STATUS_PAYMENT-DONE"]
       */
      orderStatus?: string[];
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      /**
       * 플랫폼 주문 ID (IN 검색)
       * @example ["12738273"]
       */
      platformOrderID?: string[];
      /**
       * 플랫폼 상품주문 ID (IN 검색)
       * @example ["12738274"]
       */
      platformProductOrderID?: string[];
      /**
       * 플랫폼 타입 (metadata platform, type 참조)
       * @example ["PLATFORM_TYPE_CAFE24"]
       */
      platformType?: string[];
      /** 조회할 처리 상태 (order, process-status 메타데이터 참조) */
      processStatus?: string[];
      /**
       * 수취인명 (LIKE 검색)
       * @example "받는사람"
       */
      receiverName?: string;
      /**
       * 수취인 전화번호 (하이픈 없이) (LIKE 검색)
       * @example "01012345678"
       */
      receiverPhone?: string;
      /** 기간 필터 타입 (orderDate: 주문일, paymentDone: 결제일, shippingInProgressDate: 발송확인일, purchaseDoneDate: 구매확정일) */
      searchPeriodType?: 'orderDate' | 'paymentDoneDate' | 'shippingInProgressDate' | 'purchaseDoneDate';
      /**
       * 공급사
       * @example "공급사"
       */
      supplierName?: string;
      /** @example "2023-04-14T23:59:59.999+09:00" */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopOrderIDsResponse;
  }

  /**
   * @description 샵의 주문을 취소합니다.
   * @tags Orders
   * @name OrdersCancelCreate
   * @summary 샵 주문 취소 ✅
   * @request POST:/shops/{shopID}/orders/{orderID}/cancel
   * @secure
   * @response `204` `void` No Content
   */
  export namespace OrdersCancelCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 주문 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      orderId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCancelOrderRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 주문 결제를 확인합니다.
   * @tags Orders
   * @name OrdersConfirmPaymentCreate
   * @summary 샵 주문 결제확인 ✅
   * @request POST:/shops/{shopID}/orders/{orderID}/confirm-payment
   * @secure
   * @response `204` `void` No Content
   */
  export namespace OrdersConfirmPaymentCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 주문 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      orderId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Payments
   * @name PaymentsDetailsDetail
   * @summary 결제내역을 리스트로 조회합니다. 🛠️
   * @request GET:/shops/{shopID}/payments/details
   * @secure
   * @response `200` `DomainListPaymentDetailsResponse` OK
   */
  export namespace PaymentsDetailsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 결제 월 (예: 202303)
       * @example "202303"
       */
      month?: string;
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      /**
       * 결제내역 ID
       * @example "65378b60f9505804b23cdaff"
       */
      paymentDetailID?: string;
      /**
       * 정렬방법 (asc: 오름차순 , desc: 내림차순)
       * @example "asc"
       */
      sort?: 'asc' | 'desc';
      /**
       * 정렬타입 (createDate: 생성일시)
       * @example "createDate"
       */
      sortType?: 'createDate';
      /**
       * 결제 상태 (GET: /shops/metadata의 payment, status 참고)
       * @example "PAYMENT_STATUS_PENDING"
       */
      status?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPaymentDetailsResponse;
  }

  /**
   * No description
   * @tags Payments
   * @name PaymentsDetailsTasksDetail
   * @summary 결제내역의 상세 태스크 내역을 리스트로 조회합니다. ✅
   * @request GET:/shops/{shopID}/payments/details/{paymentDetailID}/tasks
   * @secure
   * @response `200` `DomainListPaymentDetailTasksResponse` OK
   */
  export namespace PaymentsDetailsTasksDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 결제내역 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      paymentDetailId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPaymentDetailTasksResponse;
  }

  /**
   * @description 결제가 실패한 정산건을 조회해서 결제를 시도합니다.
   * @tags Payments
   * @name PaymentsRetryPayCreate
   * @summary 결제 재시도 API ✅
   * @request POST:/shops/{shopID}/payments/retry-pay
   * @secure
   * @response `204` `void` No Content
   */
  export namespace PaymentsRetryPayCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainRetryPayByUserRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 결제내역의 상태를 조회합니다.
   * @tags Payments
   * @name PaymentsStatusDetail
   * @summary 결제 상태 조회 API ✅
   * @request GET:/shops/{shopID}/payments/status
   * @secure
   * @response `200` `DomainGetShopPaymentStatusResponse` OK
   */
  export namespace PaymentsStatusDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetShopPaymentStatusResponse;
  }

  /**
   * @description 샵에 적용이 되어있는 플랜을 단건 조회합니다.
   * @tags Plans
   * @name PlansDetail
   * @summary 플랜을 단건 조회합니다. ✅
   * @request GET:/shops/{shopID}/plans
   * @deprecated
   * @secure
   * @response `200` `DomainGetShopPlanResponse` OK
   */
  export namespace PlansDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetShopPlanResponse;
  }

  /**
   * @description 플랜과 관계된 현재 상태를 조회합니다.
   * @tags Plans
   * @name PlansStatusDetail
   * @summary 플랜 상태를 조회합니다.✅
   * @request GET:/shops/{shopID}/plans/status
   * @deprecated
   * @secure
   * @response `200` `DomainGetShopPlanStatusResponse` OK
   */
  export namespace PlansStatusDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetShopPlanStatusResponse;
  }

  /**
   * @description 외부 플랫폼의 카테고리를 조회하는 API (카페24, 번개장터, 네이버스마트스토어, 세컨솔드) 상세개발 이슈 : https://github.com/looko-corp/aims-api/issues/1091
   * @tags Platforms
   * @name PlatformCategoriesDetail
   * @summary 샵 카테고리 리스트 조회 ✅
   * @request GET:/shops/{shopID}/platform-categories
   * @secure
   * @response `200` `DomainListShopPlatformCategoriesResponse` 샵 카테고리 응답값
   */
  export namespace PlatformCategoriesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /** 플랫폼 타입 (메타 데이터 shop, platform-type 참조) */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopPlatformCategoriesResponse;
  }

  /**
   * @description 외부 플랫폼의 카테고리를 수정하는 API (카페24, 번개장터, 네이버스마트스토어, 세컨솔드)
   * @tags Platforms
   * @name PlatformCategoriesPartialUpdate
   * @summary 샵 카테고리 리스트 수정
   * @request PATCH:/shops/{shopID}/platform-categories
   * @secure
   * @response `204` `void` No Content
   */
  export namespace PlatformCategoriesPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopPlatformCategoriesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 상품분류 규칙 조회
   * @tags MappingGroups
   * @name PlatformCategoryRulesDetail
   * @summary 상품분류 규칙 조회
   * @request GET:/shops/{shopID}/platform-category-rules
   * @secure
   * @response `200` `DomainListPlatformCategoryRulesResponse` OK
   */
  export namespace PlatformCategoryRulesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPlatformCategoryRulesResponse;
  }

  /**
   * @description 상품분류 규칙 수정
   * @tags MappingGroups
   * @name PlatformCategoryRulesCreate
   * @summary 상품분류 규칙 수정
   * @request POST:/shops/{shopID}/platform-category-rules
   * @secure
   * @response `204` `void` No Content
   */
  export namespace PlatformCategoryRulesCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpsertPlatformCategoryRulesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 플랫폼 연동을 해제합니다. 🚨 모든 플랫폼의 데이터가 Hard Delete로 삭제됩니다. (아이템, 클레임, 주문, 인증정보) 따라서 주의해서 사용해주세요. ## Validation |**code**|**status**|**description**| |:---:|:---:|---| |N/A|400|`platformType`이 메타데이터에 속하지 않읂 경우| |N/A|400|`platformType`이 빈 문자열이거나, 보내지 않은 경우| |N/A|400|`shopID`가 비었거나 유효하지 않은 경우| |`SHOP_NOT_FOUND`|404|샵이 존재하지 않음| |`SHOP_PLATFORM_ALREADY_DISCONNECTED`|409|요청한 플랫폼이 샵에 존재하지 않음| |`SHOP_PLATFORM_MINIMUM_NOT_REACHED`|409|플랫폼이 연동 해제 시 연동 플랫폼이 2개 이하가 되는 경우| |`IN_PROGRESS_PLATFORM_SALE_TASK_EXISTS`|409|삭제하려는 플랫폼과 관련된 진행중인 작업이 존재함|
   * @tags Shops
   * @name PlatformsDelete
   * @summary 🚨플랫폼 연동 해제 API ✅️
   * @request DELETE:/shops/{shopID}/platforms
   * @secure
   * @response `202` `void` Accepted
   */
  export namespace PlatformsDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /** 연동 해제 할 플랫폼 타입 (리스트 허용) */
      platformType: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 이미지 AI용 전처리 후 S3 업로드하는 API 입니다.
   * @tags Shops
   * @name PreprocessImageCreate
   * @summary 이미지 AI용 전처리 ✅
   * @request POST:/shops/{shopID}/preprocess-image
   * @secure
   * @response `204` `void` No Content
   */
  export namespace PreprocessImageCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPreprocessImageRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 관련 S3 서명된 URL을 생성해주는 API 입니다. (유효기간 30분)
   * @tags Shops
   * @name PresignedUrlsCreate
   * @summary 샵 관련 S3 서명된 URL 생성 ✅
   * @request POST:/shops/{shopID}/presigned-urls
   * @secure
   * @response `200` `DomainCreateShopPreSignedURLsResponse` OK
   */
  export namespace PresignedUrlsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopPreSignedURLsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateShopPreSignedURLsResponse;
  }

  /**
   * @description 가격 자동입력에 사용되는 샵 브랜드 그룹 조회 합니다.
   * @tags Brands
   * @name PriceBrandGroupsDetail
   * @summary 가격 자동입력에 사용되는 샵 브랜드 그룹 조회 ✅
   * @request GET:/shops/{shopID}/price-brand-groups
   * @secure
   * @response `200` `DomainListShopPriceBrandGroupsResponse` OK
   */
  export namespace PriceBrandGroupsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopPriceBrandGroupsResponse;
  }

  /**
   * @description 가격 브랜드 그룹을 생성하는 API 입니다. 브랜드가 없는 상품 규칙 만들기의 경우, 브랜드 ID를 빈 값으로 보내주시면 됩니다.
   * @tags Brands
   * @name PriceBrandGroupsCreate
   * @summary 가격 브랜드 그룹 생성 ✅
   * @request POST:/shops/{shopID}/price-brand-groups
   * @secure
   * @response `201` `DomainCreateShopPriceBrandGroupResponse` 가격 브랜드 그룹 생성 반환 값
   */
  export namespace PriceBrandGroupsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopPriceBrandGroupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateShopPriceBrandGroupResponse;
  }

  /**
   * @description 가격 브랜드 그룹을 삭제하는 API 입니다.
   * @tags Brands
   * @name PriceBrandGroupsDelete
   * @summary 가격 브랜드 그룹 삭제 ✅
   * @request DELETE:/shops/{shopID}/price-brand-groups/{priceBrandGroupID}
   * @secure
   * @response `204` `void` 가격 브랜드 그룹 삭제 반환 값
   */
  export namespace PriceBrandGroupsDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 가격 브랜드 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      priceBrandGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 가격 자동입력에 사용되는 샵 브랜드 그룹 업데이트 합니다.
   * @tags Brands
   * @name PriceBrandGroupsPartialUpdate
   * @summary 가격 자동입력에 사용되는 샵 브랜드 그룹 업데이트 ✅
   * @request PATCH:/shops/{shopID}/price-brand-groups/{priceBrandGroupID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace PriceBrandGroupsPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 가격 브랜드 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      priceBrandGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopPriceBrandGroupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 가격 규칙을 조회하는 API 입니다. 셀 단위의 가격 규칙 데이터들이 반환합니다.
   * @tags Tasks
   * @name PriceRulesDetail
   * @summary 가격 규칙 조회 ✅
   * @request GET:/shops/{shopID}/price-rules
   * @secure
   * @response `200` `DomainListShopPriceRulesResponse` 가격 규칙 조회 반환 값
   */
  export namespace PriceRulesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopPriceRulesResponse;
  }

  /**
   * @description 가격 규칙을 수정하는 API 입니다. 셀 단위의 가격 규칙 데이터들을 업데이트 합니다. 호출 시, 샵의 셀 단위의 가격 규칙을 삭제하고, 입력받은 데이터로 덮어씁니다.
   * @tags Tasks
   * @name PriceRulesUpdate
   * @summary 가격 규칙 수정 ✅
   * @request PUT:/shops/{shopID}/price-rules
   * @secure
   * @response `204` `void` 가격 규칙 수정 반환 값
   */
  export namespace PriceRulesUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopPriceRulesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 판매 아이템 동기화 이벤트를 수동으로 발행합니다.
   * @tags Sales
   * @name PublishUpdateSaleItemsCreate
   * @summary 판매 아이템 동기화 이벤트 수동 발행 API ✅
   * @request POST:/shops/{shopID}/publish-update-sale-items
   * @secure
   * @response `204` `void` No Content
   */
  export namespace PublishUpdateSaleItemsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPublishUpdateSaleItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 판매관리 대상 아이템 리스트를 조회하는 API
   * @tags Sales
   * @name RealtimeSaleItemsDetail
   * @summary 샵의 판매관리 대상 아이템 리스트 조회 ✅
   * @request GET:/shops/{shopID}/realtime-sale-items
   * @secure
   * @response `200` `DomainListRealtimeShopSaleItemsResponse` OK
   */
  export namespace RealtimeSaleItemsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /** 상품코드|상품명 둘 중 하나는 필수 */
      itemAlias?: string;
      /** 기간 필터 타입 (createDate: 아이템 생성일, modifyDate: 아이템 수정일, postDate: 상품 등록일) */
      searchPeriodType?: 'createDate' | 'modifyDate' | 'postDate';
      /** 상품코드|상품명 둘 중 하나는 필수 */
      title?: string;
      /**
       * 필터 종료 기간 (타임존 포함)
       * @example "2023-04-14T23:59:59.999+09:00"
       */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListRealtimeShopSaleItemsResponse;
  }

  /**
   * @description 삭제된 판매 아이템을 복원합니다. 해당 API는 삭제된 판매 아이템을 복원합니다.
   * @tags Sales
   * @name RecoverDeletedSaleItemsCreate
   * @summary 삭제된 판매 아이템 복원 API ✅
   * @request POST:/shops/{shopID}/recover-deleted-sale-items
   * @secure
   * @response `204` `void` No Content
   */
  export namespace RecoverDeletedSaleItemsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainRecoverDeletedSaleItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 주문 Acloset 할인요청을 거절합니다.
   * @tags Orders
   * @name RejectAclosetOfferCreate
   * @summary 샵 주문 Acloset 할인요청 거절 🛠️
   * @request POST:/shops/{shopID}/reject-acloset-offer
   * @secure
   * @response `204` `void` No Content
   */
  export namespace RejectAclosetOfferCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainRejectAclosetOfferRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 주문 취소를 거절합니다. 해당 API를 호출하면 CAFE24의 경우에는 배송준비중으로 변경되고 네이버의 경우에는 송장번호를 받고 배송중으로 상태가 변경됩니다.
   * @tags Orders
   * @name RejectCancelOrdersCreate
   * @summary 샵 주문 취소 거절 ✅
   * @request POST:/shops/{shopID}/reject-cancel-orders
   * @secure
   * @response `202` `DomainRejectCancelOrdersResponse` Accepted
   */
  export namespace RejectCancelOrdersCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainRejectCancelOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainRejectCancelOrdersResponse;
  }

  /**
   * @description `itemIDs`가 채워진 상태로 리매핑 수행 시: 상태, 플랫폼 카테고리 유무 여부를 떠나서 설정한 아이템에 대해 플랫폼 카테고리 리매핑을 수행 `itemIDs`가 비어있는 상태로 리매핑 수행 시: 상품 등록된 아이템 중, 판매 전 상태인 아이템이면서 플랫폼 카테고리가 비어있는 경우 플랫폼 카테고리 리매핑을 수행
   * @tags Sales
   * @name RemappingSaleItemsPlatformCategoriesCreate
   * @summary 판매 아이템 플랫폼 카테고리 재매핑 API ✅
   * @request POST:/shops/{shopID}/remapping-sale-items-platform-categories
   * @secure
   * @response `204` `void` No Content
   */
  export namespace RemappingSaleItemsPlatformCategoriesCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainRemappingSaleItemsPlatformCategoriesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 특정 이미지를 받아서 배경제거를 해주는 API 입니다.
   * @tags Tasks
   * @name RemoveBackgroundCreate
   * @summary 특정이미지를 배경제거 ✅
   * @request POST:/shops/{shopID}/remove-background
   * @secure
   * @response `200` `DomainRemoveBackgroundImageResponse` 이미지 배경제거 반환 값
   */
  export namespace RemoveBackgroundCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainRemoveBackgroundImageRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainRemoveBackgroundImageResponse;
  }

  /**
   * @description 각 플랫폼에 아이템들을 재개시합니다. 해당 API는 판매중지 상태에서만 호출이 가능합니다.
   * @tags Sales
   * @name ReopenSaleItemsCreate
   * @summary 판매 재개시 API  ✅️
   * @request POST:/shops/{shopID}/reopen-sale-items
   * @secure
   * @response `202` `DomainReopenSaleItemsResponse` Accepted
   */
  export namespace ReopenSaleItemsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainReopenSaleItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainReopenSaleItemsResponse;
  }

  /**
   * @description 판매관리 대시보드 목록을 조회합니다. dashboardItems는 상태별로 최대 5개씩만 조회됩니다.
   * @tags Sales
   * @name SaleDashboardsDetail
   * @summary 판매관리 대시보드 목록 조회 API ✅
   * @request GET:/shops/{shopID}/sale-dashboards
   * @secure
   * @response `200` `DomainListShopSaleDashboardsResponse` OK
   */
  export namespace SaleDashboardsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopSaleDashboardsResponse;
  }

  /**
   * @description 판매관리에서 사용되는 필드목록들을 조회합니다.
   * @tags Sales
   * @name SaleFieldsDetail
   * @summary 판매관리 필드목록 조회 API ✅
   * @request GET:/shops/{shopID}/sale-fields
   * @secure
   * @response `200` `DomainListShopSaleFieldsResponse` OK
   */
  export namespace SaleFieldsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopSaleFieldsResponse;
  }

  /**
   * @description 판매관리에서 사용되는 필드들을 수정합니다. 해당 API는 기존의 데이터를 모두 덮어씌웁니다.
   * @tags Sales
   * @name SaleFieldsUpdate
   * @summary 판매관리 필드 수정 API ✅
   * @request PUT:/shops/{shopID}/sale-fields
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleFieldsUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopSaleFieldsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 상품의 상태별 카운트를 조회합니다.
   * @tags Sales
   * @name SaleItemCountsDetail
   * @summary 샵의 판매관리 대상 아이템 상태별 카운트 조회 ✅
   * @request GET:/shops/{shopID}/sale-item-counts
   * @secure
   * @response `200` `DomainListShopSaleItemCountsResponse` OK
   */
  export namespace SaleItemCountsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * AIMS 카테고리 ID 목록
       * @example ["SWEATERS"]
       */
      aimsCategory?: string[];
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /** 각 쇼핑몰의 상태값에 판매중과 판매중지가 혼합되어 있는지 여부 */
      isPlatformStatusOnSaleAndStopSale?: boolean;
      /** 상품 코드 */
      itemAlias?: string;
      /**
       * 상품 코드 목록
       * @example ["12738273"]
       */
      itemAliases?: string[];
      /** 판매 상태 (메타데이터 sale, platform-status 참조) */
      platformStatus?: string[];
      /** 플랫폼 타입 (메타데이터 shop, platform-type 참조) */
      platformType?: string;
      /** 상품 ID 목록 (리스트를 허용합니다.) */
      saleItemID?: string[];
      /** 진행 상태를 조회하고자 할 때 사용 (진행 중, 실패, 대기) (메타데이터 sale, operation 참고) */
      saleOperation?: string;
      /** 판매 상태 (메타데이터 sale, status 참조) */
      saleStatus?: string[];
      /** 기간 필터 타입 (createDate: 아이템 생성일, modifyDate: 아이템 수정일, postDate: 상품 등록일) */
      searchPeriodType?: 'createDate' | 'modifyDate' | 'postDate';
      /** 공급사 (contains 검색) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
      supplierName?: string;
      /** 공급사 목록 (exact match) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
      supplierNames?: string[];
      /** 상품명 */
      title?: string;
      /**
       * 상품명 목록
       * @example ["테스트 상품"]
       */
      titles?: string[];
      /**
       * 필터 종료 기간 (타임존 포함)
       * @example "2023-04-14T23:59:59.999+09:00"
       */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * API 버전
       * @default "legacy"
       */
      'api-version'?: string;
    };
    export type ResponseBody = DomainListShopSaleItemCountsResponse;
  }

  /**
   * @description 샵의 판매관리 대상 아이템 리스트를 조회하는 API
   * @tags Sales
   * @name SaleItemsDetail
   * @summary 샵의 판매관리 대상 아이템 리스트 조회 ✅
   * @request GET:/shops/{shopID}/sale-items
   * @secure
   * @response `200` `DomainListShopSaleItemsResponse` OK
   */
  export namespace SaleItemsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * AIMS 카테고리 ID 목록
       * @example ["SWEATERS"]
       */
      aimsCategory?: string[];
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /** 각 쇼핑몰의 상태값에 판매중과 판매중지가 혼합되어 있는지 여부 */
      isPlatformStatusOnSaleAndStopSale?: boolean;
      /** 상품 코드 */
      itemAlias?: string;
      /**
       * 상품 코드 목록
       * @example ["12738273"]
       */
      itemAliases?: string[];
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      /** 플랫폼의 상품 ID */
      platformProductID?: string[];
      /** 판매 상태 (메타데이터 sale, platform-status 참조) */
      platformStatus?: string[];
      /** 플랫폼 타입 (메타데이터 shop, platform-type 참조) */
      platformType?: string;
      /** 상품 ID 목록 (리스트를 허용합니다.) */
      saleItemID?: string[];
      /** 진행 상태를 조회하고자 할 때 사용 (진행 중, 실패, 대기) (메타데이터 sale, operation 참고) */
      saleOperation?: string;
      /** 판매 상태 (메타데이터 sale, status 참조) */
      saleStatus?: string[];
      /** 기간 필터 타입 (createDate: 아이템 생성일, modifyDate: 아이템 수정일, postDate: 상품 등록일) */
      searchPeriodType?: 'createDate' | 'modifyDate' | 'postDate';
      /**
       * 정렬방법 (asc: 오름차순 , desc: 내림차순)
       * @example "asc"
       */
      sort?: 'asc' | 'desc';
      /** 정렬타입 (postDate: 등록일, price: 가격) */
      sortType?: 'postDate' | 'price';
      /** 공급사 (contains 검색) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
      supplierName?: string;
      /** 공급사 목록 (exact match) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
      supplierNames?: string[];
      /** 상품명 */
      title?: string;
      /**
       * 상품명 목록
       * @example ["테스트 상품"]
       */
      titles?: string[];
      /**
       * 필터 종료 기간 (타임존 포함)
       * @example "2023-04-14T23:59:59.999+09:00"
       */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * API 버전
       * @default "legacy"
       */
      'api-version'?: string;
    };
    export type ResponseBody = DomainListShopSaleItemsResponse;
  }

  /**
   * @description 샵의 판매관리 대상 아이템들을 엑셀로 변환하는 API (번개장터, 플레이오토 업로드 용)
   * @tags Sales
   * @name SaleItemsExportExcelCreate
   * @summary 샵의 판매관리 대상 아이템들을 엑셀 파일로 다운로드 ✅
   * @request POST:/shops/{shopID}/sale-items/export-excel
   * @secure
   * @response `200` `DomainExportExcelShopSaleItemsResponse` 엑셀 파일 생성 응답 값
   */
  export namespace SaleItemsExportExcelCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainExportExcelShopSaleItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExportExcelShopSaleItemsResponse;
  }

  /**
   * @description 샵의 판매관리 대상 아이템들의 이미지를 다운로드하는 API
   * @tags Sales
   * @name SaleItemsExportImagesCreate
   * @summary 샵의 판매관리 대상 아이템들의 이미지를 다운로드 ✅
   * @request POST:/shops/{shopID}/sale-items/export-images
   * @secure
   * @response `200` `DomainExportShopSaleItemsImagesResponse` 이미지 파일 생성 응답 값
   */
  export namespace SaleItemsExportImagesCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainExportShopSaleItemsImagesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExportShopSaleItemsImagesResponse;
  }

  /**
   * @description 샵의 판매관리 대상 아이템의 ID 리스트를 조회하는 API
   * @tags Sales
   * @name SaleItemsIdDetail
   * @summary 샵의 판매관리 대상 아이템 ID 리스트 조회 ✅
   * @request GET:/shops/{shopID}/sale-items/id
   * @secure
   * @response `200` `DomainListShopSaleItemIDsResponse` OK
   */
  export namespace SaleItemsIdDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * AIMS 카테고리 ID 목록
       * @example ["SWEATERS"]
       */
      aimsCategory?: string[];
      /**
       * 필터 시작 기간 (타임존 포함)
       * @example "2023-04-08T00:00:00.000+09:00"
       */
      from?: string;
      /** 각 쇼핑몰의 상태값에 판매중과 판매중지가 혼합되어 있는지 여부 */
      isPlatformStatusOnSaleAndStopSale?: boolean;
      /** 상품 코드 */
      itemAlias?: string;
      /**
       * 상품 코드 목록
       * @example ["12738273"]
       */
      itemAliases?: string[];
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      /** 플랫폼의 상품 ID */
      platformProductID?: string[];
      /** 판매 상태 (메타데이터 sale, platform-status 참조) */
      platformStatus?: string[];
      /** 플랫폼 타입 (메타데이터 shop, platform-type 참조) */
      platformType?: string;
      /** 상품 ID 목록 (리스트를 허용합니다.) */
      saleItemID?: string[];
      /** 진행 상태를 조회하고자 할 때 사용 (진행 중, 실패, 대기) (메타데이터 sale, operation 참고) */
      saleOperation?: string;
      /** 판매 상태 (메타데이터 sale, status 참조) */
      saleStatus?: string[];
      /** 기간 필터 타입 (createDate: 아이템 생성일, modifyDate: 아이템 수정일, postDate: 상품 등록일) */
      searchPeriodType?: 'createDate' | 'modifyDate' | 'postDate';
      /**
       * 정렬방법 (asc: 오름차순 , desc: 내림차순)
       * @example "asc"
       */
      sort?: 'asc' | 'desc';
      /** 정렬타입 (postDate: 등록일, price: 가격) */
      sortType?: 'postDate' | 'price';
      /** 공급사 (contains 검색) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
      supplierName?: string;
      /** 공급사 목록 (exact match) - supplierName, supplierNames 둘 중 하나만 사용 가능합니다. */
      supplierNames?: string[];
      /** 상품명 */
      title?: string;
      /**
       * 상품명 목록
       * @example ["테스트 상품"]
       */
      titles?: string[];
      /**
       * 필터 종료 기간 (타임존 포함)
       * @example "2023-04-14T23:59:59.999+09:00"
       */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * API 버전
       * @default "legacy"
       */
      'api-version'?: string;
    };
    export type ResponseBody = DomainListShopSaleItemIDsResponse;
  }

  /**
   * @description 판매 아이템의 인스타그램 URL을 조회합니다. 해당 API는 판매중지, 판매중, 수정대기 상태에서만 호출이 가능합니다.
   * @tags Sales
   * @name SaleItemsInstagramUrlDetail
   * @summary 판매 아이템 인스타그램 URL 조회 API ✅
   * @request GET:/shops/{shopID}/sale-items/{saleItemID}/instagram-url
   * @secure
   * @response `200` `DomainGetSaleItemInstagramURLResponse` OK
   */
  export namespace SaleItemsInstagramUrlDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetSaleItemInstagramURLResponse;
  }

  /**
   * @description 판매 아이템의 각 플랫폼 별 정보를 수정합니다.
   * @tags Sales
   * @name SaleItemsModifyCreate
   * @summary 판매 아이템 수정 API ✅
   * @request POST:/shops/{shopID}/sale-items/{saleItemID}/modify
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleItemsModifyCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainModifySaleItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 판매 아이템의 각 플랫폼 별 카테고리를 수정합니다. 카페24는 다건을 수정할 수 있고 네이버와 Acloset은 단건만 가능합니다.
   * @tags Sales
   * @name SaleItemsModifyPlatformCategoriesCreate
   * @summary 판매 아이템 플랫폼 카테고리 수정 API ✅
   * @request POST:/shops/{shopID}/sale-items/{saleItemID}/modify-platform-categories
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleItemsModifyPlatformCategoriesCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainModifySaleItemPlatformCategoriesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 수정대기 아이템의 수정사유 목록을 조회합니다.
   * @tags Sales
   * @name SaleItemsPlatformPendingModifyingReasonsDetail
   * @summary 수정대기 아이템 수정사유 목록 조회 API ✅
   * @request GET:/shops/{shopID}/sale-items/{saleItemID}/platform-pending-modifying-reasons
   * @secure
   * @response `200` `DomainListSaleItemPlatformPendingModifyingReasonsResponse` OK
   */
  export namespace SaleItemsPlatformPendingModifyingReasonsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleItemId: string;
    };
    export type RequestQuery = {
      /** 플랫폼 타입 (shop, platform-type 메타데이터 참조) (리스트 가능) (비어 있을 시 전체 조회) */
      platformType?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListSaleItemPlatformPendingModifyingReasonsResponse;
  }

  /**
   * @description 수정대기 상태의 아이템을 판매중으로 복원요청합니다. 해당 API는 수정대기 상태에서만 호출이 가능하고 현재는 네이버에서만 수정대기 상태가 존재합니다.
   * @tags Sales
   * @name SaleItemsRestorePendingModifyingCreate
   * @summary 수정대기 아이템 복원 API ✅
   * @request POST:/shops/{shopID}/sale-items/{saleItemID}/restore-pending-modifying
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleItemsRestorePendingModifyingCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 판매관리 태스크 진행사항 요약 리스트를 조회하는 API
   * @tags Sales
   * @name SaleTaskSummariesDetail
   * @summary 샵의 판매관리 태스크 진행사항 요약 리스트 조회 ✅
   * @request GET:/shops/{shopID}/sale-task-summaries
   * @secure
   * @response `200` `DomainListShopSaleTaskSummariesResponse` OK
   */
  export namespace SaleTaskSummariesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopSaleTaskSummariesResponse;
  }

  /**
   * @description 판매관리 작업 목록을 조회합니다.
   * @tags Sales
   * @name SaleTasksDetail
   * @summary 판매관리 작업 목록 조회 API ✅
   * @request GET:/shops/{shopID}/sale-tasks
   * @secure
   * @response `200` `DomainListSaleTasksResponse` OK
   */
  export namespace SaleTasksDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListSaleTasksResponse;
  }

  /**
   * @description 판매관리 작업을 단건 조회합니다.
   * @tags Sales
   * @name SaleTasksDetail2
   * @summary 판매관리 작업 단건 조회 API ✅
   * @request GET:/shops/{shopID}/sale-tasks/{saleTaskID}
   * @originalName saleTasksDetail
   * @duplicate
   * @secure
   * @response `200` `DomainSaleTaskResponse` OK
   */
  export namespace SaleTasksDetail2 {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매관리 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainSaleTaskResponse;
  }

  /**
   * @description 판매관리 내 아이템과 관련된 작업을 강제 후처리합니다. 해당 API는 개발용 API이며, 서비스에서 사용하는 것을 금합니다.
   * @tags Sales
   * @name SaleTasksForcePostProcessItemsCreate
   * @summary 판매관리 아이템 강제 후처리 API ⚙️[자동 처리 형식으로 변경됨에 따라 제거 예정]
   * @request POST:/shops/{shopID}/sale-tasks/{saleTaskID}/force-post-process-items
   * @deprecated
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleTasksForcePostProcessItemsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매관리 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 해당 API는 개발용 API로 서비스에서의 사용을 금합니다. 샵의 주문 후처리를 강제로 실행합니다. 해당 API는 주문 후처리가 실패한 경우에만 사용합니다.
   * @tags Orders
   * @name SaleTasksForcePostProcessOrdersCreate
   * @summary 샵 주문 후처리 강제 실행 ⚙️
   * @request POST:/shops/{shopID}/sale-tasks/{saleTaskID}/force-post-process-orders
   * @deprecated
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleTasksForcePostProcessOrdersCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매관리 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 비동기로 수행된 판매관리 작업에 대해서 재시도를 요청합니다.
   * @tags Sales
   * @name SaleTasksRetryCreate
   * @summary 판매관리 실패작업 재시도 ✅
   * @request POST:/shops/{shopID}/sale-tasks/{saleTaskID}/retry
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SaleTasksRetryCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매관리 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 판매관리 작업 상세 목록을 조회합니다.
   * @tags Sales
   * @name SaleTasksSaleTaskDetailsDetail
   * @summary 판매관리 작업 상세 목록 조회 API ✅
   * @request GET:/shops/{shopID}/sale-tasks/{saleTaskID}/sale-task-details
   * @secure
   * @response `200` `DomainListSaleTaskDetailsResponse` OK
   */
  export namespace SaleTasksSaleTaskDetailsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 판매관리 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      saleTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListSaleTaskDetailsResponse;
  }

  /**
   * @description 세컨솔드 카테고리 매핑 규칙 조회
   * @tags MappingGroups
   * @name SecondsoldCategoryRulesDetail
   * @summary 세컨솔드 카테고리 매핑 규칙 조회 ✅
   * @request GET:/shops/{shopID}/secondsold-category-rules
   * @secure
   * @response `200` `DomainListSecondSoldCategoryMappingRulesResponse` OK
   */
  export namespace SecondsoldCategoryRulesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListSecondSoldCategoryMappingRulesResponse;
  }

  /**
   * @description 내 서비스 가격을 조회합니다.
   * @tags Settlements
   * @name ServicePricingsDetail
   * @summary 내 서비스 가격을 조회합니다. ✅
   * @request GET:/shops/{shopID}/service-pricings
   * @secure
   * @response `200` `DomainGetMyServicePricingsResponse` OK
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
   */
  export namespace ServicePricingsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMyServicePricingsResponse;
  }

  /**
   * @description 정산을 시도합니다. 서비스 수정 기능도 포함합니다. 서비스 수정 시에 정산 데이터가 없다면 바로 수정되고, 있다면 정산을 시도한 후 수정됩니다.
   * @tags Settlements
   * @name ServicePricingsUpdate
   * @summary 수동 정산 및 서비스 변경 API ✅
   * @request PUT:/shops/{shopID}/service-pricings
   * @secure
   * @response `204` `void` No Content
   * @response `402` `void` 결제 실패한 경우 Code: PAYMENT_FAILED
   * @response `404` `void` 카드가 존재하지 않는 경우 Code: CARD_NOT_FOUND
   * @response `409` `void` 서비스 변경한지 1주일이 지나지 않은 경우 Code: PLAN_LAST_CHANGED_ONE_WEEK_NOT_PASSED
   */
  export namespace ServicePricingsUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateServicePricingWithSettlementRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Settlements
   * @name SettlementsDetail
   * @summary 정산내역을 리스트로 조회합니다. ✅
   * @request GET:/shops/{shopID}/settlements
   * @secure
   * @response `200` `DomainListSettlementsResponse` OK
   */
  export namespace SettlementsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /** 정산 월 (예: 202303) */
      month?: string;
      /**
       * 조회할 페이지 번호
       * @min 0
       * @example 1
       */
      pageNumber?: number;
      /**
       * 페이지 당 크기
       * @min 0
       * @example 10
       */
      pageSize?: number;
      /** 결제내역 ID */
      paymentDetailID?: string;
      /** 정산 ID */
      settlementID?: string;
      /**
       * 정렬방법 (asc: 오름차순 , desc: 내림차순)
       * @example "asc"
       */
      sort?: 'asc' | 'desc';
      /** 정렬타입 (createDate: 생성일시) */
      sortType?: 'createDate';
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListSettlementsResponse;
  }

  /**
   * @description 카페24 정산 데이터를 엑셀로 변환하는 API
   * @tags Settlements
   * @name SettlementsExportCafe24ExcelCreate
   * @summary 카페24 정산 데이터를 엑셀 파일로 다운로드 ✅
   * @request POST:/shops/{shopID}/settlements/export-cafe24-excel
   * @secure
   * @response `200` `DomainExportExcelSettlementsResponse` 엑셀 파일 생성 응답 값
   */
  export namespace SettlementsExportCafe24ExcelCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainExportExcelSettlementsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExportExcelSettlementsResponse;
  }

  /**
   * @description 카페24 정산 데이터를 엑셀로 변환하는 API
   * @tags Settlements
   * @name SettlementsExportExcelCreate
   * @summary 카페24 정산 데이터를 엑셀 파일로 다운로드 ✅
   * @request POST:/shops/{shopID}/settlements/export-excel
   * @deprecated
   * @secure
   * @response `200` `DomainExportExcelSettlementsResponse` 엑셀 파일 생성 응답 값
   */
  export namespace SettlementsExportExcelCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainExportExcelSettlementsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExportExcelSettlementsResponse;
  }

  /**
   * @description 웹에서 샵의 로그인 여부를 확인하는 API
   * @tags Platforms
   * @name ShopAuthExistsDetail
   * @summary 샵의 OAuth 로그인 여부 확인 ✅
   * @request GET:/shops/{shopID}/shop-auth-exists
   * @secure
   * @response `200` `DomainExistsShopAuthResponse` 샵의 OAuth 로그인 여부
   */
  export namespace ShopAuthExistsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /** 인증 제공자 */
      platformType: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExistsShopAuthResponse;
  }

  /**
   * @description 샵 사이즈 매핑 그룹 리스트를 조회하는 API 사장님이 사용중인 매핑그룹에 해당하는 사이즈 매핑 그룹 리스트를 반환합니다.
   * @tags MappingGroups
   * @name SizeMappingGroupsDetail
   * @summary 샵 사이즈 매핑 그룹 리스트 조회 ✅
   * @request GET:/shops/{shopID}/size-mapping-groups
   * @secure
   * @response `200` `DomainListSizeMappingGroupsResponse` OK
   */
  export namespace SizeMappingGroupsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListSizeMappingGroupsResponse;
  }

  /**
   * @description 샵 사이즈 매핑 그룹을 수정하는 API ## Validation - 보낸 `rules` 리스트의 `under`값이 오름차순으로 정렬되지 않은 경우 오류를 반환합니다. - Request 명세에 명시한 속성 중 메타데이터 AIMS Category 중 실제 존재하지 않는 메타데이터나, 카테고리가 포함된 경우 오류를 반환합니다.
   * @tags MappingGroups
   * @name SizeMappingGroupsUpdate
   * @summary 샵 사이즈 매핑 그룹 전체 수정 ✅
   * @request PUT:/shops/{shopID}/size-mapping-groups/{sizeMappingGroupID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace SizeMappingGroupsUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 수정할 샵 사이즈 매핑 그룹 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      sizeMappingGroupId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateSizeMappingGroupRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 웹에서 샵의 고정값 정보를 부분 수정하는 API
   * @tags Shops
   * @name StaticsUpdate
   * @summary 샵 고정값 수정 ✅️
   * @request PUT:/shops/{shopID}/statics
   * @secure
   * @response `204` `void` No Content
   */
  export namespace StaticsUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopStaticRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 각 플랫폼에 아이템들을 판매중지합니다. 해당 API는 판매중 상태에서만 호출할 수 있습니다.
   * @tags Sales
   * @name StopSaleItemsCreate
   * @summary 판매 중지 API ✅
   * @request POST:/shops/{shopID}/stop-sale-items
   * @secure
   * @response `202` `DomainStopSaleItemsResponse` Accepted
   */
  export namespace StopSaleItemsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainStopSaleItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainStopSaleItemsResponse;
  }

  /**
   * @description 샵의 작업 목록을 조회하는 API 입니다.
   * @tags Tasks
   * @name TasksDetail
   * @summary 샵의 작업 목록 조회 ✅
   * @request GET:/shops/{shopID}/tasks
   * @secure
   * @response `200` `DomainListShopTasksResponse` 샵의 작업 목록 응답 값
   */
  export namespace TasksDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {
      /**
       * 조회할 페이지 번호
       * @min 1
       * @example 1
       */
      pageNumber: number;
      /**
       * 페이지 당 크기
       * @min 1
       * @example 10
       */
      pageSize: number;
      /**
       * 작업 상태
       * @example ["SHOP_TASK-STATUS_DONE"]
       */
      status?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopTasksResponse;
  }

  /**
   * @description 샵의 작업을 생성하는 API 입니다.
   * @tags Tasks
   * @name TasksCreate
   * @summary 샵의 작업 생성 ✅
   * @request POST:/shops/{shopID}/tasks
   * @secure
   * @response `200` `DomainCreateShopTaskResponse` 샵의 작업 목록 응답 값
   */
  export namespace TasksCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopTaskRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateShopTaskResponse;
  }

  /**
   * @description 해당하는 샵의 태스크를 단건 조회하는 API
   * @tags Tasks
   * @name TasksDetail2
   * @summary 샵의 태스크를 조회 (단건) ✅
   * @request GET:/shops/{shopID}/tasks/{shopTaskID}
   * @originalName tasksDetail
   * @duplicate
   * @secure
   * @response `200` `DomainGetShopTaskResponse` 샵 목록 응답 값
   */
  export namespace TasksDetail2 {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
    };
    export type RequestQuery = {
      /**
       * 삭제된 작업 포함 여부
       * @example false
       */
      isDelete?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetShopTaskResponse;
  }

  /**
   * @description 샵의 작업을 부분 수정하는 API 입니다
   * @tags Tasks
   * @name TasksPartialUpdate
   * @summary 샵의 작업 부분 수정 (단건) ✅
   * @request PATCH:/shops/{shopID}/tasks/{shopTaskID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksPartialUpdate {
    export type RequestParams = {
      /**
       * 수정할 작업이 속한 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 수정할 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopTaskRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 상품코드 일괄 변경하는 API 입니다
   * @tags Tasks
   * @name TasksItemCodesCreate
   * @summary 상품코드 일괄 변경
   * @request POST:/shops/{shopID}/tasks/{shopTaskID}/item-codes
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksItemCodesCreate {
    export type RequestParams = {
      /**
       * 상품코드 일괄 변경할 작업이 속한 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 상품코드 일괄 변경할 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopTaskItemCodesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 작업의 아이템 목록을 조회하는 API 입니다.
   * @tags Tasks
   * @name TasksItemsDetail
   * @summary 샵의 작업의 아이템 목록 조회 ✅
   * @request GET:/shops/{shopID}/tasks/{shopTaskID}/items
   * @secure
   * @response `200` `DomainListShopTaskItemsResponse` 샵의 작업의 아이템 목록 응답 값
   */
  export namespace TasksItemsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
    };
    export type RequestQuery = {
      /**
       * 추가로 조회할 필드 요청
       * @example ["aclosetProperty"]
       */
      projectionFields?: string[];
      /**
       * 작업 아이템 ID
       * @example ["63eb6df3f45b6fc2c1045aff"]
       */
      shopTaskItemID?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopTaskItemsResponse;
  }

  /**
   * @description 샵의 작업의 아이템 목록을 삭제하는 API 입니다.
   * @tags Tasks
   * @name TasksItemsDelete
   * @summary 샵의 작업의 아이템 목록 삭제 ✅
   * @request DELETE:/shops/{shopID}/tasks/{shopTaskID}/items
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksItemsDelete {
    export type RequestParams = {
      /**
       * 삭제할 아이템이 속한 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 삭제할 아이템이 속한 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainDeleteShopTaskItemsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 상품 AI 설명을 생성하는 비동기 API입니다. 완료 여부와 무관하게 응답을 반환합니다.
   * @tags Tasks
   * @name TasksItemsGenerateAiDescriptionsCreate
   * @summary 상품 AI 설명 생성 ✅
   * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/generate-ai-descriptions
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksItemsGenerateAiDescriptionsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainGenerateShopTaskItemAIDescriptionsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 작업의 아이템의 전체 명세를 수정하는 API 입니다. (null 입력 시 SET NULL)
   * @tags Tasks
   * @name TasksItemsPartialUpdate
   * @summary 샵의 작업의 아이템 수정 ✅
   * @request PATCH:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksItemsPartialUpdate {
    export type RequestParams = {
      /**
       * 수정할 아이템이 속한 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 수정할 아이템이 속한 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
      /**
       * 수정할 아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopTaskItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 작업을 간편 분석하는 비동기 API 입니다. 완료 여부와 무관하게 응답이 반환됩니다.
   * @tags Tasks
   * @name TasksItemsAnalyzeItemCreate
   * @summary 샵 작업 간편 분석 ✅
   * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/analyze-item
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksItemsAnalyzeItemCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
      /**
       * 작업 아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainAnalyzeShopTaskItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 아이템 당 상품명 자동 기입하는 API 입니다.
   * @tags Tasks
   * @name TasksItemsGenerateTitleCreate
   * @summary 샵의 아이템 당 상품명 자동 기입 ✅
   * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/generate-title
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksItemsGenerateTitleCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
      /**
       * 샵 작업 아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainGenerateShopTaskItemTitleRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 작업의 아이템의 이미지를 수정하는 API 입니다. (최소 1개의 이미지 변경 필요)
   * @tags Tasks
   * @name TasksItemsImagesUpdate
   * @summary 샵의 작업의 아이템 이미지 수정 ✅
   * @request PUT:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/images
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksItemsImagesUpdate {
    export type RequestParams = {
      /**
       * 수정할 아이템이 속한 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 수정할 아이템이 속한 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
      /**
       * 수정할 아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopTaskItemImagesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 특정 아이템을 편집 후 수정하는 API 입니다.
   * @tags Tasks
   * @name TasksItemsImagesModifyImageCreate
   * @summary 아이템 이미지 편집 후 수정 ✅️
   * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/images/{imageID}/modify-image
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksItemsImagesModifyImageCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
      /**
       * 샵 작업 아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskItemId: string;
      /**
       * 이미지 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      itemId: string;
      imageId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainModifyShopTaskItemImageRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 특정 아이템 이미지를 다른 이미지로 대체
   * @tags Tasks
   * @name TasksItemsImagesReplaceImageCreate
   * @summary 아이템 이미지 대체 ✅️
   * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/images/{imageID}/replace-image
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksItemsImagesReplaceImageCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
      /**
       * 샵 작업 아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskItemId: string;
      /**
       * 이미지 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      itemId: string;
      imageId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainReplaceShopTaskItemImageRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 특정 아이템 이미지를 받아서 다른아이템으로 분리 및 생성
   * @tags Tasks
   * @name TasksItemsSplitCreate
   * @summary 아이템 분리 ✅️
   * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/split
   * @secure
   * @response `200` `DomainSplitShopTaskItemResponse` OK
   */
  export namespace TasksItemsSplitCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
      /**
       * 샵 작업 아이템 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainSplitShopTaskItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainSplitShopTaskItemResponse;
  }

  /**
   * @description 샵 아이템을 판매 대기로 등록하는 비동기 API 입니다.
   * @tags Tasks
   * @name TasksPostItemsCreate
   * @summary 샵 아이템 상품 등록 (작업 단위) ✅
   * @request POST:/shops/{shopID}/tasks/{shopTaskID}/post-items
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksPostItemsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 작업을 삭제하는 API 입니다.
   * @tags Tasks
   * @name TasksDelete
   * @summary 샵의 작업 삭제 ✅
   * @request DELETE:/shops/{shopID}/tasks/{taskID}
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TasksDelete {
    export type RequestParams = {
      /**
       * 삭제할 작업이 속한 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 삭제할 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      taskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 작업의 아이템을 생성하는 API 입니다.
   * @tags Tasks
   * @name TasksItemCreate
   * @summary 샵의 작업의 아이템 생성 ✅
   * @request POST:/shops/{shopID}/tasks/{taskID}/item
   * @secure
   * @response `200` `DomainCreateShopTaskItemResponse` 샵 작업 아이템 생성 응답 값
   */
  export namespace TasksItemCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 샵 작업 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopTaskId: string;
      taskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopTaskItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateShopTaskItemResponse;
  }

  /**
   * @description 판매 아이템 자세한 설명을 해주는 HTML template을 조회하는 API입니다.
   * @tags Shops
   * @name TemplatesDetail
   * @summary 샵 판매 아이템 설명 HTML Template 조회 API ✅
   * @request GET:/shops/{shopID}/templates
   * @secure
   * @response `200` `DomainListShopHTMLTemplatesResponse` OK
   */
  export namespace TemplatesDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListShopHTMLTemplatesResponse;
  }

  /**
   * @description 판매 아이템 자세한 설명을 해주는 HTML template을 저장하는 API입니다.
   * @tags Shops
   * @name TemplatesCreate
   * @summary 샵 판매 아이템 설명 HTML 템플릿을 생성하는 API ✅
   * @request POST:/shops/{shopID}/templates
   * @secure
   * @response `204` `void` No Content
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
   */
  export namespace TemplatesCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateShopHTMLTemplateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 판매 아이템 자세한 설명을 해주는 HTML template을 업데이트하는 API입니다.
   * @tags Shops
   * @name TemplatesUpdate
   * @summary 샵 판매 아이템 설명 HTML Template 업데이트 API ✅
   * @request PUT:/shops/{shopID}/templates/{templateID}
   * @secure
   * @response `204` `void` No Content
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
   */
  export namespace TemplatesUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 템플릿 ID
       * @example "4fg5b9b9b9b9b9b9b9b9b"
       */
      templateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateShopHTMLTemplateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 판매 아이템 자세한 설명을 해주는 HTML template을 삭제하는 API입니다.
   * @tags Shops
   * @name TemplatesDelete
   * @summary 샵 판매 아이템 설명 HTML Template 삭제 API ✅
   * @request DELETE:/shops/{shopID}/templates/{templateID}
   * @secure
   * @response `204` `void` No Content
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
   */
  export namespace TemplatesDelete {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 템플릿 ID
       * @example "4fg5b9b9b9b9b9b9b9b9b"
       */
      templateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 HTML template을 부분 수정하는 API입니다.
   * @tags Shops
   * @name TemplatesPartialUpdate
   * @summary 샵 HTML Template 부분 수정 API ✅
   * @request PATCH:/shops/{shopID}/templates/{templateID}
   * @secure
   * @response `204` `void` No Content
   * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
   */
  export namespace TemplatesPartialUpdate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
      /**
       * 템플릿 ID
       * @example "4fg5b9b9b9b9b9b9b9b9b"
       */
      templateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchShopHTMLTemplateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵의 주문을 배송준비중으로 변경합니다. 해당 API는 배송준비중으로 변경되는 주문의 상태가 배송중이 아닌 경우에만 사용합니다. ## Validation |HTTP Status|Code|Description| |---|---|---| |400||샵 ID가 없음| |400||주문 ID가 없음| |409|ORDER_NOT_OPERATE|주문 상태가 배송중이 아님| |404|SHOP_NOT_FOUND|샵이 존재하지 않음| |404|ORDER_NOT_FOUND|주문이 존재하지 않음| |404|SHOP_AUTH_NOT_FOUND|샵 인증 정보가 존재하지 않음| |409|PLATFORM_ORDER_NOT_SAME|같은 플랫폼 주문 ID를 가진 주문이 아닌 요청의 경우|
   * @tags Orders
   * @name UndoShippingInProgressOrdersCreate
   * @summary 샵 주문 배송준비중으로 변경 ✅
   * @request POST:/shops/{shopID}/undo-shipping-in-progress-orders
   * @secure
   * @response `204` `void` No Content
   */
  export namespace UndoShippingInProgressOrdersCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUndoShippingInProgressOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 브랜드를 사전에 정의된 엑셀 포맷으로 데이터를 업로드 합니다.
   * @tags Brands
   * @name UploadBrandsCreate
   * @summary 브랜드 엑셀파일 업로드 ✅
   * @request POST:/shops/{shopID}/upload-brands
   * @secure
   * @response `204` `void` No Content
   */
  export namespace UploadBrandsCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UploadBrandsCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 샵 관련 파일을 업로드하는 API
   * @tags Shops
   * @name UploadFileCreate2
   * @summary 샵 관련 파일 업로드 ✅
   * @request POST:/shops/{shopID}/upload-file
   * @originalName uploadFileCreate
   * @duplicate
   * @secure
   * @response `200` `DomainUploadShopFileResponse` OK
   */
  export namespace UploadFileCreate2 {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UploadFileCreate2Payload;
    export type RequestHeaders = {};
    export type ResponseBody = DomainUploadShopFileResponse;
  }

  /**
   * @description 네이버 이미지를 업로드하는 API
   * @tags Platforms
   * @name UploadNaverImagesCreate
   * @summary 네이버 이미지 업로드 ✅
   * @request POST:/shops/{shopID}/upload-naver-images
   * @secure
   * @response `200` `DomainUploadNaverImagesResponse` OK
   */
  export namespace UploadNaverImagesCreate {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UploadNaverImagesCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = DomainUploadNaverImagesResponse;
  }

  /**
   * @description 진행중인 샵 작업이 존재하는지 확인하는 API 입니다.
   * @tags Tasks
   * @name UploadingTaskExistsDetail
   * @summary 진행중인 샵 작업 존재 여부 확인 ✅
   * @request GET:/shops/{shopID}/uploading-task-exists
   * @secure
   * @response `200` `DomainExistsUploadingShopTaskResponse` OK
   */
  export namespace UploadingTaskExistsDetail {
    export type RequestParams = {
      /**
       * 샵 ID
       * @example "5f9f1b5b9b9b9b9b9b9b9b9b"
       */
      shopId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExistsUploadingShopTaskResponse;
  }
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),

        // NOTE: FormData 타입 수정(https://github.com/acacode/swagger-typescript-api/issues/671)
        ...{ 'Content-Type': type },
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title No title
 * @contact
 */
export class SwaggerApi<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  shops = {
    /**
     * @description 샵 목록을 조회하는 API 입니다.
     *
     * @tags Shops
     * @name ShopsList
     * @summary 샵 목록 조회 ✅
     * @request GET:/shops
     * @secure
     * @response `200` `DomainListShopsResponse` 샵 목록 응답 값
     */
    shopsList: (query: ShopsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopsResponse, any>({
        path: `/shops`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵을 생성하는 API 입니다. 백엔드가 직접 사용하기 때문에 OwnerID 는 Body 에 넣습니다.
     *
     * @tags Shops
     * @name ShopsCreate
     * @summary 샵 생성 ✅
     * @request POST:/shops
     * @secure
     * @response `200` `DomainCreateShopResponse` 샵 생성 응답 값
     */
    shopsCreate: (body: DomainCreateShopRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreateShopResponse, any>({
        path: `/shops`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 가격 제안 거절 사유 목록을 조회하는 API
     *
     * @tags Platforms
     * @name AclosetRejectPriceOfferReasonsList
     * @summary 가격 제안 거절 사유 목록 조회 ✅
     * @request GET:/shops/acloset-reject-price-offer-reasons
     * @secure
     * @response `200` `DomainListAclosetRejectPriceOfferReasonsResponse` OK
     */
    aclosetRejectPriceOfferReasonsList: (params: RequestParams = {}) =>
      this.http.request<DomainListAclosetRejectPriceOfferReasonsResponse, any>({
        path: `/shops/acloset-reject-price-offer-reasons`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 강제 업데이트 기준 앱 버젼 조회 API입니다.
     *
     * @tags Shops
     * @name AppVersionList
     * @summary 강제 업데이트 기준 앱 버젼 조회 ✅
     * @request GET:/shops/app-version
     * @secure
     * @response `200` `DomainGetAppVersionResponse` OK
     */
    appVersionList: (params: RequestParams = {}) =>
      this.http.request<DomainGetAppVersionResponse, any>({
        path: `/shops/app-version`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 크롤링을 통해 번개장터 상품을 불러옵니다.
     *
     * @tags Bunjang
     * @name BunjangLoadBunjangProductsCreate
     * @summary 번개장터 상품 불러오기 ✅
     * @request POST:/shops/bunjang/load-bunjang-products
     * @secure
     * @response `204` `void` No Content
     */
    bunjangLoadBunjangProductsCreate: (request: DomainLoadBunjangProductsRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/bunjang/load-bunjang-products`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 크롤링을 통해 번개장터 상품을 리셋합니다.
     *
     * @tags Bunjang
     * @name BunjangLoadBunjangProductsCancelCreate
     * @summary 번개장터 상품 리셋하기 ✅
     * @request POST:/shops/bunjang/load-bunjang-products/cancel
     * @secure
     * @response `204` `void` No Content
     */
    bunjangLoadBunjangProductsCancelCreate: (request: DomainCancelBunjangProductsRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/bunjang/load-bunjang-products/cancel`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 번개장터 샵 불러오기 작업을 다건 조회합니다.
     *
     * @tags Bunjang
     * @name BunjangShopLoadTasksList
     * @summary 번개장터 샵 불러오기 작업 다건 조회  ✅
     * @request GET:/shops/bunjang/shop-load-tasks
     * @secure
     * @response `200` `DomainListBunjangShopLoadTasksResponse` OK
     */
    bunjangShopLoadTasksList: (query: BunjangShopLoadTasksListParams, params: RequestParams = {}) =>
      this.http.request<DomainListBunjangShopLoadTasksResponse, any>({
        path: `/shops/bunjang/shop-load-tasks`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 크롤링을 통해 번개장터 샵을 불러옵니다. 비동기 API입니다. 관리자 계정만 사용이 가능합니다.
     *
     * @tags Bunjang
     * @name BunjangShopLoadTasksCreate
     * @summary 번개장터 샵 불러오기 ✅
     * @request POST:/shops/bunjang/shop-load-tasks
     * @secure
     * @response `204` `void` No Content
     */
    bunjangShopLoadTasksCreate: (request: DomainLoadBunjangShopLoadTaskRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/bunjang/shop-load-tasks`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 크롤링을 통힌 번개장터 샵 불러오기를 중단합니다.
     *
     * @tags Bunjang
     * @name BunjangShopLoadTasksPauseCreate
     * @summary 번개장터 샵 불러오기 중단 ✅
     * @request POST:/shops/bunjang/shop-load-tasks/pause
     * @secure
     * @response `204` `void` No Content
     */
    bunjangShopLoadTasksPauseCreate: (request: DomainPauseBunjangShopLoadTaskRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/bunjang/shop-load-tasks/pause`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 크롤링을 통해 번개장터 샵을 다시 불러옵니다.
     *
     * @tags Bunjang
     * @name BunjangShopLoadTasksResumeCreate
     * @summary 번개장터 샵 다시 불러오기 ✅
     * @request POST:/shops/bunjang/shop-load-tasks/resume
     * @secure
     * @response `204` `void` No Content
     */
    bunjangShopLoadTasksResumeCreate: (request: DomainResumeBunjangShopLoadTaskRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/bunjang/shop-load-tasks/resume`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 번개장터 샵을 다건 조회합니다.
     *
     * @tags Bunjang
     * @name BunjangShopsList
     * @summary 번개장터 샵 다건 조회  ✅
     * @request GET:/shops/bunjang/shops
     * @secure
     * @response `200` `DomainListBunjangShopsResponse` OK
     */
    bunjangShopsList: (query: BunjangShopsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListBunjangShopsResponse, any>({
        path: `/shops/bunjang/shops`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 기존 샵에 번개장터 샵을 생성합니다. 현재는 기존 샵에 불러오기 정보를 초기화하는 용도로 사용합니다.
     *
     * @tags Bunjang
     * @name BunjangShopsCreate
     * @summary 기존 샵에 번개장터 샵 생성 ✅
     * @request POST:/shops/bunjang/shops
     * @secure
     * @response `204` `void` No Content
     */
    bunjangShopsCreate: (request: DomainCreateBunjangShopRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/bunjang/shops`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 기존 샵에 번개장터 샵을 제거합니다. 불러오기 연동 해제입니다.
     *
     * @tags Bunjang
     * @name BunjangShopsDelete
     * @summary 번개장터 샵 제거 ✅
     * @request DELETE:/shops/bunjang/shops/{bunjangShopID}
     * @secure
     * @response `204` `void` No Content
     */
    bunjangShopsDelete: (bunjangShopId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/bunjang/shops/${bunjangShopId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 번개장터 샵을 수정합니다.
     *
     * @tags Bunjang
     * @name BunjangShopsPartialUpdate
     * @summary 번개장터 샵 수정 ✅
     * @request PATCH:/shops/bunjang/shops/{bunjangShopID}
     * @secure
     * @response `204` `void` No Content
     */
    bunjangShopsPartialUpdate: (
      bunjangShopId: string,
      request: DomainPatchBunjangShopRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/bunjang/shops/${bunjangShopId}`,
        method: 'PATCH',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 카페24 OAuth 토큰 정보 조회 API
     *
     * @tags Platforms
     * @name Cafe24AuthTokenCreate
     * @summary 카페24 OAuth 토큰 정보 조회✅
     * @request POST:/shops/cafe24-auth-token
     * @secure
     * @response `200` `DomainGetCafe24AuthTokenResponse` 카페24 OAuth 토큰 정보 반환값
     */
    cafe24AuthTokenCreate: (GetCafe24AuthTokenRequest: DomainGetCafe24AuthTokenRequest, params: RequestParams = {}) =>
      this.http.request<DomainGetCafe24AuthTokenResponse, any>({
        path: `/shops/cafe24-auth-token`,
        method: 'POST',
        body: GetCafe24AuthTokenRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Cafe24 상품 상태 목록을 조회하는 API
     *
     * @tags Platforms
     * @name Cafe24ProductConditionsList
     * @summary Cafe24 상품 상태 목록 조회 ✅
     * @request GET:/shops/cafe24-product-conditions
     * @secure
     * @response `200` `DomainListCafe24ProductConditionsResponse` OK
     */
    cafe24ProductConditionsList: (params: RequestParams = {}) =>
      this.http.request<DomainListCafe24ProductConditionsResponse, any>({
        path: `/shops/cafe24-product-conditions`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Cafe24에서 인증을 하였을 때 허용되는 API Scope 목록을 조회하는 API
     *
     * @tags Platforms
     * @name Cafe24ScopesList
     * @summary Cafe24 API Scope 조회 ✅
     * @request GET:/shops/cafe24-scopes
     * @secure
     * @response `200` `DomainListCafe24ScopesResponse` OK
     */
    cafe24ScopesList: (params: RequestParams = {}) =>
      this.http.request<DomainListCafe24ScopesResponse, any>({
        path: `/shops/cafe24-scopes`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 클레임 상태 FSM 시각화를 위한 API입니다.
     *
     * @tags Claims
     * @name ClaimStatusesFsmList
     * @summary 클레임 상태 FSM 시각화 ✅
     * @request GET:/shops/claim-statuses/fsm
     * @response `200` `void` OK
     */
    claimStatusesFsmList: (query: ClaimStatusesFsmListParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/claim-statuses/fsm`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsCreate
     * @summary 쿠폰을 생성합니다. ✅
     * @request POST:/shops/coupons
     * @secure
     * @response `200` `DomainCreateShopCouponsResponse` OK
     */
    couponsCreate: (CreateShopCouponsRequest: DomainCreateShopCouponsRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreateShopCouponsResponse, any>({
        path: `/shops/coupons`,
        method: 'POST',
        body: CreateShopCouponsRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 크레딧을 리스트로 조회합니다. 여러 샵의 크레딧을 조회할 수 있습니다.
     *
     * @tags Settlements
     * @name CreditsList
     * @summary 크레딧을 리스트로 조회합니다. (마스터용) ✅
     * @request GET:/shops/credits
     * @secure
     * @response `200` `DomainListShopCreditsForManagerResponse` OK
     */
    creditsList: (query: CreditsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopCreditsForManagerResponse, any>({
        path: `/shops/credits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵 크레딧을 생성합니다. 복수의 샵 크레딧을 생성할 수 있습니다. Amount는 양수여야 합니다. Type으로 크레딧 타입을 지정하여 지급할지 차감할지 결정할 수 있습니다.
     *
     * @tags Settlements
     * @name CreditsCreate
     * @summary 샵 크레딧을 생성합니다. ✅
     * @request POST:/shops/credits
     * @secure
     * @response `204` `void` No Content
     */
    creditsCreate: (CreateShopCreditsRequest: DomainCreateShopCreditsRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/credits`,
        method: 'POST',
        body: CreateShopCreditsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 셀러에 대한 데이터를 엑셀로 다운로드합니다.
     *
     * @tags Shops
     * @name ExportShopsCreate
     * @summary 샵 엑셀 다운로드 ✅
     * @request POST:/shops/export-shops
     * @secure
     * @response `200` `DomainExportExcelShopsResponse` OK
     */
    exportShopsCreate: (request: DomainExportExcelShopsRequest, params: RequestParams = {}) =>
      this.http.request<DomainExportExcelShopsResponse, any>({
        path: `/shops/export-shops`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 전역 상태 조회
     *
     * @tags App
     * @name GlobalStatesList
     * @summary 전역 상태 조회 ✅
     * @request GET:/shops/global-states
     * @secure
     * @response `200` `DomainListGlobalStatesResponse` OK
     */
    globalStatesList: (params: RequestParams = {}) =>
      this.http.request<DomainListGlobalStatesResponse, any>({
        path: `/shops/global-states`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Instagram에서 인증을 하였을 때 허용되는 API Scope 목록을 조회하는 API
     *
     * @tags Platforms
     * @name InstagramScopesList
     * @summary Instagram API Scope 조회 ✅
     * @request GET:/shops/instagram-scopes
     * @secure
     * @response `200` `DomainListInstagramScopesResponse` OK
     */
    instagramScopesList: (params: RequestParams = {}) =>
      this.http.request<DomainListInstagramScopesResponse, any>({
        path: `/shops/instagram-scopes`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 카카오페이 취소 사유 목록을 조회하는 API
     *
     * @tags Platforms
     * @name KakaopayCancelReasonsList
     * @summary 카카오페이 취소 사유 목록 조회 ✅
     * @request GET:/shops/kakaopay-cancel-reasons
     * @secure
     * @response `200` `DomainListKakaopayCancelReasonsResponse` OK
     */
    kakaopayCancelReasonsList: (params: RequestParams = {}) =>
      this.http.request<DomainListKakaopayCancelReasonsResponse, any>({
        path: `/shops/kakaopay-cancel-reasons`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 라벨링된 아이템에 대해 확인 완료 처리합니다. # Validation |HTTP Status|Code|Description| |:---:|:---:|---| |404|`SHOP_TASK_ITEM_NOT_FOUND`|수정할 아이템이 존재하지 않을 경우 에러를 반환합니다.| |400|`N/A`| `types`가 빈 경우 에러를 반환합니다.| |400|`N/A`| `types`에 중복된 타입으로 요청하는 경우 에러를 반환합니다.| |400|`N/A`|`items`가 빈 경우 에러를 반환합니다.| |400|`N/A`|`items`에 중복된 아이템 ID로 요청하는 경우 에러를 반환합니다.| |400|`CATEGORY_CODE_INVALID`|`items.category`가 유효하지 않은 값으로 수정 요청한 경우 에러를 반환합니다.| |400|`COLOR_CODE_INVALID`|`items.colors` 내 요소가 유효하지 않은 값을 포함한 경우 에러를 반환합니다.| |400|`GENDER_INVALID`|`items.gender`가 유효하지 않은 값을 포함한 경우 에러를 반환합니다.| |404|`BRAND_NOT_FOUND`|수정할 브랜드 ID에 해당하는 브랜드 정보를 샵에서 찾을 수 없을 경우 에러를 반환합니다.| |409|`SHOP_ITEM_NOT_MATCHED`|수정할 아이템이 요청한 샵에 속해있지 않을 경우 에러를 반환합니다.|
     *
     * @tags Labeling
     * @name LabelingConfirmCreate
     * @summary 라벨링 확인 완료 API ✅
     * @request POST:/shops/labeling/confirm
     * @secure
     * @response `204` `void` No Content
     */
    labelingConfirmCreate: (request: DomainConfirmLabelingRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/labeling/confirm`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 라벨링 대상 상품 목록을 조회합니다.
     *
     * @tags Labeling
     * @name LabelingItemsList
     * @summary 라벨링 대상 상품 목록 조회 API ✅
     * @request GET:/shops/labeling/items
     * @secure
     * @response `200` `DomainListLabelingItemsResponse` 성공
     */
    labelingItemsList: (query: LabelingItemsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListLabelingItemsResponse, any>({
        path: `/shops/labeling/items`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 점검 여부를 조회하는 API 입니다.
     *
     * @tags Shops
     * @name MaintenanceList
     * @summary 점검 여부 조회 API ✅️
     * @request GET:/shops/maintenance
     * @secure
     * @response `200` `DomainGetMaintenanceResponse` OK
     */
    maintenanceList: (params: RequestParams = {}) =>
      this.http.request<DomainGetMaintenanceResponse, any>({
        path: `/shops/maintenance`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 점검 여부를 수정하는 API 입니다. (마스터 계정만 접근 가능)
     *
     * @tags Shops
     * @name MaintenanceUpdate
     * @summary 점검 여부 수정 API ✅️
     * @request PUT:/shops/maintenance
     * @secure
     * @response `204` `void` No Content
     */
    maintenanceUpdate: (request: DomainUpdateMaintenanceRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/maintenance`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 매핑 속성 리스트를 조회하는 API
     *
     * @tags MappingGroups
     * @name MappingPropertiesList
     * @summary 샵 매핑 속성 리스트 조회 ✅
     * @request GET:/shops/mapping-properties
     * @secure
     * @response `200` `DomainListMappingPropertiesResponse` OK
     */
    mappingPropertiesList: (params: RequestParams = {}) =>
      this.http.request<DomainListMappingPropertiesResponse, any>({
        path: `/shops/mapping-properties`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Metadata 조회 https://github.com/looko-corp/aims-api/issues/126
     *
     * @tags Metadata
     * @name MetadataList
     * @summary 메타데이터 조회 ✅
     * @request GET:/shops/metadata
     * @response `200` `DomainListMetadataResponse` 메타데이터 응답값
     */
    metadataList: (query: MetadataListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMetadataResponse, any>({
        path: `/shops/metadata`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Metadata 맵 조회
     *
     * @tags Metadata
     * @name MetadataMapList
     * @summary 메타데이터 맵 조회 ✅
     * @request GET:/shops/metadata-map
     * @response `200` `DomainGetMetadataMapResponse` 메타데이터 맵 응답값
     */
    metadataMapList: (query: MetadataMapListParams, params: RequestParams = {}) =>
      this.http.request<DomainGetMetadataMapResponse, any>({
        path: `/shops/metadata-map`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵 카테고리 치수타입 맵핑 정보를 조회하는 API
     *
     * @tags Metadata
     * @name MetadataCategorySizeTypesList
     * @summary 샵 카테고리 치수타입 맵핑 정보 조회 ✅
     * @request GET:/shops/metadata/category-size-types
     * @secure
     * @response `200` `DomainListCategorySizeTypesResponse` OK
     */
    metadataCategorySizeTypesList: (params: RequestParams = {}) =>
      this.http.request<DomainListCategorySizeTypesResponse, any>({
        path: `/shops/metadata/category-size-types`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 선진국 국가 목록 조회 - 원산지 자동 입력 시 사용됩니다
     *
     * @tags Metadata
     * @name MetadataDevelopedCountriesList
     * @summary 선진국 국가 목록 조회
     * @request GET:/shops/metadata/developed-countries
     * @response `200` `DomainListDevelopedCountriesResponse` 선진국 국가 목록 응답값
     */
    metadataDevelopedCountriesList: (params: RequestParams = {}) =>
      this.http.request<DomainListDevelopedCountriesResponse, any>({
        path: `/shops/metadata/developed-countries`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description 그룹 속성 코드에 따른 하위 속성 코드를 반환합니다.<br> ## 사용 가능한 `groupCode`는 다음과 같습니다. - `CATEGORY`: 카테고리, `COLOR`: 색상, `NECK-SHOULDER`: 넥 어깨 타입 `AIMS_CATEGORY` : AIMS 카테고리, `AIMS_FABRIC` : AIMS 재질, `AIMS_ATTRIBUTE`: AIMS 속성 ## 사용 가능한 `subGroupCodes`는 다음과 같은 코드가 속할 수 있습니다. - `GROUP`: 대분류 코드, `HEADWEAR`:모자, `OUTERWEAR`: 아우터, `TOPS`: 상의, `DRESSES`: 원피스 , `PANTS`: 바지, `SKIRTS`: 스커트
     *
     * @tags Metadata
     * @name MetadataPropertiesList
     * @summary 그룹 속성 코드에 따른 하위 속성 코드 조회 ✅
     * @request GET:/shops/metadata/properties
     * @response `200` `DomainListShopPropertiesResponse` 프로퍼티 응답 값
     */
    metadataPropertiesList: (query: MetadataPropertiesListParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopPropertiesResponse, any>({
        path: `/shops/metadata/properties`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵 지역 조회 - 프론트 정적 데이터로 이관할 예정입니다.
     *
     * @tags Metadata
     * @name MetadataShopRegionsList
     * @summary 샵 지역 조회
     * @request GET:/shops/metadata/shop-regions
     * @deprecated
     * @response `200` `DomainListShopRegionsResponse` 샵 지역 응답값
     */
    metadataShopRegionsList: (params: RequestParams = {}) =>
      this.http.request<DomainListShopRegionsResponse, any>({
        path: `/shops/metadata/shop-regions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 아이클로젯 마켓 상품 배송비 마이그레이션
     *
     * @tags Migrate
     * @name MigrateAclosetMarketItemShippingFeeCreate
     * @summary [DEV-ONLY] 아이클로젯 마켓 상품 배송비 마이그레이션 ⚙️
     * @request POST:/shops/migrate/acloset-market-item-shipping-fee
     * @secure
     * @response `204` `string` ok
     */
    migrateAclosetMarketItemShippingFeeCreate: (
      request: DomainMigrateAclosetMarketItemShippingFeeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<string, any>({
        path: `/shops/migrate/acloset-market-item-shipping-fee`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 아이클로젯 주문 아이템 ID 마이그레이션
     *
     * @tags Migrate
     * @name MigrateAclosetOrderItemIdCreate
     * @summary [DEV-ONLY] 아이클로젯 주문 아이템 ID 마이그레이션 ⚙️
     * @request POST:/shops/migrate/acloset-order-item-id
     * @secure
     * @response `204` `string` ok
     */
    migrateAclosetOrderItemIdCreate: (params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/shops/migrate/acloset-order-item-id`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 아이클로젯 주문 총 결제 금액 마이그레이션
     *
     * @tags Migrate
     * @name MigrateAclosetOrderTotalPaymentAmountCreate
     * @summary [DEV-ONLY] 아이클로젯 주문 총 결제 금액 마이그레이션 ⚙️
     * @request POST:/shops/migrate/acloset-order-total-payment-amount
     * @secure
     * @response `204` `string` ok
     */
    migrateAclosetOrderTotalPaymentAmountCreate: (params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/shops/migrate/acloset-order-total-payment-amount`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 아이클로젯 잘못된 후드티 매핑
     *
     * @tags Migrate
     * @name MigrateAclosetWrongHoodieMappingCreate
     * @summary [DEV-ONLY] 아이클로젯 잘못된 후드티 매핑 ⚙️
     * @request POST:/shops/migrate/acloset-wrong-hoodie-mapping
     * @secure
     * @response `204` `string` ok
     */
    migrateAclosetWrongHoodieMappingCreate: (params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/shops/migrate/acloset-wrong-hoodie-mapping`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 샵에 대한 모든 정보를 삭제합니다. (MANAGER-ONLY)
     *
     * @tags Migrate
     * @name MigrateDestroyShopsCreate
     * @summary [DEV-ONLY] 샵에 대한 모든 정보를 삭제합니다. ⚙️
     * @request POST:/shops/migrate/destroy-shops
     * @secure
     * @response `204` `string` ok
     */
    migrateDestroyShopsCreate: (request: DomainDestroyShopsRequest, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/shops/migrate/destroy-shops`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 네이버 템플릿 고정 이미지 URL 마이그레이션
     *
     * @tags Migrate
     * @name MigrateNaverTemplateFixedImageUrlCreate
     * @summary [DEV-ONLY] 네이버 템플릿 고정 이미지 URL 마이그레이션 ⚙️
     * @request POST:/shops/migrate/naver-template-fixed-image-url
     * @secure
     * @response `204` `string` ok
     */
    migrateNaverTemplateFixedImageUrlCreate: (
      request: DomainMigrateNaverTemplateFixedImageURLRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<string, any>({
        path: `/shops/migrate/naver-template-fixed-image-url`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 샵 브랜드 이름 정규화 마이그레이션
     *
     * @tags Migrate
     * @name MigrateNormalizeShopBrandsCreate
     * @summary [DEV-ONLY] 샵 브랜드 이름 정규화 마이그레이션 ⚙️
     * @request POST:/shops/migrate/normalize-shop-brands
     * @secure
     * @response `204` `string` ok
     */
    migrateNormalizeShopBrandsCreate: (params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/shops/migrate/normalize-shop-brands`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 주문 제목이 없는 주문을 아이템 제목으로 주문 제목을 변경
     *
     * @tags Migrate
     * @name MigrateOrderTitleCreate
     * @summary [DEV-ONLY] 주문 제목을 아이템 제목으로 변경 ⚙️
     * @request POST:/shops/migrate/order-title
     * @secure
     * @response `204` `string` ok
     */
    migrateOrderTitleCreate: (params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/shops/migrate/order-title`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 재고가 설정되지 않은 상품을 감지하여 옵션을 재생성합니다.
     *
     * @tags Migrate
     * @name MigrateRecoverInvalidCafe24ProductVariantCreate
     * @summary [DEV-ONLY] 카페24 상품 옵션 재생성 ⚙️
     * @request POST:/shops/migrate/recover-invalid-cafe24-product-variant
     * @secure
     * @response `204` `string` ok
     */
    migrateRecoverInvalidCafe24ProductVariantCreate: (
      request: DomainRecoverInvalidCafe24ProductVariantRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<string, any>({
        path: `/shops/migrate/recover-invalid-cafe24-product-variant`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 네이버페이 취소 사유 목록을 조회하는 API
     *
     * @tags Platforms
     * @name NaverpayCancelReasonsList
     * @summary 네이버페이 취소 사유 목록 조회 ✅
     * @request GET:/shops/naverpay-cancel-reasons
     * @secure
     * @response `200` `DomainListNaverpayCancelReasonsResponse` OK
     */
    naverpayCancelReasonsList: (params: RequestParams = {}) =>
      this.http.request<DomainListNaverpayCancelReasonsResponse, any>({
        path: `/shops/naverpay-cancel-reasons`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 공지사항 조회
     *
     * @tags App
     * @name NoticeList
     * @summary 공지사항 조회 ✅
     * @request GET:/shops/notice
     * @secure
     * @response `200` `DomainGetNoticeResponse` OK
     */
    noticeList: (params: RequestParams = {}) =>
      this.http.request<DomainGetNoticeResponse, any>({
        path: `/shops/notice`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 공지사항 수정
     *
     * @tags App
     * @name NoticePartialUpdate
     * @summary 공지사항 수정 ✅
     * @request PATCH:/shops/notice
     * @secure
     * @response `200` `void` OK
     */
    noticePartialUpdate: (request: DomainPatchNoticeRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/notice`,
        method: 'PATCH',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 알림톡 템플릿 조회
     *
     * @tags Notifications
     * @name NotificationsKakaotalkTemplatesList
     * @summary 알림톡 템플릿 조회 ✅
     * @request GET:/shops/notifications/kakaotalk-templates
     * @secure
     * @response `200` `DomainListKakaotalkTemplatesResponse` OK
     */
    notificationsKakaotalkTemplatesList: (
      query: NotificationsKakaotalkTemplatesListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListKakaotalkTemplatesResponse, any>({
        path: `/shops/notifications/kakaotalk-templates`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 주문 상태 FSM 시각화를 위한 API입니다.
     *
     * @tags Orders
     * @name OrderStatusesFsmList
     * @summary 주문 상태 FSM 시각화 ✅
     * @request GET:/shops/order-statuses/fsm
     * @response `200` `void` OK
     */
    orderStatusesFsmList: (query: OrderStatusesFsmListParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/order-statuses/fsm`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description 해당 플랜은 샵과 상관없는 플랜의 프리셋 속성을 가지고 있습니다.
     *
     * @tags Plans
     * @name PlansList
     * @summary 플랜을 조회합니다. ✅
     * @request GET:/shops/plans
     * @deprecated
     * @secure
     * @response `200` `DomainListPlansResponse` OK
     */
    plansList: (params: RequestParams = {}) =>
      this.http.request<DomainListPlansResponse, any>({
        path: `/shops/plans`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 은행 목록을 조회하는 API
     *
     * @tags Platforms
     * @name PlatformBanksList
     * @summary 플랫폼 별 은행 목록 조회 ✅
     * @request GET:/shops/platform-banks
     * @secure
     * @response `200` `DomainListPlatformBanksResponse` OK
     */
    platformBanksList: (query: PlatformBanksListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPlatformBanksResponse, any>({
        path: `/shops/platform-banks`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 플랫폼 별 취소 사유 목록을 조회하는 API
     *
     * @tags Platforms
     * @name PlatformCancelReasonsList
     * @summary 플랫폼 별 취소 사유 목록 조회 ✅
     * @request GET:/shops/platform-cancel-reasons
     * @secure
     * @response `200` `DomainListPlatformCancelReasonsResponse` OK
     */
    platformCancelReasonsList: (query: PlatformCancelReasonsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPlatformCancelReasonsResponse, any>({
        path: `/shops/platform-cancel-reasons`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 원산지 목록을 조회하는 API
     *
     * @tags Platforms
     * @name PlatformOriginAreasList
     * @summary 플랫폼 별 원산지 목록 조회 ✅
     * @request GET:/shops/platform-origin-areas
     * @secure
     * @response `200` `DomainListPlatformOriginAreasResponse` OK
     */
    platformOriginAreasList: (query: PlatformOriginAreasListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPlatformOriginAreasResponse, any>({
        path: `/shops/platform-origin-areas`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 환불 수단 목록을 조회하는 API
     *
     * @tags Platforms
     * @name PlatformRefundMethodCodesList
     * @summary 플랫폼 별 환불 수단 목록 조회 ✅
     * @request GET:/shops/platform-refund-method-codes
     * @secure
     * @response `200` `DomainListPlatformRefundMethodCodesResponse` OK
     */
    platformRefundMethodCodesList: (query: PlatformRefundMethodCodesListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPlatformRefundMethodCodesResponse, any>({
        path: `/shops/platform-refund-method-codes`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 취소 거절 사유 목록을 조회하는 API
     *
     * @tags Platforms
     * @name PlatformRejectCancelReasonsList
     * @summary 플랫폼 별 취소 거절 사유 목록 조회 ✅
     * @request GET:/shops/platform-reject-cancel-reasons
     * @secure
     * @response `200` `DomainListPlatformRejectCancelReasonsResponse` OK
     */
    platformRejectCancelReasonsList: (query: PlatformRejectCancelReasonsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPlatformRejectCancelReasonsResponse, any>({
        path: `/shops/platform-reject-cancel-reasons`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 반품 거절 사유 목록을 조회하는 API
     *
     * @tags Platforms
     * @name PlatformRejectReturnReasonsList
     * @summary 플랫폼 별 반품 거절 사유 목록 조회 🛠
     * @request GET:/shops/platform-reject-return-reasons
     * @secure
     * @response `200` `DomainListPlatformRejectReturnReasonsResponse` OK
     */
    platformRejectReturnReasonsList: (query: PlatformRejectReturnReasonsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPlatformRejectReturnReasonsResponse, any>({
        path: `/shops/platform-reject-return-reasons`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 반품 요청 사유 목록을 조회하는 API
     *
     * @tags Platforms
     * @name PlatformRequestReturnReasonsList
     * @summary 플랫폼 별 반품 요청 사유 목록 조회 ✅
     * @request GET:/shops/platform-request-return-reasons
     * @secure
     * @response `200` `DomainListPlatformRequestReturnReasonsResponse` OK
     */
    platformRequestReturnReasonsList: (query: PlatformRequestReturnReasonsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPlatformRequestReturnReasonsResponse, any>({
        path: `/shops/platform-request-return-reasons`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 배송 업체 목록을 조회하는 API
     *
     * @tags Platforms
     * @name PlatformShippingCompaniesList
     * @summary 플랫폼 별 배송 업체 목록 조회 ✅
     * @request GET:/shops/platform-shipping-companies
     * @secure
     * @response `200` `DomainListPlatformShippingCompaniesResponse` OK
     */
    platformShippingCompaniesList: (query: PlatformShippingCompaniesListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPlatformShippingCompaniesResponse, any>({
        path: `/shops/platform-shipping-companies`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 팝업 목록을 조회하는 API 입니다.
     *
     * @tags Shops
     * @name PopupsList
     * @summary 팝업 목록 조회 API ✅
     * @request GET:/shops/popups
     * @response `200` `DomainListPopupsResponse` OK
     */
    popupsList: (query: PopupsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPopupsResponse, any>({
        path: `/shops/popups`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description 팝업을 생성하는 API 입니다. (마스터 계정만 접근 가능)
     *
     * @tags Shops
     * @name PopupsCreate
     * @summary 팝업 생성 API ✅
     * @request POST:/shops/popups
     * @secure
     * @response `204` `void` No Content
     */
    popupsCreate: (request: DomainCreatePopupRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/popups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 팝업을 삭제하는 API 입니다. (마스터 계정만 접근 가능)
     *
     * @tags Shops
     * @name PopupsDelete
     * @summary 팝업 삭제 API ✅
     * @request DELETE:/shops/popups/{popupID}
     * @secure
     * @response `204` `void` No Content
     */
    popupsDelete: (popupId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/popups/${popupId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 범용 프록시 API입니다. API를 대신 실행시켜주는 단순한 기능만을 담당합니다.
     *
     * @tags Platforms
     * @name ProxyCreate
     * @summary 범용 프록시 API입니다. ✅
     * @request POST:/shops/proxy
     * @secure
     * @response `200` `DomainProxyResponse` OK
     */
    proxyCreate: (request: DomainProxyRequest, params: RequestParams = {}) =>
      this.http.request<DomainProxyResponse, any>({
        path: `/shops/proxy`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 모든 상점 큐 메시지 소진 여부 확인 해당 API는 개발용 API로 서비스에서의 사용을 금합니다.
     *
     * @tags RabbitMQ
     * @name RabbitmqCheckAllShopQueuesConsumedList
     * @summary [DEV-ONLY] 모든 상점 큐 메시지 소진 여부 확인 ⚙️
     * @request GET:/shops/rabbitmq/check-all-shop-queues-consumed
     * @response `200` `DomainCheckAllShopQueueConsumedResponse` OK
     */
    rabbitmqCheckAllShopQueuesConsumedList: (params: RequestParams = {}) =>
      this.http.request<DomainCheckAllShopQueueConsumedResponse, any>({
        path: `/shops/rabbitmq/check-all-shop-queues-consumed`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 판매 아이템의 정합성 보고서 목록을 조회합니다.
     *
     * @tags Sales
     * @name SaleItemsConsistencyReportsList
     * @summary 판매 아이템 정합성 보고서 목록 조회 API ✅
     * @request GET:/shops/sale-items/consistency-reports
     * @secure
     * @response `200` `DomainListItemConsistencyReportsResponse` OK
     */
    saleItemsConsistencyReportsList: (query: SaleItemsConsistencyReportsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListItemConsistencyReportsResponse, any>({
        path: `/shops/sale-items/consistency-reports`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 판매 아이템의 정합성 보고서를 수정합니다. (Master Only)
     *
     * @tags Sales
     * @name SaleItemsConsistencyReportsPartialUpdate
     * @summary 판매 아이템 정합성 보고서 수정 API ✅
     * @request PATCH:/shops/sale-items/consistency-reports/{reportID}
     * @secure
     * @response `204` `void` No Content
     */
    saleItemsConsistencyReportsPartialUpdate: (
      reportId: string,
      PatchItemConsistencyReportRequest: DomainPatchItemConsistencyReportRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/sale-items/consistency-reports/${reportId}`,
        method: 'PATCH',
        body: PatchItemConsistencyReportRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 상품 상태만 강제 업데이트합니다. 상품 플랫폼의 상태까지 변경하지 않고 내부 상태만 변경합니다. (Master Only)
     *
     * @tags Sales
     * @name SaleItemsForceChangeStatusCreate
     * @summary 상품 상태 강제 업데이트 API ✅
     * @request POST:/shops/sale-items/force-change-status
     * @secure
     * @response `204` `void` No Content
     */
    saleItemsForceChangeStatusCreate: (
      ForceChangeSaleItemsStatus: DomainForceChangeSaleItemsStatusRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/sale-items/force-change-status`,
        method: 'POST',
        body: ForceChangeSaleItemsStatus,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 판매중인 세컨솔드 상품을 강제로 판매중지합니다. (Master Only)
     *
     * @tags Sales
     * @name SaleItemsForceStopAclosetItemsCreate
     * @summary 판매중인 세컨솔드 상품 강제 판매중지 API ✅
     * @request POST:/shops/sale-items/force-stop-acloset-items
     * @secure
     * @response `204` `void` No Content
     */
    saleItemsForceStopAclosetItemsCreate: (
      ForceStopSaleAclosetItemsRequest: DomainForceStopSaleAclosetItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/sale-items/force-stop-acloset-items`,
        method: 'POST',
        body: ForceStopSaleAclosetItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 상품 플랫폼 상태 FSM 시각화를 위한 API입니다.
     *
     * @tags Sales
     * @name SalePlatformStatusesFsmList
     * @summary 상품 플랫폼 상태 FSM 시각화 ✅
     * @request GET:/shops/sale-platform-statuses/fsm
     * @response `200` `void` OK
     */
    salePlatformStatusesFsmList: (query: SalePlatformStatusesFsmListParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/sale-platform-statuses/fsm`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description 상품 주요 상태 FSM 시각화를 위한 API입니다.
     *
     * @tags Sales
     * @name SaleStatusesFsmList
     * @summary 상품 주요 상태 FSM 시각화 ✅
     * @request GET:/shops/sale-statuses/fsm
     * @response `200` `void` OK
     */
    saleStatusesFsmList: (query: SaleStatusesFsmListParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/sale-statuses/fsm`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description 서비스 가격 목록을 리스트로 조회합니다.
     *
     * @tags Settlements
     * @name ServicePricingsList
     * @summary 서비스 가격 목록을 리스트로 조회합니다. ✅
     * @request GET:/shops/service-pricings
     * @response `200` `DomainListServicePricingsResponse` OK
     */
    servicePricingsList: (params: RequestParams = {}) =>
      this.http.request<DomainListServicePricingsResponse, any>({
        path: `/shops/service-pricings`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description 배송 업체 매핑 목록을 조회하는 API
     *
     * @tags Platforms
     * @name ShippingCompaniesList
     * @summary 배송 업체 매핑 목록 조회 ✅
     * @request GET:/shops/shipping-companies
     * @secure
     * @response `200` `DomainListShippingCompaniesResponse` OK
     */
    shippingCompaniesList: (query: ShippingCompaniesListParams, params: RequestParams = {}) =>
      this.http.request<DomainListShippingCompaniesResponse, any>({
        path: `/shops/shipping-companies`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 검수자 작업 목록을 조회하는 API 입니다.
     *
     * @tags Tasks
     * @name TasksList
     * @summary 검수자 작업 목록 조회 ✅
     * @request GET:/shops/tasks
     * @secure
     * @response `200` `DomainListTasksResponse` 검수자 작업 목록 응답 값
     */
    tasksList: (query: TasksListParams, params: RequestParams = {}) =>
      this.http.request<DomainListTasksResponse, any>({
        path: `/shops/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 미리보기용 AI 설명을 생성하는 API입니다.
     *
     * @tags Tasks
     * @name TasksGenerateAiDescriptionPreviewCreate
     * @summary 미리보기용 AI 설명 생성 ✅
     * @request POST:/shops/tasks/generate-ai-description/preview
     * @secure
     * @response `200` `DomainGenerateAIDescriptionPreviewResponse` 미리보기용 AI 설명 생성 반환 값
     */
    tasksGenerateAiDescriptionPreviewCreate: (
      GenerateAIDescriptionPreviewRequest: DomainGenerateAIDescriptionPreviewRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainGenerateAIDescriptionPreviewResponse, any>({
        path: `/shops/tasks/generate-ai-description/preview`,
        method: 'POST',
        body: GenerateAIDescriptionPreviewRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 사이즈 타겟 키워드 목록을 조회하는 API 입니다. 관리자만 사용 가능합니다.
     *
     * @tags Tasks
     * @name TasksSizeTargetKeywordsList
     * @summary 치수추출 사이즈 타겟 키워드 목록 조회 ✅ (MASTER Only)
     * @request GET:/shops/tasks/size-target-keywords
     * @secure
     * @response `200` `DomainListSizeTargetKeywordsResponse` 사이즈 타겟 키워드 목록 조회 반환 값
     */
    tasksSizeTargetKeywordsList: (params: RequestParams = {}) =>
      this.http.request<DomainListSizeTargetKeywordsResponse, any>({
        path: `/shops/tasks/size-target-keywords`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 사이즈 타겟 키워드를 수정하는 API 입니다. 관리자만 사용 가능합니다.
     *
     * @tags Tasks
     * @name TasksSizeTargetKeywordsPartialUpdate
     * @summary 치수추출 사이즈 타겟 키워드 수정 ✅ (MASTER Only)
     * @request PATCH:/shops/tasks/size-target-keywords/{sizeTargetKeywordID}
     * @secure
     * @response `204` `void` No Content
     */
    tasksSizeTargetKeywordsPartialUpdate: (
      sizeTargetKeywordId: string,
      request: DomainPatchSizeTargetKeywordRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/tasks/size-target-keywords/${sizeTargetKeywordId}`,
        method: 'PATCH',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 템플릿 필드 목록 조회 API
     *
     * @tags Templates
     * @name TemplateFieldsList
     * @summary [DEV] 템플릿 필드 목록 조회 ✅
     * @request GET:/shops/template-fields
     * @secure
     * @response `200` `DomainListTemplateFieldsResponse` OK
     */
    templateFieldsList: (query: TemplateFieldsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListTemplateFieldsResponse, any>({
        path: `/shops/template-fields`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 기본 템플릿 없으면 생성 (있으면 무시)
     *
     * @tags Templates
     * @name TemplatesMigrationCreate
     * @summary [DEV] 기존 샵에 템플릿 마이그레이션하기 ✅️
     * @request POST:/shops/templates/migration
     * @secure
     */
    templatesMigrationCreate: (request: DomainMigrationTemplatesRequest, params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/shops/templates/migration`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 파일을 업로드하는 API
     *
     * @tags Shops
     * @name UploadFileCreate
     * @summary 파일 업로드 ✅
     * @request POST:/shops/upload-file
     * @secure
     * @response `200` `DomainUploadFileResponse` OK
     */
    uploadFileCreate: (data: UploadFileCreatePayload, params: RequestParams = {}) =>
      this.http.request<DomainUploadFileResponse, any>({
        path: `/shops/upload-file`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @description AIMS 자동 계정 생성 API
     *
     * @tags Users
     * @name UsersAutoCreateAccountCreate
     * @summary AIMS 자동 계정 생성  ✅
     * @request POST:/shops/users/auto-create-account
     * @secure
     * @response `204` `void` No Content
     */
    usersAutoCreateAccountCreate: (
      AutoCreateAccountRequest: DomainAutoCreateAccountRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/users/auto-create-account`,
        method: 'POST',
        body: AutoCreateAccountRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersExistsCreate
     * @summary AIMS 회원가입 중복 확인 ✅
     * @request POST:/shops/users/exists
     * @secure
     * @response `200` `DomainExistsUserResponse` 회원가입 중복 확인 응답 값
     */
    usersExistsCreate: (ExistsUserRequest: DomainExistsUserRequest, params: RequestParams = {}) =>
      this.http.request<DomainExistsUserResponse, any>({
        path: `/shops/users/exists`,
        method: 'POST',
        body: ExistsUserRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 영업용 초대 토큰을 생성하는 API입니다. 해당 토큰은 일반 액세스토큰처럼 사용할 수 있으며, 리프레시토큰 발급이 가능합니다. 24시간동안 유효합니다.
     *
     * @tags Users
     * @name UsersInvitationTokenCreate
     * @summary 영업용 초대 토큰 생성 API ✅
     * @request POST:/shops/users/invitation-token
     * @secure
     * @response `200` `DomainGenerateInvitationTokenResponse` 새로 발급 된 액세스 토큰
     */
    usersInvitationTokenCreate: (
      GenerateInvitationTokenRequest: DomainGenerateInvitationTokenRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainGenerateInvitationTokenResponse, any>({
        path: `/shops/users/invitation-token`,
        method: 'POST',
        body: GenerateInvitationTokenRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description AIMS 비밀번호 변경 API
     *
     * @tags Users
     * @name UsersModifyPasswordCreate
     * @summary AIMS 비밀번호 변경 ✅
     * @request POST:/shops/users/modify-password
     * @secure
     * @response `204` `void` No Content
     */
    usersModifyPasswordCreate: (ModifyPasswordRequest: DomainModifyPasswordRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/users/modify-password`,
        method: 'POST',
        body: ModifyPasswordRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 리프레시 토큰을 생성하는 API입니다. 현재는 초대 토큰의 경우에만 사용 가능합니다.
     *
     * @tags Users
     * @name UsersRefreshTokenCreate
     * @summary 리프레시 토큰 생성 API ✅
     * @request POST:/shops/users/refresh-token
     * @secure
     * @response `200` `DomainGenerateRefreshTokenResponse` 새로 발급 된 리프레시 토큰
     */
    usersRefreshTokenCreate: (
      GenerateRefreshTokenRequest: DomainGenerateRefreshTokenRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainGenerateRefreshTokenResponse, any>({
        path: `/shops/users/refresh-token`,
        method: 'POST',
        body: GenerateRefreshTokenRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 업로드 사이트 로그인 API 입니다. |code|status|description| |---|---|---| ||400|입력한 이메일이 없는 경우| |`USER_PASSWORD_INCORRECT`|401|비밀번호가 유효하지 않은 경우| |`USER_NOT_FOUND`|404|해당하는 유저가 없으면|
     *
     * @tags Users
     * @name UsersSignInCreate
     * @summary AIMS 로그인 ✅
     * @request POST:/shops/users/sign-in
     * @secure
     * @response `200` `DomainSignInResponse` 로그인 응답 값
     */
    usersSignInCreate: (SignInRequest: DomainSignInRequest, params: RequestParams = {}) =>
      this.http.request<DomainSignInResponse, any>({
        path: `/shops/users/sign-in`,
        method: 'POST',
        body: SignInRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 게스트 로그인 API 입니다.
     *
     * @tags Users
     * @name UsersSignInGuestCreate
     * @summary AIMS 게스트 로그인 ✅
     * @request POST:/shops/users/sign-in/guest
     * @response `200` `DomainSignInAsGuestResponse` 게스트 로그인 응답 값
     */
    usersSignInGuestCreate: (SignInAsGuestRequest: DomainSignInAsGuestRequest, params: RequestParams = {}) =>
      this.http.request<DomainSignInAsGuestResponse, any>({
        path: `/shops/users/sign-in/guest`,
        method: 'POST',
        body: SignInAsGuestRequest,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description AIMS 사이트 회원가입 API 입니다. 카페24 같이 데이터를 가져올 때 사용합니다.
     *
     * @tags Users
     * @name UsersSignUpLoadOwnerCreate
     * @summary AIMS 회원가입 ✅
     * @request POST:/shops/users/sign-up/load-owner
     * @response `204` `void` No Content
     */
    usersSignUpLoadOwnerCreate: (SignUpLoadOwnerRequest: DomainSignUpLoadOwnerRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/users/sign-up/load-owner`,
        method: 'POST',
        body: SignUpLoadOwnerRequest,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description AIMS 사이트 회원가입 API 입니다.
     *
     * @tags Users
     * @name UsersSignUpOwnerCreate
     * @summary AIMS 회원가입 ✅
     * @request POST:/shops/users/sign-up/owner
     * @response `204` `void` No Content
     */
    usersSignUpOwnerCreate: (SignUpOwnerRequest: DomainSignUpOwnerRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/users/sign-up/owner`,
        method: 'POST',
        body: SignUpOwnerRequest,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description |code|status|description| |---|---|---| |`USER_TOKEN_INVALID`|401|토큰이 유효하지 않은 경우|
     *
     * @tags Users
     * @name UsersTokenCreate
     * @summary 액세스 토큰 리프레시 API ✅
     * @request POST:/shops/users/token
     * @secure
     * @response `200` `DomainRefreshTokenResponse` 새로 발급 된 액세스 토큰
     * @response `500` `void` Internal Server Error
     */
    usersTokenCreate: (params: RequestParams = {}) =>
      this.http.request<DomainRefreshTokenResponse, void>({
        path: `/shops/users/token`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 토큰 검증만을 수행하는 API입니다.
     *
     * @tags Users
     * @name UsersVerifyTokenList
     * @summary VerifyToken 토큰 검증
     * @request GET:/shops/users/verify-token
     * @secure
     * @response `204` `void` No Content
     */
    usersVerifyTokenList: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/users/verify-token`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 실시간 정산내역을 리스트로 조회합니다.
     *
     * @tags Settlements
     * @name V2SettlementsRealtimeDetail
     * @summary 실시간 정산내역을 리스트로 조회합니다. ✅
     * @request GET:/shops/v2/{shopID}/settlements/realtime
     * @secure
     * @response `200` `DomainListRealtimeSettlementsV2Response` OK
     */
    v2SettlementsRealtimeDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListRealtimeSettlementsV2Response, any>({
        path: `/shops/v2/${shopId}/settlements/realtime`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 이메일 인증 코드를 발송하는 API입니다.
     *
     * @tags Users
     * @name VerificationEmailSendCreate
     * @summary 이메일 인증 코드 발송 ✅
     * @request POST:/shops/verification/email/send
     * @secure
     * @response `204` `void` No Content
     */
    verificationEmailSendCreate: (
      SendEmailVerificationCodeRequest: DomainSendEmailVerificationCodeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/verification/email/send`,
        method: 'POST',
        body: SendEmailVerificationCodeRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 이메일 인증 코드를 검증하는 API입니다.
     *
     * @tags Users
     * @name VerificationEmailVerifyCreate
     * @summary 이메일 인증 코드 검증 ✅
     * @request POST:/shops/verification/email/verify
     * @secure
     * @response `204` `void` No Content
     */
    verificationEmailVerifyCreate: (
      VerifyEmailVerificationCodeRequest: DomainVerifyEmailVerificationCodeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/verification/email/verify`,
        method: 'POST',
        body: VerifyEmailVerificationCodeRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description AIMS 초대코드를 검증하는 API
     *
     * @tags Users
     * @name VerifyInvitationCodeCreate
     * @summary AIMS 초대코드 검증 ✅
     * @request POST:/shops/verify-invitation-code
     * @secure
     * @response `200` `DomainVerifyInvitationCodeResponse` AIMS 초대코드 검증 응답값
     */
    verifyInvitationCodeCreate: (
      VerifyInvitationCodeRequest: DomainVerifyInvitationCodeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainVerifyInvitationCodeResponse, any>({
        path: `/shops/verify-invitation-code`,
        method: 'POST',
        body: VerifyInvitationCodeRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 세컨솔드 웹훅 처리 핸들러
     *
     * @tags Webhooks
     * @name WebhooksAclosetCreate
     * @summary 세컨솔드 웹훅 핸들러🚨 (세컨솔드 접근 전용) (일반적인 테스트 용도로 사용 금지)
     * @request POST:/shops/webhooks/acloset
     * @response `204` `void` No Content
     */
    webhooksAclosetCreate: (webhook: DomainAclosetWebhookRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/webhooks/acloset`,
        method: 'POST',
        body: webhook,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 세컨솔드 크롤링 웹훅 처리 핸들러
     *
     * @tags Webhooks
     * @name WebhooksAclosetCrawlingCreate
     * @summary 세컨솔드 크롤링 웹훅 핸들러🚨 (세컨솔드 접근 전용) (일반적인 테스트 용도로 사용 금지)
     * @request POST:/shops/webhooks/acloset-crawling
     * @deprecated
     * @response `200` `DomainAclosetCrawlingWebhookResponse` OK
     */
    webhooksAclosetCrawlingCreate: (webhook: DomainAclosetCrawlingWebhookRequest, params: RequestParams = {}) =>
      this.http.request<DomainAclosetCrawlingWebhookResponse, any>({
        path: `/shops/webhooks/acloset-crawling`,
        method: 'POST',
        body: webhook,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 카페24 웹훅 처리 핸들러
     *
     * @tags Webhooks
     * @name WebhooksCafe24Create
     * @summary 카페24 웹훅 핸들러🚨 (카페 24 접근 전용) (일반적인 테스트 용도로 사용 금지)
     * @request POST:/shops/webhooks/cafe24
     * @response `202` `string` Accepted
     */
    webhooksCafe24Create: (webhook: DomainCafe24WebhookRequest, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/shops/webhooks/cafe24`,
        method: 'POST',
        body: webhook,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵을 조회하는 API 입니다.
     *
     * @tags Shops
     * @name ShopsDetail
     * @summary 샵 조회 ✅
     * @request GET:/shops/{shopID}
     * @secure
     * @response `200` `DomainShopResponse` 샵 조회 응답 값
     */
    shopsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainShopResponse, any>({
        path: `/shops/${shopId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 웹에서 샵의 정보를 부분 수정하는 API fabricNotation은 GET: /shops/metadata의 metadata-alias, fabric-notation 참고
     *
     * @tags Shops
     * @name ShopsPartialUpdate
     * @summary 샵 부분 수정 ✅
     * @request PATCH:/shops/{shopID}
     * @secure
     * @response `204` `void` No Content
     */
    shopsPartialUpdate: (shopId: string, patchShopRequest: DomainPatchShopRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}`,
        method: 'PATCH',
        body: patchShopRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settlements
     * @name AclosetSettlementsDetail
     * @summary 세컨솔드 정산내역을 리스트로 조회합니다. ✅
     * @request GET:/shops/{shopID}/acloset-settlements
     * @secure
     * @response `200` `DomainListAclosetSettlementsResponse` OK
     */
    aclosetSettlementsDetail: ({ shopId, ...query }: AclosetSettlementsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListAclosetSettlementsResponse, any>({
        path: `/shops/${shopId}/acloset-settlements`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 세컨솔드 정산 금액을 조회합니다.
     *
     * @tags Settlements
     * @name AclosetSettlementsAmountDetail
     * @summary 세컨솔드 정산 금액을 조회합니다. ✅
     * @request GET:/shops/{shopID}/acloset-settlements/amount
     * @secure
     * @response `200` `DomainGetAclosetSettlementAmountResponse` OK
     */
    aclosetSettlementsAmountDetail: (
      { shopId, ...query }: AclosetSettlementsAmountDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainGetAclosetSettlementAmountResponse, any>({
        path: `/shops/${shopId}/acloset-settlements/amount`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settlements
     * @name AclosetSettlementsExportExcelCreate
     * @summary 세컨솔드 정산내역을 엑셀로 다운로드합니다. ✅
     * @request POST:/shops/{shopID}/acloset-settlements/export-excel
     * @secure
     * @response `200` `DomainExportExcelAclosetSettlementsResponse` OK
     */
    aclosetSettlementsExportExcelCreate: (
      shopId: string,
      ExportExcelAclosetSettlementsRequest: DomainExportExcelAclosetSettlementsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainExportExcelAclosetSettlementsResponse, any>({
        path: `/shops/${shopId}/acloset-settlements/export-excel`,
        method: 'POST',
        body: ExportExcelAclosetSettlementsRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 세컨솔드 파트너 샵 정보를 수정하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetPartnerShopInfoUpdate
     * @summary 세컨솔드 파트너 샵 수정 API ✅
     * @request PUT:/shops/{shopID}/acloset/partner-shop-info/{partnerShopInfoID}
     * @secure
     * @response `204` `void` No Content
     */
    aclosetPartnerShopInfoUpdate: (
      shopId: string,
      partnerShopInfoId: string,
      request: DomainUpdateAclosetPartnerShopInfoRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/acloset/partner-shop-info/${partnerShopInfoId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 세컨솔드 파트너 샵 목록을 조회하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetPartnerShopsDetail
     * @summary 세컨솔드 파트너 샵 목록 조회 API ✅
     * @request GET:/shops/{shopID}/acloset/partner-shops
     * @secure
     * @response `200` `DomainListAclosetPartnerShopsResponse` OK
     */
    aclosetPartnerShopsDetail: ({ shopId, ...query }: AclosetPartnerShopsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListAclosetPartnerShopsResponse, any>({
        path: `/shops/${shopId}/acloset/partner-shops`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 세컨솔드 리뷰 목록을 조회하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetReviewsDetail
     * @summary 세컨솔드 리뷰 목록 조회 API ✅
     * @request GET:/shops/{shopID}/acloset/reviews
     * @secure
     * @response `200` `DomainListAclosetMarketItemReviewsResponse` OK
     */
    aclosetReviewsDetail: ({ shopId, ...query }: AclosetReviewsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListAclosetMarketItemReviewsResponse, any>({
        path: `/shops/${shopId}/acloset/reviews`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 세컨솔드 리뷰 답글을 수정하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetReviewsReplyUpdate
     * @summary 세컨솔드 리뷰 답글 수정 API ✅
     * @request PUT:/shops/{shopID}/acloset/reviews/{reviewID}/reply
     * @secure
     * @response `204` `void` No Content
     */
    aclosetReviewsReplyUpdate: (
      shopId: string,
      reviewId: string,
      request: DomainUpdateAclosetMarketItemReviewReplyRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/acloset/reviews/${reviewId}/reply`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 세컨솔드 고객대응 점수를 조회하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetServiceScoreDetail
     * @summary 세컨솔드 고객대응 점수 조회 API ✅
     * @request GET:/shops/{shopID}/acloset/service-score
     * @secure
     * @response `200` `DomainGetShopServiceScoreResponse` OK
     */
    aclosetServiceScoreDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetShopServiceScoreResponse, any>({
        path: `/shops/${shopId}/acloset/service-score`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 세컨솔드 공급사 목록을 조회하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetSuppliersDetail
     * @summary 세컨솔드 공급사 목록 조회 API ✅
     * @request GET:/shops/{shopID}/acloset/suppliers
     * @secure
     * @response `200` `DomainListAclosetSuppliersResponse` OK
     */
    aclosetSuppliersDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListAclosetSuppliersResponse, any>({
        path: `/shops/${shopId}/acloset/suppliers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 세컨솔드 공급사를 생성하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetSuppliersCreate
     * @summary 세컨솔드 공급사 생성 API ✅
     * @request POST:/shops/{shopID}/acloset/suppliers
     * @secure
     * @response `200` `DomainCreateAclosetSupplierResponse` OK
     */
    aclosetSuppliersCreate: (shopId: string, request: DomainCreateAclosetSupplierRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreateAclosetSupplierResponse, any>({
        path: `/shops/${shopId}/acloset/suppliers`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 세컨솔드 공급사를 조회하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetSuppliersDetail2
     * @summary 세컨솔드 공급사 조회 API ✅
     * @request GET:/shops/{shopID}/acloset/suppliers/{supplierID}
     * @originalName aclosetSuppliersDetail
     * @duplicate
     * @secure
     * @response `200` `DomainGetAclosetSupplierResponse` 응답값
     */
    aclosetSuppliersDetail2: (shopId: string, supplierId: number, params: RequestParams = {}) =>
      this.http.request<DomainGetAclosetSupplierResponse, any>({
        path: `/shops/${shopId}/acloset/suppliers/${supplierId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 세컨솔드 공급사를 수정하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetSuppliersUpdate
     * @summary 세컨솔드 공급사 수정 API ✅
     * @request PUT:/shops/{shopID}/acloset/suppliers/{supplierID}
     * @secure
     * @response `204` `void` No Content
     */
    aclosetSuppliersUpdate: (
      shopId: string,
      supplierId: number,
      request: DomainUpdateAclosetSupplierRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/acloset/suppliers/${supplierId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 세컨솔드 공급사를 삭제하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetSuppliersDelete
     * @summary 세컨솔드 공급사 삭제 API ✅
     * @request DELETE:/shops/{shopID}/acloset/suppliers/{supplierID}
     * @secure
     * @response `204` `void` No Content
     */
    aclosetSuppliersDelete: (shopId: string, supplierId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/acloset/suppliers/${supplierId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 통계 데이터 누적을 위해 세컨솔드 문의 답변 이력을 전송하는 API 입니다.
     *
     * @tags Platforms
     * @name AclosetUserInquiryResponseHistoryCreate
     * @summary 세컨솔드 문의 답변 이력 전송 API ✅
     * @request POST:/shops/{shopID}/acloset/user-inquiry-response-history
     * @secure
     * @response `204` `void` No Content
     */
    aclosetUserInquiryResponseHistoryCreate: (
      shopId: string,
      request: DomainSendAclosetUserInquiryResponseHistoryRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/acloset/user-inquiry-response-history`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 추가 필드 맵핑 스키마를 조회하는 API
     *
     * @tags Shops
     * @name AdditionalFieldMappingsDetail
     * @summary 샵의 추가 필드 맵핑 스키마 조회 ✅
     * @request GET:/shops/{shopID}/additional-field-mappings
     * @secure
     * @response `200` `DomainListShopAdditionalFieldMappingsResponse` OK
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
     */
    additionalFieldMappingsDetail: (
      shopId: string,
      request: DomainListShopAdditionalFieldMappingsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListShopAdditionalFieldMappingsResponse, void>({
        path: `/shops/${shopId}/additional-field-mappings`,
        method: 'GET',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵의 추가 필드 스키마를 조회하는 API
     *
     * @tags Shops
     * @name AdditionalFieldsDetail
     * @summary 샵의 추가 필드 스키마 조회 ✅
     * @request GET:/shops/{shopID}/additional-fields
     * @secure
     * @response `200` `(DomainShopAdditionalFieldResponse)[]` OK
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
     */
    additionalFieldsDetail: (
      shopId: string,
      request: DomainListShopAdditionalFieldsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainShopAdditionalFieldResponse[], void>({
        path: `/shops/${shopId}/additional-fields`,
        method: 'GET',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵의 모든 추가 필드를 덮어쓰는 API
     *
     * @tags Shops
     * @name AdditionalFieldsCreate
     * @summary 샵의 추가 필드 전체 덮어쓰기 ✅
     * @request POST:/shops/{shopID}/additional-fields
     * @secure
     * @response `204` `void` No Content
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
     */
    additionalFieldsCreate: (
      shopId: string,
      request: DomainCreateShopAdditionalFieldsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/additional-fields`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 주문 취소를 승인합니다.
     *
     * @tags Orders
     * @name ApproveCancelOrdersCreate
     * @summary 샵 주문 취소 승인 (다건) ✅
     * @request POST:/shops/{shopID}/approve-cancel-orders
     * @secure
     * @response `204` `void` No Content
     */
    approveCancelOrdersCreate: (
      shopId: string,
      ApproveCancelOrdersRequest: DomainApproveCancelOrdersRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/approve-cancel-orders`,
        method: 'POST',
        body: ApproveCancelOrdersRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 인증 정보를 생성하는 API 입니다.
     *
     * @tags Platforms
     * @name AuthCreate
     * @summary 샵 인증 정보 생성 API ✅
     * @request POST:/shops/{shopID}/auth
     * @secure
     * @response `204` `void` No Content
     */
    authCreate: (shopId: string, request: DomainCreateShopAuthRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/auth`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 방해고객 리스트를 조회합니다.
     *
     * @tags Orders
     * @name BlackConsumersDetail
     * @summary 방해고객 리스트 조회 ✅
     * @request GET:/shops/{shopID}/black-consumers
     * @secure
     * @response `200` `DomainListBlackConsumersResponse` OK
     */
    blackConsumersDetail: ({ shopId, ...query }: BlackConsumersDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListBlackConsumersResponse, any>({
        path: `/shops/${shopId}/black-consumers`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 방해고객을 추가합니다.
     *
     * @tags Orders
     * @name BlackConsumersCreate
     * @summary 방해고객 추가 ✅
     * @request POST:/shops/{shopID}/black-consumers
     * @secure
     * @response `204` `void` No Content
     */
    blackConsumersCreate: (shopId: string, request: DomainAddBlackConsumerRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/black-consumers`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 방해고객을 삭제합니다.
     *
     * @tags Orders
     * @name BlackConsumersDelete
     * @summary 방해고객 삭제 ✅
     * @request DELETE:/shops/{shopID}/black-consumers
     * @secure
     * @response `204` `void` No Content
     */
    blackConsumersDelete: ({ shopId, ...query }: BlackConsumersDeleteParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/black-consumers`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵을 차단/차단해제하는 API 입니다.
     *
     * @tags Shops
     * @name BlockPartialUpdate
     * @summary 샵 차단/차단해제 API ✅
     * @request PATCH:/shops/{shopID}/block
     * @secure
     * @response `204` `void` No Content
     */
    blockPartialUpdate: (shopId: string, request: DomainPatchShopBlockRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/block`,
        method: 'PATCH',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 별로 관리하고 있는 브랜드 그룹들을 조회합니다.
     *
     * @tags Brands
     * @name BrandGroupsDetail
     * @summary 샵 브랜드 그룹 리스트 조회 ✅
     * @request GET:/shops/{shopID}/brand-groups
     * @secure
     * @response `200` `DomainListShopBrandGroupsResponse` OK
     */
    brandGroupsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListShopBrandGroupsResponse, any>({
        path: `/shops/${shopId}/brand-groups`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 별로 관리하고 있는 브랜드 그룹을 생성합니다.
     *
     * @tags Brands
     * @name BrandGroupsCreate
     * @summary 샵 브랜드 그룹 생성 ✅
     * @request POST:/shops/{shopID}/brand-groups
     * @secure
     * @response `201` `DomainCreateShopBrandGroupResponse` 샵 브랜드 그룹 생성 반환 값
     */
    brandGroupsCreate: (shopId: string, request: DomainCreateShopBrandGroupRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreateShopBrandGroupResponse, any>({
        path: `/shops/${shopId}/brand-groups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 별로 관리하고 있는 브랜드 그룹들을 삭제합니다.
     *
     * @tags Brands
     * @name BrandGroupsDelete
     * @summary 샵 브랜드 그룹 삭제 ✅
     * @request DELETE:/shops/{shopID}/brand-groups
     * @secure
     * @response `204` `void` No Content
     */
    brandGroupsDelete: ({ shopId, ...query }: BrandGroupsDeleteParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/brand-groups`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 별로 관리하고 있는 브랜드 그룹을 브랜드 그룹 아이디로 조회합니다.
     *
     * @tags Brands
     * @name BrandGroupsDetail2
     * @summary 샵 브랜드 그룹 단일 조회 ✅
     * @request GET:/shops/{shopID}/brand-groups/{brandGroupID}
     * @originalName brandGroupsDetail
     * @duplicate
     * @secure
     * @response `200` `DomainGetShopBrandGroupResponse` OK
     */
    brandGroupsDetail2: (shopId: string, brandGroupId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetShopBrandGroupResponse, any>({
        path: `/shops/${shopId}/brand-groups/${brandGroupId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 별로 관리하고 있는 브랜드 이미지 정보들을 업데이트 합니다. (없을 시 생성, 있을 시 덮어쓰기)
     *
     * @tags Brands
     * @name BrandImagesUpdate
     * @summary 샵 브랜드 이미지 업데이트 ✅
     * @request PUT:/shops/{shopID}/brand-images
     * @secure
     * @response `204` `void` No Content
     */
    brandImagesUpdate: (shopId: string, request: DomainUpdateShopBrandImagesRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/brand-images`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 별로 관리하고 있는 브랜드 리스트를 조회합니다. (Acloset Brand x)
     *
     * @tags Brands
     * @name BrandsDetail
     * @summary 샵 브랜드 리스트 조회 ✅
     * @request GET:/shops/{shopID}/brands
     * @secure
     * @response `200` `DomainListShopBrandsResponse` OK
     */
    brandsDetail: ({ shopId, ...query }: BrandsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopBrandsResponse, any>({
        path: `/shops/${shopId}/brands`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 별로 관리하고 있는 브랜드 리스트 정보를 업데이트 합니다. (덮어쓰기)
     *
     * @tags Brands
     * @name BrandsUpdate
     * @summary 샵 브랜드 업데이트 ✅
     * @request PUT:/shops/{shopID}/brands
     * @secure
     * @response `204` `void` No Content
     */
    brandsUpdate: (shopId: string, request: DomainUpdateShopBrandsRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/brands`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 별로 관리하고 있는 브랜드를 생성합니다. (한/영 별도로 입력)
     *
     * @tags Brands
     * @name BrandsCreate
     * @summary 샵 브랜드 생성 ✅
     * @request POST:/shops/{shopID}/brands
     * @secure
     * @response `204` `void` No Content
     */
    brandsCreate: (shopId: string, request: DomainCreateShopBrandRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/brands`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 별로 관리하고 있는 브랜드를 삭제합니다. 여러개를 삭제할 수 있습니다
     *
     * @tags Brands
     * @name BrandsDelete
     * @summary 샵 브랜드 삭제 ✅
     * @request DELETE:/shops/{shopID}/brands
     * @secure
     * @response `204` `void` No Content
     */
    brandsDelete: ({ shopId, ...query }: BrandsDeleteParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/brands`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 사업자 정보를 조회하는 API (단건)
     *
     * @tags Business
     * @name BusinessDetail
     * @summary 샵의 사업자 정보 조회 ✅
     * @request GET:/shops/{shopID}/business
     * @secure
     * @response `200` `DomainGetShopBusinessResponse` OK
     */
    businessDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetShopBusinessResponse, any>({
        path: `/shops/${shopId}/business`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 사업자 정보를 수정하는 API
     *
     * @tags Business
     * @name BusinessUpdate
     * @summary 샵의 사업자 정보 수정 ✅
     * @request PUT:/shops/{shopID}/business
     * @secure
     * @response `204` `void` No Content
     */
    businessUpdate: (
      shopId: string,
      UpdateShopBusinessRequest: DomainUpdateShopBusinessRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/business`,
        method: 'PUT',
        body: UpdateShopBusinessRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 사업자 정보를 등록하는 API
     *
     * @tags Business
     * @name BusinessCreate
     * @summary 샵의 사업자 정보 등록 ✅
     * @request POST:/shops/{shopID}/business
     * @secure
     * @response `204` `void` No Content
     */
    businessCreate: (
      shopId: string,
      CreateShopBusinessRequest: DomainCreateShopBusinessRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/business`,
        method: 'POST',
        body: CreateShopBusinessRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 사업자 정보를 부분 수정하는 API
     *
     * @tags Business
     * @name BusinessPartialUpdate
     * @summary 샵의 사업자 정보 부분 수정 ✅
     * @request PATCH:/shops/{shopID}/business
     * @secure
     * @response `204` `void` No Content
     */
    businessPartialUpdate: (
      shopId: string,
      PatchShopBusinessRequest: DomainPatchShopBusinessRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/business`,
        method: 'PATCH',
        body: PatchShopBusinessRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 카페24 정보를 조회하는 API
     *
     * @tags Platforms
     * @name Cafe24AuthDetail
     * @summary 샵의 카페24 정보 조회 ✅
     * @request GET:/shops/{shopID}/cafe24-auth
     * @secure
     * @response `200` `DomainGetShopCafe24AuthResponse` 카페24 정보 응답 값
     */
    cafe24AuthDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetShopCafe24AuthResponse, any>({
        path: `/shops/${shopId}/cafe24-auth`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵의 카페24 토큰 정보를 부분 수정하는 API ⚠️ 유효하지 않은 `mallID` 입력 시 토큰이 제대로 Refresh 되지 않으며, **카페 24 관련 모든 API가 정상 작동 하지 않게 됨.** 반드시 유효한 `mallID`로만 테스트 할 것.
     *
     * @tags Platforms
     * @name Cafe24AuthPartialUpdate
     * @summary 샵의 카페24 토큰 정보 부분 수정 ✅
     * @request PATCH:/shops/{shopID}/cafe24-auth
     * @secure
     * @response `204` `void` No Content
     */
    cafe24AuthPartialUpdate: (
      shopId: string,
      PatchShopCafe24AuthRequest: DomainPatchShopCafe24AuthRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/cafe24-auth`,
        method: 'PATCH',
        body: PatchShopCafe24AuthRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 설정에 있는 카페24 추가항목을 갱신해주는 API 입니다. 카페24 최신 상품 하나를 조회하여 추가항목을 가져옵니다.
     *
     * @tags Shops
     * @name Cafe24AdditionalInformationCreate
     * @summary 샵의 카페24 추가항목을 갱신하는 API ✅
     * @request POST:/shops/{shopID}/cafe24/additional-information
     * @secure
     * @response `204` `void` No Content
     */
    cafe24AdditionalInformationCreate: (shopId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/cafe24/additional-information`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 주문을 취소합니다.
     *
     * @tags Orders
     * @name CancelOrdersCreate
     * @summary 샵 주문 취소 (다건)
     * @request POST:/shops/{shopID}/cancel-orders
     * @secure
     * @response `204` `void` No Content
     */
    cancelOrdersCreate: (shopId: string, CancelOrderRequest: DomainCancelOrdersRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/cancel-orders`,
        method: 'POST',
        body: CancelOrderRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵이 등록했던 카드를 조회합니다.
     *
     * @tags Cards
     * @name CardsDetail
     * @summary 카드를 조회합니다. ✅
     * @request GET:/shops/{shopID}/cards
     * @secure
     * @response `200` `DomainListPaymentCardsResponse` OK
     */
    cardsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListPaymentCardsResponse, any>({
        path: `/shops/${shopId}/cards`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cards
     * @name CardsCreate
     * @summary 카드를 생성합니다. ✅
     * @request POST:/shops/{shopID}/cards
     * @secure
     * @response `204` `void` No Content
     */
    cardsCreate: (
      shopId: string,
      CreatePaymentCardRequest: DomainCreatePaymentCardRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/cards`,
        method: 'POST',
        body: CreatePaymentCardRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 카드를 ID로 단건 조회합니다. 리스트와는 응답이 다릅니다.
     *
     * @tags Cards
     * @name CardsDetail2
     * @summary 카드를 단건 조회합니다. ✅
     * @request GET:/shops/{shopID}/cards/{cardID}
     * @originalName cardsDetail
     * @duplicate
     * @secure
     * @response `200` `DomainGetPaymentCardResponse` OK
     */
    cardsDetail2: (shopId: string, cardId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetPaymentCardResponse, any>({
        path: `/shops/${shopId}/cards/${cardId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 카드를 삭제합니다. 내부적으로는 Soft Delete를 수행합니다.
     *
     * @tags Cards
     * @name CardsDelete
     * @summary 카드를 삭제합니다. ✅
     * @request DELETE:/shops/{shopID}/cards/{cardID}
     * @secure
     * @response `204` `void` No Content
     */
    cardsDelete: (shopId: string, cardId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/cards/${cardId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 카드의 정보를 업데이트 합니다. 현재는 기본값 여부만 업데이트 가능합니다.
     *
     * @tags Cards
     * @name CardsPartialUpdate
     * @summary 카드의 정보를 업데이트합니다. ✅
     * @request PATCH:/shops/{shopID}/cards/{cardID}
     * @secure
     * @response `204` `void` No Content
     */
    cardsPartialUpdate: (
      shopId: string,
      cardId: string,
      PatchPaymentCardRequest: DomainPatchPaymentCardRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/cards/${cardId}`,
        method: 'PATCH',
        body: PatchPaymentCardRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description **(주의)** 웹소켓 프로토콜을 이용하여 스웨거에서는 테스트 불가능합니다. 변경된 샵 알람 데이터를 웹소켓을 이용해 전송한다.
     *
     * @tags Notifications
     * @name ChangedNotificationsWsDetail
     * @summary (웹소켓) 변경된 샵 알람 데이터를 웹소켓을 이용해 전송 ✅
     * @request GET:/shops/{shopID}/changed-notifications/ws
     * @secure
     * @response `200` `DomainStreamChangedShopNotificationResponse` OK
     */
    changedNotificationsWsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainStreamChangedShopNotificationResponse, any>({
        path: `/shops/${shopId}/changed-notifications/ws`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description **(주의)** 웹소켓 프로토콜을 이용하여 스웨거에서는 테스트 불가능합니다. 변경된 아이템 데이터를 웹소켓을 이용해 전송한다.
     *
     * @tags Tasks
     * @name ChangedShopTaskItemWsDetail
     * @summary (웹소켓) 변경된 아이템 데이터를 웹소켓을 이용해 전송 ✅
     * @request GET:/shops/{shopID}/changed-shop-task-item/ws
     * @secure
     * @response `200` `DomainStreamChangedShopTaskItemResponse` OK
     */
    changedShopTaskItemWsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainStreamChangedShopTaskItemResponse, any>({
        path: `/shops/${shopId}/changed-shop-task-item/ws`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 클레임 카운트를 조회하는 API 입니다.
     *
     * @tags Claims
     * @name ClaimCountsDetail
     * @summary 클레임 카운트 조회 API ✅
     * @request GET:/shops/{shopID}/claim-counts
     * @secure
     * @response `200` `DomainListClaimCountsResponse` OK
     */
    claimCountsDetail: ({ shopId, ...query }: ClaimCountsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListClaimCountsResponse, any>({
        path: `/shops/${shopId}/claim-counts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 클레임 리스트를 조회하는 API 입니다. (반품, 교환관련)
     *
     * @tags Claims
     * @name ClaimsDetail
     * @summary 클레임 리스트 조회 API ✅
     * @request GET:/shops/{shopID}/claims
     * @secure
     * @response `200` `DomainListClaimsResponse` 클레임 리스트 응답값
     */
    claimsDetail: ({ shopId, ...query }: ClaimsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListClaimsResponse, any>({
        path: `/shops/${shopId}/claims`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 클레임 단건을 조회하는 API 입니다. (반품, 교환관련)
     *
     * @tags Claims
     * @name ClaimsDetail2
     * @summary 클레임 단건 조회 API ✅
     * @request GET:/shops/{shopID}/claims/{claimID}
     * @originalName claimsDetail
     * @duplicate
     * @secure
     * @response `200` `DomainGetClaimResponse` 클레임 단건 응답값
     */
    claimsDetail2: (shopId: string, claimId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetClaimResponse, any>({
        path: `/shops/${shopId}/claims/${claimId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 플랫폼별 클레임 단건을 상세 조회하는 API 입니다. (현재는 Acloset만 지원)
     *
     * @tags Claims
     * @name ClaimsDetailDetail
     * @summary 클레임 단건 조회 상세 API ✅
     * @request GET:/shops/{shopID}/claims/{claimID}/detail
     * @secure
     * @response `200` `DomainGetClaimDetailResponse` 클레임 단건 상세 응답값
     */
    claimsDetailDetail: ({ shopId, claimId, ...query }: ClaimsDetailDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainGetClaimDetailResponse, any>({
        path: `/shops/${shopId}/claims/${claimId}/detail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 반품 클레임을 수거 완료하는 API 입니다. (카페24에서만 사용 중)
     *
     * @tags Claims
     * @name ClaimsPickupCreate
     * @summary 수거 완료 API ✅
     * @request POST:/shops/{shopID}/claims/{claimID}/pickup
     * @secure
     * @response `204` `void` No Content
     */
    claimsPickupCreate: (shopId: string, claimId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/claims/${claimId}/pickup`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 반품 클레임을 거부하는 API 입니다.
     *
     * @tags Claims
     * @name ClaimsRejectReturnCreate
     * @summary 반품 거부 API ✅
     * @request POST:/shops/{shopID}/claims/{claimID}/reject-return
     * @secure
     * @response `204` `void` No Content
     */
    claimsRejectReturnCreate: (
      shopId: string,
      claimId: string,
      RejectReturnClaimRequest: DomainRejectReturnClaimRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/claims/${claimId}/reject-return`,
        method: 'POST',
        body: RejectReturnClaimRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 반품 요청 클레임을 접수하는 API 입니다. (카페24 에서만 사용 중)
     *
     * @tags Claims
     * @name ClaimsRequestReturnCreate
     * @summary 반품 요청 클레임 접수 API ✅
     * @request POST:/shops/{shopID}/claims/{claimID}/request-return
     * @secure
     * @response `204` `void` No Content
     */
    claimsRequestReturnCreate: (
      shopId: string,
      claimId: string,
      RequestReturnClaimRequest: DomainRequestReturnClaimRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/claims/${claimId}/request-return`,
        method: 'POST',
        body: RequestReturnClaimRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 반품 클레임을 완료 처리하는 API 입니다.
     *
     * @tags Claims
     * @name ClaimsReturnCreate
     * @summary 반품 완료 API ✅
     * @request POST:/shops/{shopID}/claims/{claimID}/return
     * @secure
     * @response `204` `void` No Content
     */
    claimsReturnCreate: (
      shopId: string,
      claimId: string,
      ReturnClaimRequest: DomainReturnClaimRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/claims/${claimId}/return`,
        method: 'POST',
        body: ReturnClaimRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 이미지 리스트를 받아 타입을 분류하는 API 입니다.
     *
     * @tags Tasks
     * @name ClassifyImageTypesCreate
     * @summary AIMS 타입 분류 ✅
     * @request POST:/shops/{shopID}/classify-image-types
     * @secure
     * @response `200` `DomainClassifyImageTypesResponse` 이미지 타입 분류 반환 값
     */
    classifyImageTypesCreate: (shopId: string, request: DomainClassifyImageTypesRequest, params: RequestParams = {}) =>
      this.http.request<DomainClassifyImageTypesResponse, any>({
        path: `/shops/${shopId}/classify-image-types`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵의 주문을 배송확인합니다. 해당 API를 호출하면 배송중으로 변경이 됩니다.
     *
     * @tags Orders
     * @name ConfirmOrderShippingsCreate
     * @summary 샵 주문 배송확인 (다건) ✅
     * @request POST:/shops/{shopID}/confirm-order-shippings
     * @secure
     * @response `202` `DomainConfirmOrderShippingsResponse` Accepted
     */
    confirmOrderShippingsCreate: (
      shopId: string,
      ConfirmOrderShippingsRequest: DomainConfirmOrderShippingsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainConfirmOrderShippingsResponse, any>({
        path: `/shops/${shopId}/confirm-order-shippings`,
        method: 'POST',
        body: ConfirmOrderShippingsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 주문을 확인합니다. 해당 API를 호출하면 배송준비중으로 상태값이 변경됩니다.
     *
     * @tags Orders
     * @name ConfirmOrdersCreate
     * @summary 샵 주문 확인 (다건) ✅
     * @request POST:/shops/{shopID}/confirm-orders
     * @secure
     * @response `202` `DomainConfirmOrdersResponse` Accepted
     */
    confirmOrdersCreate: (
      shopId: string,
      ConfirmOrdersRequest: DomainConfirmOrdersRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainConfirmOrdersResponse, any>({
        path: `/shops/${shopId}/confirm-orders`,
        method: 'POST',
        body: ConfirmOrdersRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 새로운 플랫폼을 연동하는 API 입니다. ### 존재하는 맵핑 그룹에 디폴트 카테고리 맵핑을 추가하고 등록한 아이템에 플랫폼 정보를 추가합니다.
     *
     * @tags Platforms
     * @name ConnectPlatformCreate
     * @summary 플랫폼 연동 API ✅
     * @request POST:/shops/{shopID}/connect-platform
     * @secure
     * @response `204` `void` No Content
     */
    connectPlatformCreate: (shopId: string, request: DomainConnectPlatformRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/connect-platform`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 수정대기 아이템 갯수를 반환합니다. 필터에 영향을 받지 않습니다.
     *
     * @tags Sales
     * @name CountPendingModifyingDetail
     * @summary 수정대기 아이템 계수 API ✅
     * @request GET:/shops/{shopID}/count-pending-modifying
     * @secure
     * @response `200` `DomainCountPendingModifyingResponse` OK
     */
    countPendingModifyingDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainCountPendingModifyingResponse, any>({
        path: `/shops/${shopId}/count-pending-modifying`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsDetail
     * @summary 쿠폰을 리스트로 조회합니다. ✅
     * @request GET:/shops/{shopID}/coupons
     * @secure
     * @response `200` `DomainListShopCouponsResponse` OK
     */
    couponsDetail: ({ shopId, ...query }: CouponsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopCouponsResponse, any>({
        path: `/shops/${shopId}/coupons`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsAclosetCouponsDetail
     * @summary 세컨솔드 쿠폰을 조회합니다.
     * @request GET:/shops/{shopID}/coupons/acloset-coupons
     * @secure
     * @response `200` `DomainListAclosetCouponsResponse` 세컨솔드 쿠폰 목록 조회 응답값
     */
    couponsAclosetCouponsDetail: (
      { shopId, ...query }: CouponsAclosetCouponsDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListAclosetCouponsResponse, any>({
        path: `/shops/${shopId}/coupons/acloset-coupons`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsAclosetCouponsCreate
     * @summary 세컨솔드 쿠폰을 생성합니다.
     * @request POST:/shops/{shopID}/coupons/acloset-coupons
     * @secure
     * @response `204` `void` No Content
     */
    couponsAclosetCouponsCreate: (
      shopId: string,
      CreateAclosetCouponRequest: DomainCreateAclosetCouponRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/coupons/acloset-coupons`,
        method: 'POST',
        body: CreateAclosetCouponRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsAclosetCouponsDelete
     * @summary 세컨솔드 쿠폰을 삭제합니다.
     * @request DELETE:/shops/{shopID}/coupons/acloset-coupons/{aclosetCouponID}
     * @secure
     * @response `204` `void` No Content
     */
    couponsAclosetCouponsDelete: (shopId: string, aclosetCouponId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/coupons/acloset-coupons/${aclosetCouponId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsAclosetStoreCouponsDetail
     * @summary 세컨솔드 매장전용(현장결제) 쿠폰을 조회합니다. ✅
     * @request GET:/shops/{shopID}/coupons/acloset-store-coupons
     * @secure
     * @response `200` `DomainListAclosetStoreCouponsResponse` 세컨솔드 매장전용(현장결제) 쿠폰 목록 조회 응답값
     */
    couponsAclosetStoreCouponsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListAclosetStoreCouponsResponse, any>({
        path: `/shops/${shopId}/coupons/acloset-store-coupons`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsAclosetStoreCouponsCreate
     * @summary 세컨솔드 매장전용(현장결제) 쿠폰을 생성합니다. ✅
     * @request POST:/shops/{shopID}/coupons/acloset-store-coupons
     * @secure
     * @response `204` `void` No Content
     */
    couponsAclosetStoreCouponsCreate: (
      shopId: string,
      CreateAclosetStoreCouponRequest: DomainCreateAclosetStoreCouponRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/coupons/acloset-store-coupons`,
        method: 'POST',
        body: CreateAclosetStoreCouponRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsAclosetStoreCouponsUpdate
     * @summary 세컨솔드 매장전용(현장결제) 쿠폰을 수정합니다. ✅
     * @request PUT:/shops/{shopID}/coupons/acloset-store-coupons/{storeCouponID}
     * @secure
     * @response `204` `void` No Content
     */
    couponsAclosetStoreCouponsUpdate: (
      shopId: string,
      storeCouponId: string,
      UpdateAclosetStoreCouponRequest: DomainUpdateAclosetStoreCouponRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/coupons/acloset-store-coupons/${storeCouponId}`,
        method: 'PUT',
        body: UpdateAclosetStoreCouponRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsApplyPartialUpdate
     * @summary 쿠폰을 사용합니다. ✅
     * @request PATCH:/shops/{shopID}/coupons/{couponID}/apply
     * @secure
     * @response `204` `void` No Content
     * @response `400` `void` 사용하려는 쿠폰이 등록할 수 있는 상태가 아닌 경우 Code: SHOP_COUPON_IS_NOT_APPLICABLE, SHOP_COUPON_ALREADY_APPLIED, FREE_TRIAL_ALREADY_APPLIED
     * @response `404` `void` 사용하려는 쿠폰이 존재하지 않는 경우 Code: SHOP_COUPON_NOT_FOUND
     */
    couponsApplyPartialUpdate: (shopId: string, couponId: string, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/coupons/${couponId}/apply`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupon
     * @name CouponsRegisterPartialUpdate
     * @summary 쿠폰을 등록합니다. ✅
     * @request PATCH:/shops/{shopID}/coupons/{couponID}/register
     * @secure
     * @response `204` `void` No Content
     * @response `400` `void` 등록하려는 쿠폰이 등록할 수 있는 상태가 아닌 경우 Code: SHOP_COUPON_IS_NOT_REGISTRABLE
     * @response `404` `void` 등록하려는 쿠폰이 존재하지 않는 경우 Code: SHOP_COUPON_NOT_FOUND
     */
    couponsRegisterPartialUpdate: (shopId: string, couponId: string, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/coupons/${couponId}/register`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * @description 특정 샵의 크레딧을 리스트로 조회합니다.
     *
     * @tags Settlements
     * @name CreditsDetail
     * @summary 크레딧을 리스트로 조회합니다. ✅
     * @request GET:/shops/{shopID}/credits
     * @secure
     * @response `200` `DomainListShopCreditsResponse` OK
     */
    creditsDetail: ({ shopId, ...query }: CreditsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopCreditsResponse, any>({
        path: `/shops/${shopId}/credits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 판매 아이템들을 삭제합니다. 해당 API는 판매중지, 판매중, 수정대기 상태에서만 호출이 가능합니다.
     *
     * @tags Sales
     * @name DeleteSaleItemsCreate
     * @summary 판매 아이템 삭제 API ✅
     * @request POST:/shops/{shopID}/delete-sale-items
     * @secure
     * @response `202` `DomainDeleteSaleItemsResponse` Accepted
     */
    deleteSaleItemsCreate: (
      shopId: string,
      DeleteSaleItemsRequest: DomainDeleteSaleItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainDeleteSaleItemsResponse, any>({
        path: `/shops/${shopId}/delete-sale-items`,
        method: 'POST',
        body: DeleteSaleItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 엑셀 템플릿 목록 조회 API
     *
     * @tags Templates
     * @name ExcelTemplatesDetail
     * @summary 엑셀 템플릿 목록 조회 ✅
     * @request GET:/shops/{shopID}/excel-templates
     * @secure
     * @response `200` `DomainListExcelTemplatesResponse` OK
     */
    excelTemplatesDetail: ({ shopId, ...query }: ExcelTemplatesDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListExcelTemplatesResponse, any>({
        path: `/shops/${shopId}/excel-templates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 엑셀 템플릿 생성 API
     *
     * @tags Templates
     * @name ExcelTemplatesCreate
     * @summary 엑셀 템플릿 생성 ✅
     * @request POST:/shops/{shopID}/excel-templates
     * @secure
     * @response `204` `void` No Content
     */
    excelTemplatesCreate: (shopId: string, request: DomainCreateExcelTemplateRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/excel-templates`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 엑셀 템플릿 수정 API
     *
     * @tags Templates
     * @name ExcelTemplatesUpdate
     * @summary 엑셀 템플릿 수정 ✅
     * @request PUT:/shops/{shopID}/excel-templates/{excelTemplateID}
     * @secure
     * @response `204` `void` No Content
     */
    excelTemplatesUpdate: (
      shopId: string,
      excelTemplateId: string,
      request: DomainUpdateExcelTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/excel-templates/${excelTemplateId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 엑셀 템플릿 삭제 API
     *
     * @tags Templates
     * @name ExcelTemplatesDelete
     * @summary 엑셀 템플릿 삭제 ✅
     * @request DELETE:/shops/{shopID}/excel-templates/{excelTemplateID}
     * @secure
     * @response `204` `void` No Content
     */
    excelTemplatesDelete: (shopId: string, excelTemplateId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/excel-templates/${excelTemplateId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 엑셀 상품 목록 내보내기 API
     *
     * @tags Templates
     * @name ExcelTemplatesExportSaleItemsCreate
     * @summary 엑셀 상품 목록 내보내기 ✅️
     * @request POST:/shops/{shopID}/excel-templates/{excelTemplateID}/export-sale-items
     * @secure
     * @response `200` `DomainExportExcelSaleItemsResponse` OK
     */
    excelTemplatesExportSaleItemsCreate: (
      shopId: string,
      excelTemplateId: string,
      request: DomainExportExcelSaleItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainExportExcelSaleItemsResponse, any>({
        path: `/shops/${shopId}/excel-templates/${excelTemplateId}/export-sale-items`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 엑셀 주문 목록 내보내기 API
     *
     * @tags Templates
     * @name ExcelTemplatesExportShopOrdersCreate
     * @summary 엑셀 주문 목록 내보내기 ✅️
     * @request POST:/shops/{shopID}/excel-templates/{excelTemplateID}/export-shop-orders
     * @secure
     * @response `200` `DomainExportExcelShopOrdersResponse` OK
     */
    excelTemplatesExportShopOrdersCreate: (
      shopId: string,
      excelTemplateId: string,
      request: DomainExportExcelShopOrdersRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainExportExcelShopOrdersResponse, any>({
        path: `/shops/${shopId}/excel-templates/${excelTemplateId}/export-shop-orders`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 엑셀을 기반으로 주문 목록을 단체로 업데이트 하는 정말 대단한 API
     *
     * @tags Templates
     * @name ExcelTemplatesModifyShopOrdersCreate
     * @summary 엑셀을 가져와 주문 목록 수정하기 ✅️
     * @request POST:/shops/{shopID}/excel-templates/{excelTemplateID}/modify-shop-orders
     * @secure
     * @response `200` `DomainModifyExcelShopOrdersFromExcelResponse` OK
     */
    excelTemplatesModifyShopOrdersCreate: (
      shopId: string,
      excelTemplateId: string,
      data: ExcelTemplatesModifyShopOrdersCreatePayload,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainModifyExcelShopOrdersFromExcelResponse, any>({
        path: `/shops/${shopId}/excel-templates/${excelTemplateId}/modify-shop-orders`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @description 샵 패브릭 가격 계산기 리스트를 조회하는 API
     *
     * @tags MappingGroups
     * @name FabricPriceCalculatorsDetail
     * @summary 샵 패브릭 가격 계산기 리스트 조회 ✅
     * @request GET:/shops/{shopID}/fabric-price-calculators
     * @secure
     * @response `200` `DomainListFabricPriceCalculatorsResponse` OK
     */
    fabricPriceCalculatorsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListFabricPriceCalculatorsResponse, any>({
        path: `/shops/${shopId}/fabric-price-calculators`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 소재 가격 정보를 전부 지우고 재생성합니다. |**code**|**status**|**description**| |---|---|---| |400|N/A|샵 ID가 없음| |400|N/A|소재가 중복됨| |400|N/A|plus나 multiply가 누락됨|
     *
     * @tags MappingGroups
     * @name FabricPriceCalculatorsUpdate
     * @summary 샵 소재 가격 계산기 수정 ✅
     * @request PUT:/shops/{shopID}/fabric-price-calculators
     * @secure
     * @response `204` `void` No Content
     */
    fabricPriceCalculatorsUpdate: (
      shopId: string,
      request: DomainUpdateFabricPriceCalculatorsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/fabric-price-calculators`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inference
     * @name InferenceAutoLiquifyImageCreate
     * @summary 이미지에 대한 픽셀 자동 유동화를 수행합니다. ✅
     * @request POST:/shops/{shopID}/inference/auto-liquify-image
     * @secure
     * @response `200` `DomainAutoLiquifyImageResponse` OK
     */
    inferenceAutoLiquifyImageCreate: (
      shopId: string,
      AutoLiquifyImageRequest: DomainAutoLiquifyImageRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainAutoLiquifyImageResponse, any>({
        path: `/shops/${shopId}/inference/auto-liquify-image`,
        method: 'POST',
        body: AutoLiquifyImageRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inference
     * @name InferenceMultiModelCreate
     * @summary 여러가지 모델을 사용할 수 있는 API입니다. ✅
     * @request POST:/shops/{shopID}/inference/multi-model
     * @secure
     * @response `200` `DomainMultiModelResponse` OK
     */
    inferenceMultiModelCreate: (
      shopId: string,
      MultiModelRequest: DomainMultiModelRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainMultiModelResponse, any>({
        path: `/shops/${shopId}/inference/multi-model`,
        method: 'POST',
        body: MultiModelRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 인스타그램 게시물 제한을 조회하는 API 입니다.
     *
     * @tags Platforms
     * @name InstagramPublishLimitDetail
     * @summary 인스타그램 게시물 제한 조회 API ✅
     * @request GET:/shops/{shopID}/instagram-publish-limit
     * @secure
     * @response `200` `DomainGetInstagramPublishLimitResponse` OK
     * @response `404` `void` INSTAGRAM_SHOP_NOT_FOUND: Shop Not Found
     */
    instagramPublishLimitDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetInstagramPublishLimitResponse, void>({
        path: `/shops/${shopId}/instagram-publish-limit`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵의 카페24 OAuth 인증을 요청하는 API
     *
     * @tags Platforms
     * @name IssueCafe24AuthCreate
     * @summary 샵 카페24 OAuth 인증 ✅
     * @request POST:/shops/{shopID}/issue-cafe24-auth
     * @secure
     * @response `204` `void` No Content
     */
    issueCafe24AuthCreate: (
      shopId: string,
      IssueShopCafe24AuthRequest: DomainIssueShopCafe24AuthRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/issue-cafe24-auth`,
        method: 'POST',
        body: IssueShopCafe24AuthRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 인스타그램 OAuth 인증을 요청하는 API
     *
     * @tags Platforms
     * @name IssueInstagramAuthCreate
     * @summary 샵 인스타그램 OAuth 인증 ✅
     * @request POST:/shops/{shopID}/issue-instagram-auth
     * @secure
     * @response `204` `void` No Content
     */
    issueInstagramAuthCreate: (
      shopId: string,
      IssueShopInstagramAuthRequest: DomainIssueShopInstagramAuthRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/issue-instagram-auth`,
        method: 'POST',
        body: IssueShopInstagramAuthRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 네이버 스마트 스토어 OAuth 인증을 요청하는 API
     *
     * @tags Platforms
     * @name IssueNaverAuthCreate
     * @summary 샵 네이버 스마트 스토어 OAuth 인증 ✅
     * @request POST:/shops/{shopID}/issue-naver-auth
     * @secure
     * @response `204` `void` No Content
     */
    issueNaverAuthCreate: (
      shopId: string,
      IssueShopNaverSmartStoreAuthRequest: DomainIssueShopNaverSmartStoreAuthRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/issue-naver-auth`,
        method: 'POST',
        body: IssueShopNaverSmartStoreAuthRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 아이템 목록을 수정하는 API 입니다.
     *
     * @tags Shops
     * @name ItemsPartialUpdate
     * @summary 샵의 아이템 다건 수정 ✅
     * @request PATCH:/shops/{shopID}/items
     * @secure
     * @response `204` `void` No Content
     */
    itemsPartialUpdate: (
      shopId: string,
      PatchShopItemsRequest: DomainPatchShopItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/items`,
        method: 'PATCH',
        body: PatchShopItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 카페24 아이템을 불러오는 API 입니다.
     *
     * @tags Shops
     * @name LoadCafe24ProductsCreate
     * @summary 카페24 아이템 불러오기  ✅️
     * @request POST:/shops/{shopID}/load-cafe24-products
     * @secure
     */
    loadCafe24ProductsCreate: (shopId: string, params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/shops/${shopId}/load-cafe24-products`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 카페24 아이템을 불러오기를 강제로 취소하고 관계된 데이터를 전부 삭제합니다. (큐 강제 제거, 상품 제거, 작업 제거, Shop 상태 데이터 초기화)
     *
     * @tags Shops
     * @name LoadCafe24ProductsCancelCreate
     * @summary [MANAGER-ONLY] 카페24 아이템 불러오기 취소 ✅️
     * @request POST:/shops/{shopID}/load-cafe24-products/cancel
     * @secure
     */
    loadCafe24ProductsCancelCreate: (shopId: string, params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/shops/${shopId}/load-cafe24-products/cancel`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 네이버 아이템을 불러오는 API 입니다.
     *
     * @tags Shops
     * @name LoadNaverProductsCreate
     * @summary 네이버 아이템 불러오기 ✅
     * @request POST:/shops/{shopID}/load-naver-products
     * @secure
     */
    loadNaverProductsCreate: (shopId: string, params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/shops/${shopId}/load-naver-products`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 네이버 아이템을 불러오기를 강제로 취소하고 관계된 데이터를 전부 삭제합니다. (큐 강제 제거, 상품 제거, 작업 제거, Shop 상태 데이터 초기화)
     *
     * @tags Shops
     * @name LoadNaverProductsCancelCreate
     * @summary [MANAGER-ONLY] 네이버 아이템 불러오기 취소 ✅
     * @request POST:/shops/{shopID}/load-naver-products/cancel
     * @secure
     */
    loadNaverProductsCancelCreate: (shopId: string, params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/shops/${shopId}/load-naver-products/cancel`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 외부 플랫폼의 카테고리를 수동으로 동기화하는 API (커스텀 카테고리를 사용하는 플랫폼만 해당 함)
     *
     * @tags Platforms
     * @name ManualSyncPlatformCategoriesCreate
     * @summary 샵 카테고리 수동 동기화 ✅
     * @request POST:/shops/{shopID}/manual-sync-platform-categories
     * @secure
     * @response `204` `void` No Content
     */
    manualSyncPlatformCategoriesCreate: (
      shopId: string,
      SyncShopPlatformCategoriesRequest: DomainSyncShopPlatformCategoriesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/manual-sync-platform-categories`,
        method: 'POST',
        body: SyncShopPlatformCategoriesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹 리스트를 조회하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsDetail
     * @summary 샵 매핑 그룹 리스트 조회 ✅
     * @request GET:/shops/{shopID}/mapping-groups
     * @secure
     * @response `200` `DomainListMappingGroupsResponse` OK
     */
    mappingGroupsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListMappingGroupsResponse, any>({
        path: `/shops/${shopId}/mapping-groups`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹을 생성하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsCreate
     * @summary 샵 매핑 그룹 생성 ✅
     * @request POST:/shops/{shopID}/mapping-groups
     * @secure
     * @response `200` `DomainCreateMappingGroupResponse` OK
     */
    mappingGroupsCreate: (shopId: string, request: DomainCreateMappingGroupRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreateMappingGroupResponse, any>({
        path: `/shops/${shopId}/mapping-groups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 새로운 플랫폼에 대해 맵핑그룹 맵핑 추가 API 입니다. ### 존재하는 맵핑 그룹에 디폴트 카테고리 맵핑을 추가합니다.
     *
     * @tags MappingGroups
     * @name MappingGroupsAddDefaultMappingCreate
     * @summary 맵핑그룹 맵핑 추가 API ✅
     * @request POST:/shops/{shopID}/mapping-groups/add-default-mapping
     * @secure
     * @response `204` `void` No Content
     */
    mappingGroupsAddDefaultMappingCreate: (
      shopId: string,
      request: DomainAddDefaultMappingGroupMappingsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-groups/add-default-mapping`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 연결되지 않은 상품분류 조회
     *
     * @tags MappingGroups
     * @name MappingGroupsUnMappedRulesDetail
     * @summary 연결되지 않은 상품분류 조회
     * @request GET:/shops/{shopID}/mapping-groups/un-mapped-rules
     * @secure
     * @response `200` `DomainListUnMappedMappingGroupMappingRulesResponse` OK
     * @response `204` `void` No Content
     */
    mappingGroupsUnMappedRulesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListUnMappedMappingGroupMappingRulesResponse, any>({
        path: `/shops/${shopId}/mapping-groups/un-mapped-rules`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 연결되지 않은 상품분류 수
     *
     * @tags MappingGroups
     * @name MappingGroupsUnMappedRulesPartialUpdate
     * @summary 연결되지 않은 상품분류 수정
     * @request PATCH:/shops/{shopID}/mapping-groups/un-mapped-rules
     * @secure
     * @response `204` `void` No Content
     */
    mappingGroupsUnMappedRulesPartialUpdate: (
      shopId: string,
      request: DomainUpdateUnMappedMappingGroupMappingRulesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-groups/un-mapped-rules`,
        method: 'PATCH',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹을 조회하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsDetail2
     * @summary 샵 매핑 그룹 조회 (단건) ✅
     * @request GET:/shops/{shopID}/mapping-groups/{mappingGroupID}
     * @originalName mappingGroupsDetail
     * @duplicate
     * @secure
     * @response `200` `DomainGetMappingGroupResponse` OK
     */
    mappingGroupsDetail2: (shopId: string, mappingGroupId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetMappingGroupResponse, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹을 삭제하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsDelete
     * @summary 샵 매핑 그룹 삭제 ✅
     * @request DELETE:/shops/{shopID}/mapping-groups/{mappingGroupID}
     * @secure
     * @response `204` `void` No Content
     */
    mappingGroupsDelete: (shopId: string, mappingGroupId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹을 수정하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsPartialUpdate
     * @summary 샵 매핑 그룹 수정 ✅
     * @request PATCH:/shops/{shopID}/mapping-groups/{mappingGroupID}
     * @secure
     * @response `204` `void` No Content
     */
    mappingGroupsPartialUpdate: (
      shopId: string,
      mappingGroupId: string,
      PatchMappingGroupRequest: DomainPatchMappingGroupRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}`,
        method: 'PATCH',
        body: PatchMappingGroupRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹에 기존 매핑을 삭제하고 기본 매핑을 밀어넣는 API ### 🚨 해당 API는 개발용 API로, 서비스 용도로 사용을 금합니다. - 해당 API는 매핑 그룹 상태를 무시하므로, 서비스 용도로 적합하지 않습니다. - 디버깅 상황에서 매핑 그룹 자원이 통제되었을 때에만 사용해주세요.
     *
     * @tags MappingGroups
     * @name MappingGroupsAddDefaultMappingCreate2
     * @summary [DEV] 샵 매핑 그룹 기본 매핑 추가 ⚙️
     * @request POST:/shops/{shopID}/mapping-groups/{mappingGroupID}/add-default-mapping
     * @originalName mappingGroupsAddDefaultMappingCreate
     * @duplicate
     * @secure
     * @response `204` `void` No Content
     */
    mappingGroupsAddDefaultMappingCreate2: (
      shopId: string,
      mappingGroupId: string,
      request: DomainAddDefaultMappingGroupMappingRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}/add-default-mapping`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹 매핑 리스트를 조회하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsMappingsDetail
     * @summary 샵 매핑 그룹 매핑 리스트 조회 ✅
     * @request GET:/shops/{shopID}/mapping-groups/{mappingGroupID}/mappings
     * @secure
     * @response `200` `DomainListMappingGroupMappingsResponse` OK
     */
    mappingGroupsMappingsDetail: (
      { shopId, mappingGroupId, ...query }: MappingGroupsMappingsDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListMappingGroupMappingsResponse, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}/mappings`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹 매핑을 수정하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsMappingsUpdate
     * @summary 샵 매핑 그룹 매핑 전체 수정 ✅
     * @request PUT:/shops/{shopID}/mapping-groups/{mappingGroupID}/mappings
     * @secure
     * @response `204` `void` No Content
     */
    mappingGroupsMappingsUpdate: (
      shopId: string,
      mappingGroupId: string,
      request: DomainUpdateMappingGroupMappingsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}/mappings`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹 매핑을 생성하는 API ⚠️ 카페 24 커스텀 매핑을 사용할 시 호출해주세요.
     *
     * @tags MappingGroups
     * @name MappingGroupsMappingsCreate
     * @summary 샵 매핑 그룹 매핑 생성 (단건) ✅
     * @request POST:/shops/{shopID}/mapping-groups/{mappingGroupID}/mappings
     * @secure
     * @response `204` `void` No Content
     */
    mappingGroupsMappingsCreate: (
      shopId: string,
      mappingGroupId: string,
      request: DomainCreateMappingGroupMappingRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}/mappings`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹 내 매핑 내 규칙을 부분 수정하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsMappingsRulesPartialUpdate
     * @summary 샵 매핑 그룹 내 매핑 내 규칙 부분 수정 ✅
     * @request PATCH:/shops/{shopID}/mapping-groups/{mappingGroupID}/mappings/{mappingID}/rules/{ruleID}
     * @secure
     * @response `204` `void` No Content
     */
    mappingGroupsMappingsRulesPartialUpdate: (
      shopId: string,
      mappingGroupId: string,
      mappingId: string,
      ruleId: string,
      request: DomainPatchMappingRuleRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}/mappings/${mappingId}/rules/${ruleId}`,
        method: 'PATCH',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹 속성 리스트를 조회하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsPropertiesDetail
     * @summary 샵 매핑 그룹 속성 리스트 조회 ✅
     * @request GET:/shops/{shopID}/mapping-groups/{mappingGroupID}/properties
     * @secure
     * @response `200` `DomainListMappingGroupPropertiesResponse` OK
     */
    mappingGroupsPropertiesDetail: (shopId: string, mappingGroupId: string, params: RequestParams = {}) =>
      this.http.request<DomainListMappingGroupPropertiesResponse, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}/properties`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 매핑 그룹 속성을 수정하는 API
     *
     * @tags MappingGroups
     * @name MappingGroupsPropertiesUpdate
     * @summary 샵 매핑 그룹 속성 전체 수정 ✅
     * @request PUT:/shops/{shopID}/mapping-groups/{mappingGroupID}/properties
     * @secure
     * @response `204` `void` No Content
     */
    mappingGroupsPropertiesUpdate: (
      shopId: string,
      mappingGroupId: string,
      request: DomainUpdateMappingGroupPropertiesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-groups/${mappingGroupId}/properties`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 매핑 속성 리스트를 조회하는 API
     *
     * @tags MappingGroups
     * @name MappingPropertiesDetail
     * @summary 샵 매핑 속성 리스트 조회
     * @request GET:/shops/{shopID}/mapping-properties
     * @secure
     * @response `200` `DomainListMappingGroupPropertiesResponse` OK
     */
    mappingPropertiesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListMappingGroupPropertiesResponse, any>({
        path: `/shops/${shopId}/mapping-properties`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 매핑 속성을 수정하는 API
     *
     * @tags MappingGroups
     * @name MappingPropertiesUpdate
     * @summary 샵 매핑 속성 전체 수정
     * @request PUT:/shops/{shopID}/mapping-properties
     * @secure
     * @response `204` `void` No Content
     */
    mappingPropertiesUpdate: (
      shopId: string,
      request: DomainUpdateShopMappingPropertiesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/mapping-properties`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 별 카테고리 속성 별칭 조회
     *
     * @tags Metadata
     * @name MetadataCategoryAliasesDetail
     * @summary 샵 별 카테고리 속성 별칭 조회 ✅
     * @request GET:/shops/{shopID}/metadata/category-aliases
     * @secure
     * @response `200` `DomainListCategoryAliasResponse` 샵 별 카테고리 속성 별칭 응답값
     */
    metadataCategoryAliasesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListCategoryAliasResponse, any>({
        path: `/shops/${shopId}/metadata/category-aliases`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵 별 카테고리 속성 별칭 수정
     *
     * @tags Metadata
     * @name MetadataCategoryAliasesUpdate
     * @summary 샵 별 카테고리 속성 별칭 수정 ✅
     * @request PUT:/shops/{shopID}/metadata/category-aliases
     * @secure
     * @response `204` `void` No Content
     * @response `404` `void` 해당 매핑 그룹ID가 없는 경우
     */
    metadataCategoryAliasesUpdate: (
      shopId: string,
      UpdateCategoryAliasesRequest: DomainUpdateCategoryAliasesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/metadata/category-aliases`,
        method: 'PUT',
        body: UpdateCategoryAliasesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 별 컬러 별칭 조회
     *
     * @tags Metadata
     * @name MetadataColorAliasesDetail
     * @summary 샵 별 컬러 별칭 조회 ✅
     * @request GET:/shops/{shopID}/metadata/color-aliases
     * @secure
     * @response `200` `DomainListColorAliasesResponse` 샵 별 컬러 별칭 응답값
     */
    metadataColorAliasesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListColorAliasesResponse, any>({
        path: `/shops/${shopId}/metadata/color-aliases`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵 별 컬러 별칭 수정
     *
     * @tags Metadata
     * @name MetadataColorAliasesUpdate
     * @summary 샵 별 컬러 별칭 수정 ✅
     * @request PUT:/shops/{shopID}/metadata/color-aliases
     * @secure
     * @response `204` `void` No Content
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: METADATA_ALIAS_NOT_FOUND
     */
    metadataColorAliasesUpdate: (
      shopId: string,
      UpdateColorAliasesRequest: DomainUpdateColorAliasesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/metadata/color-aliases`,
        method: 'PUT',
        body: UpdateColorAliasesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 별 소재 별칭 조회
     *
     * @tags Metadata
     * @name MetadataFabricAliasesDetail
     * @summary 샵 별 소재 별칭 조회 ✅
     * @request GET:/shops/{shopID}/metadata/fabric-aliases
     * @secure
     * @response `200` `DomainListFabricAliasesResponse` 샵 별 소재 별칭 응답값
     */
    metadataFabricAliasesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListFabricAliasesResponse, any>({
        path: `/shops/${shopId}/metadata/fabric-aliases`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵 별 소재 별칭 수정
     *
     * @tags Metadata
     * @name MetadataFabricAliasesUpdate
     * @summary 샵 별 소재 별칭 수정 ✅
     * @request PUT:/shops/{shopID}/metadata/fabric-aliases
     * @secure
     * @response `204` `void` No Content
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: METADATA_ALIAS_NOT_FOUND
     */
    metadataFabricAliasesUpdate: (
      shopId: string,
      UpdateFabricAliasesRequest: DomainUpdateFabricAliasesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/metadata/fabric-aliases`,
        method: 'PUT',
        body: UpdateFabricAliasesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 카페24 상품 추가 이미지 삭제
     *
     * @tags Migrate
     * @name MigrateDeleteCafe24ProductAdditionalImagesCreate
     * @summary [DEV-ONLY] 카페24 상품 추가 이미지 삭제 ⚙️
     * @request POST:/shops/{shopID}/migrate/delete-cafe24-product-additional-images
     * @secure
     * @response `204` `string` ok
     */
    migrateDeleteCafe24ProductAdditionalImagesCreate: (
      shopId: string,
      request: DomainMigrateDeleteCafe24ProductAdditionalImagesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<string, any>({
        path: `/shops/${shopId}/migrate/delete-cafe24-product-additional-images`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당 API는 개발용으로 제작되었습니다. 서비스 용도로 사용을 금합니다. 🚨 상품 수정 사항 반영
     *
     * @tags Migrate
     * @name MigrateModifySaleItemsCreate
     * @summary [DEV-ONLY] 상품 수정 사항 반영 ⚙️
     * @request POST:/shops/{shopID}/migrate/modify-sale-items
     * @secure
     * @response `204` `string` ok
     */
    migrateModifySaleItemsCreate: (
      shopId: string,
      request: DomainMigrateModifySaleItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<string, any>({
        path: `/shops/${shopId}/migrate/modify-sale-items`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 이메일 변경 API
     *
     * @tags Users
     * @name ModifyEmailCreate
     * @summary 이메일 변경 ✅
     * @request POST:/shops/{shopID}/modify-email
     * @secure
     * @response `204` `void` No Content
     */
    modifyEmailCreate: (
      shopId: string,
      ModifyUserEmailRequest: DomainModifyUserEmailRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/modify-email`,
        method: 'POST',
        body: ModifyUserEmailRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 해당 API를 요청하면 다른 플랜으로 변경합니다. 같은 플랜으로는 변경이 불가능합니다.
     *
     * @tags Plans
     * @name ModifyPlanCreate
     * @summary 샵 플랜의 값을 변경합니다. ✅
     * @request POST:/shops/{shopID}/modify-plan
     * @deprecated
     * @secure
     * @response `204` `void` No Content
     */
    modifyPlanCreate: (
      shopId: string,
      ModifyShopPlanRequest: DomainModifyShopPlanRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/modify-plan`,
        method: 'POST',
        body: ModifyShopPlanRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 아이템들의 각 플랫폼 별 할인율을 수정합니다. 해당 API는 수정대기, 판매중지, 판매중 상태에서만 호출이 가능합니다.
     *
     * @tags Sales
     * @name ModifySaleItemDiscountsCreate
     * @summary 할인율 수정 API ✅
     * @request POST:/shops/{shopID}/modify-sale-item-discounts
     * @secure
     * @response `202` `DomainModifySaleItemDiscountsResponse` Accepted
     */
    modifySaleItemDiscountsCreate: (
      shopId: string,
      ModifySaleItemDiscountsRequest: DomainModifySaleItemDiscountsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainModifySaleItemDiscountsResponse, any>({
        path: `/shops/${shopId}/modify-sale-item-discounts`,
        method: 'POST',
        body: ModifySaleItemDiscountsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 판매 아이템의 인스타그램 설명을 수정합니다. 해당 API는 판매중지, 판매중, 수정대기 상태에서만 호출이 가능합니다.
     *
     * @tags Sales
     * @name ModifySaleItemInstagramDescriptionCreate
     * @summary 판매 아이템 인스타그램 설명 수정 API ✅
     * @request POST:/shops/{shopID}/modify-sale-item-instagram-description
     * @secure
     * @response `204` `void` No Content
     */
    modifySaleItemInstagramDescriptionCreate: (
      shopId: string,
      ModifySaleItemInstagramDescriptionRequest: DomainModifySaleItemInstagramDescriptionRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/modify-sale-item-instagram-description`,
        method: 'POST',
        body: ModifySaleItemInstagramDescriptionRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description AIMS 이메일과 비밀번호 변경 API
     *
     * @tags Users
     * @name ModifyUserEmailPasswordCreate
     * @summary AIMS 이메일과 비밀번호 변경 ✅
     * @request POST:/shops/{shopID}/modify-user-email-password
     * @secure
     * @response `204` `void` No Content
     */
    modifyUserEmailPasswordCreate: (
      shopId: string,
      ModifyUserEmailPasswordRequest: DomainModifyUserEmailPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/modify-user-email-password`,
        method: 'POST',
        body: ModifyUserEmailPasswordRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description AIMS 비밀번호 변경 API
     *
     * @tags Users
     * @name ModifyUserPasswordCreate
     * @summary AIMS 비밀번호 변경 ✅
     * @request POST:/shops/{shopID}/modify-user-password
     * @secure
     * @response `204` `void` No Content
     */
    modifyUserPasswordCreate: (
      shopId: string,
      ModifyUserPasswordRequest: DomainModifyUserPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/modify-user-password`,
        method: 'POST',
        body: ModifyUserPasswordRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 알람을 가져온다. ### 판매 게시 실패 시 오류 처리 (in `additionalField`) #### 포맷 ```json { "errors": [{ "errorCode": "에러 코드", "errorMessage": "메시지", "platformType": "플랫폼 타입", "saleItemID": "실패한 아이템 ID", "itemAlias": "실패한 아이템 코드" }] } ``` #### 에러 코드 | 코드 | 설명 | | --- | --- | | `PLATFORM_CATEGORY_NOT_FOUND` | `플랫폼 카테고리가 비어있어 업로드 실패` |
     *
     * @tags Notifications
     * @name NotificationsDetail
     * @summary 샵 알람 리스트 ✅
     * @request GET:/shops/{shopID}/notifications
     * @secure
     * @response `200` `DomainListShopNotificationsResponse` OK
     */
    notificationsDetail: ({ shopId, ...query }: NotificationsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopNotificationsResponse, any>({
        path: `/shops/${shopId}/notifications`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 세컨솔드 주문 알람을 가져온다.
     *
     * @tags Notifications
     * @name NotificationsAclosetDetail
     * @summary 세컨솔드 알람 리스트 ✅
     * @request GET:/shops/{shopID}/notifications/acloset
     * @secure
     * @response `200` `DomainListAclosetNotificationsResponse` OK
     */
    notificationsAclosetDetail: ({ shopId, ...query }: NotificationsAclosetDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListAclosetNotificationsResponse, any>({
        path: `/shops/${shopId}/notifications/acloset`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 세컨솔드 주문 알람 카운트를 가져온다.
     *
     * @tags Notifications
     * @name NotificationsAclosetCountDetail
     * @summary 세컨솔드 알람 카운트 ✅
     * @request GET:/shops/{shopID}/notifications/acloset/count
     * @secure
     * @response `200` `DomainCountAclosetNotificationsResponse` OK
     */
    notificationsAclosetCountDetail: (
      { shopId, ...query }: NotificationsAclosetCountDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainCountAclosetNotificationsResponse, any>({
        path: `/shops/${shopId}/notifications/acloset/count`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 알람 카운트를 가져온다.
     *
     * @tags Notifications
     * @name NotificationsCountDetail
     * @summary 알람 카운트 ✅
     * @request GET:/shops/{shopID}/notifications/count
     * @secure
     * @response `200` `DomainCountShopNotificationsResponse` OK
     */
    notificationsCountDetail: ({ shopId, ...query }: NotificationsCountDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainCountShopNotificationsResponse, any>({
        path: `/shops/${shopId}/notifications/count`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 알림톡 보내기
     *
     * @tags Notifications
     * @name NotificationsKakaotalkCreate
     * @summary 카카오 알림톡 생성 ✅
     * @request POST:/shops/{shopID}/notifications/kakaotalk
     * @secure
     * @response `204` `void` No Content
     */
    notificationsKakaotalkCreate: (
      shopId: string,
      request: DomainSendKakaotalkNotificationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/notifications/kakaotalk`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 알람을 삭제한다.
     *
     * @tags Notifications
     * @name NotificationsDelete
     * @summary 샵 알람 삭제 ✅
     * @request DELETE:/shops/{shopID}/notifications/{notificationID}
     * @secure
     * @response `204` `void` No Content
     */
    notificationsDelete: (shopId: string, notificationId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/notifications/${notificationId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 각 플랫폼에 아이템들을 판매게시합니다. 해당 API를 호출하면 판매중 상태로 변환됩니다. |code|status|description| |---|---|---| |`SHOP_PLATFORM_CATEGORY_NOT_FOUND`|409|게시하고자 하는 플랫폼의 카테고리가 비어있습니다.| |`SHOP_TEMPLATE_NOT_FOUND`|409|게시하고자 하는 플랫폼의 템플릿이 비어있습니다.| |`SHOP_AVAILABLE-FEATURES_INACTIVE`|403|샵 사용 가능한 기능이 비활성화 되어 있습니다.|
     *
     * @tags Sales
     * @name OpenSaleItemsCreate
     * @summary 판매 개시 API ✅
     * @request POST:/shops/{shopID}/open-sale-items
     * @secure
     * @response `202` `DomainOpenSaleItemsResponse` Accepted
     */
    openSaleItemsCreate: (
      shopId: string,
      OpenSaleItemsRequest: DomainOpenSaleItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainOpenSaleItemsResponse, any>({
        path: `/shops/${shopId}/open-sale-items`,
        method: 'POST',
        body: OpenSaleItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 주문의 상태별 카운트를 조회합니다. ## 유효성 검사 > 해당 API 유효성 검사가 많아 아래에 해당 내역을 명세합니다. - `shopID`가 존재하는지 형식에 맞는지 확인합니다. - `platformType`이 비어있지 않은 경우 메타데이터 shop, platform-type에 명시된 값이 아니면 오류를 반환합니다. - `orderStatus`값이 메타데이터에 포함되어 있지 않은 값이면 오류를 반환합니다. - `searchPeriodType`값이 빈 값이면 에러를 반환하며, 해당 값이 enum에 설정된 값이 아닌 경우 오류를 반환합니다. - `searchPeriodType`값이 존재하나, to, from 중 하나라도 값이 채워져 있다면 오류를 반환합니다. - `searchKeywordType`이 있는 경우 해당 값이 enum에 설정된 값이 아닌 경우 오류를 반환합니다. - `searchKeyword`가 있으나 `searchKeywordType` 값이 없는 경우 오류를 반환합니다. = `to`, `from` 중 하나만 채워져 있는 경우 오류를 반환합니다. - `to`가 `from`보다 이전인 경우 에러를 반환합니다.
     *
     * @tags Orders
     * @name OrderCountsDetail
     * @summary 샵 주문 상태별 카운트 조회 ✅
     * @request GET:/shops/{shopID}/order-counts
     * @secure
     * @response `200` `DomainListShopOrderCountsResponse` OK
     */
    orderCountsDetail: ({ shopId, ...query }: OrderCountsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopOrderCountsResponse, any>({
        path: `/shops/${shopId}/order-counts`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 주문 대시보드를 조회합니다. dashboardItems는 상태별로 최대 5개씩만 조회됩니다.
     *
     * @tags Orders
     * @name OrderDashboardsDetail
     * @summary 샵 주문 대시보드 조회 ✅
     * @request GET:/shops/{shopID}/order-dashboards
     * @secure
     * @response `200` `DomainListShopOrderDashboardsResponse` OK
     */
    orderDashboardsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListShopOrderDashboardsResponse, any>({
        path: `/shops/${shopId}/order-dashboards`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 주문 리스트를 조회합니다.
     *
     * @tags Orders
     * @name OrdersDetail
     * @summary 샵 주문 리스트 조회 ✅
     * @request GET:/shops/{shopID}/orders
     * @secure
     * @response `200` `DomainListShopOrdersResponse` OK
     */
    ordersDetail: ({ shopId, ...query }: OrdersDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopOrdersResponse, any>({
        path: `/shops/${shopId}/orders`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 주문 리스트를 수정합니다.
     *
     * @tags Orders
     * @name OrdersPartialUpdate
     * @summary 샵 주문 리스트 수정 ✅
     * @request PATCH:/shops/{shopID}/orders
     * @secure
     * @response `204` `void` No Content
     */
    ordersPartialUpdate: (
      shopId: string,
      PatchShopOrdersRequest: DomainPatchShopOrdersRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/orders`,
        method: 'PATCH',
        body: PatchShopOrdersRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 주문 ID 리스트를 조회합니다.
     *
     * @tags Orders
     * @name OrdersIdDetail
     * @summary 샵 주문 ID 리스트 조회 ✅
     * @request GET:/shops/{shopID}/orders/id
     * @secure
     * @response `200` `DomainListShopOrderIDsResponse` OK
     */
    ordersIdDetail: ({ shopId, ...query }: OrdersIdDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopOrderIDsResponse, any>({
        path: `/shops/${shopId}/orders/id`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 주문을 취소합니다.
     *
     * @tags Orders
     * @name OrdersCancelCreate
     * @summary 샵 주문 취소 ✅
     * @request POST:/shops/{shopID}/orders/{orderID}/cancel
     * @secure
     * @response `204` `void` No Content
     */
    ordersCancelCreate: (
      shopId: string,
      orderId: string,
      CancelOrderRequest: DomainCancelOrderRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/orders/${orderId}/cancel`,
        method: 'POST',
        body: CancelOrderRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 주문 결제를 확인합니다.
     *
     * @tags Orders
     * @name OrdersConfirmPaymentCreate
     * @summary 샵 주문 결제확인 ✅
     * @request POST:/shops/{shopID}/orders/{orderID}/confirm-payment
     * @secure
     * @response `204` `void` No Content
     */
    ordersConfirmPaymentCreate: (shopId: string, orderId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/orders/${orderId}/confirm-payment`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsDetailsDetail
     * @summary 결제내역을 리스트로 조회합니다. 🛠️
     * @request GET:/shops/{shopID}/payments/details
     * @secure
     * @response `200` `DomainListPaymentDetailsResponse` OK
     */
    paymentsDetailsDetail: ({ shopId, ...query }: PaymentsDetailsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListPaymentDetailsResponse, any>({
        path: `/shops/${shopId}/payments/details`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsDetailsTasksDetail
     * @summary 결제내역의 상세 태스크 내역을 리스트로 조회합니다. ✅
     * @request GET:/shops/{shopID}/payments/details/{paymentDetailID}/tasks
     * @secure
     * @response `200` `DomainListPaymentDetailTasksResponse` OK
     */
    paymentsDetailsTasksDetail: (shopId: string, paymentDetailId: string, params: RequestParams = {}) =>
      this.http.request<DomainListPaymentDetailTasksResponse, any>({
        path: `/shops/${shopId}/payments/details/${paymentDetailId}/tasks`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 결제가 실패한 정산건을 조회해서 결제를 시도합니다.
     *
     * @tags Payments
     * @name PaymentsRetryPayCreate
     * @summary 결제 재시도 API ✅
     * @request POST:/shops/{shopID}/payments/retry-pay
     * @secure
     * @response `204` `void` No Content
     */
    paymentsRetryPayCreate: (
      shopId: string,
      RetryPayByUserRequest: DomainRetryPayByUserRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/payments/retry-pay`,
        method: 'POST',
        body: RetryPayByUserRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 결제내역의 상태를 조회합니다.
     *
     * @tags Payments
     * @name PaymentsStatusDetail
     * @summary 결제 상태 조회 API ✅
     * @request GET:/shops/{shopID}/payments/status
     * @secure
     * @response `200` `DomainGetShopPaymentStatusResponse` OK
     */
    paymentsStatusDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetShopPaymentStatusResponse, any>({
        path: `/shops/${shopId}/payments/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵에 적용이 되어있는 플랜을 단건 조회합니다.
     *
     * @tags Plans
     * @name PlansDetail
     * @summary 플랜을 단건 조회합니다. ✅
     * @request GET:/shops/{shopID}/plans
     * @deprecated
     * @secure
     * @response `200` `DomainGetShopPlanResponse` OK
     */
    plansDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetShopPlanResponse, any>({
        path: `/shops/${shopId}/plans`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 플랜과 관계된 현재 상태를 조회합니다.
     *
     * @tags Plans
     * @name PlansStatusDetail
     * @summary 플랜 상태를 조회합니다.✅
     * @request GET:/shops/{shopID}/plans/status
     * @deprecated
     * @secure
     * @response `200` `DomainGetShopPlanStatusResponse` OK
     */
    plansStatusDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetShopPlanStatusResponse, any>({
        path: `/shops/${shopId}/plans/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 외부 플랫폼의 카테고리를 조회하는 API (카페24, 번개장터, 네이버스마트스토어, 세컨솔드) 상세개발 이슈 : https://github.com/looko-corp/aims-api/issues/1091
     *
     * @tags Platforms
     * @name PlatformCategoriesDetail
     * @summary 샵 카테고리 리스트 조회 ✅
     * @request GET:/shops/{shopID}/platform-categories
     * @secure
     * @response `200` `DomainListShopPlatformCategoriesResponse` 샵 카테고리 응답값
     */
    platformCategoriesDetail: ({ shopId, ...query }: PlatformCategoriesDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopPlatformCategoriesResponse, any>({
        path: `/shops/${shopId}/platform-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 외부 플랫폼의 카테고리를 수정하는 API (카페24, 번개장터, 네이버스마트스토어, 세컨솔드)
     *
     * @tags Platforms
     * @name PlatformCategoriesPartialUpdate
     * @summary 샵 카테고리 리스트 수정
     * @request PATCH:/shops/{shopID}/platform-categories
     * @secure
     * @response `204` `void` No Content
     */
    platformCategoriesPartialUpdate: (
      shopId: string,
      PatchShopPlatformCategoriesRequest: DomainPatchShopPlatformCategoriesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/platform-categories`,
        method: 'PATCH',
        body: PatchShopPlatformCategoriesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 상품분류 규칙 조회
     *
     * @tags MappingGroups
     * @name PlatformCategoryRulesDetail
     * @summary 상품분류 규칙 조회
     * @request GET:/shops/{shopID}/platform-category-rules
     * @secure
     * @response `200` `DomainListPlatformCategoryRulesResponse` OK
     */
    platformCategoryRulesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListPlatformCategoryRulesResponse, any>({
        path: `/shops/${shopId}/platform-category-rules`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 상품분류 규칙 수정
     *
     * @tags MappingGroups
     * @name PlatformCategoryRulesCreate
     * @summary 상품분류 규칙 수정
     * @request POST:/shops/{shopID}/platform-category-rules
     * @secure
     * @response `204` `void` No Content
     */
    platformCategoryRulesCreate: (
      shopId: string,
      request: DomainUpsertPlatformCategoryRulesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/platform-category-rules`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 플랫폼 연동을 해제합니다. 🚨 모든 플랫폼의 데이터가 Hard Delete로 삭제됩니다. (아이템, 클레임, 주문, 인증정보) 따라서 주의해서 사용해주세요. ## Validation |**code**|**status**|**description**| |:---:|:---:|---| |N/A|400|`platformType`이 메타데이터에 속하지 않읂 경우| |N/A|400|`platformType`이 빈 문자열이거나, 보내지 않은 경우| |N/A|400|`shopID`가 비었거나 유효하지 않은 경우| |`SHOP_NOT_FOUND`|404|샵이 존재하지 않음| |`SHOP_PLATFORM_ALREADY_DISCONNECTED`|409|요청한 플랫폼이 샵에 존재하지 않음| |`SHOP_PLATFORM_MINIMUM_NOT_REACHED`|409|플랫폼이 연동 해제 시 연동 플랫폼이 2개 이하가 되는 경우| |`IN_PROGRESS_PLATFORM_SALE_TASK_EXISTS`|409|삭제하려는 플랫폼과 관련된 진행중인 작업이 존재함|
     *
     * @tags Shops
     * @name PlatformsDelete
     * @summary 🚨플랫폼 연동 해제 API ✅️
     * @request DELETE:/shops/{shopID}/platforms
     * @secure
     * @response `202` `void` Accepted
     */
    platformsDelete: ({ shopId, ...query }: PlatformsDeleteParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/platforms`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 이미지 AI용 전처리 후 S3 업로드하는 API 입니다.
     *
     * @tags Shops
     * @name PreprocessImageCreate
     * @summary 이미지 AI용 전처리 ✅
     * @request POST:/shops/{shopID}/preprocess-image
     * @secure
     * @response `204` `void` No Content
     */
    preprocessImageCreate: (shopId: string, request: DomainPreprocessImageRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/preprocess-image`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵 관련 S3 서명된 URL을 생성해주는 API 입니다. (유효기간 30분)
     *
     * @tags Shops
     * @name PresignedUrlsCreate
     * @summary 샵 관련 S3 서명된 URL 생성 ✅
     * @request POST:/shops/{shopID}/presigned-urls
     * @secure
     * @response `200` `DomainCreateShopPreSignedURLsResponse` OK
     */
    presignedUrlsCreate: (shopId: string, request: DomainCreateShopPreSignedURLsRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreateShopPreSignedURLsResponse, any>({
        path: `/shops/${shopId}/presigned-urls`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 가격 자동입력에 사용되는 샵 브랜드 그룹 조회 합니다.
     *
     * @tags Brands
     * @name PriceBrandGroupsDetail
     * @summary 가격 자동입력에 사용되는 샵 브랜드 그룹 조회 ✅
     * @request GET:/shops/{shopID}/price-brand-groups
     * @secure
     * @response `200` `DomainListShopPriceBrandGroupsResponse` OK
     */
    priceBrandGroupsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListShopPriceBrandGroupsResponse, any>({
        path: `/shops/${shopId}/price-brand-groups`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 가격 브랜드 그룹을 생성하는 API 입니다. 브랜드가 없는 상품 규칙 만들기의 경우, 브랜드 ID를 빈 값으로 보내주시면 됩니다.
     *
     * @tags Brands
     * @name PriceBrandGroupsCreate
     * @summary 가격 브랜드 그룹 생성 ✅
     * @request POST:/shops/{shopID}/price-brand-groups
     * @secure
     * @response `201` `DomainCreateShopPriceBrandGroupResponse` 가격 브랜드 그룹 생성 반환 값
     */
    priceBrandGroupsCreate: (
      shopId: string,
      request: DomainCreateShopPriceBrandGroupRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainCreateShopPriceBrandGroupResponse, any>({
        path: `/shops/${shopId}/price-brand-groups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 가격 브랜드 그룹을 삭제하는 API 입니다.
     *
     * @tags Brands
     * @name PriceBrandGroupsDelete
     * @summary 가격 브랜드 그룹 삭제 ✅
     * @request DELETE:/shops/{shopID}/price-brand-groups/{priceBrandGroupID}
     * @secure
     * @response `204` `void` 가격 브랜드 그룹 삭제 반환 값
     */
    priceBrandGroupsDelete: (shopId: string, priceBrandGroupId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/price-brand-groups/${priceBrandGroupId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 가격 자동입력에 사용되는 샵 브랜드 그룹 업데이트 합니다.
     *
     * @tags Brands
     * @name PriceBrandGroupsPartialUpdate
     * @summary 가격 자동입력에 사용되는 샵 브랜드 그룹 업데이트 ✅
     * @request PATCH:/shops/{shopID}/price-brand-groups/{priceBrandGroupID}
     * @secure
     * @response `204` `void` No Content
     */
    priceBrandGroupsPartialUpdate: (
      shopId: string,
      priceBrandGroupId: string,
      request: DomainPatchShopPriceBrandGroupRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/price-brand-groups/${priceBrandGroupId}`,
        method: 'PATCH',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 가격 규칙을 조회하는 API 입니다. 셀 단위의 가격 규칙 데이터들이 반환합니다.
     *
     * @tags Tasks
     * @name PriceRulesDetail
     * @summary 가격 규칙 조회 ✅
     * @request GET:/shops/{shopID}/price-rules
     * @secure
     * @response `200` `DomainListShopPriceRulesResponse` 가격 규칙 조회 반환 값
     */
    priceRulesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListShopPriceRulesResponse, any>({
        path: `/shops/${shopId}/price-rules`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 가격 규칙을 수정하는 API 입니다. 셀 단위의 가격 규칙 데이터들을 업데이트 합니다. 호출 시, 샵의 셀 단위의 가격 규칙을 삭제하고, 입력받은 데이터로 덮어씁니다.
     *
     * @tags Tasks
     * @name PriceRulesUpdate
     * @summary 가격 규칙 수정 ✅
     * @request PUT:/shops/{shopID}/price-rules
     * @secure
     * @response `204` `void` 가격 규칙 수정 반환 값
     */
    priceRulesUpdate: (shopId: string, request: DomainUpdateShopPriceRulesRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/price-rules`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 판매 아이템 동기화 이벤트를 수동으로 발행합니다.
     *
     * @tags Sales
     * @name PublishUpdateSaleItemsCreate
     * @summary 판매 아이템 동기화 이벤트 수동 발행 API ✅
     * @request POST:/shops/{shopID}/publish-update-sale-items
     * @secure
     * @response `204` `void` No Content
     */
    publishUpdateSaleItemsCreate: (
      shopId: string,
      PublishUpdateSaleItemsRequest: DomainPublishUpdateSaleItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/publish-update-sale-items`,
        method: 'POST',
        body: PublishUpdateSaleItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 판매관리 대상 아이템 리스트를 조회하는 API
     *
     * @tags Sales
     * @name RealtimeSaleItemsDetail
     * @summary 샵의 판매관리 대상 아이템 리스트 조회 ✅
     * @request GET:/shops/{shopID}/realtime-sale-items
     * @secure
     * @response `200` `DomainListRealtimeShopSaleItemsResponse` OK
     */
    realtimeSaleItemsDetail: ({ shopId, ...query }: RealtimeSaleItemsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListRealtimeShopSaleItemsResponse, any>({
        path: `/shops/${shopId}/realtime-sale-items`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 삭제된 판매 아이템을 복원합니다. 해당 API는 삭제된 판매 아이템을 복원합니다.
     *
     * @tags Sales
     * @name RecoverDeletedSaleItemsCreate
     * @summary 삭제된 판매 아이템 복원 API ✅
     * @request POST:/shops/{shopID}/recover-deleted-sale-items
     * @secure
     * @response `204` `void` No Content
     */
    recoverDeletedSaleItemsCreate: (
      shopId: string,
      RecoverDeletedSaleItemsRequest: DomainRecoverDeletedSaleItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/recover-deleted-sale-items`,
        method: 'POST',
        body: RecoverDeletedSaleItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 주문 Acloset 할인요청을 거절합니다.
     *
     * @tags Orders
     * @name RejectAclosetOfferCreate
     * @summary 샵 주문 Acloset 할인요청 거절 🛠️
     * @request POST:/shops/{shopID}/reject-acloset-offer
     * @secure
     * @response `204` `void` No Content
     */
    rejectAclosetOfferCreate: (shopId: string, request: DomainRejectAclosetOfferRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/reject-acloset-offer`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 주문 취소를 거절합니다. 해당 API를 호출하면 CAFE24의 경우에는 배송준비중으로 변경되고 네이버의 경우에는 송장번호를 받고 배송중으로 상태가 변경됩니다.
     *
     * @tags Orders
     * @name RejectCancelOrdersCreate
     * @summary 샵 주문 취소 거절 ✅
     * @request POST:/shops/{shopID}/reject-cancel-orders
     * @secure
     * @response `202` `DomainRejectCancelOrdersResponse` Accepted
     */
    rejectCancelOrdersCreate: (
      shopId: string,
      RejectCancelOrdersRequest: DomainRejectCancelOrdersRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainRejectCancelOrdersResponse, any>({
        path: `/shops/${shopId}/reject-cancel-orders`,
        method: 'POST',
        body: RejectCancelOrdersRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description `itemIDs`가 채워진 상태로 리매핑 수행 시: 상태, 플랫폼 카테고리 유무 여부를 떠나서 설정한 아이템에 대해 플랫폼 카테고리 리매핑을 수행 `itemIDs`가 비어있는 상태로 리매핑 수행 시: 상품 등록된 아이템 중, 판매 전 상태인 아이템이면서 플랫폼 카테고리가 비어있는 경우 플랫폼 카테고리 리매핑을 수행
     *
     * @tags Sales
     * @name RemappingSaleItemsPlatformCategoriesCreate
     * @summary 판매 아이템 플랫폼 카테고리 재매핑 API ✅
     * @request POST:/shops/{shopID}/remapping-sale-items-platform-categories
     * @secure
     * @response `204` `void` No Content
     */
    remappingSaleItemsPlatformCategoriesCreate: (
      shopId: string,
      RemappingSaleItemsPlatformCategoriesRequest: DomainRemappingSaleItemsPlatformCategoriesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/remapping-sale-items-platform-categories`,
        method: 'POST',
        body: RemappingSaleItemsPlatformCategoriesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 특정 이미지를 받아서 배경제거를 해주는 API 입니다.
     *
     * @tags Tasks
     * @name RemoveBackgroundCreate
     * @summary 특정이미지를 배경제거 ✅
     * @request POST:/shops/{shopID}/remove-background
     * @secure
     * @response `200` `DomainRemoveBackgroundImageResponse` 이미지 배경제거 반환 값
     */
    removeBackgroundCreate: (shopId: string, request: DomainRemoveBackgroundImageRequest, params: RequestParams = {}) =>
      this.http.request<DomainRemoveBackgroundImageResponse, any>({
        path: `/shops/${shopId}/remove-background`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 각 플랫폼에 아이템들을 재개시합니다. 해당 API는 판매중지 상태에서만 호출이 가능합니다.
     *
     * @tags Sales
     * @name ReopenSaleItemsCreate
     * @summary 판매 재개시 API  ✅️
     * @request POST:/shops/{shopID}/reopen-sale-items
     * @secure
     * @response `202` `DomainReopenSaleItemsResponse` Accepted
     */
    reopenSaleItemsCreate: (
      shopId: string,
      ReopenSaleItemsRequest: DomainReopenSaleItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainReopenSaleItemsResponse, any>({
        path: `/shops/${shopId}/reopen-sale-items`,
        method: 'POST',
        body: ReopenSaleItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 판매관리 대시보드 목록을 조회합니다. dashboardItems는 상태별로 최대 5개씩만 조회됩니다.
     *
     * @tags Sales
     * @name SaleDashboardsDetail
     * @summary 판매관리 대시보드 목록 조회 API ✅
     * @request GET:/shops/{shopID}/sale-dashboards
     * @secure
     * @response `200` `DomainListShopSaleDashboardsResponse` OK
     */
    saleDashboardsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListShopSaleDashboardsResponse, any>({
        path: `/shops/${shopId}/sale-dashboards`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 판매관리에서 사용되는 필드목록들을 조회합니다.
     *
     * @tags Sales
     * @name SaleFieldsDetail
     * @summary 판매관리 필드목록 조회 API ✅
     * @request GET:/shops/{shopID}/sale-fields
     * @secure
     * @response `200` `DomainListShopSaleFieldsResponse` OK
     */
    saleFieldsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListShopSaleFieldsResponse, any>({
        path: `/shops/${shopId}/sale-fields`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 판매관리에서 사용되는 필드들을 수정합니다. 해당 API는 기존의 데이터를 모두 덮어씌웁니다.
     *
     * @tags Sales
     * @name SaleFieldsUpdate
     * @summary 판매관리 필드 수정 API ✅
     * @request PUT:/shops/{shopID}/sale-fields
     * @secure
     * @response `204` `void` No Content
     */
    saleFieldsUpdate: (
      shopId: string,
      UpdateShopSaleFieldsRequest: DomainUpdateShopSaleFieldsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/sale-fields`,
        method: 'PUT',
        body: UpdateShopSaleFieldsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 상품의 상태별 카운트를 조회합니다.
     *
     * @tags Sales
     * @name SaleItemCountsDetail
     * @summary 샵의 판매관리 대상 아이템 상태별 카운트 조회 ✅
     * @request GET:/shops/{shopID}/sale-item-counts
     * @secure
     * @response `200` `DomainListShopSaleItemCountsResponse` OK
     */
    saleItemCountsDetail: ({ shopId, ...query }: SaleItemCountsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopSaleItemCountsResponse, any>({
        path: `/shops/${shopId}/sale-item-counts`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 판매관리 대상 아이템 리스트를 조회하는 API
     *
     * @tags Sales
     * @name SaleItemsDetail
     * @summary 샵의 판매관리 대상 아이템 리스트 조회 ✅
     * @request GET:/shops/{shopID}/sale-items
     * @secure
     * @response `200` `DomainListShopSaleItemsResponse` OK
     */
    saleItemsDetail: ({ shopId, ...query }: SaleItemsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopSaleItemsResponse, any>({
        path: `/shops/${shopId}/sale-items`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 판매관리 대상 아이템들을 엑셀로 변환하는 API (번개장터, 플레이오토 업로드 용)
     *
     * @tags Sales
     * @name SaleItemsExportExcelCreate
     * @summary 샵의 판매관리 대상 아이템들을 엑셀 파일로 다운로드 ✅
     * @request POST:/shops/{shopID}/sale-items/export-excel
     * @secure
     * @response `200` `DomainExportExcelShopSaleItemsResponse` 엑셀 파일 생성 응답 값
     */
    saleItemsExportExcelCreate: (
      shopId: string,
      ExportExcelShopSaleItemsRequest: DomainExportExcelShopSaleItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainExportExcelShopSaleItemsResponse, any>({
        path: `/shops/${shopId}/sale-items/export-excel`,
        method: 'POST',
        body: ExportExcelShopSaleItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 판매관리 대상 아이템들의 이미지를 다운로드하는 API
     *
     * @tags Sales
     * @name SaleItemsExportImagesCreate
     * @summary 샵의 판매관리 대상 아이템들의 이미지를 다운로드 ✅
     * @request POST:/shops/{shopID}/sale-items/export-images
     * @secure
     * @response `200` `DomainExportShopSaleItemsImagesResponse` 이미지 파일 생성 응답 값
     */
    saleItemsExportImagesCreate: (
      shopId: string,
      ExportShopSaleItemsImagesRequest: DomainExportShopSaleItemsImagesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainExportShopSaleItemsImagesResponse, any>({
        path: `/shops/${shopId}/sale-items/export-images`,
        method: 'POST',
        body: ExportShopSaleItemsImagesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 판매관리 대상 아이템의 ID 리스트를 조회하는 API
     *
     * @tags Sales
     * @name SaleItemsIdDetail
     * @summary 샵의 판매관리 대상 아이템 ID 리스트 조회 ✅
     * @request GET:/shops/{shopID}/sale-items/id
     * @secure
     * @response `200` `DomainListShopSaleItemIDsResponse` OK
     */
    saleItemsIdDetail: ({ shopId, ...query }: SaleItemsIdDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopSaleItemIDsResponse, any>({
        path: `/shops/${shopId}/sale-items/id`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 판매 아이템의 인스타그램 URL을 조회합니다. 해당 API는 판매중지, 판매중, 수정대기 상태에서만 호출이 가능합니다.
     *
     * @tags Sales
     * @name SaleItemsInstagramUrlDetail
     * @summary 판매 아이템 인스타그램 URL 조회 API ✅
     * @request GET:/shops/{shopID}/sale-items/{saleItemID}/instagram-url
     * @secure
     * @response `200` `DomainGetSaleItemInstagramURLResponse` OK
     */
    saleItemsInstagramUrlDetail: (shopId: string, saleItemId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetSaleItemInstagramURLResponse, any>({
        path: `/shops/${shopId}/sale-items/${saleItemId}/instagram-url`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 판매 아이템의 각 플랫폼 별 정보를 수정합니다.
     *
     * @tags Sales
     * @name SaleItemsModifyCreate
     * @summary 판매 아이템 수정 API ✅
     * @request POST:/shops/{shopID}/sale-items/{saleItemID}/modify
     * @secure
     * @response `204` `void` No Content
     */
    saleItemsModifyCreate: (
      shopId: string,
      saleItemId: string,
      request: DomainModifySaleItemRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/sale-items/${saleItemId}/modify`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 판매 아이템의 각 플랫폼 별 카테고리를 수정합니다. 카페24는 다건을 수정할 수 있고 네이버와 Acloset은 단건만 가능합니다.
     *
     * @tags Sales
     * @name SaleItemsModifyPlatformCategoriesCreate
     * @summary 판매 아이템 플랫폼 카테고리 수정 API ✅
     * @request POST:/shops/{shopID}/sale-items/{saleItemID}/modify-platform-categories
     * @secure
     * @response `204` `void` No Content
     */
    saleItemsModifyPlatformCategoriesCreate: (
      shopId: string,
      saleItemId: string,
      request: DomainModifySaleItemPlatformCategoriesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/sale-items/${saleItemId}/modify-platform-categories`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 수정대기 아이템의 수정사유 목록을 조회합니다.
     *
     * @tags Sales
     * @name SaleItemsPlatformPendingModifyingReasonsDetail
     * @summary 수정대기 아이템 수정사유 목록 조회 API ✅
     * @request GET:/shops/{shopID}/sale-items/{saleItemID}/platform-pending-modifying-reasons
     * @secure
     * @response `200` `DomainListSaleItemPlatformPendingModifyingReasonsResponse` OK
     */
    saleItemsPlatformPendingModifyingReasonsDetail: (
      { shopId, saleItemId, ...query }: SaleItemsPlatformPendingModifyingReasonsDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListSaleItemPlatformPendingModifyingReasonsResponse, any>({
        path: `/shops/${shopId}/sale-items/${saleItemId}/platform-pending-modifying-reasons`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 수정대기 상태의 아이템을 판매중으로 복원요청합니다. 해당 API는 수정대기 상태에서만 호출이 가능하고 현재는 네이버에서만 수정대기 상태가 존재합니다.
     *
     * @tags Sales
     * @name SaleItemsRestorePendingModifyingCreate
     * @summary 수정대기 아이템 복원 API ✅
     * @request POST:/shops/{shopID}/sale-items/{saleItemID}/restore-pending-modifying
     * @secure
     * @response `204` `void` No Content
     */
    saleItemsRestorePendingModifyingCreate: (shopId: string, saleItemId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/sale-items/${saleItemId}/restore-pending-modifying`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 판매관리 태스크 진행사항 요약 리스트를 조회하는 API
     *
     * @tags Sales
     * @name SaleTaskSummariesDetail
     * @summary 샵의 판매관리 태스크 진행사항 요약 리스트 조회 ✅
     * @request GET:/shops/{shopID}/sale-task-summaries
     * @secure
     * @response `200` `DomainListShopSaleTaskSummariesResponse` OK
     */
    saleTaskSummariesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListShopSaleTaskSummariesResponse, any>({
        path: `/shops/${shopId}/sale-task-summaries`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 판매관리 작업 목록을 조회합니다.
     *
     * @tags Sales
     * @name SaleTasksDetail
     * @summary 판매관리 작업 목록 조회 API ✅
     * @request GET:/shops/{shopID}/sale-tasks
     * @secure
     * @response `200` `DomainListSaleTasksResponse` OK
     */
    saleTasksDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListSaleTasksResponse, any>({
        path: `/shops/${shopId}/sale-tasks`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 판매관리 작업을 단건 조회합니다.
     *
     * @tags Sales
     * @name SaleTasksDetail2
     * @summary 판매관리 작업 단건 조회 API ✅
     * @request GET:/shops/{shopID}/sale-tasks/{saleTaskID}
     * @originalName saleTasksDetail
     * @duplicate
     * @secure
     * @response `200` `DomainSaleTaskResponse` OK
     */
    saleTasksDetail2: (shopId: string, saleTaskId: string, params: RequestParams = {}) =>
      this.http.request<DomainSaleTaskResponse, any>({
        path: `/shops/${shopId}/sale-tasks/${saleTaskId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 판매관리 내 아이템과 관련된 작업을 강제 후처리합니다. 해당 API는 개발용 API이며, 서비스에서 사용하는 것을 금합니다.
     *
     * @tags Sales
     * @name SaleTasksForcePostProcessItemsCreate
     * @summary 판매관리 아이템 강제 후처리 API ⚙️[자동 처리 형식으로 변경됨에 따라 제거 예정]
     * @request POST:/shops/{shopID}/sale-tasks/{saleTaskID}/force-post-process-items
     * @deprecated
     * @secure
     * @response `204` `void` No Content
     */
    saleTasksForcePostProcessItemsCreate: (shopId: string, saleTaskId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/sale-tasks/${saleTaskId}/force-post-process-items`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 해당 API는 개발용 API로 서비스에서의 사용을 금합니다. 샵의 주문 후처리를 강제로 실행합니다. 해당 API는 주문 후처리가 실패한 경우에만 사용합니다.
     *
     * @tags Orders
     * @name SaleTasksForcePostProcessOrdersCreate
     * @summary 샵 주문 후처리 강제 실행 ⚙️
     * @request POST:/shops/{shopID}/sale-tasks/{saleTaskID}/force-post-process-orders
     * @deprecated
     * @secure
     * @response `204` `void` No Content
     */
    saleTasksForcePostProcessOrdersCreate: (shopId: string, saleTaskId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/sale-tasks/${saleTaskId}/force-post-process-orders`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 비동기로 수행된 판매관리 작업에 대해서 재시도를 요청합니다.
     *
     * @tags Sales
     * @name SaleTasksRetryCreate
     * @summary 판매관리 실패작업 재시도 ✅
     * @request POST:/shops/{shopID}/sale-tasks/{saleTaskID}/retry
     * @secure
     * @response `204` `void` No Content
     */
    saleTasksRetryCreate: (shopId: string, saleTaskId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/sale-tasks/${saleTaskId}/retry`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 판매관리 작업 상세 목록을 조회합니다.
     *
     * @tags Sales
     * @name SaleTasksSaleTaskDetailsDetail
     * @summary 판매관리 작업 상세 목록 조회 API ✅
     * @request GET:/shops/{shopID}/sale-tasks/{saleTaskID}/sale-task-details
     * @secure
     * @response `200` `DomainListSaleTaskDetailsResponse` OK
     */
    saleTasksSaleTaskDetailsDetail: (shopId: string, saleTaskId: string, params: RequestParams = {}) =>
      this.http.request<DomainListSaleTaskDetailsResponse, any>({
        path: `/shops/${shopId}/sale-tasks/${saleTaskId}/sale-task-details`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 세컨솔드 카테고리 매핑 규칙 조회
     *
     * @tags MappingGroups
     * @name SecondsoldCategoryRulesDetail
     * @summary 세컨솔드 카테고리 매핑 규칙 조회 ✅
     * @request GET:/shops/{shopID}/secondsold-category-rules
     * @secure
     * @response `200` `DomainListSecondSoldCategoryMappingRulesResponse` OK
     */
    secondsoldCategoryRulesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListSecondSoldCategoryMappingRulesResponse, any>({
        path: `/shops/${shopId}/secondsold-category-rules`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 내 서비스 가격을 조회합니다.
     *
     * @tags Settlements
     * @name ServicePricingsDetail
     * @summary 내 서비스 가격을 조회합니다. ✅
     * @request GET:/shops/{shopID}/service-pricings
     * @secure
     * @response `200` `DomainGetMyServicePricingsResponse` OK
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
     */
    servicePricingsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainGetMyServicePricingsResponse, void>({
        path: `/shops/${shopId}/service-pricings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 정산을 시도합니다. 서비스 수정 기능도 포함합니다. 서비스 수정 시에 정산 데이터가 없다면 바로 수정되고, 있다면 정산을 시도한 후 수정됩니다.
     *
     * @tags Settlements
     * @name ServicePricingsUpdate
     * @summary 수동 정산 및 서비스 변경 API ✅
     * @request PUT:/shops/{shopID}/service-pricings
     * @secure
     * @response `204` `void` No Content
     * @response `402` `void` 결제 실패한 경우 Code: PAYMENT_FAILED
     * @response `404` `void` 카드가 존재하지 않는 경우 Code: CARD_NOT_FOUND
     * @response `409` `void` 서비스 변경한지 1주일이 지나지 않은 경우 Code: PLAN_LAST_CHANGED_ONE_WEEK_NOT_PASSED
     */
    servicePricingsUpdate: (
      shopId: string,
      UpdateServicePricingWithSettlementRequest: DomainUpdateServicePricingWithSettlementRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/service-pricings`,
        method: 'PUT',
        body: UpdateServicePricingWithSettlementRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settlements
     * @name SettlementsDetail
     * @summary 정산내역을 리스트로 조회합니다. ✅
     * @request GET:/shops/{shopID}/settlements
     * @secure
     * @response `200` `DomainListSettlementsResponse` OK
     */
    settlementsDetail: ({ shopId, ...query }: SettlementsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListSettlementsResponse, any>({
        path: `/shops/${shopId}/settlements`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 카페24 정산 데이터를 엑셀로 변환하는 API
     *
     * @tags Settlements
     * @name SettlementsExportCafe24ExcelCreate
     * @summary 카페24 정산 데이터를 엑셀 파일로 다운로드 ✅
     * @request POST:/shops/{shopID}/settlements/export-cafe24-excel
     * @secure
     * @response `200` `DomainExportExcelSettlementsResponse` 엑셀 파일 생성 응답 값
     */
    settlementsExportCafe24ExcelCreate: (
      shopId: string,
      ExportExcelSettlementsRequest: DomainExportExcelSettlementsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainExportExcelSettlementsResponse, any>({
        path: `/shops/${shopId}/settlements/export-cafe24-excel`,
        method: 'POST',
        body: ExportExcelSettlementsRequest,
        secure: true,
        ...params,
      }),

    /**
     * @description 카페24 정산 데이터를 엑셀로 변환하는 API
     *
     * @tags Settlements
     * @name SettlementsExportExcelCreate
     * @summary 카페24 정산 데이터를 엑셀 파일로 다운로드 ✅
     * @request POST:/shops/{shopID}/settlements/export-excel
     * @deprecated
     * @secure
     * @response `200` `DomainExportExcelSettlementsResponse` 엑셀 파일 생성 응답 값
     */
    settlementsExportExcelCreate: (
      shopId: string,
      ExportExcelSettlementsRequest: DomainExportExcelSettlementsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainExportExcelSettlementsResponse, any>({
        path: `/shops/${shopId}/settlements/export-excel`,
        method: 'POST',
        body: ExportExcelSettlementsRequest,
        secure: true,
        ...params,
      }),

    /**
     * @description 웹에서 샵의 로그인 여부를 확인하는 API
     *
     * @tags Platforms
     * @name ShopAuthExistsDetail
     * @summary 샵의 OAuth 로그인 여부 확인 ✅
     * @request GET:/shops/{shopID}/shop-auth-exists
     * @secure
     * @response `200` `DomainExistsShopAuthResponse` 샵의 OAuth 로그인 여부
     */
    shopAuthExistsDetail: ({ shopId, ...query }: ShopAuthExistsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainExistsShopAuthResponse, any>({
        path: `/shops/${shopId}/shop-auth-exists`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 사이즈 매핑 그룹 리스트를 조회하는 API 사장님이 사용중인 매핑그룹에 해당하는 사이즈 매핑 그룹 리스트를 반환합니다.
     *
     * @tags MappingGroups
     * @name SizeMappingGroupsDetail
     * @summary 샵 사이즈 매핑 그룹 리스트 조회 ✅
     * @request GET:/shops/{shopID}/size-mapping-groups
     * @secure
     * @response `200` `DomainListSizeMappingGroupsResponse` OK
     */
    sizeMappingGroupsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListSizeMappingGroupsResponse, any>({
        path: `/shops/${shopId}/size-mapping-groups`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 사이즈 매핑 그룹을 수정하는 API ## Validation - 보낸 `rules` 리스트의 `under`값이 오름차순으로 정렬되지 않은 경우 오류를 반환합니다. - Request 명세에 명시한 속성 중 메타데이터 AIMS Category 중 실제 존재하지 않는 메타데이터나, 카테고리가 포함된 경우 오류를 반환합니다.
     *
     * @tags MappingGroups
     * @name SizeMappingGroupsUpdate
     * @summary 샵 사이즈 매핑 그룹 전체 수정 ✅
     * @request PUT:/shops/{shopID}/size-mapping-groups/{sizeMappingGroupID}
     * @secure
     * @response `204` `void` No Content
     */
    sizeMappingGroupsUpdate: (
      shopId: string,
      sizeMappingGroupId: string,
      request: DomainUpdateSizeMappingGroupRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/size-mapping-groups/${sizeMappingGroupId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 웹에서 샵의 고정값 정보를 부분 수정하는 API
     *
     * @tags Shops
     * @name StaticsUpdate
     * @summary 샵 고정값 수정 ✅️
     * @request PUT:/shops/{shopID}/statics
     * @secure
     * @response `204` `void` No Content
     */
    staticsUpdate: (
      shopId: string,
      UpdateShopStaticRequest: DomainUpdateShopStaticRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/statics`,
        method: 'PUT',
        body: UpdateShopStaticRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 각 플랫폼에 아이템들을 판매중지합니다. 해당 API는 판매중 상태에서만 호출할 수 있습니다.
     *
     * @tags Sales
     * @name StopSaleItemsCreate
     * @summary 판매 중지 API ✅
     * @request POST:/shops/{shopID}/stop-sale-items
     * @secure
     * @response `202` `DomainStopSaleItemsResponse` Accepted
     */
    stopSaleItemsCreate: (
      shopId: string,
      StopSaleItemsRequest: DomainStopSaleItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainStopSaleItemsResponse, any>({
        path: `/shops/${shopId}/stop-sale-items`,
        method: 'POST',
        body: StopSaleItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 작업 목록을 조회하는 API 입니다.
     *
     * @tags Tasks
     * @name TasksDetail
     * @summary 샵의 작업 목록 조회 ✅
     * @request GET:/shops/{shopID}/tasks
     * @secure
     * @response `200` `DomainListShopTasksResponse` 샵의 작업 목록 응답 값
     */
    tasksDetail: ({ shopId, ...query }: TasksDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopTasksResponse, any>({
        path: `/shops/${shopId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵의 작업을 생성하는 API 입니다.
     *
     * @tags Tasks
     * @name TasksCreate
     * @summary 샵의 작업 생성 ✅
     * @request POST:/shops/{shopID}/tasks
     * @secure
     * @response `200` `DomainCreateShopTaskResponse` 샵의 작업 목록 응답 값
     */
    tasksCreate: (shopId: string, CreateShopTaskRequest: DomainCreateShopTaskRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreateShopTaskResponse, any>({
        path: `/shops/${shopId}/tasks`,
        method: 'POST',
        body: CreateShopTaskRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 해당하는 샵의 태스크를 단건 조회하는 API
     *
     * @tags Tasks
     * @name TasksDetail2
     * @summary 샵의 태스크를 조회 (단건) ✅
     * @request GET:/shops/{shopID}/tasks/{shopTaskID}
     * @originalName tasksDetail
     * @duplicate
     * @secure
     * @response `200` `DomainGetShopTaskResponse` 샵 목록 응답 값
     */
    tasksDetail2: ({ shopId, shopTaskId, ...query }: TasksDetail2Params, params: RequestParams = {}) =>
      this.http.request<DomainGetShopTaskResponse, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵의 작업을 부분 수정하는 API 입니다
     *
     * @tags Tasks
     * @name TasksPartialUpdate
     * @summary 샵의 작업 부분 수정 (단건) ✅
     * @request PATCH:/shops/{shopID}/tasks/{shopTaskID}
     * @secure
     * @response `204` `void` No Content
     */
    tasksPartialUpdate: (
      shopId: string,
      shopTaskId: string,
      PatchShopTaskRequest: DomainPatchShopTaskRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}`,
        method: 'PATCH',
        body: PatchShopTaskRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 상품코드 일괄 변경하는 API 입니다
     *
     * @tags Tasks
     * @name TasksItemCodesCreate
     * @summary 상품코드 일괄 변경
     * @request POST:/shops/{shopID}/tasks/{shopTaskID}/item-codes
     * @secure
     * @response `204` `void` No Content
     */
    tasksItemCodesCreate: (
      shopId: string,
      shopTaskId: string,
      UpdateShopTaskItemCodesRequest: DomainUpdateShopTaskItemCodesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/item-codes`,
        method: 'POST',
        body: UpdateShopTaskItemCodesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 작업의 아이템 목록을 조회하는 API 입니다.
     *
     * @tags Tasks
     * @name TasksItemsDetail
     * @summary 샵의 작업의 아이템 목록 조회 ✅
     * @request GET:/shops/{shopID}/tasks/{shopTaskID}/items
     * @secure
     * @response `200` `DomainListShopTaskItemsResponse` 샵의 작업의 아이템 목록 응답 값
     */
    tasksItemsDetail: ({ shopId, shopTaskId, ...query }: TasksItemsDetailParams, params: RequestParams = {}) =>
      this.http.request<DomainListShopTaskItemsResponse, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵의 작업의 아이템 목록을 삭제하는 API 입니다.
     *
     * @tags Tasks
     * @name TasksItemsDelete
     * @summary 샵의 작업의 아이템 목록 삭제 ✅
     * @request DELETE:/shops/{shopID}/tasks/{shopTaskID}/items
     * @secure
     * @response `204` `void` No Content
     */
    tasksItemsDelete: (
      shopId: string,
      shopTaskId: string,
      DeleteShopTaskItemsRequest: DomainDeleteShopTaskItemsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items`,
        method: 'DELETE',
        body: DeleteShopTaskItemsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 상품 AI 설명을 생성하는 비동기 API입니다. 완료 여부와 무관하게 응답을 반환합니다.
     *
     * @tags Tasks
     * @name TasksItemsGenerateAiDescriptionsCreate
     * @summary 상품 AI 설명 생성 ✅
     * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/generate-ai-descriptions
     * @secure
     * @response `204` `void` No Content
     */
    tasksItemsGenerateAiDescriptionsCreate: (
      shopId: string,
      shopTaskId: string,
      GenerateShopTaskItemAIDescriptionsRequest: DomainGenerateShopTaskItemAIDescriptionsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items/generate-ai-descriptions`,
        method: 'POST',
        body: GenerateShopTaskItemAIDescriptionsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 작업의 아이템의 전체 명세를 수정하는 API 입니다. (null 입력 시 SET NULL)
     *
     * @tags Tasks
     * @name TasksItemsPartialUpdate
     * @summary 샵의 작업의 아이템 수정 ✅
     * @request PATCH:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}
     * @secure
     * @response `204` `void` No Content
     */
    tasksItemsPartialUpdate: (
      shopId: string,
      shopTaskId: string,
      shopTaskItemId: string,
      PatchShopTaskItemRequest: DomainPatchShopTaskItemRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items/${shopTaskItemId}`,
        method: 'PATCH',
        body: PatchShopTaskItemRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 작업을 간편 분석하는 비동기 API 입니다. 완료 여부와 무관하게 응답이 반환됩니다.
     *
     * @tags Tasks
     * @name TasksItemsAnalyzeItemCreate
     * @summary 샵 작업 간편 분석 ✅
     * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/analyze-item
     * @secure
     * @response `204` `void` No Content
     */
    tasksItemsAnalyzeItemCreate: (
      shopId: string,
      shopTaskId: string,
      shopTaskItemId: string,
      AnalyzeShopTaskItemRequest: DomainAnalyzeShopTaskItemRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items/${shopTaskItemId}/analyze-item`,
        method: 'POST',
        body: AnalyzeShopTaskItemRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 아이템 당 상품명 자동 기입하는 API 입니다.
     *
     * @tags Tasks
     * @name TasksItemsGenerateTitleCreate
     * @summary 샵의 아이템 당 상품명 자동 기입 ✅
     * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/generate-title
     * @secure
     * @response `204` `void` No Content
     */
    tasksItemsGenerateTitleCreate: (
      shopId: string,
      shopTaskId: string,
      shopTaskItemId: string,
      GenerateShopTaskItemTitleRequest: DomainGenerateShopTaskItemTitleRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items/${shopTaskItemId}/generate-title`,
        method: 'POST',
        body: GenerateShopTaskItemTitleRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 작업의 아이템의 이미지를 수정하는 API 입니다. (최소 1개의 이미지 변경 필요)
     *
     * @tags Tasks
     * @name TasksItemsImagesUpdate
     * @summary 샵의 작업의 아이템 이미지 수정 ✅
     * @request PUT:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/images
     * @secure
     * @response `204` `void` No Content
     */
    tasksItemsImagesUpdate: (
      shopId: string,
      shopTaskId: string,
      shopTaskItemId: string,
      UpdateShopTaskItemImagesRequest: DomainUpdateShopTaskItemImagesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items/${shopTaskItemId}/images`,
        method: 'PUT',
        body: UpdateShopTaskItemImagesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 특정 아이템을 편집 후 수정하는 API 입니다.
     *
     * @tags Tasks
     * @name TasksItemsImagesModifyImageCreate
     * @summary 아이템 이미지 편집 후 수정 ✅️
     * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/images/{imageID}/modify-image
     * @secure
     * @response `204` `void` No Content
     */
    tasksItemsImagesModifyImageCreate: (
      shopId: string,
      shopTaskId: string,
      shopTaskItemId: string,
      itemId: string,
      imageId: string,
      ModifyShopTaskItemImageRequest: DomainModifyShopTaskItemImageRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items/${shopTaskItemId}/images/${imageId}/modify-image`,
        method: 'POST',
        body: ModifyShopTaskItemImageRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 특정 아이템 이미지를 다른 이미지로 대체
     *
     * @tags Tasks
     * @name TasksItemsImagesReplaceImageCreate
     * @summary 아이템 이미지 대체 ✅️
     * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/images/{imageID}/replace-image
     * @secure
     * @response `204` `void` No Content
     */
    tasksItemsImagesReplaceImageCreate: (
      shopId: string,
      shopTaskId: string,
      shopTaskItemId: string,
      itemId: string,
      imageId: string,
      request: DomainReplaceShopTaskItemImageRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items/${shopTaskItemId}/images/${imageId}/replace-image`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 특정 아이템 이미지를 받아서 다른아이템으로 분리 및 생성
     *
     * @tags Tasks
     * @name TasksItemsSplitCreate
     * @summary 아이템 분리 ✅️
     * @request POST:/shops/{shopID}/tasks/{shopTaskID}/items/{shopTaskItemID}/split
     * @secure
     * @response `200` `DomainSplitShopTaskItemResponse` OK
     */
    tasksItemsSplitCreate: (
      shopId: string,
      shopTaskId: string,
      shopTaskItemId: string,
      request: DomainSplitShopTaskItemRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainSplitShopTaskItemResponse, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/items/${shopTaskItemId}/split`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 샵 아이템을 판매 대기로 등록하는 비동기 API 입니다.
     *
     * @tags Tasks
     * @name TasksPostItemsCreate
     * @summary 샵 아이템 상품 등록 (작업 단위) ✅
     * @request POST:/shops/{shopID}/tasks/{shopTaskID}/post-items
     * @secure
     * @response `204` `void` No Content
     */
    tasksPostItemsCreate: (shopId: string, shopTaskId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${shopTaskId}/post-items`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 작업을 삭제하는 API 입니다.
     *
     * @tags Tasks
     * @name TasksDelete
     * @summary 샵의 작업 삭제 ✅
     * @request DELETE:/shops/{shopID}/tasks/{taskID}
     * @secure
     * @response `204` `void` No Content
     */
    tasksDelete: (shopId: string, taskId: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/tasks/${taskId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵의 작업의 아이템을 생성하는 API 입니다.
     *
     * @tags Tasks
     * @name TasksItemCreate
     * @summary 샵의 작업의 아이템 생성 ✅
     * @request POST:/shops/{shopID}/tasks/{taskID}/item
     * @secure
     * @response `200` `DomainCreateShopTaskItemResponse` 샵 작업 아이템 생성 응답 값
     */
    tasksItemCreate: (
      shopId: string,
      shopTaskId: string,
      taskId: string,
      CreateShopTaskItemRequest: DomainCreateShopTaskItemRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainCreateShopTaskItemResponse, any>({
        path: `/shops/${shopId}/tasks/${taskId}/item`,
        method: 'POST',
        body: CreateShopTaskItemRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 판매 아이템 자세한 설명을 해주는 HTML template을 조회하는 API입니다.
     *
     * @tags Shops
     * @name TemplatesDetail
     * @summary 샵 판매 아이템 설명 HTML Template 조회 API ✅
     * @request GET:/shops/{shopID}/templates
     * @secure
     * @response `200` `DomainListShopHTMLTemplatesResponse` OK
     */
    templatesDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainListShopHTMLTemplatesResponse, any>({
        path: `/shops/${shopId}/templates`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description 판매 아이템 자세한 설명을 해주는 HTML template을 저장하는 API입니다.
     *
     * @tags Shops
     * @name TemplatesCreate
     * @summary 샵 판매 아이템 설명 HTML 템플릿을 생성하는 API ✅
     * @request POST:/shops/{shopID}/templates
     * @secure
     * @response `204` `void` No Content
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
     */
    templatesCreate: (
      shopId: string,
      CreateShopHTMLTemplateRequest: DomainCreateShopHTMLTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/templates`,
        method: 'POST',
        body: CreateShopHTMLTemplateRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 판매 아이템 자세한 설명을 해주는 HTML template을 업데이트하는 API입니다.
     *
     * @tags Shops
     * @name TemplatesUpdate
     * @summary 샵 판매 아이템 설명 HTML Template 업데이트 API ✅
     * @request PUT:/shops/{shopID}/templates/{templateID}
     * @secure
     * @response `204` `void` No Content
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
     */
    templatesUpdate: (
      shopId: string,
      templateId: string,
      UpdateShopHTMLTemplateRequest: DomainUpdateShopHTMLTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/templates/${templateId}`,
        method: 'PUT',
        body: UpdateShopHTMLTemplateRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 판매 아이템 자세한 설명을 해주는 HTML template을 삭제하는 API입니다.
     *
     * @tags Shops
     * @name TemplatesDelete
     * @summary 샵 판매 아이템 설명 HTML Template 삭제 API ✅
     * @request DELETE:/shops/{shopID}/templates/{templateID}
     * @secure
     * @response `204` `void` No Content
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
     */
    templatesDelete: (shopId: string, templateId: string, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/templates/${templateId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 샵 HTML template을 부분 수정하는 API입니다.
     *
     * @tags Shops
     * @name TemplatesPartialUpdate
     * @summary 샵 HTML Template 부분 수정 API ✅
     * @request PATCH:/shops/{shopID}/templates/{templateID}
     * @secure
     * @response `204` `void` No Content
     * @response `404` `void` 샵이 존재하지 않거나, 소유한 샵이 아닌 경우 Code: SHOP_NOT_FOUND
     */
    templatesPartialUpdate: (
      shopId: string,
      templateId: string,
      PatchShopHTMLTemplateRequest: DomainPatchShopHTMLTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, void>({
        path: `/shops/${shopId}/templates/${templateId}`,
        method: 'PATCH',
        body: PatchShopHTMLTemplateRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 샵의 주문을 배송준비중으로 변경합니다. 해당 API는 배송준비중으로 변경되는 주문의 상태가 배송중이 아닌 경우에만 사용합니다. ## Validation |HTTP Status|Code|Description| |---|---|---| |400||샵 ID가 없음| |400||주문 ID가 없음| |409|ORDER_NOT_OPERATE|주문 상태가 배송중이 아님| |404|SHOP_NOT_FOUND|샵이 존재하지 않음| |404|ORDER_NOT_FOUND|주문이 존재하지 않음| |404|SHOP_AUTH_NOT_FOUND|샵 인증 정보가 존재하지 않음| |409|PLATFORM_ORDER_NOT_SAME|같은 플랫폼 주문 ID를 가진 주문이 아닌 요청의 경우|
     *
     * @tags Orders
     * @name UndoShippingInProgressOrdersCreate
     * @summary 샵 주문 배송준비중으로 변경 ✅
     * @request POST:/shops/{shopID}/undo-shipping-in-progress-orders
     * @secure
     * @response `204` `void` No Content
     */
    undoShippingInProgressOrdersCreate: (
      shopId: string,
      request: DomainUndoShippingInProgressOrdersRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/undo-shipping-in-progress-orders`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 브랜드를 사전에 정의된 엑셀 포맷으로 데이터를 업로드 합니다.
     *
     * @tags Brands
     * @name UploadBrandsCreate
     * @summary 브랜드 엑셀파일 업로드 ✅
     * @request POST:/shops/{shopID}/upload-brands
     * @secure
     * @response `204` `void` No Content
     */
    uploadBrandsCreate: (shopId: string, data: UploadBrandsCreatePayload, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/shops/${shopId}/upload-brands`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @description 샵 관련 파일을 업로드하는 API
     *
     * @tags Shops
     * @name UploadFileCreate2
     * @summary 샵 관련 파일 업로드 ✅
     * @request POST:/shops/{shopID}/upload-file
     * @originalName uploadFileCreate
     * @duplicate
     * @secure
     * @response `200` `DomainUploadShopFileResponse` OK
     */
    uploadFileCreate2: (shopId: string, data: UploadFileCreate2Payload, params: RequestParams = {}) =>
      this.http.request<DomainUploadShopFileResponse, any>({
        path: `/shops/${shopId}/upload-file`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @description 네이버 이미지를 업로드하는 API
     *
     * @tags Platforms
     * @name UploadNaverImagesCreate
     * @summary 네이버 이미지 업로드 ✅
     * @request POST:/shops/{shopID}/upload-naver-images
     * @secure
     * @response `200` `DomainUploadNaverImagesResponse` OK
     */
    uploadNaverImagesCreate: (shopId: string, data: UploadNaverImagesCreatePayload, params: RequestParams = {}) =>
      this.http.request<DomainUploadNaverImagesResponse, any>({
        path: `/shops/${shopId}/upload-naver-images`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @description 진행중인 샵 작업이 존재하는지 확인하는 API 입니다.
     *
     * @tags Tasks
     * @name UploadingTaskExistsDetail
     * @summary 진행중인 샵 작업 존재 여부 확인 ✅
     * @request GET:/shops/{shopID}/uploading-task-exists
     * @secure
     * @response `200` `DomainExistsUploadingShopTaskResponse` OK
     */
    uploadingTaskExistsDetail: (shopId: string, params: RequestParams = {}) =>
      this.http.request<DomainExistsUploadingShopTaskResponse, any>({
        path: `/shops/${shopId}/uploading-task-exists`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
